<template>
  <div>
    <div v-show="!isLoading">
      <v-container
        v-if="selectedView" :title="maximised ? 'Click to expand the view' : 'Click to collapse the view' "
        fluid :class="maximised ? 'rm-view-container-maximised' : 'rm-view-container'"
      >
      <!-- <v-btn @click="maximiseView" :title="maximised ? 'Restore View Area' : 'Expand View Area'" fab x-small fixed bottom left><v-icon >{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn> -->
      <!-- <v-btn title="Report Designer"
          @click="toggleDesigner" fab x-small fixed bottom :style="maximised ? 'margin-left: 60px;' : 'margin-left: 30px;'" ><v-icon >mdi-tools</v-icon></v-btn> -->
      <template v-if="!maximised">
        <v-row class="flex-nowrap" v-if="primaryTabs.filter(x => x.visible && !x.other).length > 1 && !selectedStatistic">
          <v-col v-for="(t, ti) in primaryTabs.filter(x => x.visible && !x.other)"
              @click="selectTab(t)" :style="t.width"
              :key="'tab' + ti">
            <div class="rm-primary-tab rm-box" style="cursor: pointer;" 
              :style="t === selectedTab ? 'border: 4px solid ' + t.borderColour : ''"
              :class="t === selectedTab ? 'tab-selected' : ''">
              <v-icon v-if="t.icon" :color="t.iconColour" class="mr-4 rm-primary-tab-icon">{{ t.icon }}</v-icon>
            {{t.title}}</div>
          </v-col>
          <v-col v-for="(t, ti) in primaryTabs.filter(x => x.visible && x.other)"           
              :key="'tabo' + ti" :style="t.width"> 
              <!-- @click="selectTab(t)" -->
            <div class="rm-primary-tab rm-box" style="cursor: pointer;" 
              :style="t === selectedTab ? 'border: 4px solid ' + t.borderColour : ''"
              :class="t === selectedTab ? 'tab-selected' : ''"
              @click="openViewMenu">
              <v-icon v-if="t.icon" :color="t.iconColour" class="mr-4 rm-primary-tab-icon">{{ t.icon }}</v-icon>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="showPrimaryViewTabs()">
          <v-col class="mb-4 mt-2">
            <v-tabs v-model="selectedViewIndex" class="rm-tab-container">
              <v-tabs-slider class="rm-tab-slider"></v-tabs-slider>
              <v-tab v-for="(v, vi) in primaryViews.filter(x => !selectedTab || x.definition.parentTab === selectedTab.key)"
                      @click="selectView(v)" class="rm-tab"
                      :key="'pv' + vi">{{v.tabTitle}}
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col v-if="primaryTabs.filter(x => x.visible && !x.other).length <= 1" cols="1" class="mt-2">
            <v-btn
              class="ml-2 float-right rm-button-icon" elevation="0"
              title="Reports Available 1"
              @click="openViewMenu"
              ><v-icon>mdi-dots-horizontal</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </template>
      <v-row v-if="selectedStatistic">
        <v-col cols="6"
            class="statistic-container-current" 
            :style="{ backgroundColor: selectedStatistic.backgroundColour}" @click="resetSelectedStatistic"
        >
          <v-icon class="statistic-icon" :color="selectedStatistic.iconDisplay.colour">{{ selectedStatistic.iconDisplay.icon }}</v-icon>
          <div class="statistic-text-container">
            <div class="statistic-title">
              <v-icon class="mr-2" color="orange" v-if="selectedStatistic.includeWarning">mdi-alert</v-icon>
              {{ selectedStatistic.displayTitle }} {{ selectedStatistic.description }}
              <v-icon class="float-right statistic-icon" >mdi-close</v-icon>
              </div>
            <!-- <div class="statistic-description">{{ selectedStatistic.description }}</div> -->
            <div class="statistic-description">{{ selectedStatistic.viewName }}</div>
          </div>
        </v-col>
      </v-row>
        <div
          v-if="!haveData && currentViewHierarchy"
          class="d-flex justify-center mt-6"
        >
          <v-alert type="info" width="500">
            <div class="d-flex justify-space-between align-center">
              <div>
                No {{ utils.pluralise(currentViewHierarchy.label) }} exist
              </div>
              <v-btn
                color="white"
                small
                outlined
                @click="addHierarchy(currentViewHierarchy)"
                >Create {{ currentViewHierarchy.label }}</v-btn
              >
            </div>
          </v-alert>
        </div>
        <v-card
          v-if="haveData && selectedView.definition.viewType === 'catalogue'" 
          :class="!maximised ? 'rm-box mt-4' : 'rm-maximised'" 
          :style="!maximised && primaryTabsVisible && primaryViews.filter(x => !selectedTab || x.definition.parentTab === selectedTab.key).length === 1  ? 'margin-top: 40px !important;' : !primaryTabsVisible ? 'margin-top: 0 !important;' : ''"
        >
          <v-card-text :style="!maximised ? 'padding: 32px;' : ''">
            <template v-if="selectedView.definition.displayAs.indexOf('grid') >= 0">
              <v-row v-if="!maximised && selectedView.definition.title">
                <v-col cols="8" class="rm-title">{{selectedView.definition.title}}</v-col>
                <v-col class="float-right" v-if="titleWithFilters && !showHighlights">
                  <FilterOptions
                    :filters="getfilterableOptions" :columnSpace="4" @filterChanged="filterChanged($event)" @textfilterChanged="filterAxes($event)"
                  ></FilterOptions>
                </v-col>
                <v-col cols="1" v-if="titleWithFilters && primaryViews.length <= 1 && !primaryTabsVisible"
                 @click="reportMenuVisible = !reportMenuVisible">
                  <v-btn v-if="reportMenuVisible"
                    class="ml-2 float-right rm-button-icon" elevation="0"
                    title="Reports Available 2"
                    @click="openViewMenu"
                    ><v-icon>mdi-dots-horizontal</v-icon></v-btn
                  ></v-col>
                <v-col v-if="titleWithFilters && showViewButton('title')">
                  <v-btn v-if="primaryTabsVisible" @click="maximiseView" 
                    :title="maximised ? 'Restore View Area' : 'Expand View Area'"  elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn>
                  <v-btn v-if="allowDesigner('title')"
                    elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    title="Report Designer"
                    @click="toggleDesigner"
                    ><v-icon small>mdi-tools</v-icon></v-btn
                ></v-col>
              </v-row>
              <v-row no-gutters class="mb-4" v-if="!maximised && selectedView.definition.description">
                <v-col cols="9" class="rm-label">{{selectedView.definition.description}}</v-col>
                <v-col v-if="showViewButton('description')">
                  <v-btn v-if="primaryTabsVisible" @click="maximiseView" 
                    :title="maximised ? 'Restore View Area' : 'Expand View Area'"  elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn>
                  <v-btn v-if="allowDesigner('description')" elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    title="Report Designer"
                    @click="toggleDesigner"
                    ><v-icon small>mdi-tools</v-icon></v-btn
                ></v-col>
              </v-row>
              <v-row v-if="!maximised && !titleWithFilters">
                <v-col cols="2" v-if="(!selectedTab && primaryViews.length < 2) || selectedTab?.other">
                  <v-row dense v-if="getfilterableOptions.length"><v-col class="rm-label"><br/></v-col></v-row>
                  <v-row dense><v-col class="rm-view-title">{{ selectedView.name }}</v-col></v-row>
                </v-col>
                <v-col :cols="(!selectedTab && primaryViews.length < 2) || selectedTab?.other ? 6 : 8">
                  <FilterOptions
                    :filters="getfilterableOptions" :columnSpace="8" @filterChanged="filterChanged($event)" @textfilterChanged="filterAxes($event)"
                  ></FilterOptions>
                </v-col>
                <v-col cols="4"> 
                  <v-row dense v-if="getfilterableOptions.length"><v-col class="rm-label"><br/></v-col></v-row>
                  <v-row dense><v-col>
                  <v-btn
                    v-if="primaryViews.length <= 1 && !primaryTabsVisible"
                    class="ml-2 float-right rm-button-icon" elevation="0"
                    title="Reports Available 3"
                    @click="openViewMenu"
                    ><v-icon>mdi-dots-horizontal</v-icon></v-btn
                  >
                  <v-btn v-if="!selectedStatistic && allowDesigner('')" elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    title="Report Designer"
                    @click="toggleDesigner"
                    ><v-icon small>mdi-tools</v-icon></v-btn
                  >
                  <v-btn v-if="primaryTabsVisible" @click="maximiseView"
                    :title="maximised ? 'Restore View Area' : 'Expand View Area'"  elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="selectedView.definition.viewType === 'catalogue' && Object.keys(columnWidths.overrides).length"
                    @click="resetAllColumnWidths"
                    title="Reset column widths to automatic" elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    ><v-icon small>mdi-arrow-split-vertical</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="selectedView.definition.viewType === 'catalogue' && selectedView.definition.showDownload !== 'hidden'"
                    class="ml-2 float-right rm-button" elevation="0"
                    title="Download To xlsx"
                    @click="exportToExcel"
                    ><v-icon class="mr-2">mdi-tray-arrow-down</v-icon> <template v-if="selectedView.definition.showDownload === 'icon + title'">Excel</template></v-btn
                  >
                  <v-badge
                    v-if="compareDocs.length"
                    color="green" class="float-right"
                    left
                    overlap
                    :content="compareDocs.length"
                  >
                    <v-btn class="rm-button" @click="compareDocDetailsFull(compareDocs)" elevation="0">
                      <v-icon>mdi-compare</v-icon> Compare <v-divider class="ml-3" vertical></v-divider><v-icon class="ml-3" title="Deselect All Documents" @click.stop="resetCompare">mdi-close-box-outline</v-icon></v-btn
                    ><v-menu>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-2 rm-button" elevation="0"
                          v-bind="attrs"
                          v-on="on"
                        >
                          Actions <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>     
                      <v-list>
                        <v-list-item @click="compareDocDetailsFull(compareDocs)">
                          <v-list-item-title>Full compare view</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="editDocs()">
                          <v-list-item-title>Bulk Edit</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="compareDocDetails(compareDocs)"
                          :disabled="compareDocs.length > 15">
                          <v-list-item-title>Side-by-side view</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item v-if="usesTags" @click="getDocumentTags(compareDocs)">
                          <v-list-item-title>{{ (tagsDialogue.subject || 'Skill') + ' Comparison' }}</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="openDocListMenu($event)">
                          <v-list-item-title>List Selected Documents</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item @click="resetCompare">
                          <v-list-item-title>Clear Selected Documents</v-list-item-title>
                        </v-list-item>
                      </v-list>   
                    </v-menu>
                  </v-badge>
                  <template v-else-if="layout?.canSelectDocs"
                    ><v-btn class="ml-2 rm-button float-right" elevation="0" disabled>
                      Actions <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                    <v-btn
                      disabled
                      color="#eeeeee"
                      class="rm-button float-right"
                      @click="compareDocDetailsFull"
                      elevation="0"
                    >
                      <v-icon>mdi-compare</v-icon> Compare</v-btn
                    >
                  </template>
                </v-col></v-row>
                </v-col>
              </v-row>
              <v-row v-if="maximised">
                <v-col cols="2">
                  <v-menu bottom close-on-click>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="rm-maximised-title">
                        {{ selectedView.name }}<v-icon >mdi-menu-down</v-icon>
                      </div>
                    </template
                    ><v-list class="selectViewMenu">
                      <v-list-item
                        v-for="(v, vi) in primaryViews"
                        :key="'vir' + vi"
                        @click="selectView(v)"
                      >
                        <v-list-item-content class="ml-3">{{
                          v.name
                        }}</v-list-item-content
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col>
                  <FilterOptions
                    :filters="getfilterableOptions" dense :columnSpace="7" @filterChanged="filterChanged($event)" @textfilterChanged="filterAxes($event)"
                  ></FilterOptions>
                </v-col>
                <v-col cols="3">
                  <v-btn v-if="showViewButton('')" @click="maximiseView" 
                    :title="maximised ? 'Restore View Area' : 'Expand View Area'"  elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn>
                  <v-btn v-if="allowDesigner('')" elevation="0"
                    class="ml-3 rm-button-icon float-right"
                    title="Report Designer"
                    @click="toggleDesigner"
                    ><v-icon small>mdi-tools</v-icon></v-btn
                >
                  <v-badge
                    v-if="compareDocs.length"
                    color="green" class="float-right"
                    left
                    overlap
                    :content="compareDocs.length"
                  >
                    <v-btn style="rm-button" @click="compareDocDetailsFull(compareDocs)" elevation="0">
                      <v-icon>mdi-compare</v-icon>Compare <v-divider class="ml-3" vertical></v-divider><v-icon class="ml-3" title="Clear Select Documents" @click.stop="resetCompare">mdi-close-box-outline</v-icon></v-btn
                    ><v-menu>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-2 rm-button" elevation="0"
                          v-bind="attrs"
                          v-on="on"
                        >
                          Actions <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>     
                      <v-list>
                        <v-list-item @click="compareDocDetailsFull(compareDocs)">
                          <v-list-item-title>Full compare view</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="editDocs()">
                          <v-list-item-title>Bulk Edit</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="compareDocDetails(compareDocs)"
                          :disabled="compareDocs.length > 15">
                          <v-list-item-title>Side-by-side view</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item v-if="usesTags" @click="getDocumentTags(compareDocs)">
                          <v-list-item-title>{{ (tagsDialogue.subject || 'Skill') + ' Comparison' }}</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="openDocListMenu($event)">
                          <v-list-item-title>List Selected Documents</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item @click="resetCompare">
                          <v-list-item-title>Clear Selected Documents</v-list-item-title>
                        </v-list-item>
                      </v-list>   
                    </v-menu>
                  </v-badge>
                  <template v-else-if="layout?.canSelectDocs"
                    ><v-btn class="ml-2 rm-button float-right" elevation="0" disabled>
                      Actions <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                    <v-btn
                      disabled
                      color="#eeeeee"
                      class="rm-button float-right"
                      @click="compareDocDetailsFull"
                      elevation="0"
                    >
                      <v-icon>mdi-compare</v-icon> Compare</v-btn
                    >
                  </template>
                </v-col>
              </v-row>
            </template>
            <template v-for="(row,ri) in viewSectionsLayout">
              <v-row :key="'sr' + ri">
                <v-col v-for="(column, ci) in row.cols" 
                  :key="'sr' + ri + 'c' + ci"
                  :cols="column.colWidth">
                  <v-row v-for="(section, ii) in column.sections.filter(x => !x.hideSection)" :key="'sr' + ri + 'c' + ci + 'section' + ii">
                    <v-col v-if="section.type === 'statistic'"
                        class="statistic-container" 
                        :style="{ backgroundColor: section.backgroundColour, cursor: section.view ? 'pointer' : ''}"
                        @click="viewStatDetail(section)"
                    >
                      <v-icon class="statistic-icon" :color="section.iconDisplay.colour">{{ section.iconDisplay.icon }}</v-icon>
                      <div class="statistic-text-container">
                        <div class="statistic-title">
                          <v-icon class="mr-2" color="green" v-if="section.goodIdentified">mdi-check-circle</v-icon>
                          <v-icon class="mr-2" :color="section.errorIdentified ? 'red' : 'orange'" v-if="section.errorIdentified || section.warningIdentified">mdi-alert</v-icon>
                          {{ section.displayTitle }}</div>
                        <div class="statistic-description">{{ section.description }}</div>
                      </div>
                    </v-col>
                    <v-col v-else>
                      <v-row v-if="section.title">
                        <v-col class="rm-title">{{section.title}}</v-col>
                        <v-col :cols="allowDesigner('title', section, ri) ? 2 : 1" v-if="ri === 0 && ci === row.cols.length - 1 && showViewButton('title', section, ri)">
                          <v-btn @click="maximiseView" 
                            :title="maximised ? 'Restore View Area' : 'Expand View Area'"  elevation="0"
                            class="ml-3 rm-button-icon float-right"
                            ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn>
                          <v-btn v-if="allowDesigner('title', section, ri)" elevation="0"
                              class="ml-3 rm-button-icon float-right"
                              title="Report Designer"
                              @click="toggleDesigner"
                              ><v-icon small>mdi-tools</v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                      <v-row v-if="section.description">
                        <v-col class="rm-label">{{section.description}}</v-col>
                        <v-col cols="1" v-if="ri === 0 && showViewButton('description', section, ri)">
                          <v-btn @click="maximiseView" 
                            :title="maximised ? 'Restore View Area' : 'Expand View Area'" elevation="0"
                            class="ml-3 rm-button-icon float-right"
                            ><v-icon small>{{ maximised ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon></v-btn>
                          <v-btn v-if="allowDesigner('description', section, ri)" elevation="0"
                            class="ml-3 rm-button-icon float-right"
                            title="Report Designer"
                            @click="toggleDesigner"
                            ><v-icon small>mdi-tools</v-icon></v-btn
                        ></v-col>
                      </v-row>
                      <FilterOptions v-if="section.filtersData && section.filtersData.length"
                        :filters="section.filtersData" :columnSpace="12" @filterChanged="chartFilterChanged(section)" @textfilterChanged="filterAxes($event)"
                      ></FilterOptions>
                      <v-row v-if="section.type === 'bar_chart'">
                        <v-col class="chartHolder">
                          <Bar
                            :data="section.chartData"
                            :options="section.option"
                            :style="section.style"
                            ></Bar>
                        </v-col>
                        <v-col cols="2" class="chartLegend">
                          <v-select v-if="!section.useRange"
                            label="Sort Chart"
                            outlined
                            class="roundish"
                            dense
                            :items="chartSortOptions"
                            v-model="section.selectedSortOption" @change="setChartData(section)"
                            >
                          </v-select>
                          <div class="ml-2">
                            <span v-if="section.yAxis" class="rm-label">Distributed By</span>
                            <span v-else class="rm-chart-label">{{ section.title }}</span>
                            <v-select v-if="section.yAxis" :items="horAxisAvailable" item-value="name" item-text="name"
                              v-model="section.yAxisName" @change="changeChartYAxis(section);"
                              dense hide-details outlined
                              class="rm-select mt-1 mb-2"></v-select>
                            <div class="bar-legend" style="section.legendStyle">
                              <div>
                                <v-checkbox
                                  v-for="(s, si) in section.data.stacks"
                                  v-model="section.data.stacksSelected" class="checkbox-small"
                                  :key="'s' + si"
                                  :label="s.label + ''" @change="setChartData(section)"
                                  :value="s">
                                  <template v-slot:label>
                                    <v-icon :color="s.colour" size="20" class="mr-2">circle</v-icon>{{ s.label }}
                                  </template>
                                </v-checkbox>
                              </div>
                              <div v-if="section.link && section.linkTitle" @click="doLink(section)" class="chart-link">
                                {{ section.linkTitle }}
                              </div>
                            </div>
                          </div>
                        </v-col>      
                      </v-row>
                      <v-row v-else-if="section.type === 'pie_chart'">
                        <v-col class="chartHolder" v-if="section.chartData">
                            <div class="pie-container">
                              <Doughnut 
                                :data="section.chartData"
                                :options="section.option"
                                :style="section.style"
                              ></Doughnut>
                              <div class="pie-title">
                                <div class="pie-title-number">{{ section.chartData.measureTotal }}</div>
                                <div class="pie-title-text">{{ section.measure.title }}</div>
                              </div>
                            </div>
                            <div class="pie-legend" style="section.legendStyle">
                              <div>
                                <!-- <v-checkbox
                                  v-for="(s, si) in section.chartData.detaillabels"
                                  :key="'s' + si"
                                  :label="s" @change="setChartData(section)"
                                  :value="s">
                                  <template v-slot:label>
                                    <v-icon :color="section.chartData.datasets[0].backgroundColor[si]" size="20" class="mr-2">circle</v-icon>{{ s }}
                                  </template>
                                </v-checkbox> -->
                                <ul style="list-style-type: none; padding: 0;">
                                  <li class="pie-legend-item"
                                    v-for="(s, si) in section.chartData.detaillabels"
                                    :key="'s' + si" @click="setChartData(section)">
                                      <v-icon :color="section.chartData.datasets[0].backgroundColor[si]" size="20" class="mr-2">circle</v-icon>{{ s }}
                                  </li>
                                </ul>
                                <div v-if="section.link && section.linkTitle" @click="doLink(section)" class="chart-link">
                                  {{ section.linkTitle }}
                                </div>
                              </div>
                            </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="section.type === 'task_list'">
                        <v-col>
                          <TaskList 
                            :ViewDef="section" 
                            :definitionChanged="section.updated"
                            @openDocument="$emit('openDocument', $event)">
                          </TaskList>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
            <v-row no-gutters v-if="selectedView.definition.displayAs.indexOf('grid') >= 0 && layout?.highlights?.length">
              <v-col class="highlight-container" v-for="(h,hi) in layout.highlights" :key="'hi' + hi" :style="h.style" :class="h.values.some(x => x.match_key) ? 'highlight-container-link' : ''">
                <v-row no-gutters>
                  <v-col>
                    <v-row no-gutters>
                      <v-col class="highlight-title">{{ h.title }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col v-for="(v, vi) in h.values" :key="'ji' + hi + 'vi' + vi" >
                        <v-row no-gutters>
                          <!-- :style="{ color: v.valueColour -->
                          <v-col class="highlight-value" :style="{ cursor: v.match_key ? 'pointer' : '' }" @click="v.match_key ? doMeasureDrilldown(v) : null">
                            <v-icon v-if="v.showWarning" :color="v.valueColour">mdi-alert</v-icon>
                            <v-icon v-else-if="v.showTick" color="green">mdi-check-circle</v-icon>
                             {{ v.valueText }}
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col class="highlight-addendum">
                            <span v-html="v.valueTextAddendum"></span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col style="max-width: 40px;"><v-icon x-large style="font-size: 50px;" :color="h.iconColour">{{ h.icon }}</v-icon></v-col>
                </v-row>
                <v-row no no-gutters v-if="h.addendumText">
                  <v-col class="highlight-addendum">
                    <span v-html="h.addendumText"></span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="selectedView.definition.displayAs.indexOf('grid') >= 0 && (this.keyLegends.length || selectedView.definition.axisPickerOptions?.length || selectedView.definition.measurePickerOptions?.length)">
              <v-col v-for="(l,li) in keyLegends" :key="'l' + li">
                <v-row no-gutters class="mb-2">
                  <v-col class="highlight-legend-text">{{ l.title }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <div v-for="(v, vi) in l.values" :key="'l' + li + 'v' + vi" class="highlight-legend-container">
                      <div class="highlight-legend-box" :style="v.style"></div>
                      <div class="highlight-legend-text">{{ v.description }}</div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="float-right" v-if="getfilterableOptions.length">
                <FilterOptions
                  :filters="getfilterableOptions" :columnSpace="2" @filterChanged="filterChanged($event)" @textfilterChanged="filterAxes($event)"
                ></FilterOptions>
              </v-col>
              <v-col cols="2" v-if="selectedView.definition.measurePickerOptions?.length && horizontalMeasures.filter(x => x.visible).length === 1">
                <v-row no-gutters><v-col class="highlight-legend-text">Measure</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <HierarchyViewMeasurePicker
                      :column="horizontalMeasures.filter(x => x.visible)[0]"
                      :columnsAvailable="horizontalMeasures.filter(x => x.available && selectedView.definition.measurePickerOptions.some(o => o === x.id))"
                      :columnsUsed="horizontalMeasures.filter(x => x.visible)"
                      :measureDisplayTypes="measureDisplayTypes.filter(x => x.horizontal)"
                      pickerOnly
                      @changeColumn="(col, prev) => setMeasureOptionTemp(col, prev)"
                    ></HierarchyViewMeasurePicker>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="selectedView.definition.axisPickerOptions?.length">
                <v-col cols="2" v-if="verAxisSelected.length === 1">
                  <v-row no-gutters><v-col class="highlight-legend-text">Vertical Axis</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <HierarchyViewColumnPicker
                        :column="
                          getCompareOptionDef(verAxisSelected[0], 'verAxisSelected')
                        "
                        :columnsAvailable="
                          verAxisAvailable.filter(x => selectedView.definition.axisPickerOptions.some(o => o === x.name))
                        "
                        :columnsUsed="
                          getOptionsUsed('vertical')
                        "
                        :index="0" allowPrefix allowTitleOverride allowIncludeInColumn allowDisplayType allowIncludeRangeColumn
                        pickerOnly
                        :columnType="'verAxisSelected'"
                        :columnSubject="'vertical axis'"
                        @changeColumn="setAxisCompareOptionTemp"
                      ></HierarchyViewColumnPicker>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2" v-if="horAxisSelected.length === 1">
                  <v-row no-gutters><v-col class="highlight-legend-text">Horizontal Axis</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <HierarchyViewColumnPicker
                        :column="
                          getCompareOptionDef(horAxisSelected[0], 'horAxisSelected')
                        "
                        :columnsAvailable="
                          horAxisAvailable.filter(x => selectedView.definition.axisPickerOptions.some(o => o === x.name))
                        "
                        :columnsUsed="
                          getOptionsUsed('horizontal')
                        "
                        :index="0" allowPrefix allowTitleOverride allowIncludeInColumn allowDisplayType allowIncludeRangeColumn
                        pickerOnly
                        :columnType="'horAxisSelected'"
                        :columnSubject="'horizontal axis'"
                        @changeColumn="setAxisCompareOptionTemp"
                      ></HierarchyViewColumnPicker>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <!-- <template v-if="getfilterableOptions.length">
                <v-col cols="6"></v-col>
                <v-col cols="6" class="float-right">
                  <FilterOptions
                    :filters="getfilterableOptions" :columnSpace="6" @filterChanged="filterChanged($event)" @textfilterChanged="filterAxes($event)"
                  ></FilterOptions>
                </v-col>
              </template> -->
            </v-row>
            <v-row v-if="selectedView.definition.displayAs.indexOf('grid') >= 0">
              <v-col :cols="selectedView.definition.gridWidth">
                <!-- <v-row v-if="filterList.length || dragTarget.show" no-gutters>
                  <v-col v-if="filterList.length">
                    <v-chip
                      small
                      v-for="(f, fi) in filterList"
                      :key="'f' + fi"
                      close
                      @click:close="removeFilter(f)"
                    >
                      {{ f.title }}</v-chip
                    ></v-col
                  >
                  <v-col v-if="dragTarget.show && dragTarget.buckets.length">
                    <v-row>
                      <v-col
                        v-for="(b, bi) in dragTarget.buckets"
                        :key="'dtb' + bi"
                        :offset="dragTarget.buckets.length === 1 ? 6 : null"
                        ><v-card
                          class="drag-target"
                          v-on:drop="addAddition($event, b)"
                          v-on:dragover="allowDrop($event, b)"
                          ><v-toolbar
                            color="teal lighten-5"
                            height="32"
                            elevation="1"
                          >
                            <v-toolbar-title
                              ><v-text-field
                                dense
                                hide-details
                                v-model="b.title"
                                :full-width="false"
                                v-if="b.edit"
                                @blur="b.edit = false"
                                @keypress.enter="b.edit = false"
                                @keypress.escape="b.edit = false"
                              ></v-text-field
                              ><span
                                v-else
                                @click="b.edit = true"
                                style="font-size: 13px"
                                >{{ b.title }}</span
                              ></v-toolbar-title
                            ><v-divider vertical class="mx-1"></v-divider>
                            <v-btn
                              small
                              icon
                              @click="removeBucket(b)"
                              title="Delete workspace"
                              ><v-icon>mdi-delete-forever</v-icon></v-btn
                            ><v-divider vertical class="ml-1"></v-divider>
                            <v-spacer></v-spacer
                            ><span style="font-size: 13px">{{
                              !b.additions.length
                                ? "empty"
                                : b.additions.length +
                                  " " +
                                  b.subject +
                                  (b.additions.length > 1 ? "s" : "")
                            }}</span
                            ><v-divider vertical class="mx-1"></v-divider>
                            <v-btn
                              v-if="b.additions.length"
                              small
                              icon
                              @click="removeAdditionAll(b)"
                              title="Remove all items"
                              ><v-icon>mdi-playlist-remove</v-icon></v-btn
                            ><v-divider vertical class="ml-1"></v-divider>
                            <v-spacer></v-spacer
                            ><v-divider vertical class="mr-2"></v-divider>
                            <v-btn
                              small
                              icon
                              @click="compareBucketDocs(b)"
                              :title="
                                'Compare Documents for selected ' +
                                b.subject +
                                's'
                              "
                              ><v-icon>mdi-content-duplicate</v-icon></v-btn
                            ><v-divider v-if="permissions.nodeMoveMerge" vertical class="mx-2"></v-divider>
                            <v-btn v-if="permissions.nodeMoveMerge"
                              small
                              icon
                              @click="moveBucket(b)"
                              :title="'Bulk Move selected ' + b.subject + 's'"
                              ><v-icon>mdi-file-move</v-icon></v-btn
                            ><v-divider vertical class="mx-2"></v-divider>
                            <v-btn
                              small
                              icon
                              @click="b.show = !b.show"
                              :title="
                                b.show ? 'Hide Contents' : 'Show Contents'
                              "
                              ><v-icon>{{
                                b.show ? "mdi-chevron-up" : "mdi-chevron-down"
                              }}</v-icon></v-btn
                            >
                          </v-toolbar>
                          <v-card-text v-if="b.show" class="pa-2">
                            <v-chip
                              x-small
                              class="mr-2"
                              label
                              close
                              @click="viewNodeDoc($event, a)"
                              @click:close="removeAddition(b, a.node)"
                              v-for="(a, ai) in b.additions"
                              :key="'dtb' + bi + 'a' + ai"
                              >{{ a.title }}</v-chip
                            >
                          </v-card-text></v-card
                        >
                      </v-col></v-row
                    ></v-col
                  >
                </v-row> -->
                <div v-if="columnWidths.drag.active" class="col-resize-guide"
                  :style="{ left: columnWidths.drag.guideX + 'px', top: columnWidths.drag.guideTop + 'px', height: columnWidths.drag.guideHeight + 'px' }"></div>
                <div v-if="columnWidths.hoverGuide.show && !columnWidths.drag.active" class="col-resize-guide-hover"
                  :style="{ left: columnWidths.hoverGuide.x + 'px', top: columnWidths.hoverGuide.top + 'px', height: columnWidths.hoverGuide.height + 'px' }"></div>
                <v-row v-if="layout" no-gutters class="flex-nowrap mx-0 mt-0" :class="selectedView.definition.showTotalsRow ? 'horizontal-border-bottom' : ''"
                  @mouseover="handleResizeHover" @mouseleave="hideResizeHover">
                  <v-col
                    v-if="layout.leftPanel.cols"
                    :style="layout.leftPanel.colWidthStyle"
                    class="col-resizable"
                    >
                    <div v-if="layout.rightPanel.cols" class="panel-resize-handle" title="Drag to resize the vertical axis panel; double-click to reset"
                      @click.stop
                      @dblclick.stop="resetColumnWidth('LP')"
                      @pointerdown.stop.prevent="startColResize($event, 'LP', layout.leftPanel.viewportPx)"></div>
                    <template v-if="horAxisSelected.length"><v-row no-gutters v-for="x in horAxisSelected.length - 1" :key="x + 'xx'"><v-col class="y-columnHeader-empty"><br/></v-col></v-row></template>
                    <v-row no-gutters v-if="horAxisSelected.length && horAxisSelected[0].overrideTitle">
                      <v-col class="y-columnHeader-empty"><br/></v-col>
                    </v-row>
                    <v-row no-gutters v-if="layout.rightPanel.horizontalHeadingVisible">
                      <v-col class="y-columnHeader-empty"><br/></v-col>
                    </v-row>
                    <div ref="leftHead" class="left-hscroll-region" :class="layout.rightPanel.cols ? 'panel-divider' : ''" style="overflow: hidden;">
                    <v-row no-gutters class="flex-nowrap" :style="layout.leftPanel.scrollWidthStyle">
                      <v-col v-if="layout.leftPanel.colsTitle"
                          :style="layout.leftPanel.titleSectionStyle"
                          :class="layout.rightTotalPanel.cols ? 'vertical-border-right' : null">
                            <v-row no-gutters class="flex-nowrap">
                              <v-col v-if="selectedView.definition.fullVerticalView" style="max-width: 40px; text-overflow: unset;"
                                class="y-columnHeader first-row first-column"
                                :class="layout.gridLineClass" >
                                <v-icon @click="selectAllRowsClicked" style="font-size: 18px;">{{
                                  !selectAllRows ? "mdi-checkbox-blank-outline" : "mdi-checkbox-marked"
                                }}</v-icon>
                              </v-col>
                              <v-col
                                v-for="(vc, vci) in layout.detailRow.rowHeading.titleWidths"
                                :key="'vc' + vci" :title="vc.title"
                                class="y-columnHeader first-row col-resizable"
                                :class="(vci === 0 && !selectedView.definition.fullVerticalView ? 'first-column' : '') + (!layout.headerRow && !layout.leftPanel.colsTotal && vci === layout.detailRow.rowHeading.titleWidths.length - 1 ? ' last-column' : '') + layout.gridLineClass + (layout.rightPanel.cols > 0 && layout.leftPanel.colsTotal === 0 && vci === layout.detailRow.rowHeading.titleWidths.length - 1 ? ' gridline-vertical' : '')"
                                :style="{ cursor: allowSort(vc, vci) ? 'pointer' : '',
                                          maxWidth: selectedView.definition.fullVerticalView && vci === 0 ? 'calc(' + layout.detailRow.rowHeading.titleWidths[vci].percent + ' - 40px)' : layout.detailRow.rowHeading.titleWidths[vci].percent + '' }"
                                @click="allowSort(vc, vci) ? setSort(vc, vc.sortIndex !== undefined && vc.sortIndex !== null ? vc.sortIndex : vci) : toggleDesigner()">
                                <v-icon v-if="selectedView.sortColumn && vc.column === selectedView.sortColumn.name" color="#AAAAAA">{{
                                  selectedView.sortColumn.descending ? "mdi-arrow-down-thin" : "mdi-arrow-up-thin"
                                }}</v-icon>
                                <v-icon v-else-if="allowSort(vc, vci)" color="#AAAAAA" small>mdi-swap-vertical</v-icon>
                                {{vc.title}}
                                <div v-if="vc.key" class="col-resize-handle" title="Drag to resize; double-click to reset"
                                  @click.stop
                                  @dblclick.stop="resetColumnWidth(vc.key)"
                                  @pointerdown.stop.prevent="startColResize($event, vc.key, vc.px)"></div>
                              </v-col>
                            </v-row>
                          </v-col>
                      <v-col v-if="layout.leftPanel.colsTotal"
                        :style="layout.leftPanel.totalSectionStyle">
                        <v-row no-gutters class="flex-nowrap">
                          <v-col
                            v-for="(m, mi) in verticalMeasures.filter(x => x.visible && x.available)"
                            :key="'mh' + mi"
                            :title="m.title"
                            class="y-columnHeader-number first-row col-resizable"
                            :class="(!layout.rightPanel.cols && layout.detailRow.rowHeading.measureWidths.length - 1 === mi ? ' last-column' : '') + layout.gridLineClass + (layout.rightPanel.cols && layout.detailRow.rowHeading.measureWidths.length - 1 === mi ? layout.rightPanel.cols ? ' gridline-separator' : ' gridline-vertical' : '')"
                            :style="{ cursor: allowSortMeasure() ? 'pointer' : '',
                                      textAlign : m.alignment,
                                      minWidth: layout.detailRow.rowHeading.measureWidths[mi]?.percent ?? m.widthPct,
                                      maxWidth: layout.detailRow.rowHeading.measureWidths[mi]?.percent ?? m.widthPct }"
                            @click="allowSortMeasure() ? setSort(m, mi, true) : toggleDesigner()">
                            <v-icon v-if="selectedView.sortColumn && m.column === selectedView.sortColumn.name">{{
                                selectedView.sortColumn.descending ? "mdi-arrow-down-thin" : "mdi-arrow-up-thin"
                              }}</v-icon>
                              <v-icon v-else-if="allowSortMeasure()" color="#AAAAAA" small>mdi-swap-vertical</v-icon>
                              {{ m.columnTitle }}
                              <div class="col-resize-handle" title="Drag to resize; double-click to reset"
                                @click.stop
                                @dblclick.stop="resetColumnWidth('VM:' + (m.id || m.column))"
                                @pointerdown.stop.prevent="startColResize($event, 'VM:' + (m.id || m.column), m.widthPx)"></div>
                              </v-col> </v-row>
                          </v-col>
                          <!--  -->
                    </v-row>
                    </div>
                  </v-col>
                  <v-col
                    v-if="layout.rightPanel.cols"
                    :style="layout.rightPanel.colWidthStyle"
                    :class="hEdgeClipped ? 'clipped-right-border' : ''">
                    <v-row v-if="horAxisSelected.length && horAxisSelected[0].overrideTitle" class="flex-nowrap" no-gutters>
                      <v-col class="x-rowHeader first-row first-column last-column"
                        :class="selectedView.definition.gridlines.indexOf('horizontal') >= 0 ? 'gridline-horizontal' : ''"
                        :style="{ maxWidth: layout.rightPanel.scrollWidthStyle.minWidth }">{{horAxisSelected[0].overrideTitle}}</v-col>
                    </v-row>
                    <v-row class="flex-nowrap" no-gutters
                      v-if="layout.headerRow"
                      :ref="layout.headerRow.ref" style="overflow: hidden;">
                      <v-col
                        v-for="(c, ci) in layout.headerRow.columnsSett"
                        :key="'c' + ci"
                        :class="(c.class || '') + ' col-resizable'"
                        :style="c.colCSS"
                        ><div class="col-resize-handle" title="Drag to resize columns; double-click to reset"
                          @click.stop
                          @dblclick.stop="resetColumnWidth('H')"
                          @pointerdown.stop.prevent="startColResize($event, 'H', layout.hLeafPx, c.leafCount)"></div
                        ><v-row
                          no-gutters
                          ><v-col>
                            <HierarchyViewColumnHeading
                              :item="c"
                              axis="horAxisSelected"
                              :catalogueDocType="catalogueDocType"
                              :detailHeading="layout.headerRow.detailHeadings"
                              @resizeColumn="startColResize"
                              @resetColumnWidth="resetColumnWidth"
                              :searchTerms="(selectedView.definition.searchText || '').split(' ').filter(x => x)"
                              :hideNodeActions="selectedView.definition.hideNodeActions"
                              @openDocumentID="openDocumentID"
                              @openDocActionsMenuContext="
                                openDocActionsMenuContext
                              "
                              @showMatches="showMatches"
                              @selectJob="selectJob"
                              @doMenuAction="doMenuAction"
                              @openDocument="openDocument"
                              @copyDocument="$emit('copyDocument', $event)"
                            ></HierarchyViewColumnHeading> </v-col
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="layout.rightTotalPanel.cols"
                    :style="layout.rightTotalPanel.colWidthStyle"
                    class="vertical-border-left">
                        <v-row no-gutters>
                          <v-col
                            v-for="(m, mi) in verticalMeasures.filter(x => x.visible && x.available)"
                            :key="'mh' + mi"
                            :title="m.title"
                            class="y-columnHeader first-row col-resizable"
                            :class="verticalMeasures.filter(x => x.visible && x.available).length - 1 === mi ? ' last-column' : layout.gridLineClass"
                            :style="{ cursor: allowSortMeasure() ? 'pointer' : '',
                                      textAlign : m.alignment,
                                      minWidth: layout.detailRow.rowHeading.measureWidths[mi]?.percent ?? m.widthPct,
                                      maxWidth: layout.detailRow.rowHeading.measureWidths[mi]?.percent ?? m.widthPct }"
                            @click="allowSortMeasure() ? setSort(m, mi, true) : toggleDesigner()">
                            <v-icon v-if="selectedView.sortColumn && m.column === selectedView.sortColumn.name">{{
                                selectedView.sortColumn.descending ? "mdi-arrow-down-thin" : "mdi-arrow-up-thin"
                              }}</v-icon>
                              <v-icon v-else-if="allowSortMeasure()" color="#AAAAAA" small>mdi-swap-vertical</v-icon>
                              {{ m.columnTitle }}
                              <div class="col-resize-handle" title="Drag to resize; double-click to reset"
                                @click.stop
                                @dblclick.stop="resetColumnWidth('VM:' + (m.id || m.column))"
                                @pointerdown.stop.prevent="startColResize($event, 'VM:' + (m.id || m.column), m.widthPx)"></div>
                              </v-col> </v-row>

                  </v-col>
                  <!-- spacer matching the detail row's vertical scrollbar column so the
                       header and detail columns stretch to identical widths -->
                  <v-col style="flex: 0 0 auto; width: 18px;"></v-col>
                </v-row>
                  <!-- :style="{ height: vScroll.pageHeight + 'px' }" -->
                <v-row
                  v-if="layout && layout.detailRow"
                  class="flex-nowrap mx-0"
                  @wheel.stop="wheelScroll"
                  @mouseover="handleResizeHover" @mouseleave="hideResizeHover"
                  ref="detailRow" no-gutters
                >
                  <v-col
                    v-if="layout.leftPanel.cols"
                    :style="layout.leftPanel.colWidthStyle"
                    class="col-resizable"
                  >
                    <div v-if="layout.rightPanel.cols" class="panel-resize-handle" title="Drag to resize the vertical axis panel; double-click to reset"
                      @click.stop
                      @dblclick.stop="resetColumnWidth('LP')"
                      @pointerdown.stop.prevent="startColResize($event, 'LP', layout.leftPanel.viewportPx)"></div>
                    <div ref="leftBody" class="left-hscroll-region" :class="layout.rightPanel.cols ? 'panel-divider' : ''" style="overflow: hidden;">
                    <div :style="layout.leftPanel.scrollWidthStyle">
                    <RowHeaders
                    :class="selectedView.definition.showTotalsRow && layout.rightPanel.cols ? 'vertical-border-right' : ''"
                      :headerRows="pageStructureSett" 
                      :visibleMeasures="verticalMeasures.filter(x => x.visible)"
                      :catalogueDocType="catalogueDocType"
                      :rowSelectable="selectedView.definition.fullVerticalView"
                      :searchTerms="(selectedView.definition.searchText || '').split(' ').filter(x => x)"
                      :hideNodeActions="selectedView.definition.hideNodeActions"
                      @openDocumentID="openDocumentID"
                      @openDocActionsMenuContext="openDocActionsMenuContext"
                      @showMatches="showMatches"
                      @selectJob="selectJobRowHeader"
                      @selectRow="selectListRow"
                      @doMenuAction="doMenuAction"
                      @openDocument="openDocument"
                      @copyDocument="$emit('copyDocument', $event)"  
                      @nodeSelected="nodeSelected"
                      @viewNodeDoc="viewNodeDoc"
                      @saveDescriptor="saveDescriptorInline"
                      @drilldown="doMeasureDrilldown(...arguments)"
                      @resizeColumn="startColResize"
                      @resetColumnWidth="resetColumnWidth"
                    ></RowHeaders>
                      <!-- @showDocList="openDocListMenu" -->
                    <v-row no-gutters class="flex-nowrap" v-if="selectedView.definition.showTotalsRow && layout.footerRow.data"
                      :class="layout.rightPanel.cols ? ' vertical-border-right' : ''"
                      :style="layout.leftPanel.scrollWidthStyle">
                      <v-col v-if="layout.leftPanel.colsTitle"
                          :style="layout.leftPanel.titleSectionStyle"
                          class="y-columnFooter last-row first-column gridline-vertical">TOTALS</v-col>
                      <v-col v-if="layout.leftPanel.colsTotal"
                        :style="layout.leftPanel.totalSectionStyle"
                        class="rm-footer last-row gridline-separator">
                        <v-row no-gutters class="flex-nowrap">
                          <v-col v-for="(vm, vmi) in verticalMeasures.filter(x => x.visible)" :key="'v_tot' + vmi"
                                    :style="{ minWidth: layout.detailRow.rowHeading.measureWidths[vmi]?.percent ?? vm.widthPct,
                                              maxWidth: layout.detailRow.rowHeading.measureWidths[vmi]?.percent ?? vm.widthPct }"
                                    >
                                    <MeasureDisplay
                                      class="measure-column"
                                      :item="layout.footerRow.data"
                                      :measure="vm"
                                      :selectable="vm.type === 'job_count'"
                                      :backColour="layout.footerRow.data.colour"
                                      @click="selectJobRowDetail(layout.footerRow.data)"
                                      @showLinkedDocs="showLinkedDocs(layout.footerRow.data)"
                                      @drilldown="doMeasureDrilldown(...arguments)"
                                    ></MeasureDisplay>
                                  </v-col
                                >
                        </v-row>
                      </v-col>
                    </v-row>
                    </div>
                    </div>
                  </v-col>
                  <!-- :cols="layout.rightPanel.cols" -->
                  <v-col
                    v-if="layout.rightPanel.cols"
                    :style="layout.rightPanel.colWidthStyle"
                    :class="hEdgeClipped ? 'clipped-right-border' : ''"
                    >
                    <v-row no-gutters style="overflow: hidden;" ref="detailH">
                      <v-col>
                        <RowDetails 
                          :headerRows="pageStructureSett" 
                          :visibleMeasures="horizontalMeasures.filter(x => x.visible)"
                          :catalogueDocType="catalogueDocType"
                          :detailDef="layout.detailRow.detail"
                          :showDetails="detAxisSelected.length > 0"
                          :vScroll="vScroll"
                          :searchTerms="(selectedView.definition.searchText || '').split(' ').filter(x => x)"
                          :hideNodeActions="selectedView.definition.hideNodeActions"
                          @openDocumentID="openDocumentID"
                          @openDocActionsMenuContext="openDocActionsMenuContext"
                          @showMatches="showMatches"
                          @selectJob="selectJobRowDetail"
                          @selectItem="selectJobRowDetail"
                          @doMenuAction="doMenuAction"
                          @openDocument="openDocument"
                          @copyDocument="$emit('copyDocument', $event)"    
                          @dragStart="dragStart"                            
                          @viewNodeDoc="viewNodeDoc"                           
                          @removeAdditionNode="removeAdditionNode"
                          @showLinkedDocs="showLinkedDocs"
                          @drilldown="doMeasureDrilldown(...arguments)"
                          @resizeColumn="startColResize"
                          @resetColumnWidth="resetColumnWidth"
                        ></RowDetails>
                      <!-- @showDocList="openDocListMenu"                  -->
                        <v-row v-if="selectedView.definition.showTotalsRow" no-gutters>
                          <v-col>
                            <v-row no-gutters class="flex-nowrap">
                              <v-col
                                v-for="(c, ci) in layout.headerRow.columnsSett"
                                :key="'c_tot' + ci" class="rm-footer last-row"
                                :class="layout.gridLineClass"
                                :style="c.colCSS"
                                ><v-row class="flex-nowrap" no-gutters
                                  ><v-col v-for="(vm, vmi) in horizontalMeasures.filter(x => x.visible)" :key="'c_tot' + ci + 'vm' + vmi"
                                    :style="{ minWidth: layout.detailRow.detail.measureWidths[vmi].percent, maxWidth: layout.detailRow.detail.measureWidths[vmi].percent }"
                                    >
                                    <MeasureDisplay
                                      class="measure-column"
                                      :item="c.headerColumns[0]"
                                      :measure="vm"
                                      :selectable="vm.type === 'job_count'"
                                      :backColour="c.headerColumns[0].colour"
                                      @click="selectJobRowDetail(c.headerColumns[0])"
                                      @showLinkedDocs="showLinkedDocs(c.headerColumns[0])"
                                      @drilldown="doMeasureDrilldown(...arguments)"
                                    ></MeasureDisplay>
                                  </v-col
                                ></v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="layout.rightTotalPanel.cols"
                    :style="layout.rightTotalPanel.colWidthStyle">
                    <RowMeasures 
                      class="vertical-border-left"
                      :headerRows="pageStructureSett" 
                      :visibleMeasures="verticalMeasures.filter(x => x.visible)"
                      :catalogueDocType="catalogueDocType"
                      :rowSelectable="selectedView.definition.fullVerticalView"
                      :searchTerms="(selectedView.definition.searchText || '').split(' ').filter(x => x)"
                      @openDocumentID="openDocumentID"
                      @openDocActionsMenuContext="openDocActionsMenuContext"
                      @showMatches="showMatches"
                      @selectJob="selectJobRowHeader"
                      @selectRow="selectListRow"
                      @doMenuAction="doMenuAction"
                      @openDocument="openDocument"
                      @copyDocument="$emit('copyDocument', $event)"  
                      @nodeSelected="nodeSelected"
                      @viewNodeDoc="viewNodeDoc"
                      @drilldown="doMeasureDrilldown(...arguments)"
                      @resizeColumn="startColResize"
                      @resetColumnWidth="resetColumnWidth"
                    ></RowMeasures>
                    <v-row v-if="layout.rightTotalPanel.cols" no-gutters
                      class="vertical-border-left">
                      <v-col
                        :style="layout.rightTotalPanel.colWidthStyle"
                        class="rm-footer last-row last-column gridline-separator">
                        <v-row no-gutters class="flex-nowrap">
                          <v-col v-for="(vm, vmi) in verticalMeasures.filter(x => x.visible)" :key="'v_tot' + vmi"
                                    :style="{ minWidth: layout.detailRow.rowHeading.measureWidths[vmi]?.percent ?? vm.widthPct,
                                              maxWidth: layout.detailRow.rowHeading.measureWidths[vmi]?.percent ?? vm.widthPct }"
                                    >
                                    <MeasureDisplay
                                      class="measure-column"
                                      :item="layout.footerRow.data"
                                      :measure="vm"
                                      :selectable="vm.type === 'job_count'"
                                      :backColour="layout.footerRow.data.colour"
                                      @click="selectJobRowDetail(layout.footerRow.data)"
                                      @showLinkedDocs="showLinkedDocs(layout.footerRow.data)"
                                      @drilldown="doMeasureDrilldown(...arguments)"
                                    ></MeasureDisplay>
                                  </v-col
                                >
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- :style="{ height: vScroll.pageHeight + 'px' }" -->
                  <v-col
                    style="
                      overflow: auto;
                      flex: 0 0 auto;
                      width: 18px;
                      min-width: 10px;
                    "
                    ref="scrollContainer"
                    @scroll="setVScroll_"
                  >
                    <!-- -->
                    <div ref="scrollBar"
                  :style="{ height: vScroll.maxHeight, width: '1px' }"></div>
                  </v-col>
                </v-row>
                <v-row v-if="layout && layout.headerRow" no-gutters class="flex-nowrap mx-0 mb-0">
                  <!-- :cols="layout.leftPanel.cols" -->
                  <v-col
                    v-if="layout.leftPanel.cols"
                    :style="layout.leftPanel.colWidthStyle"
                    class="scrollCol"
                    ><v-row no-gutters><v-col class="scrollCol"></v-col></v-row
                  ></v-col>
                  <!-- :cols="layout.rightPanel.cols" -->
                </v-row>
                <v-row v-if="layout" no-gutters class="flex-nowrap mx-0 mb-0">
                  <!-- :cols="layout.leftPanel.cols" -->
                  <v-col
                    v-if="layout.leftPanel.cols"
                    :style="layout.leftPanel.colWidthStyle"
                    class="scrollCol"
                    >
                    <v-row no-gutters
                      v-if="layout.leftPanel.scrollVisible"
                      style="overflow: auto; height: 12px;"
                      ref="leftfoot"
                      class="flex-nowrap left-hscroll-region"
                      @scroll="setLeftHScroll"
                      >
                      <v-col
                        class="scrollCol"
                        :style="layout.leftPanel.scrollWidthStyle"
                      ></v-col>
                      </v-row
                  ></v-col>
                  <!-- :cols="layout.rightPanel.cols" -->
                  <v-col
                    v-if="layout.rightPanel.cols && layout.headerRow"
                    :style="layout.rightPanel.colWidthStyle"
                    class="scrollCol"
                  >
                    <v-row no-gutters
                      v-show="hScrollNeeded"
                      style="overflow: auto; height: 12px;"
                      ref="colfoot"
                      class="flex-nowrap"
                      @scroll="setHScroll"
                      >
                      <v-col
                        class="scrollCol"
                        :style="layout.rightPanel.scrollWidthStyle"
                      ></v-col>
                      </v-row
                  ></v-col>
                  <v-col
                    v-if="layout.rightTotalPanel.cols"
                    :style="layout.rightTotalPanel.colWidthStyle">
                  </v-col>
                  <!-- spacer matching the detail row's vertical scrollbar column -->
                  <v-col style="flex: 0 0 auto; width: 18px;"></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card v-if="selectedView.definition.viewType === 'audit'">
          <v-card-title>{{ nodeHistoryReport.label }}</v-card-title>
          <v-card-actions>
            <v-row dense>
              <v-col>
                <DateRangePicker
                  :DateRange="nodeHistoryReport.dateRangeFilter"
                  label="Items Updated Between"
                  @updated="filterAuditReportDateRange"
                ></DateRangePicker>
              </v-col>
              <v-col>
                <v-select
                  multiple
                  outlined
                  dense
                  hide-details
                  label="Items Updated By"
                  v-model="nodeHistoryReport.userFilter"
                  clearable
                  :items="nodeHistoryReport.userList"
                  @change="filterAuditReport()"
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-btn dense @click="showAuditReportChanges(true)"
                  ><v-icon>mdi-eye</v-icon> Show All Changes</v-btn
                >
              </v-col>
              <v-col cols="2">
                <v-btn dense @click="showAuditReportChanges(false)"
                  ><v-icon>mdi-eye-off</v-icon> Hide All Changes</v-btn
                >
              </v-col>
            </v-row></v-card-actions
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <HierarchyTreeNodeAudit
                    :nodes="nodeHistoryReport.nodes"
                    :levels="4"
                  ></HierarchyTreeNodeAudit>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card v-if="selectedView.definition.viewType === 'audit_data'">
          <v-card-title>{{ nodeAuditData.label }}</v-card-title>
          <v-card-actions>
            <v-row dense>
              <v-col>
                <DateRangePicker
                  :DateRange="nodeAuditData.dateRangeFilter"
                  label="Updates Between"
                  @updated="filterAuditDataDateRange"
                ></DateRangePicker>
              </v-col>
              <v-col>
                <v-select
                  multiple
                  outlined
                  dense
                  hide-details
                  label="Type"
                  v-model="nodeAuditData.typeFilter"
                  clearable
                  :items="nodeAuditData.typeList"
                  @change="filterAuditData()"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  multiple
                  outlined
                  dense
                  hide-details
                  label="Updates By"
                  v-model="nodeAuditData.userFilter"
                  clearable
                  :items="nodeAuditData.userList"
                  @change="filterAuditData()"
                ></v-select>
              </v-col>
              <v-col v-if="nodeAuditData.reasonList.length">
                <v-select
                  multiple
                  outlined
                  dense
                  hide-details
                  label="Change Reason"
                  v-model="nodeAuditData.reasonFilter"
                  clearable
                  :items="nodeAuditData.reasonList"
                  @change="filterAuditData()"
                ></v-select>
              </v-col>
              <!-- <v-col cols="2">
                <v-btn dense @click="showAuditReportChanges(true)"
                  ><v-icon>mdi-eye</v-icon> Show All Changes</v-btn
                >
              </v-col>
              <v-col cols="2">
                <v-btn dense @click="showAuditReportChanges(false)"
                  ><v-icon>mdi-eye-off</v-icon> Hide All Changes</v-btn
                >
              </v-col> -->
            </v-row></v-card-actions
          >
          <v-card-text v-if="nodeAuditData.data">
            <v-data-table
              :headers="nodeAuditData.headers"
              :items="nodeAuditData.items"
              single-expand
              :expanded.sync="nodeAuditData.expanded"
              item-key="hierarchy_transaction_id"
              show-expand
              class="elevation-1"
              @click:row="selectAuditRow"
            >
              <template v-slot:[`item.transaction_description`]="{ item }">
                <div
                  v-html="getAuditDescriptionHTML(item.transaction_description)"
                ></div>
              </template>
              <template v-slot:[`item.user_name`]="{ item }">
                <v-chip dark small :title="item.user_email">
                  {{ item.user_name }}
                </v-chip>
              </template>
              <template v-slot:[`item.transaction_reason_type`]="{ item }">
                <v-chip label small outlined v-if="item.transaction_reason_type"
                  >{{ item.transaction_reason_type
                  }}<v-tooltip v-if="item.transaction_reason_notes" bottom
                    ><template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" right>
                        mdi-message-text
                      </v-icon>
                    </template>
                    <span style="max-width: 500px">
                      {{ item.transaction_reason_notes }}
                    </span></v-tooltip
                  ></v-chip
                >
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-container>
                    <v-row
                      dense
                      v-for="(n, ni) in item.nodes_affected"
                      :key="'t' + item.hierarchy_transaction_id + 'n' + ni"
                    >
                      <v-col cols="1">-</v-col>
                      <v-col :cols="n.difference ? 6 : 11"
                        ><div
                          v-html="getAuditDescriptionHTML(n.effect_description)"
                        ></div>
                      </v-col>
                      <v-col v-if="n.difference"
                        ><div v-html="n.difference"></div
                      ></v-col> </v-row
                  ></v-container>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-card v-if="['linked','similarity'].some(x => x ===selectedView.definition.viewType)" class="rm-box mt-4" :style="primaryViews.filter(x => !selectedTab || x.definition.parentTab === selectedTab.key).length === 1 ? 'margin-top: 40px !important;' : ''">
          <v-card-text v-if="!isBuilding">
            <v-row v-if="selectedView.definition.title"><v-col class="rm-title">{{selectedView.definition.title}}</v-col></v-row>
            <v-row v-if="selectedView.definition.description"><v-col class="rm-label">{{selectedView.definition.description}}</v-col></v-row>
            <v-row  no-gutters class="flex-nowrap">
              <v-col>
                <SimilarityView 
                  :ViewDef="selectedView.definition" 
                  :ViewData="similarityData" 
                  :usesTags="usesTags" 
                  :allowDesigner="permissions.changeSettings && permissions.designIconVisible" 
                  allowMaximise
                  :maximised="maximised"
                  :definitionChanged="similarityData.updated"
                  @showDesigner="toggleDesigner"
                  @openDocument="openDocument"
                  @maximise="maximiseView"></SimilarityView>
              </v-col>
            </v-row>
          </v-card-text>
          </v-card>
        <v-menu
          v-model="contextMenu.show"
          absolute
          :position-x="contextMenu.posX"
          :position-y="contextMenu.posY"
          offset-y
          :close-on-content-click="false"
          nudge-width="300"
        >
          <v-card>
            <v-card-text v-if="contextMenu.busy">
              <v-row>
                <v-col cols="5"></v-col>
                <v-col>
                  <v-progress-circular indeterminate size="50" color="grey">
                  </v-progress-circular>
                </v-col>
                <v-col cols="5"></v-col>
              </v-row>
            </v-card-text>
            <v-list dense v-else>
              <v-list-item>
                <v-list-item-title
                  ><div class="menuSubject">
                    {{ contextMenu.title }}
                  </div></v-list-item-title
                ></v-list-item
              >
              <v-list-item
                v-for="(a, ai) in contextMenu.actions"
                :key="'cma' + ai"
                @click="doContextMenuAction(a)"
              >
                <v-list-item-icon>
                  <v-icon>{{ a.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ a.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <DocListMenu
          :context="docListMenu"
          @openDocument="openDocument"
          @copyDocument="$emit('copyDocument', $event)"
          @assignHierarchy="assignHierarchy"
          @itemRemoved="removeFromDocList"
          showAttributeCompare
          @editDocs="editDocs"
          @openDocumentSummary="openDocumentSummary"
          :showTagCompare="usesTags"
          @compareTags="getDocumentTags"
        ></DocListMenu>
        <v-menu
          v-model="viewMenu.show"
          absolute
          :position-x="viewMenu.posX"
          :position-y="viewMenu.posY"
          offset-y
          :close-on-click="!viewMenu.keepOpen"
          :close-on-content-click="false"
            ><v-card max-height="800" min-width="800" v-if="viewMenu.show">
              <v-tabs v-model="viewMenu.tab">
                <v-tab
                  v-for="(v, vi) in viewMenu.tabs"
                  :key="'vmt' + vi" :title="v.tip"
                  @click="v.admin ? setEditShortcuts() : null">{{ v.title }}
                </v-tab>
              </v-tabs>
              <v-list v-if="viewMenu.tabs[viewMenu.tab].views" dense>
                <v-list-item dense
                  v-for="(v, vi) in viewMenu.tabs[viewMenu.tab].views"
                  :key="'vir' + vi"
                  @click="selectView(v)" :style="v.lastInSection ? 'border-bottom: 1px lightgray solid;' : null"
                >
                  <v-list-item-icon class="mr-0">
                    <v-icon v-if="selectedView === v">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="ml-3">
                    <div>
                      {{ v.name }}
                      <v-tooltip bottom v-if="v.description.length > 60">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="ml-2"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <span v-html="v.description"></span> </v-tooltip
                      >
                      <v-tooltip bottom close-on-click v-if="v.isDirty">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" color="amber" class="ml-2"
                            >mdi-triangle</v-icon
                          >
                        </template>
                        <v-list>
                          <v-list-item
                            >Changes:</v-list-item
                          >
                          <v-list-item v-if="v.isDirty">
                            <ul>
                              <li
                                v-for="(c, ci) in getDefinitionChanges(v)"
                                :key="'dc' + ci"
                                class="caption"
                              >
                                {{ c }}
                              </li>
                            </ul>
                          </v-list-item>
                        </v-list>
                      </v-tooltip>
                    </div>
                  </v-list-item-content>
                  <v-list-item-action v-if="permissions.changeSettings && viewMenu.tabs[viewMenu.tab].rename" class="ml-4"
                    ><v-icon v-if="selectedView === v && v.isDirty" @click.stop="resetDefinition" title="Undo design/filter changes">mdi-arrow-u-left-top-bold</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-if="permissions.changeSettings && viewMenu.tabs[viewMenu.tab].rename" class="ml-4"
                    ><v-icon v-if="selectedView === v && v.isDirty" @click.stop="saveDefinition" title="Save design/filter changes">mdi-content-save</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-if="permissions.changeSettings && viewMenu.tabs[viewMenu.tab].rename" class="ml-4"
                    ><v-icon v-if="selectedView === v && v.isDirty" @click.stop="saveDefinitionAs()" title="Save Updated View As...">mdi-content-duplicate</v-icon>
                    <v-icon v-else @click.stop="saveDefinitionAs(v)" title="Copy View...">mdi-content-copy</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-if="permissions.changeSettings" class="ml-4">
                    <v-icon v-if="selectedView === v" @click.stop="toggleDesigner" :title="viewDefinition.showDesigner ? 'Hide Designer' : 'Show Designer'">mdi-tools</v-icon>
                  </v-list-item-action>
                  <template v-if="viewMenu.tabs[viewMenu.tab].rename">
                  <v-list-item-action class="ml-4"
                    ><v-icon @click.stop="deleteDefinition(v)" title="Delete View">mdi-trash-can-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-action
                    ><v-icon @click.stop="editDefinition(v)" :disabled="v.isDirty" title="Rename View">mdi-rename</v-icon>
                  </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list>
              <v-card v-else max-height="800" min-width="800">
                <v-card-title class="py-2">
                <template v-if="viewMenu.tabs[viewMenu.tab].admin">
                  <v-spacer></v-spacer>
                  <v-btn small @click="addShortcut" class="mr-4 mt-2">Add Tab</v-btn>
                  <v-btn
                    small class="mr-2 mt-2"
                    :disabled="!shortcuts.isDirty"
                    @click="saveShortcuts"
                    >Save Tabs</v-btn
                  ><v-btn small class="mr-2 mt-2" 
                    :disabled="!shortcuts.isDirty"
                    @click="cancelShortcuts">Reset Tabs</v-btn>
                </template></v-card-title>
                <v-list dense>
                  <v-divider></v-divider><v-list-item
                    ><v-list-item-content
                      ><v-row
                        ><v-col>Report</v-col>
                        <v-col>Tab Title</v-col>
                        <v-col cols="1">#</v-col>
                        <v-col cols="3">Section</v-col>
                  </v-row></v-list-item-content
                  ></v-list-item>
                  <v-divider></v-divider>
                  <template v-for="(s, si) in shortcuts.editItems">
                    <v-list-item :key="'sc' + si">
                      <v-list-item-content
                        ><v-row
                          ><v-col cols="4"
                            ><v-select
                              v-if="s.isNew"
                              :items="
                                views.filter(
                                  (v) =>
                                    !shortcuts.editItems.some(
                                      (x) =>
                                        x.name === v.name && x.name !== s.name
                                    ) && !v.restricted && v.view_definition_id
                                )
                              "
                              item-text="name"
                              item-value="name"
                              v-model="s.name"
                              outlined
                              label="New Shortcut basis"
                              hide-details
                              dense
                              @change="s.tabTitle = s.name"
                            ></v-select
                            ><v-chip
                              v-else
                              label
                              outlined :title="s.name"
                              :color="s.delete ? 'red' : ''"
                              >
                              {{ s.name }}
                              <v-tooltip top v-if="s.restricted">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="warning" class="ml-2"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </template>
                                <span>NOTE: This view not visible to other users! </span>
                              </v-tooltip>
                              </v-chip
                            ></v-col
                          ><v-col
                            ><v-text-field
                              outlined
                              :disabled="s.delete"
                              :color="s.delete ? 'red' : ''"
                              dense
                              hide-details
                              v-model="s.tabTitle"
                              @change="shortcuts.isDirty = true"
                            ></v-text-field></v-col
                          ><v-col cols="1"
                            ><v-text-field
                              outlined
                              :disabled="s.delete"
                              :color="s.delete ? 'red' : ''"
                              dense
                              hide-details
                              v-model="s.position"
                              @change="shortcuts.isDirty = true"
                            ></v-text-field></v-col
                          >
                          <v-col cols="3"
                            ><v-select
                              hide-details
                              :color="s.delete ? 'red' : ''"
                              outlined
                              @change="shortcuts.isDirty = true"
                              dense
                              :items="primaryTabs.filter(t => !t.other)"
                              item-text="key"
                              item-value="key"
                              v-model="s.parentTab"
                              :append-outer-icon="s.delete ? 'mdi-delete-off' : 'mdi-delete'"
                              @click:append-outer="toggleRemoveShortcut(s)">
                              </v-select
                            ></v-col
                          >
                          </v-row
                        ></v-list-item-content
                      >
                    </v-list-item>
                    <v-divider v-if="s.isNew" :key="'scd' + si"></v-divider
                  ></template>
                </v-list>
              </v-card>
            </v-card>
        </v-menu>
        <ResponseHandler :serviceResponse="response"></ResponseHandler>
      </v-container>
    </div>
    <Loading
      :isVisible="isLoading || isBuilding || isSaving || isLoadingData || inProgressIndexRequests > 0"
    />
    <v-dialog
      v-model="tagsDialogue.show"
      :max-width="tagsDialogue.doc_ids.length === 1 ? '800px' : ''"
      scrollable
    >
      <TagCompare
        v-if="tagsDialogue.show"
        :documentIDs="tagsDialogue.doc_ids"
        :hierarchy_node_id="tagsDialogue.hierarchy_node_id"
        :tag_type_id="tagsDialogue.tag_type_id"
        :withinDialog="true"
      @close="tagsDialogue.show = false"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
      ></TagCompare>
    </v-dialog>
    <v-dialog
      v-model="editDialogue.show"
      scrollable
      :max-width="editDialogue.items.length === 1 ? '1000px' : ''"
    >
      <!-- :max-width="editDialogue.items.length === 1 ? '500px' : ''" -->
      <v-card v-if="editDialogue.show">
        <v-card-title>
          <h4>
            Detail Comparison - select the documents and properties to be
            updated
          </h4>
        </v-card-title>
        <v-card-text>
          <v-row v-if="editDialogue.items.length >= 1">
            <v-col cols="2">
              <v-row dense class="dialogueRow"><v-col>:</v-col></v-row>
              <v-row dense class="dialogueRow"
                ><v-col><h3>Properties:</h3></v-col></v-row
              >
              <v-row dense class="dialogueRow"><v-col></v-col></v-row>
              <v-row
                dense
                v-for="(a, ai) in editDialogue.columns"
                :key="'aa1_' + ai"
                :class="{
                  dialogueRow: a.tpa_id,
                  dialogueRowHierarchy: a.ht_id,
                }"
                ><v-col
                  ><v-badge
                    v-if="editDialogueCheckCount(a.value_column)"
                    :content="editDialogueCheckCount(a.value_column)"
                    ><span style="font-weight: bold; font-size: 15px">{{
                      a.label
                    }}</span></v-badge
                  >
                  <span v-else style="font-weight: bold; font-size: 15px">{{
                    a.label
                  }}</span
                  ><v-btn
                    v-if="editDialogue.items.length > 1"
                    x-small
                    class="float-right"
                    :title="
                      'Apply ' +
                      a.label +
                      ' updates for all ' +
                      editDialogue.items.length +
                      ' documents'
                    "
                    @click="editDialogueCheckAll(a.value_column)"
                  >
                    <v-icon small
                      >mdi-checkbox-multiple-marked-outline</v-icon
                    ></v-btn
                  >
                </v-col></v-row
              >
            </v-col>
            <v-col cols="7">
              <v-row dense class="dialogueRow"
                ><v-col cols="1"
                  ><v-btn
                    small
                    @click="dialogueNextPage(editDialogue, false)"
                    :disabled="editDialogue.page === 0"
                    ><v-icon>mdi-chevron-left</v-icon></v-btn
                  ></v-col
                ><v-col
                  ><h3 style="text-align: center">
                    Selected Documents {{ this.editDialogue.pageText }}:
                  </h3></v-col
                >
                <v-col cols="1"
                  ><v-btn
                    small
                    @click="dialogueNextPage(editDialogue, true)"
                    :disabled="editDialogue.page === editDialogue.pages - 1"
                    ><v-icon>mdi-chevron-right</v-icon></v-btn
                  ></v-col
                ></v-row
              >
              <v-row dense class="dialogueRow flex-nowrap">
                <v-col
                  class="dialogueColumnTop"
                  :cols="editDialogue.colSize"
                  v-for="(d, di) in editDialogue.items.filter(
                    (x) => x.page === editDialogue.page
                  )"
                  :key="'dd1_' + di"
                  ><v-chip small label outlined @click="openDocument(d)">{{
                    d.system_number
                  }}</v-chip
                  ><DocStatus
                    :doc_id="d.doc_id"
                    style="margin-left: 10px"
                  ></DocStatus></v-col
              ></v-row>
              <v-row dense class="dialogueRow flex-nowrap">
                <v-col
                  class="dialogueColumnBottom"
                  :cols="editDialogue.colSize"
                  v-for="(d, di) in editDialogue.items.filter(
                    (x) => x.page === editDialogue.page
                  )"
                  :key="'dd2_' + di"
                  ><v-tooltip top
                    ><template v-slot:activator="{ on, attrs }"
                      ><span v-bind="attrs" v-on="on">{{
                        d.doc_name
                      }}</span></template
                    ><span>{{ d.doc_name }}</span></v-tooltip
                  ></v-col
                ></v-row
              >
              <v-row
                class="flex-nowrap"
                :class="{
                  dialogueRow: a.tpa_id,
                  dialogueRowHierarchy: a.ht_id,
                }"
                dense
                v-for="(a, ai) in editDialogue.columns"
                :key="'aa2_' + ai + 'attr' + ai"
                ><v-col
                  :class="{
                    dialogueColumnBottom:
                      ai === editDialogue.columns.length - 1,
                    dialogueColumn: ai !== editDialogue.columns.length - 1,
                    dialogueColumnSame: a.same,
                  }"
                  :cols="editDialogue.colSize"
                  v-for="(d, di) in editDialogue.items.filter(
                    (x) => x.page === editDialogue.page
                  )"
                  :key="'aa2_' + ai + 'd' + di"
                >
                  <v-checkbox
                    v-if="a.ht_id"
                    v-model="d['change_' + a.value_column]"
                    dense
                    hide-details
                    :title="
                      a.tpa_id
                        ? d[a.value_column]
                        : d[a.value_column + '_label']
                    "
                    @click="setCanSave"
                  >
                    <template v-slot:label>
                      <li
                        v-for="(hl, hli) in d[a.value_column + '_label'].split(
                          ' > '
                        )"
                        :key="'aa2_' + ai + 'attr' + ai + 'hl' + hli"
                        :title="hl"
                        class="dialogueColumnCheckBoxRow"
                        :style="{
                          marginLeft: hli * 15 + 'px',
                          listStyleType: hli ? 'disclosure-closed' : 'none',
                        }"
                      >
                        {{ hl }}
                      </li>
                    </template></v-checkbox
                  >
                  <v-checkbox
                    v-else
                    v-model="d['change_' + a.value_column]"
                    dense
                    hide-details
                    :label="
                      a.tpa_id
                        ? d[a.value_column]
                        : d[a.value_column + '_label']
                    "
                    :title="
                      a.tpa_id
                        ? d[a.value_column]
                        : d[a.value_column + '_label']
                    "
                    @click="setCanSave"
                  ></v-checkbox> </v-col
              ></v-row>
            </v-col>
            <v-col cols="3">
              <v-row dense class="dialogueRow"><v-col></v-col></v-row>
              <v-row dense class="dialogueRow"><v-col></v-col></v-row>
              <v-row dense class="dialogueRow"
                ><v-col style="text-align: center"
                  >Enter the new values for each property:</v-col
                ></v-row
              >
              <v-row
                dense
                v-for="(a, ai) in editDialogue.columns.filter((x) => x.tpa_id)"
                :key="'av' + ai"
                :class="{
                  dialogueRow: a.tpa_id,
                  dialogueRowHierarchy: a.ht_id,
                }"
                ><v-col v-if="a.values.length"
                  ><v-select
                    :items="a.values"
                    :class="a.isDirty ? 'changedSelect' : ''"
                    v-model="a.value"
                    :label="a.label + ':'"
                    outlined
                    dense
                    hide-details
                    prepend-icon="mdi-plus"
                    @input="attributePicked(a)"
                    @click:prepend="addAttribute(a)"
                  ></v-select></v-col
                ><v-col cols="1" v-if="!a.values.length"></v-col
                ><v-col cols="11" v-if="!a.values.length"
                  ><DatePicker
                    v-if="a.value_data_type === 'date'"
                    v-model="a.value"
                    :css_class="a.isDirty ? 'changedSelect' : ''"
                    :label="a.label"
                    @input="attributePicked(a)"
                  ></DatePicker>
                  <v-text-field
                    v-else
                    outlined
                    :class="a.isDirty ? 'changedSelect' : ''"
                    dense
                    hide-details
                    :label="a.label + ':'"
                    v-model="a.value"
                    @input="attributePicked(a)"
                  ></v-text-field
                ></v-col>
              </v-row>
              <v-row
                dense
                v-for="(h, hi) in editDialogue.columns.filter((x) => x.ht_id)"
                :key="'hv' + hi"
                :class="{
                  dialogueRow: h.tpa_id,
                  dialogueRowHierarchy: h.ht_id,
                }"
                ><v-col cols="1"></v-col
                ><v-col cols="11">
                  <div
                    class="subjectPicker selectable"
                    :class="h.isDirty ? 'changed' : ''"
                    @click="pickHierarchy(h, editDialogue)"
                  >
                    <div class="subjectText">
                      <li
                        v-for="(hl, hli) in h.hLabel"
                        :key="'hv' + hi + 'hl' + hli"
                        :title="hl"
                        class="dialogueColumnCheckBoxRow"
                        :style="{
                          marginLeft: hli * 15 + 'px',
                          listStyleType: hli ? 'disclosure-closed' : 'none',
                        }"
                      >
                        {{ hl }}
                      </li>
                    </div>
                    <!-- <v-icon class="subjectIcon">mdi-pencil-box-outline</v-icon> -->
                    <v-btn
                      x-small
                      class="subjectIcon"
                      :title="h.label + ' Picker'"
                      >...</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-container v-else>
            <v-row
              v-for="(a, ai) in editDialogue.columns.filter((x) => x.tpa_id)"
              :key="'as' + ai"
              :class="{
                dialogueRow: a.tpa_id,
                dialogueRowHierarchy: a.ht_id,
              }"
            >
              <v-col v-if="a.values.length">
                <v-select
                  :items="a.values"
                  :class="a.isDirty ? 'changedSelect' : ''"
                  v-model="a.value"
                  :label="a.label + ':'"
                  outlined
                  dense
                  hide-details
                  prepend-icon="mdi-plus"
                  @input="attributePicked(a)"
                  @click:prepend="addAttribute(a)"
                ></v-select> </v-col
              ><v-col cols="1" v-if="!a.values.length"></v-col
              ><v-col cols="11" v-if="!a.values.length"
                ><DatePicker
                  v-if="a.value_data_type === 'date'"
                  v-model="a.value"
                  :css_class="a.isDirty ? 'changedSelect' : ''"
                  :label="a.label"
                  @input="attributePicked(a)"
                ></DatePicker
                ><v-text-field
                  v-else
                  outlined
                  :class="a.isDirty ? 'changedSelect' : ''"
                  dense
                  hide-details
                  :label="a.label + ':'"
                  v-model="a.value"
                  @input="attributePicked(a)"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row
              v-for="(h, hi) in editDialogue.columns.filter((x) => x.ht_id)"
              :key="'hv' + hi"
              :class="{
                dialogueRow: h.tpa_id,
                dialogueRowHierarchy: h.ht_id,
              }"
              ><v-col cols="1"></v-col
              ><v-col cols="11">
                <div
                  class="subjectPicker selectable"
                  :class="h.isDirty ? 'changed' : ''"
                  @click="pickHierarchy(h, editDialogue)"
                >
                  <div class="subjectText">
                    <span style="font-size: 11px; font-style: italic"
                      >{{ h.label }}:</span
                    >
                    <li
                      v-for="(hl, hli) in h.hLabel"
                      :key="'hv' + hi + 'hl' + hli"
                      :title="hl"
                      class="dialogueColumnCheckBoxRow"
                      :style="{
                        marginLeft: hli * 15 + 'px',
                        listStyleType: hli ? 'disclosure-closed' : 'none',
                      }"
                    >
                      {{ hl }}
                    </li>
                  </div>
                  <v-btn
                    x-small
                    class="subjectIcon"
                    :title="h.label + ' Picker'"
                    >...</v-btn
                  >
                </div></v-col
              >
            </v-row>
          </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!editDialogue.canSave"
            @click="saveDocs"
            >Apply Changes</v-btn
          >
          <v-btn color="primary" @click="editDialogue.show = false"
            >Close</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="hierarchyDescriptorDialogue.show" max-width="800px">
      <v-card v-if="hierarchyDescriptorDialogue.node">
        <v-card-title
          >{{ hierarchyDescriptorDialogue.label }} Description:
          {{ hierarchyDescriptorDialogue.node.name }}</v-card-title
        >
        <v-card-text
          ><v-textarea
            outlined
            clearable
            v-model="hierarchyDescriptorDialogue.text"
          ></v-textarea
        ></v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn @click="saveHierarchyDescriptor">Save</v-btn>
          <v-btn @click="hierarchyDescriptorDialogue.show = false"
            >Cancel</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="measureEditDialogue.show" max-width="800px">
      <v-card v-if="measureEditDialogue.show">
        <v-card-title>{{ measureEditDialogue.measure.title }} [{{ measureEditDialogue.measure.aggregation }}]</v-card-title>
        <v-card-text
          ><v-row>
            <v-col>
          <v-text-field
            outlined clearable
            v-model="measureEditDialogue.columnTitle" dense hide-details
            label="Column Title"
          ></v-text-field></v-col><v-col>
        <v-select 
            hide-details
            outlined
            dense
            v-model="measureEditDialogue.alignment" clearable
            label="Title Alignment"
            :items="['left','center','right']"
          ></v-select></v-col><v-col>
        <v-select 
            hide-details
            outlined
            dense
            v-model="measureEditDialogue.displayType" return-object
            label="Measure Display"
            :items="measureDisplayTypes.filter(x => x[measureEditDialogue.axis])" item-text="title" item-value="id"
          ></v-select></v-col>
          <v-col v-if="measureEditDialogue.measure.column === 'job_count'">
            <v-switch label="Hide Check Box?" v-model="measureEditDialogue.hideSelector"></v-switch>
            </v-col></v-row>
            <v-row><v-col>
          <v-text-field
            outlined clearable type="number"
            v-model="measureEditDialogue.alertLevelGT" dense hide-details
            label="Show Alert When >="
          ></v-text-field></v-col><v-col>
          <v-text-field
            outlined clearable type="number"
            v-model="measureEditDialogue.alertLevelLT" dense hide-details
            label="Show Alert When <="
          ></v-text-field></v-col><v-col>
          <v-text-field
            outlined clearable
            v-model="measureEditDialogue.alertLevelMessage" dense hide-details
            label="Alert Tooltip"
          ></v-text-field></v-col>
          </v-row>
          </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer>
          <v-btn @click="editMeasureSave"
            >Save</v-btn
          >
          <v-btn @click="measureEditDialogue.show = false"
            >Close</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog> -->
    <HierarchyNodeHistory :node="historyNode"> </HierarchyNodeHistory>

    <v-dialog v-model="sideBySide.show" style="max-height: 93%;">
      <DocumentSideBySide
        v-if="sideBySide.show"
        :items="sideBySide.items"
        :isDialogue="true"
        @close="sideBySide.show = false"
        @openContext="openDocActionsMenuContext"
      ></DocumentSideBySide>
    </v-dialog>
    <DocumentCompare
      :show="fullCompareView.show"
      :compareList="fullCompareView.items"
      :highlightChanges="fullCompareView.highlightChanges"
      multiDoc
      showWorkflowActions
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
      @nodata="fullCompareView.show = false"
      @close="fullCompareView.show = false"
    >
    </DocumentCompare>
    <v-dialog v-if="generateContentDialog2.show" v-model="generateContentDialog2.show" style="background-color: white">
      <v-card v-if="generateContentDialog2.node">
        <v-card-title>
          Content Generation - {{ generateContentDialog2.node.node.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            large
            class="btn-background"
            @click="generateContentDialog2.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <GenerateContent :node="generateContentDialog2.node" :prompt_chain="generateContentDialog2.prompt_chain" @accept="(data) => acceptContentGen(data)"/>
        </v-card-text>
      </v-card>
    </v-dialog>      

    <AdminHierarchyNodeDetail
      :node="hierarchyEditDialogue.node"
      :mode="hierarchyEditDialogue.mode"
      :action="hierarchyEditDialogue.action"
      :show="hierarchyEditDialogue.show"
      :showAddNodeDescriptor="hierarchyEditDialogue.showAddNodeDescriptor"
      :multiNodes="hierarchyEditDialogue.multiNodes"
      @close="hierarchyEditDialogue.show = false"
      @saved="nodeUpdated"
      @picked="nodePicked"
      @deleted="hierarchyEditDialogue.show = false"
    >
    </AdminHierarchyNodeDetail>

    <AdminHierarchyAdd
      :ht_id="hierarchyAddDialogue.ht_id"
      :show="hierarchyAddDialogue.show"
      @close="hierarchyAddDialogue.show = false"
      @saved="nodeUpdated"
    >
    </AdminHierarchyAdd>
    <DocActionsMenu
      :context="docActionsMenuContext"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocActionsMenu>
    <SaveViewDefinition
      :currentView="viewDefinition.view"
      :page="page"
      :saveTrigger="viewDefinition.saveTrigger"
      :saveAsTrigger="viewDefinition.saveAsTrigger"
      :inactiveTrigger="viewDefinition.inactiveTrigger"
      :editTrigger="viewDefinition.editTrigger"
      :permissions="permissions"
      @viewsLoaded="loadViews"
      @viewAdded="viewAdded"
      @viewInactive="viewInactive"
      @viewSaved="viewSaved"
      @cancel="viewEditCancelled"
    ></SaveViewDefinition>
    <AttributeValueAdmin
      :show="attributeAdmin.show"
      :attribute="attributeAdmin.attribute"
      :rawValues="attributeAdmin.rawValues"
      @updated="lookupUpdated"
      @created="lookupCreated"
    ></AttributeValueAdmin>
    <DocSummary
      :doc_id="documentSummary.doc_id"
      :trigger="documentSummary.trigger"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>
    <AdminHierarchyDetail
      :node="hr_idDialogue.node"
      :show="hr_idDialogue.show"
      @close="hr_idDialogue.show = false"
      @saved="hr_idDialogue.show = false"
    ></AdminHierarchyDetail>
    <v-bottom-sheet
      v-model="viewDefinition.showDesigner"
      hide-overlay
      persistent
    >
      <v-sheet
        ><v-card class="pl-4" v-if="selectedView">
          <v-tabs v-model="viewDefinition.tab">
            <v-tab> Filters </v-tab>
            <v-tab v-if="permissions.changeSettings"> Designer </v-tab>
            <v-spacer></v-spacer
            >
            <v-chip class="ma-3" label outlined>{{ selectedView.name }}</v-chip>
              <!-- <v-menu bottom close-on-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined small color="gray" class="ma-3" elevation="0"
                    >{{ selectedView.name }}<v-icon >mdi-menu-down</v-icon>
                  </v-btn> 
                </template
                ><v-list class="selectViewMenu">
                  <v-list-item v-if="views.some((x) => x.restricted)">
                    <v-list-item-title class="subtitle-1"
                      >My Views:</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    v-for="(v, vi) in views.filter((x) => x.restricted)"
                    :key="'vir' + vi"
                    @click="selectView(v)"
                  >
                    <v-list-item-content class="ml-3">{{
                      v.name
                    }}</v-list-item-content
                    ><v-list-item-icon
                      ><v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <div v-html="v.description"></div> </v-tooltip
                    ></v-list-item-icon>
                  </v-list-item>
                  <v-list-item v-if="views.some((x) => x.restricted)">
                    <v-list-item-title class="subtitle-1"
                      >Standard Views:</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    v-for="(v, vi) in views.filter((x) => !x.restricted)"
                    :key="'vi' + vi"
                    @click="selectView(v)"
                  >
                    <v-list-item-content
                      :class="views.some((x) => x.restricted) ? 'ml-3' : ''"
                      >{{ v.name }}</v-list-item-content
                    ><v-list-item-icon
                      ><v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <div v-html="v.description"></div> </v-tooltip
                    ></v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-menu> -->
            <template v-if="permissions.saveViewMain || permissions.saveViewOwn">              
                    <v-btn v-if="selectedView.isDirty &&
                      ((permissions.saveViewMain && !selectedView.restricted) ||
                        (permissions.saveViewOwn && selectedView.restricted))" 
                        @click="saveDefinition" small color="#eeeeee" class="ma-3" elevation="0">
                      Save View
                    </v-btn>
              <v-menu bottom close-on-click v-if="selectedView.isDirty">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small color="gray" class="ma-3" elevation="0"
                    >Changes<v-icon small>mdi-information</v-icon>
                  </v-btn> 
                </template
                >
                <v-list>
                  <v-list-item
                    >Changes:</v-list-item
                  >
                  <v-list-item v-if="selectedView.isDirty">
                    <ul>
                      <li
                        v-for="(c, ci) in getDefinitionChanges(selectedView)"
                        :key="'dc' + ci"
                        class="caption"
                      >
                        {{ c }}
                      </li>
                    </ul>
                  </v-list-item>
                </v-list>
              </v-menu>
                    <v-btn v-if="permissions.saveViewMain || permissions.saveViewOwn" 
                    @click="saveDefinitionAs()" small color="#eeeeee" class="ma-3" elevation="0">
                      Save View As...
                    </v-btn>
                    <v-btn v-if="selectedView.isDirty" 
                    @click="resetDefinition" small color="#eeeeee" class="ma-3" elevation="0"
                        >Reset View</v-btn
                      >
                    <!-- <v-btn v-if="(selectedView.restricted && permissions.saveViewOwn) ||
                      (permissions.saveViewMain &&
                        !selectedView.definition.isBase)" 
                        @click="deleteDefinition" small color="#eeeeee" class="ma-3" elevation="0"
                        >Delete View</v-btn
                      > -->
            </template>
            <v-icon class="pr-4" @click="viewDefinition.showDesigner = false"
              >mdi-close</v-icon
            >
          </v-tabs>
          <v-tabs-items v-model="viewDefinition.tab">
            <v-tab-item class="pa-4"
              ><v-container fluid>
                <template v-if="selectedView.definition.viewType === 'catalogue'">
                  <v-row>
                    <v-col
                      v-for="(f, fi) in verAxisAvailable.filter(
                        (x) => x.listValues && x.listValues.length
                      )"
                      :key="'f' + fi"
                      cols="2"
                    ><v-row dense><v-col>
                      <v-autocomplete
                        dense
                        hide-details
                        outlined
                        :items="f.listValuesFiltered"
                        v-model="f.filterValues"
                        @change="selectJDs(false, f)"
                        multiple
                        clearable
                        :title="f.name + ' Filter'"
                      >
                        <template v-slot:prepend>
                          <v-icon
                            v-if="f.tpa_id && f.listValues.length < 60"
                            small
                            @click="editAttributes(f)"
                            >mdi-format-list-numbered</v-icon
                          >
                        </template>
                        <template v-slot:label>
                          <span style="font-size: 13px">{{ f.name }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          <span
                            style="font-size: 13px"
                            v-if="item && index === 0"
                            class="blue--text text-caption"
                            :title="f.filterValues.join(', ')"
                          >
                            ({{ f.filterValues.length }} item{{
                              f.filterValues.length > 1 ? "s" : ""
                            }})
                          </span>
                        </template>
                        <!--<template v-slot:item="{ item }">
                          <span style="font-size: 13px">{{ item }}</span>
                        </template> -->
                      </v-autocomplete>
                      </v-col><v-col cols="1">
                      <v-checkbox v-model="f.visible" @click="updateViewDefinition"></v-checkbox>
                      </v-col></v-row>
                      </v-col
                    ></v-row
                  >
                  <v-row v-if="hierarchyPickerFilters.length">
                    <v-col
                      v-for="(hp, hpi) in hierarchyPickerFilters"
                      :key="'hp' + hpi"
                      cols="2"
                    ><v-row dense><v-col>
                      <HierarchyTreeFilter
                        :filter="hp"
                        dense
                        @change="filterChanged(hp)"
                      />
                      </v-col><v-col cols="1">
                      <v-checkbox v-model="hp.included" :title="'Show ' + hp.name + ' tree filter'" @click="toggleHierarchyPicker"></v-checkbox>
                      </v-col></v-row>
                      </v-col
                    ></v-row
                  >
                  <v-row>
                    <v-col cols="2">
                      <v-row dense><v-col>Measure</v-col></v-row>
                      <v-row dense v-for="(m, mi) in measureFilterTypeTitles" :key="'mftt' + mi">
                        <v-col style="min-height: 50px;">
                          <v-chip label outlined><v-icon left small>mdi-cube-outline</v-icon
                                    >{{ m.title }}</v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col :cols="mfti === 0 ? 2 : ''" v-for="(mft, mfti) in measureFilterTypes" :key="'mft' + mfti">
                      <v-row dense><v-col>{{ mft.name }}</v-col><v-col v-if="mfti === measureFilterTypes.length - 1"><v-btn class="float-right" small color="#eeeeee" elevation="0" @click="applyViewMeasureFilters">Apply Measure Filters</v-btn></v-col></v-row>
                      <v-row dense v-for="(m, mi) in mft.filters" :key="'mft' + mfti + 'f' + mi">
                        <template v-if="m">
                          <v-col v-if="mfti > 0"><v-select v-model="m.aggregation" label="Type:" :items="['sum','mean','count']" outlined dense hide-details></v-select></v-col>
                          <v-col><v-text-field prefix=">=" v-model="m.rangeFrom" type="number" outlined dense hide-details></v-text-field></v-col>
                          <v-col><v-text-field prefix="<=" v-model="m.rangeTo" type="number" outlined dense hide-details></v-text-field></v-col>
                          <v-col cols="1"><v-icon @click="resetViewMeasureFilterRange(m)">mdi-close-circle-outline</v-icon></v-col>
                          <v-col cols="1"><v-checkbox v-model="m.visible" @click="updateViewDefinition"></v-checkbox>
                          </v-col>
                        </template>
                        <v-col v-else style="min-height: 50px;">-</v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-container>
            </v-tab-item>
            <v-tab-item class="pa-4"
              ><v-container fluid>
                <template v-if="selectedView.definition.viewType === 'catalogue'">
                  <v-row>
                    <v-col>
                      <v-row style="border-bottom: 2px solid lightgray;">
                        <v-col cols="2"
                          ><v-select
                            hide-details label="Display Type"
                            outlined
                            dense
                            v-model="selectedView.definition.displayAs"
                            :items="layoutTypes" item-text="title" item-value="type"
                            @change="changeViewSetting('displayAs')"
                          ></v-select> 
                        </v-col>
                        <v-col cols="2"
                          ><v-select
                            hide-details label="Document Type"
                            outlined
                            dense
                            v-model="selectedView.definition.tmpl_id"
                            :items="docTypeSummary"
                            item-value="tmpl_id"
                            item-text="docType"
                            @change="changeViewSetting('tmpl_id')"
                          ></v-select></v-col
                        >
                        <v-col cols="3">
                          <v-text-field dense hide-details v-model="selectedView.definition.title" outlined @change="updateViewDefinition" clearable label="Title"></v-text-field>
                        </v-col>
                        <v-col>
                          <v-textarea dense hide-details v-model="selectedView.definition.description" outlined @change="updateViewDefinition" rows="1" clearable label="Description"></v-textarea>
                        </v-col>
                      </v-row>
                      <template v-if="selectedView.definition.displayAs.indexOf('grid') >= 0">
                        <v-row>
                          <v-col cols="2"></v-col>
                          <v-col cols="2"
                            ><v-select
                              hide-details label="Show Download"
                              outlined
                              dense
                              clearable
                              v-model="selectedView.definition.showDownload"
                              :items="['hidden','icon only','icon + title']" item-text="title" item-value="type"
                              @change="changeViewSetting('showDownload')"
                            ></v-select> 
                          </v-col>
                          <v-col cols="2">
                            <v-checkbox v-model="selectedView.definition.fullVerticalView" label="Show All Column Values (list view)?" dense hide-details @change="changeViewSetting('fullVerticalView')"></v-checkbox>
                            <v-checkbox v-model="selectedView.definition.allowColumnSort" label="Allow Vertical Column Sorting?" dense hide-details @change="changeViewSetting('allowColumnSort')"></v-checkbox>
                            <v-checkbox v-model="selectedView.definition.showTotalsRow" label="Totals Row visible?" dense hide-details @change="changeViewSetting('showTotalsRow')"></v-checkbox>
                          </v-col>
                          <v-col cols="2">
                            <v-checkbox v-model="selectedView.definition.showSubHeading" label="Show Sub Heading On Expansion?" dense hide-details @change="changeViewSetting('showSubHeading')"></v-checkbox>
                            <v-checkbox v-model="selectedView.definition.showTextSearch" label="Show Text Search?" dense hide-details @change="changeViewSetting('showTextSearch')"></v-checkbox>
                            <v-checkbox v-model="selectedView.definition.hideNodeActions" label="Hide Hierarchy Node Actions?" dense hide-details @change="changeViewSetting('hideNodeActions')"></v-checkbox>
                          </v-col>
                          <v-col cols="2"><v-select hide-details label="Gridlines"
                              outlined
                              dense
                              v-model="selectedView.definition.gridlines"
                              :items="['vertical only','horizontal only','vertical and horizontal','none']"
                              @change="changeViewSetting('gridlines')"
                            ></v-select><v-select hide-details label="Grid Width"
                              outlined
                              dense
                              v-model="selectedView.definition.gridWidth" 
                              :items="[{ text: '25%', value: 3 }, { text: '50%', value: 6 }, { text: '75%', value: 9 }, { text: '100%', value: 12 }]" item-text="text" item-value="value"
                              @change="changeViewSetting('gridWidth')"
                            ></v-select> </v-col>
                          <v-col cols="2"
                            ><v-select
                              hide-details label="Default Sort"
                              outlined
                              dense
                              clearable
                              v-model="defaultSortModel"
                              :items="defaultSortItems" item-text="text" item-value="value"
                            ></v-select><v-select v-if="defaultSortModel"
                              hide-details label="Sort Direction"
                              outlined
                              dense
                              v-model="defaultSortDirectionModel"
                              :items="[{ text: 'Ascending', value: 'asc' }, { text: 'Descending', value: 'desc' }]" item-text="text" item-value="value"
                            ></v-select><v-select
                              hide-details label="Axis Picker"
                              outlined multiple
                              dense
                              clearable
                              item-value="value" item-text="name" 
                              v-model="selectedView.definition.axisPickerOptions"
                              :items="verAxisAvailable"
                              @change="changeViewSetting('axisPickerOptions')"
                            ></v-select><v-select
                              hide-details label="Measure Picker"
                              outlined multiple
                              dense
                              clearable
                              item-value="id" item-text="title" 
                              v-model="selectedView.definition.measurePickerOptions"
                              :items="horizontalMeasures.filter(x => x.available)"
                              @change="changeViewSetting('measurePickerOptions')"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2"
                            >Vertical Axis Columns
                            <v-icon
                              small
                              @click="
                                removeAxisCompareOptionAll('verAxisSelected')
                              "
                              >mdi-delete</v-icon
                            ></v-col
                          >
                          <v-col
                            cols="2"
                            v-if="!verAxisSelected.length"
                            style="border-bottom: 2px solid lightgray"
                            ><HierarchyViewColumnPicker
                              :columnsAvailable="verAxisAvailable"
                              :index="0"
                              :columnType="'verAxisSelected'"
                              :columnSubject="'vertical axis'"
                              @addColumn="addAxisCompareOption"
                            ></HierarchyViewColumnPicker
                          ></v-col>
                          <v-col v-else
                            ><v-row style="border-bottom: 2px solid lightgray">
                              <v-col
                                v-for="(vc, vci) in verAxisSelected"
                                :key="'vc' + vci"
                                cols="3"
                              >
                                <HierarchyViewColumnPicker
                                  :column="
                                    getCompareOptionDef(vc, 'verAxisSelected')
                                  "
                                  :columnsAvailable="
                                    getOptionsAvailable('vertical')
                                  "
                                  :columnsUsed="
                                    getOptionsUsed('vertical')
                                  "
                                  :index="vci" allowPrefix allowTitleOverride allowIncludeInColumn allowDisplayType allowIncludeRangeColumn allowDefaultSort
                                  :defaultSort="columnDefaultSort(getCompareOptionDef(vc, 'verAxisSelected'))"
                                  @setDefaultSort="setColumnDefaultSort"
                                  :allowRemove="true"
                                  :allowAdd="getOptionsAvailable('vertical').length > 0"
                                  :allowShowDescriptor="columnSupportsDescriptor(getCompareOptionDef(vc, 'verAxisSelected'))"
                                  :allowStyling="permissions.saveViewMain"
                                  :columnType="'verAxisSelected'"
                                  :columnSubject="'vertical axis'"
                                  :defaultColours="{ font: '#000000FF', background: '#FFFFFF00' }"
                                  :measuresAvailable="measures"
                                  @changeColumn="setAxisCompareOption"
                                  @addColumn="addAxisCompareOption"
                                  @removeColumn="removeAxisCompareOption"
                                  @changeColumnStyle="setAxisCompareOptionStyle"
                                ></HierarchyViewColumnPicker> </v-col></v-row
                          ></v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2"
                            >Vertical Axis Measures
                            <v-icon
                              small
                              @click="
                                verticalMeasures.filter(x => x.visible).forEach(x => { x.visible = false; changeViewSetting('changeViewMeasure', 'verticalMeasures', x);})
                              "
                              >mdi-delete</v-icon
                            ></v-col
                          >
                          <v-col
                            cols="2"
                            v-if="!verticalMeasures.some(x => x.visible)"
                            style="border-bottom: 2px solid lightgray"
                            ><HierarchyViewMeasurePicker
                              :columnsAvailable="verticalMeasures.filter(x => x.available)"
                              :index="0"
                              @addColumn="(col) => { col.visible = true; changeViewSetting('changeViewMeasure', 'verticalMeasures', col); }"
                            ></HierarchyViewMeasurePicker
                          ></v-col>
                          <v-col v-else
                            ><v-row style="border-bottom: 2px solid lightgray">
                              <v-col
                                v-for="(vc, vci) in verticalMeasures.filter(x => x.visible)"
                                :key="'vc' + vci"
                                cols="3"
                              >
                                <HierarchyViewMeasurePicker
                                  :column="vc"
                                  :columnsAvailable="verticalMeasures.filter(x => x.available)"
                                  :columnsUsed="verticalMeasures.filter(x => x.visible)"
                                  :allowRemove="true"
                                  :allowAdd="true"
                                  allowDefaultSort
                                  :defaultSort="measureDefaultSort(vc)"
                                  :clientColours="clientColours"
                                  :measureDisplayTypes="measureDisplayTypes.filter(x => x.vertical)"
                                  :measuresAvailable="measures"
                                  @changeColumn="(col, prev) => { col.visible = true; prev.visible = false; changeViewSetting('changeViewMeasure', 'verticalMeasures', col); }"
                                  @addColumn="(col) => { col.visible = true; changeViewSetting('changeViewMeasure', 'verticalMeasures', col); }"
                                  @removeColumn="vc.visible = false; changeViewSetting('changeViewMeasure', 'verticalMeasures', vc);"
                                  @changeColumnStyle="(updates) => saveMeasure(vc, updates, 'vertical')"
                                ></HierarchyViewMeasurePicker> </v-col></v-row
                          ></v-col>
                        </v-row>
                        <!-- <v-row style="border-bottom: 1px solid gray;">
                          <v-col cols="2">Vertical Measures</v-col>
                          <v-col v-if="verAxisSelected.length">
                            <v-row>
                              <v-col v-for="(m, mi) in verticalMeasures.filter(x => x.available)" :key="'me' + mi">
                                <v-chip label outlined
                                  ><v-icon left small>mdi-cube-outline</v-icon
                                  >{{ m.title }} ({{ m.derivation || m.aggregation }})<v-switch
                                  v-model="m.visible"
                                  hide-details dense class="ml-4 mt-0"
                                  @change="changeViewSetting('changeViewMeasure', 'verticalMeasures', m)"
                                ></v-switch>
                                  <v-icon v-if="m.visible" right small @click="editMeasure(m, 'vertical')">mdi-cog</v-icon>
                                  </v-chip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row> -->
                        <v-row 
                          ><v-col cols="2"
                            >Horizontal Axis Columns
                            <v-icon
                              small
                              @click="
                                removeAxisCompareOptionAll('horAxisSelected')
                              "
                              >mdi-delete</v-icon
                            ></v-col
                          ><v-col
                            cols="2"
                            v-if="!horAxisSelected.length"
                            style="border-bottom: 2px solid lightgray"
                            ><HierarchyViewColumnPicker
                              :columnsAvailable="horAxisAvailable"
                              :index="0"
                              :columnType="'horAxisSelected'"
                              :columnSubject="'horizontal axis'"
                              @addColumn="addAxisCompareOption"
                            ></HierarchyViewColumnPicker></v-col
                          ><v-col v-else
                            ><v-row
                            style="border-bottom: 2px solid lightgray"
                              ><v-col
                                cols="3"
                                v-for="(hc, hci) in horAxisSelected"
                                :key="'hc' + hci"
                              >
                                <HierarchyViewColumnPicker
                                  :column="
                                    getCompareOptionDef(hc, 'horAxisSelected')
                                  "
                                  :columnsAvailable="
                                    getOptionsAvailable('horizontal')
                                  "
                                  :columnsUsed="
                                    getOptionsUsed('horizontal')
                                  "
                                  :allowTitleOverride="hci === 0"
                                  :index="hci" allowPrefix
                                  :allowRemove="true"
                                  :allowAdd="horAxisSelected.length <= 3"
                                  :allowStyling="permissions.saveViewMain"
                                  :columnType="'horAxisSelected'"
                                  :columnSubject="'horizontal axis'"
                                  :defaultColours="{ font: '#000000FF', background: '#eeeeeeFF' }"
                                  @changeColumn="setAxisCompareOption"
                                  @addColumn="addAxisCompareOption"
                                  @removeColumn="removeAxisCompareOption"
                                  @changeColumnStyle="setAxisCompareOptionStyle"
                                ></HierarchyViewColumnPicker> </v-col></v-row></v-col
                        ></v-row>
                        <v-row>
                          <v-col cols="2"
                            >Horizontal Measures
                            <v-icon
                              small
                              @click="
                                horizontalMeasures.filter(x => x.visible).forEach(x => { x.visible = false; changeViewSetting('changeViewMeasure', 'horizontalMeasures', x);})
                              "
                              >mdi-delete</v-icon
                            >
                            <v-checkbox v-model="selectedView.definition.horizontalHeadingVisible" label="Headings?" dense hide-details @change="changeViewSetting('horizontalHeadingVisible')"></v-checkbox></v-col
                          >
                          <v-col
                            cols="2"
                            v-if="!horizontalMeasures.some(x => x.visible)"
                            style="border-bottom: 2px solid lightgray"
                            ><HierarchyViewMeasurePicker
                              :columnsAvailable="horizontalMeasures.filter(x => x.available)"
                              :index="0"
                              @addColumn="(col) => { col.visible = true; changeViewSetting('changeViewMeasure', 'horizontalMeasures', col); }"
                            ></HierarchyViewMeasurePicker
                          ></v-col>
                          <v-col v-else
                            ><v-row style="border-bottom: 2px solid lightgray">
                              <v-col
                                v-for="(vc, vci) in horizontalMeasures.filter(x => x.visible)"
                                :key="'vc' + vci"
                                cols="3"
                              >
                                <HierarchyViewMeasurePicker
                                  :column="vc"
                                  :columnsAvailable="horizontalMeasures.filter(x => x.available)"
                                  :columnsUsed="horizontalMeasures.filter(x => x.visible)"
                                  :allowRemove="true"
                                  :allowAdd="true"
                                  :clientColours="clientColours"
                                  :measureDisplayTypes="measureDisplayTypes.filter(x => x.vertical)"
                                  :measuresAvailable="measures"
                                  @changeColumn="(col, prev) => { col.visible = true; prev.visible = false; changeViewSetting('changeViewMeasure', 'horizontalMeasures', col); }"
                                  @addColumn="(col) => { col.visible = true; changeViewSetting('changeViewMeasure', 'horizontalMeasures', col); }"
                                  @removeColumn="vc.visible = false; changeViewSetting('changeViewMeasure', 'horizontalMeasures', vc);"
                                  @changeColumnStyle="(updates) => saveMeasure(vc, updates, 'horizontal')"
                                ></HierarchyViewMeasurePicker> </v-col></v-row
                          ></v-col>
                        </v-row>
                        <!-- <v-row
                            style="border-bottom: 2px solid lightgray">
                          <v-col cols="2">Horizontal Measures</v-col>
                          <v-col v-if="horAxisSelected.length">
                            <v-row>
                              <v-col v-for="(m, mi) in horizontalMeasures" :key="'me' + mi">
                                <v-chip label outlined
                                  ><v-icon left small>mdi-cube-outline</v-icon
                                  >{{ m.title }} ({{ m.derivation || m.aggregation }})<v-switch
                                  v-model="m.visible"
                                  hide-details dense class="ml-4 mt-0"
                                  @change="changeViewSetting('changeViewMeasure', 'horizontalMeasures', m)"
                                ></v-switch>
                                  <v-icon v-if="m.visible" right small @click="editMeasure(m, 'horizontal')">mdi-cog</v-icon>
                                  </v-chip
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row> -->
                        <v-row style="border-bottom: 1px solid gray;"
                          ><v-col cols="2"
                            >Detail Axis Columns
                            <v-icon
                              small
                              @click="
                                removeAxisCompareOptionAll('detAxisSelected')
                              "
                              >mdi-delete</v-icon
                            ></v-col
                          ><v-col v-if="!detAxisSelected.length"
                            ><HierarchyViewColumnPicker
                              :columnsAvailable="detAxisAvailable"
                              :index="0"
                              :columnType="'detAxisSelected'"
                              :columnSubject="'drilldown'"
                              @addColumn="addAxisCompareOption"
                            ></HierarchyViewColumnPicker
                          ></v-col>
                          <v-col v-else
                            ><v-row>
                              <v-col
                                v-for="(dc, dci) in detAxisSelected"
                                :key="'dc' + dci"
                                cols="3" style="border-bottom: 2px solid lightgray"
                                ><HierarchyViewColumnPicker
                                  :column="
                                    getCompareOptionDef(dc, 'detAxisSelected')
                                  "
                                  :columnsAvailable="getOptionsAvailable('detail')"
                                  :columnsUsed="
                                    getOptionsUsed('detail')
                                  "
                                  :index="dci" allowPrefix allowTitleOverride allowShowTitle allowDisplayType allowIncludeInColumn
                                  :allowRemove="true"
                                  :allowAdd="detAxisSelected.length <= 7"
                                  :columnType="'detAxisSelected'"
                                  :columnSubject="'drilldown'"
                                  @changeColumn="setAxisCompareOption"
                                  @addColumn="addAxisCompareOption"
                                  @removeColumn="removeAxisCompareOption"
                                  @changeColumnStyle="setAxisCompareOptionStyle"
                                ></HierarchyViewColumnPicker> </v-col></v-row></v-col
                        ></v-row>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row v-if="selectedView.definition.displayAs.indexOf('bar chart') >= 0"  style="padding-top: 10px;">
                    <v-col cols="1">Sections:</v-col>
                    <v-col cols="1">
                        <v-btn @click="addChart('bar_chart')" small color="#eeeeee" class="ma-3" elevation="0">Add Bar Chart</v-btn>
                        <v-btn @click="addChart('pie_chart')" small color="#eeeeee" class="ma-3" elevation="0">Add Pie Chart</v-btn>
                        <v-btn @click="addTaskList" small color="#eeeeee" class="ma-3" elevation="0">Add Task List</v-btn>
                        <v-btn @click="addStatistic" small color="#eeeeee" class="ma-3" elevation="0">Add Statistic</v-btn>
                    </v-col>
                    <v-col>
                      <template v-for="(row,ri) in viewSectionsDesign">
                        <v-row :key="'sr' + ri">
                          <v-col v-for="(column, ci) in row.cols" 
                            :key="'sr' + ri + 'c' + ci"
                            :cols="column.colWidth" style="border: solid 1px lightgray;">
                            <v-row v-for="(section, ii) in column.sections" :key="'sr' + ri + 'c' + ci + 'section' + ii">
                              <v-col :title="'Row: ' + section.rowPosition + '; Column: ' + section.colPosition + '; Width: ' + section.colWidth + ';'">
                                <v-chip
                                  :outlined="section.isEdited" label class="mr-4 mb-2"
                                  @click="editViewItem(section)">
                                  <v-avatar left><v-icon>mdi-{{ section.type === 'bar_chart' ? 'chart-bar' : section.type === 'pie_chart' ? 'chart-donut' : section.type === 'statistic' ? 'card-outline' : 'list-box-outline' }}</v-icon></v-avatar>
                                  {{ section.title }}
                                </v-chip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </template>
                      <v-row v-if="chartEdit.show" style="padding-top: 20px;">
                        <v-col style="border: 1px solid lightgray; border-radius: 16px;">
                          <v-row dense>
                            <v-col cols="2"><v-select :items="horAxisAvailable" item-value="name" item-text="name" label="x Axis" v-model="chartEdit.xAxis" dense hide-details outlined></v-select></v-col>
                            <v-col cols="2" v-if="chartEdit.type === 'bar_chart'"><v-select :items="horAxisAvailable" item-value="name" item-text="name" clearable label="Y Axis" v-model="chartEdit.yAxis" dense hide-details outlined></v-select></v-col>
                            <v-col><v-select :items="measures" label="Measure" item-value="column" item-text="title" v-model="chartEdit.measure" dense hide-details outlined></v-select></v-col>
                            <v-col v-if="chartEdit.type === 'bar_chart'"><v-switch v-model="chartEdit.useRange" label="Show Range" dense hide-details></v-switch></v-col>
                            <v-col v-if="chartEdit.type === 'bar_chart'"><v-text-field type="number" label="Last X Periods" v-model="chartEdit.rangeQuantity" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="1"><v-btn @click="saveChart" :disabled="!chartEdit.xAxis || !chartEdit.measure" small color="#eeeeee" class="ma-3" elevation="0">Save</v-btn>
                            <v-icon @click="clearViewSectionEdit">mdi-close</v-icon></v-col>
                          </v-row>
                          <v-row dense>
                            <!-- <v-col cols="2"><v-text-field label="X Axis Prefix" v-model="chartEdit.xAxisPrefix" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="2" v-if="chartEdit.type === 'bar_chart'"><v-text-field label="Y Axis Prefix" v-model="chartEdit.yAxisPrefix" dense hide-details outlined></v-text-field></v-col> -->
                            <v-col cols="2"><v-text-field label="Title" v-model="chartEdit.title" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="4"><v-text-field label="Description" v-model="chartEdit.description" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="2"><v-text-field label="Link URL" v-model="chartEdit.link" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="2"><v-text-field label="Link Title" v-model="chartEdit.linkTitle" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="1"><v-btn v-if="this.chartEdit.existingIndex < 0" @click="removeChart" small color="#eeeeee" class="ma-3" elevation="0">Remove</v-btn></v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="6">
                              <v-select :items="verAxisAvailable.filter((x) => x.listValues && x.listValues.length)"
                                item-value="value" item-text="name" 
                                label="Filter Columns"
                                multiple v-model="chartEdit.filtersVisible" dense hide-details outlined></v-select></v-col>
                                <v-col><v-text-field type="number" v-model="chartEdit.rowPosition" label="Row Number"></v-text-field></v-col>
                                <v-col><v-text-field type="number" v-model="chartEdit.colPosition" label="Column Position"></v-text-field></v-col>
                                <v-col><v-text-field type="number" v-model="chartEdit.colWidth" clearable label="Column Width"></v-text-field></v-col>
                                <!-- <v-col><v-text-field type="number" v-model="chartEdit.rowHeight" label="Row Height"></v-text-field></v-col> -->
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row v-if="taskEdit.show" style="padding-top: 20px;">
                        <v-col style="border: 1px solid lightgray; border-radius: 16px;">
                          <v-row dense>
                            <v-col>
                              <v-select :items="utils.taskListFields" item-value="value" item-text="text" 
                              label="Default Visible Columns"
                              multiple v-model="taskEdit.columnsVisible" dense hide-details outlined></v-select></v-col>
                            <v-col cols="2"><v-select :items="statusFilterOptions" item-value="value" item-text="text" label="Default View" v-model="taskEdit.defaultView" dense hide-details outlined></v-select></v-col>
                            <v-col cols="2"><v-text-field label="Title" v-model="taskEdit.title" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="1"><v-btn @click="saveTaskList" :disabled="!taskEdit.columnsVisible.length || !taskEdit.defaultView || !taskEdit.title" small color="#eeeeee" class="ma-3" elevation="0">Save</v-btn>
                            <v-icon @click="clearViewSectionEdit">mdi-close</v-icon></v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="8">
                              <v-select :items="utils.taskListFields" item-value="value" item-text="text" 
                              label="Filter Columns"
                              multiple v-model="taskEdit.filtersVisible" dense hide-details outlined></v-select></v-col>
                            <v-col cols="2"><v-text-field label="Description" v-model="taskEdit.description" dense hide-details outlined></v-text-field></v-col>
                            <v-col cols="1"><v-btn v-if="this.taskEdit.existingIndex >= 0" @click="removeTaskList" small color="#eeeeee" class="ma-3" elevation="0">Remove</v-btn></v-col>
                          </v-row>
                          <v-row>
                            <v-col><v-text-field type="number" v-model="taskEdit.rowPosition" label="Row Number"></v-text-field></v-col>
                            <v-col><v-text-field type="number" v-model="taskEdit.colPosition" label="Column Number"></v-text-field></v-col>
                            <v-col><v-text-field type="number" v-model="taskEdit.colWidth" clearable label="Column Width"></v-text-field></v-col>
                            <!-- <v-col><v-text-field type="number" v-model="taskEdit.rowHeight" label="Row Height"></v-text-field></v-col> -->
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row v-if="statisticEdit.show" style="padding-top: 20px;">
                        <v-col style="border: 1px solid lightgray; border-radius: 16px;">
                          <v-row dense>
                            <v-col><v-text-field label="Title" v-model="statisticEdit.title" dense hide-details outlined></v-text-field></v-col>
                            <v-col><v-text-field label="Description" v-model="statisticEdit.description" dense hide-details outlined></v-text-field></v-col>
                            <v-col><v-text-field label="Icon" v-model="statisticEdit.icon" dense hide-details outlined></v-text-field></v-col>
                            <v-col><v-text-field label="Background Colour" v-model="statisticEdit.backgroundColour" dense hide-details outlined></v-text-field></v-col>
                            <v-col><v-text-field label="Icon Colour" v-model="statisticEdit.iconColour" dense hide-details outlined></v-text-field></v-col>
                            <v-col><v-switch label="Use Status Icon?" v-model="statisticEdit.useStatusIcon" dense hide-details outlined></v-switch></v-col>
                            <v-col cols="1"><v-btn @click="saveStatistic" :disabled="!statisticEdit.title || !statisticEdit.description || !statisticEdit.icon" small color="#eeeeee" class="ma-3" elevation="0">Save</v-btn>
                            <v-icon @click="clearViewSectionEdit">mdi-close</v-icon></v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="2"><v-select label="Statistic" :items="['sum','percent']" v-model="statisticEdit.displayBasis" dense hide-details outlined></v-select></v-col>
                            <v-col cols="1" style="text-align: center; padding-top: 12px;">Of</v-col>
                            <v-col cols="3"><v-select label="Target View" :items="views" v-model="statisticEdit.view" item-text="name" item-value="view_definition_id" dense hide-details outlined></v-select></v-col>
                            <template v-if="statisticEdit.viewType !== 'similarity'">
                              <v-col cols="1" style="text-align: center; padding-top: 12px;">where</v-col>
                            <v-col><v-select label="Statistic Value" :items="statisticEdit.availableMeasures" v-model="statisticEdit.criteriaMeasure" item-text="name" item-value="name" dense hide-details outlined></v-select></v-col>
                            <v-col cols="1"><v-select label="Comparator" :items="['>=','=','<=']" v-model="statisticEdit.criteriaComparator" dense hide-details outlined></v-select></v-col>
                            <v-col cols="1"><v-text-field label="Value" v-model="statisticEdit.criteriaValue" dense hide-details outlined></v-text-field></v-col>
                            </template>
                          </v-row>
                          <v-row dense>
                            <v-col>Show Tick if statistic</v-col>
                            <v-col cols="1">
                              <v-select :items="['>=','=','<=']" v-model="statisticEdit.includeGoodTriggerComparator" dense hide-details outlined></v-select>
                            </v-col>
                            <v-col cols="1">
                              <v-text-field dense hide-details outlined clearable v-model="statisticEdit.includeGoodTrigger"></v-text-field>
                            </v-col>
                            <v-col>Show Error if statistic</v-col>
                            <v-col cols="1">
                              <v-select :items="['>=','=','<=']" v-model="statisticEdit.includeErrorTriggerComparator" dense hide-details outlined></v-select>
                            </v-col>
                            <v-col cols="1">
                              <v-text-field dense hide-details outlined clearable v-model="statisticEdit.includeErrorTrigger"></v-text-field>
                            </v-col>
                            <v-col>Show Warning if statistic</v-col>
                            <v-col cols="1">
                              <v-select :items="['>=','=','<=']" v-model="statisticEdit.includeWarningTriggerComparator" dense hide-details outlined></v-select>
                            </v-col>
                            <v-col cols="1">
                              <v-text-field dense hide-details outlined clearable v-model="statisticEdit.includeWarningTrigger"></v-text-field>
                            </v-col>
                            <v-col><v-switch label="Hide Statistic if zero" v-model="statisticEdit.hideZeroStatistic"></v-switch></v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="1">Filters: </v-col>
                            <v-col>
                              <v-chip v-for="(f,fi) in statisticEdit.filters" :key="'sf' + fi" @click="editStatisticFilter(f)">
                              {{ statisticEdit.editFilter.availableFilters.find(x => x.column === f.column)?.name }}: {{ f.filterValues.length ? f.filterValues.join(' | ') : f.filterComparator + " " + f.filterValue }}</v-chip>
                              <v-btn  small color="#eeeeee" elevation="0" @click="addStatisticFilter">Add Filter</v-btn>
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col><v-text-field type="number" v-model="statisticEdit.rowPosition" label="Row Number"></v-text-field></v-col>
                            <v-col><v-text-field type="number" v-model="statisticEdit.colPosition" label="Column Number"></v-text-field></v-col>
                            <v-col><v-text-field type="number" v-model="statisticEdit.colWidth" clearable label="Column Width"></v-text-field></v-col>
                            <v-col cols="1"><v-btn v-if="this.statisticEdit.existingIndex >= 0" @click="removeStatistic" small color="#eeeeee" class="ma-3" elevation="0">Remove</v-btn></v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              <v-row v-if="['linked','similarity'].some(x => x ===selectedView.definition.viewType)">
                <v-col>                  
                    <v-card
                      ><v-card-subtitle>
                        <v-row>
                          <v-col
                            ><span
                              style="cursor: pointer; font-weight: bold"
                              ><v-icon class="pr-4">mdi-information</v-icon
                              >{{ getSimDescription() }}</span
                            ></v-col
                          >
                        </v-row>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row
                          ><v-col cols="3"
                            ><v-select
                              v-if="selectedView.definition.linked_doc_view"
                              :items="docTypeSummary"
                              label="Document Types:"
                              item-text="docType"
                              item-value="tmpl_id"
                              outlined
                              multiple
                              hide-details
                              dense
                              v-model="selectedView.definition.templates"
                              @change="setSimDirty('changeDocType')"
                            ></v-select
                            ><v-select
                              v-else
                              :items="docTypeSummary"
                              label="Document Type:"
                              item-text="docType"
                              item-value="tmpl_id"
                              outlined
                              hide-details
                              dense
                              v-model="selectedView.definition.tmpl_id"
                              @change="setSimDirty('changeDocType')"
                            ></v-select
                          ></v-col>
                          <v-col cols="3">
                            <v-select
                              v-model="selectedView.definition.statuses"
                              :items="similarityData.docStatusList"
                              item-text="doc_status_text"
                              item-value="doc_status_text"
                              label="Document Statuses"
                              multiple
                              outlined
                              hide-details
                              :menu-props="{
                                closeOnContentClick: false,
                                maxHeight: '400',
                                'offset-y': true,
                              }"
                              dense
                              @change="setSimDirty('filterMatches')"
                            >
                            </v-select></v-col
                          >
                          <v-col cols="3">
                            <v-select
                              v-model="selectedView.definition.matchLevels"
                              :items="similarityData.matchLevels"
                              item-text="name"
                              item-value="name"
                              label="Match Levels"
                              multiple
                              outlined
                              hide-details
                              :menu-props="{
                                closeOnContentClick: false,
                                maxHeight: '400',
                                'offset-y': true,
                              }"
                              dense
                              clearable
                              @change="setSimDirty('filterMatches')"
                            >
                            </v-select></v-col
                          >
                          <v-col cols="3">
                            <v-select
                              v-model="
                                selectedView.definition.columnsVisible
                              "
                              :items="detailColumns"
                              item-text="text"
                              item-value="value"
                              label="Columns Visible"
                              multiple
                              outlined
                              hide-details
                              :menu-props="{
                                closeOnContentClick: false,
                                maxHeight: '400',
                                'offset-y': true,
                              }"
                              dense
                              @change="setSimDirty('setColumns')"
                            >
                            </v-select></v-col
                          >
                      <v-col>
                        <v-text-field dense hide-details v-model="selectedView.definition.title" outlined @change="updateViewDefinition" rows="2" clearable label="Title"></v-text-field>
                      </v-col>
                      <v-col>
                        <v-textarea dense hide-details v-model="selectedView.definition.description" outlined @change="updateViewDefinition" rows="2" clearable label="Description"></v-textarea>
                      </v-col>
                      <v-col
                          v-if="
                            !selectedView.definition.linked_doc_view
                          "><v-switch label="Use Title Row?" @change="updateViewDefinition" v-model="selectedView.definition.showSimilarityTitleRow"></v-switch></v-col>
                      <v-col
                          v-if="
                            !selectedView.definition.linked_doc_view || similarityData.showLinkSimilarity
                          "><v-switch label="Show Match Scores?" @change="updateViewDefinition" v-model="selectedView.definition.showMatchScores"></v-switch></v-col>
                      <v-col
                          v-if="
                            selectedView.definition.linked_doc_view && similarityData.showLinkSimilarity
                          "><v-switch label="Multi Colour Scores?" @change="updateViewDefinition" v-model="selectedView.definition.showLinkSimilarityColours"></v-switch></v-col>
                      </v-row>
                        <v-row
                          v-if="
                            !selectedView.definition.linked_doc_view
                          "
                        >
                          <v-col cols="6"
                            ><v-radio-group
                              row
                              v-model="selectedView.definition.name_match"
                              @change="setSimDirty('filterMatches')"
                              ><v-radio
                                v-for="c in similarityData.similarityColumnsName"
                                :key="c.column"
                                :label="c.label"
                                :value="c.column"
                              ></v-radio></v-radio-group
                          ></v-col>
                          <v-col cols="6"
                            ><v-radio-group
                              row
                              v-model="
                                selectedView.definition.content_match
                              "
                              @change="setSimDirty('filterMatches')"
                              ><v-radio
                                v-for="c in similarityData.similarityColumnsContent"
                                :key="c.column"
                                :label="c.label"
                                :value="c.column"
                              ></v-radio></v-radio-group
                          ></v-col>
                        </v-row>
                        <!-- <v-row v-if="filterList.length"
                          ><v-col>
                            <v-chip
                              small
                              v-for="(f, fi) in filterList"
                              :key="'f' + fi"
                              close
                              @click:close="removeColumnFilter(f)"
                            >
                              {{ f.title }}</v-chip
                            ></v-col
                          ></v-row
                        > -->
                        </v-card-text
                      >
                    </v-card>
                </v-col>
              </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog v-model="statisticEdit.editFilter.show" max-width="900px" style="background-color: white">
      <v-card>
        <v-card-title>
          Filter
          <v-spacer></v-spacer>
          <v-btn v-if="statisticEdit.editFilter.filter"
            class="btn-background mr-2"
            @click="saveStatisticFilter(true)"
          >Remove
            <v-icon>mdi-bin</v-icon>
          </v-btn>
          <v-btn :disabled="!canSaveStatisticFilter()"
            class="btn-background mr-2"
            @click="saveStatisticFilter(false)"
          >Save
            <v-icon>mdi-save</v-icon>
          </v-btn>
          <v-btn
            class="btn-background"
            @click="statisticEdit.editFilter.show = false"
          >Cancel
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col><v-select :items="statisticEdit.editFilter.availableFilters" label="Filters Available" item-text="name" item-value="column" v-model="statisticEdit.editFilter.column" outlined hide-details dense
            @change="setStatisticEditFilterType"></v-select></v-col>
          </v-row>
          <v-row dense>
            <template v-if="statisticEdit.editFilter.data_type === 'number'">
              <v-col cols="3"><v-select label="Comparator" :items="['>=','=','<=']" v-model="statisticEdit.editFilter.filterComparator" dense hide-details outlined></v-select></v-col>
              <v-col cols="3"><v-text-field label="Value" v-model="statisticEdit.editFilter.filterValue" dense hide-details outlined></v-text-field></v-col>
            </template>
            <v-col v-else>
              <v-autocomplete
                dense
                hide-details
                outlined
                :items="getFilterListValues()"
                v-model="statisticEdit.editFilter.filterValues"
                multiple
                clearable
              >
              </v-autocomplete></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="drillDownDialogue.show"
      max-width="80%" style="background-color: white"
      scrollable
    >
      <v-card>
        <v-card-title>
          <v-row>
              <v-col>
                <div class="rm-view-title">{{drillDownDialogue.title}}</div>
                <div class="drilldown-sub-title" :style="'border-color: ' + drillDownDialogue.titleColour">
                  <v-icon v-if="drillDownDialogue.titleIcon" small :color="drillDownDialogue.titleColour" class="mr-2">{{ drillDownDialogue.titleIcon}}</v-icon>
                  <span>{{drillDownDialogue.measureTitle}}</span>
                  <span class="drilldown-sub-title-stat ml-4">
                     {{ drillDownDialogue.titleValue }} 
                  </span>
                </div>
              </v-col>
              <v-col cols="5" v-if="drillDownDialogue.alert">
                <div class="drilldown-alert-container"><v-icon class="mr-2">mdi-alert</v-icon>{{ drillDownDialogue.alert }}</div>
              </v-col>
              <v-col cols="1" v-if="drillDownStack.show">   
                <v-btn class="float-right" outlined
                @click="revertCategoryDrilldown"><v-icon>mdi-arrow-left</v-icon> Back to {{ drillDownStack.title }}</v-btn>
            </v-col>
              <v-col cols="1">   
                <v-icon class="float-right"
                @click="drillDownDialogue.show = false">mdi-close</v-icon>
            </v-col>
          </v-row>
          </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col>
              <div class="drilldown-section">
                <div class="drilldown-section-title">{{ drillDownDialogue.analysisTitle + " Analysis" }}</div>
                <div v-for="(ck, cki) in drillDownDialogue.detailColourKey" :key="'ck' + cki" class="highlight-legend-container">
                  <div class="highlight-legend-box" :style="ck.style"></div>
                  <div class="highlight-legend-text">{{ ck.label }}</div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="pr-6">
              <v-row no-gutters>
                <v-col v-if="drillDownDialogue.summaryView" cols="3"></v-col>
                <v-col>
                  <rmTable
                    :columns="drillDownDialogue.analysisHeadings"
                    :rows="drillDownDialogue.analysisRows"
                    :maxHeight="400"
                    :hideFilter="true"
                    :hideSort="true"
                  ></rmTable>  
                </v-col>
                <v-col v-if="drillDownDialogue.summaryView" cols="3"></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-row no-gutters>
                    <v-col>
                      <div class="drilldown-section">
                        <div class="drilldown-section-title">{{ drillDownDialogue.analysisTitle + " Distribution" }}</div>
                      </div>
                    </v-col>
                    <v-col>
                      <div class="float-right drilldown-section drilldown-section-label" v-if="drillDownDialogue.summaryView">Click graph for drilldown</div>
                    </v-col>
                  </v-row>
                  <div class="drilldown-chart-container">
                    <boxplot 
                      :datasets="drillDownDialogue.datasets" 
                      :labels="drillDownDialogue.labels" 
                      :match_keys="drillDownDialogue.match_keys" 
                      :width="drillDownDialogue.summaryView ? 1400 : 700" 
                      :height="400"
                      :showLegend="false"
                      @chartClick="doCategoryDrilldown"></boxplot>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" v-if="!drillDownDialogue.summaryView">
              <v-row>
                <v-col>
                  <rmTable
                    :columns="drillDownDialogue.docHeadings"
                    :rows="drillDownDialogue.documents"
                    rowClickDocSummary
                    :hideFilter="true"
                    :hideSort="true"
                    :hideActionColumn="true"
                    :groupColumns="['quartile']"
                    :expandGroups="['first','last']"
                  ></rmTable>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import utils from "@/common/utils.js";
// import HierarchySearch from "@/components/cHierarchySearch";
import { mapState } from "vuex";
// import * as d3 from "d3";
import dayJS from "dayjs";
// import * as similarity from "string-similarity";
// const d3 = require("d3");
import DocumentSideBySide from "@/components/cDocumentSideBySide.vue";
// import Pagination from "@/components/cPagination";
// import PageDescription from "@/components/cPageDescription";
import AdminHierarchyNodeDetail from "@/components/hierarchy/cAdminHierarchyNodeDetail";
import AdminHierarchyAdd from "@/components/hierarchy/cAdminHierarchyAdd";
import axios from "axios";
import HierarchyTreeNodeAudit from "@/components/hierarchy/cHierarchyTreeNodeAudit";
import DateRangePicker from "@/components/common/DateRangePicker";
import DocStatus from "@/components/common/DocStatus";
import DatePicker from "@/components/common/DatePicker";
import DocActionsMenu from "@/components/common/DocActionsMenu";
import DocumentCompare from "@/components/document/DocumentCompare";
import DocListMenu from "@/components/common/DocListMenu";
import HierarchyNodeHistory from "@/components/hierarchy/cHierarchyNodeHistory";
import SaveViewDefinition from "@/components/jobArchitecture/saveViewDefinition";
import AttributeValueAdmin from "@/components/jobArchitecture/attributeValueAdmin";
import DocSummary from "@/components/common/DocViewPopUp";
import AdminHierarchyDetail from "@/components/hierarchy/cAdminHierarchyDetail";
import HierarchyViewColumnHeading from "@/components/jobArchitecture/HierarchyViewColumnHeadingAlt";
// import HierarchyViewColumnDetail from "@/components/jobArchitecture/HierarchyViewColumnDetailAlt";
import HierarchyViewColumnPicker from "@/components/cHierarchyViewColumnPicker";
import TagCompare from "@/components/jobArchitecture/TagCompare";
import RowHeaders from "@/components/jobArchitecture/RowHeaders";
import RowDetails from "@/components/jobArchitecture/RowDetails";
import RowMeasures from "@/components/jobArchitecture/RowMeasures";
import SimilarityView from "@/components/jobArchitecture/similarityAnalysisAlt";
import TaskList from "@/components/jobArchitecture/TaskList";
import FilterOptions from "@/components/jobArchitecture/FilterOptions";
import HierarchyTreeFilter from "@/components/jobArchitecture/HierarchyTreeFilter";
import { Bar, Doughnut } from 'vue-chartjs';
import { json } from 'd3';
import jaCommon from "@/components/jobArchitecture/common.js";
import GenerateContent from "@/components/common/GenerateContent";
import HierarchyViewMeasurePicker from "@/components/jobArchitecture/HierarchyViewMeasurePicker";
import boxplot from "@/components/common/BoxPlotChart";
import rmTable from "@/components/common/TableAlt";
import MeasureDisplay from "@/components/jobArchitecture/MeasureDisplay.vue";

// import Tasks from "@/components/cTasks";

let _descriptors = {};
let _nodeDescriptorMap = null;
let _documents = {};
let _reviewNodes = {};
let _hierarchyTypeNodes = {};
// let _reviewDocuments = {};
const _newTitle = "< New >";
const _page = "HierarchyViewAlt";
const _defaultHeaderColours = {
          color: "#000000FF",
          backgroundColor: "#EEEEEEFF",
        };
// canonical px-per-character used to convert content-derived column lengths to px widths
const _pxPerChar = 8;
// base px width of one horizontal-axis leaf column (multiplied by display.h_col.colWidth)
const _hLeafBasePx = 150;
const _minColumnPx = 40;

export default {
  name: "HierarchyViewAlt",
  components: {
    ResponseHandler,
    // HierarchySearch,
    DocumentSideBySide,
    // Pagination,
    // PageDescription,
    AdminHierarchyNodeDetail,
    AdminHierarchyAdd,
    HierarchyTreeNodeAudit,
    DateRangePicker,
    DocStatus,
    DatePicker,
    DocActionsMenu,
    DocumentCompare,
    DocListMenu,
    HierarchyNodeHistory,
    SaveViewDefinition,
    AttributeValueAdmin,
    DocSummary,
    AdminHierarchyDetail,
    HierarchyViewColumnHeading,
    // HierarchyViewColumnDetail,
    HierarchyViewColumnPicker,
    TagCompare,
    RowHeaders,
    RowDetails,
    RowMeasures,
    Bar,
    Doughnut,
    SimilarityView,
    TaskList,
    FilterOptions,
    HierarchyTreeFilter,
    GenerateContent,
    HierarchyViewMeasurePicker,
    boxplot,
    rmTable,
    MeasureDisplay,
  },
  props: {
    container: String,
  },
  data: function () {
    return {
      utils: utils,
      page: this.container ?? _page,
      response: null,
      items: [],
      isDirty: false,
      reviewDocs: [],
      // documentsForSearch: [],
      csvHeaders: [],
      dialog: false,
      options: { itemsPerPage: 15 },
      filteredItems: [],
      defaultHierarchy: false,
      // hierarchyTypes: [],
      // jobTitles: [],
      // selectedDocs: [],
      filterList: [],
      layout: null,
      verAxisAvailable: [],
      horAxisAvailable: [],
      detAxisAvailable: [],
      // compareCriteria: [],
      transactionTypes: [],
      //   horizontalCompareOption: null,
      //   verticalCompareOption: null,
      horAxisSelected: [],
      verAxisSelected: [],
      detAxisSelected: [],
      mainVAxis: null,
      mainHAxis: null,
      //   detailCompareOption: null,
      measureFilterTypes: [],
      measureFilterTypeTitles: [],
      compareDocs: [],
      compareSkillMatrix: [],
      sideBySide: { show: false, items: [] },
      fullCompareView: { show: false, highlightChanges: false, items: [] },
      compareView: true,
      usesReviews: false,
      viewDefinition: {
        view: null,
        saveAsTrigger: 0,
        saveTrigger: 0,
        inactiveTrigger: 0,
        editTrigger: 0,
        showDesigner: false,
        showFilters: false,
        tab: 0,
        saveAsIsCurrent: false,
      },
      similarityData: { 
        matchLevels: [], 
        docStatuss: [], 
        docStatusList: [], 
        similarityColumnsName: [], 
        similarityColumnsContent: [], 
        matchDocs: [], 
        relatedDocs: [], 
        updated: 0, 
        initialised: false, 
        showLinkSimilarity: false, 
      },
      isBuilding: true,
      resetIsBuilding: false,
      doSetView: false,
      catalogueDocType: null,
      tmpl_id_default: null,
      usesTags: false,
      viewToSelect: null,
      measureFilters: [],
      nestedDrilldownFilter: null,
      hScrollNeeded: true,
      hEdgeClipped: false,
      columnWidths: {
        // user px overrides keyed "V:<col>" | "VM:<measure>" | "D:<col>" | "DM:<measure>" | "H"
        overrides: {},
        loadedForView: null,
        fingerprint: null,
        saveTimer: null,
        hoverGuide: {
          show: false,
          x: 0,
          top: 0,
          height: 0,
        },
        drag: {
          active: false,
          key: null,
          startX: 0,
          startPx: 0,
          scale: 1,
          unitCount: 1,
          guideX: 0,
          guideTop: 0,
          guideHeight: 0,
        },
      },
      display: {
        v_col: { colWidth: 1 },
        h_col: { colWidth: 1 },
        total_col: {
          colWidth: 1,
          leafCountLabel: "",
          leafCountTitle: "",
        },
        z_col: {
          show: false,
          colWidth: 1,
          showLabel: false,
          colWidthLabel: 0,
        },
      },
      isSaving: false,
      isLoadingData: false,
      isDataLoaded: false,
      inProgressIndexRequests: 0,
      narrowFilterToken: 0,
      hierarchyPickerFilters: [],
      hierarchyPickerScopedTmpl: null,
      indexHierarchyDocNodes: null,
      filterStateVersion: 0,
      haveData: false,
      selectedView: null,
      selectedViewIndex: 0,
      // selectedViewData: null, // for sim view
      primaryViews: [],
      primaryTabs: [
        { key: "home", title: "", index: 0, icon: "mdi-home", iconColour: "#50B3CB", borderColour: "#A7D9E5", width: "", visible: true, default: true },
        { key: "workspace", title: "Workspace", index: 1, icon: "mdi-dots-triangle", iconColour: "#FFCB00", borderColour: "#FFE580", width: "", visible: true, },
        { key: "dashboard", title: "Dashboard", index: 2, icon: "mdi-view-dashboard", iconColour: "#EA3785", borderColour: "#F7AFCE", width: "", visible: true, },
        { key: "admin", title: "Admin", index: 3, icon: "mdi-cog", iconColour: "#CEDC26", borderColour: "#E2EA7D", width: "", visible: true, },
        { key: "custom", title: "", index: 4, icon: "mdi-dots-vertical", iconColour: "#50B3CB", borderColour: "#A7D9E5", width: "", visible: true, other: true, },
      ],
      selectedTab: null,
      selectedStatistic: null,
      selectAllRows: false,
      preSelectedHierarchies: [],
      views: [],
      measureDisplayTypes: [
        { title: "Text", id: "value", type: "chip", divisor: null, vertical: true, horizontal: true, percentColumn: "", scope: "", calc: "" },
        { title: "Overall Max Bar", id: "max_value_overall", type: "bar", divisor: "_max_value_overall", vertical: true, horizontal: true, percentColumn: "_pct_of_max_value_overall", scope: "overall", calc: "max" },
        { title: "Line Max Bar", id: "max_value_line", type: "bar", divisor: "_max_value_line", vertical: false, horizontal: true, percentColumn: "_pct_of_max_value_line", scope: "line", calc: "max" },
        { title: "Overall Total Bar", id: "total_value_overall", type: "bar_total", divisor: "_total_value_overall", vertical: true, horizontal: true, percentColumn: "_pct_of_total_value_overall", scope: "overall", calc: "tot" },
        { title: "Line Total Bar", id: "total_value_line", type: "bar_total", divisor: "_total_value_line", vertical: false, horizontal: true, percentColumn: "_pct_of_total_value_line", scope: "line", calc: "tot" },
        ],
      permissions: {
        saveViewMain: true,
        saveViewOwn: true,
        changeSettings: true,
        saveShortcuts: false,
        editDescriptor: false,
      },
      vScroll: {
        pageHeight: 0,
        maxHeight: 0,
        allocatedHeight: 0,
        endClipped: false,
        doSetup: false,
        dStart: 0,
        dEnd: 0,
        dMax: 0,
        inProgress: false,
        lineHeightZ: 50,
        lineHeightY: 50,
      },
      // drilldownFilters: [],
      editDialogue: {
        show: false,
        canSave: false,
        items: [],
        columns: [],
        page: 0,
        pageSize: 4,
        colSize: 3,
      },
      generateContentDialog: {
        show: false,
        node: null,
        type: "jf_generate"
      },     
      generateContentDialog2: {
        show: false,
        prompt_chain: null,
        node: null,
      },
      tagsDialogue: {
        show: false,
        doc_ids: [],
        subject: "",
        hierarchy_node_id: null,
        tag_type_id: null,
      },
      //   docSkillDialogue: {
      //     show: false,
      //     sections: [],
      //     doc: null,
      //   },
      hierarchyDescriptorDialogue: {
        show: false,
        node: null,
        label: "",
        text: "",
      },
      historyNode: null,
      nodeReviewDialogue: {
        show: false,
        node: null,
      },
      nodeHistoryReport: {
        show: false,
        label: "",
        nodes: [],
        dateRangeFilter: [],
        userFilter: [],
        userList: [],
      },
      nodeAuditData: {
        show: false,
        label: "",
        ht_id: null,
        data: [],
        dateRangeFilter: [],
        userFilter: [],
        userList: [],
        typeFilter: [],
        typeList: [],
        reasonFilter: [],
        reasonList: [],
        headers: [
          { text: "Date", value: "transaction_date" },
          { text: "Type", value: "transaction_sub_type" },
          { text: "User", value: "user_name" },
          { text: "Description", value: "transaction_description" },
          { text: "Reason", value: "transaction_reason_type" },
          { text: "", value: "data-table-expand" },
        ],
        expanded: [],
      },
      hierarchyEditDialogue: {
        show: false,
        mode: "edit",
        node: null,
        showAddNodeDescriptor: false,
        multiNodes: [],
        bucket: null,
      },
      // measureEditDialogue: {
      //   show: false,
      //   measure: null,
      //   axis: null,
      //   displayType: null,
      //   columnTitle: null,
      //   alignment: null,
      //   hideSelector: false,
      //   alertLevelGT: null,
      //   alertLevelLT: null,
      //   alertLevelMessage: null,
      // },
      hierarchyAddDialogue: {
        show: false,
        ht_id: null,
      },
      contextMenu: {
        show: false,
        busy: false,
        item: null,
        title: null,
        actions: [],
        posX: 0,
        posY: 0,
      },
      docListMenu: {
        show: false,
        busy: false,
        title: null,
        documents: [],
        matchSets: [],
        posX: 0,
        posY: 0,
        matchColumn: false,
        hierarchySuggestions: {
          show: false,
          hierarchyType: null,
          response: null,
        },
        documentType: this.catalogueDocType?.docType,
      },
      shortcuts: {
        busy: false,
        title: null,
        default: null,
        items: [],
        editItems: [],
        isDirty: false,
        posX: 0,
        posY: 0,
      },
      attributeAdmin: {
        show: 0,
        attribute: null,
        rawValues: [],
      },
      docActionsMenuContext: {
        show: false,
        busy: false,
        document: null,
        posX: 0,
        posY: 0,
      },
      viewMenu: {
        show: false,
        keepOpen: false,
        tab: 0,
        tabs: [],
        posX: 0,
        posY: 0,
      },
      documentSummary: {
        trigger: null,
        doc_id: null,
      },
      hr_idDialogue: {
        show: false,
        node: null,
      },
      dragTarget: {
        show: true,
        buckets: [],
      },
      dragItem: null,
      verticalMeasures: [],
      horizontalMeasures: [],
      measures: [],
      attributes: [],
      hierarchyDescriptors: [],
      nodeDescriptorView: {
        show: false,
        node: null,
        view: "initiate",
        labels: [],
        showFeedbackOnly: false,
      },
      pageStructure: [],
      pageStructureSett: [],
      viewSectionsLayout: [],
      viewSectionsDesign: [],
      hasExpanded: false,
      statusFilterOptions: [
        { text: "All Tasks", value: "1" },
        { text: "My Tasks", value: "2" },
        { text: "Unassigned Tasks", value: "3" }
      ],
      layoutTypes: [ 
        { type: "grid only", title: "Grid", default: true },
        { type: "bar chart only", title: "Dashboard" },
        { type: "bar chart and grid", title: "Dashboard + Grid" }, ],
      chartEdit: { show: false, type: null, existingIndex: -1, xAxis: null, yAxis: null, measure: null, useRange: false, rangeQuantity: 0, title: "", description: "", xAxisPrefix: "", yAxisPrefix: "", filtersVisible: [],
        colPosition: 1, rowPosition: 1, colWidth: 12, rowHeight: 1, link: null, linkTitle: "", 
       },
      taskEdit: { show: false, existingIndex: -1, columnsVisible: [], filtersVisible: [], defaultView: "1", title: "Task List", description: "", 
        colPosition: 1, rowPosition: 1, colWidth: 12, rowHeight: 1,
      },
      statisticEdit: { show: false, existingIndex: -1, type: null, icon: null, backgroundColour: null, iconColour: null, useStatusIcon: false, title: "Statistic", description: "", source: "",
        includeWarningTrigger: null, includeErrorTrigger: null, includeGoodTrigger: null, hideZeroStatistic: false, warningIdentified: false, errorIdentified: false, goodIdentified: false,
        includeWarningTriggerComparator: null, includeErrorTriggerComparator: null, includeGoodTriggerComparator: null, 
        colPosition: 1, rowPosition: 1, colWidth: 12, rowHeight: 1, view: null, criteriaMeasure: null, criteriaComparator: "=", criteriaValue: 0, displayBasis: "sum",
        viewType: null, availableMeasures: [], 
        editFilter: { show: false, availableFilters: [], column: null, filterValues: [], filter: null, filterComparator: null, filterValue: null, data_type: "list", }
      },
      // charts: [],
      chartSortOptions: [
          'Alphabetically',
          'Reverse Alphabetically',
          'High to Low',
          'Low to High'
        ],
      chartDateOptions: [
          { type: "date", unit: "day", format: "YYYY-MM-DD"},
          { type: "month", unit: "month", format: "YYYY-MM"},
          { type: "year", unit: "year", format: "YYYY"},
        ],
      chartColours: [
          "#50B3CB", // Blue
          "#FFCB00", // Yellow
          "#2cd946", // Green
          "#ED742D", // Orange
          "#EA3785", // Pink
          "#5E2872", // Purple
          "#8DD3C7", // Turquoise
          "#CCEBC5", // Pale Blue
          "#FFFFB3", // Pale Yellow
          "#BEBADA", // Lavender
          "#FCCDE5", // Pink
          "#D9D9D9", // Grey,
        ],
      maximised: false,
      clientColours: [],
      drillDownDialogue: { show: false, tab: 0, subjects: [], description: "", documents: [],
        docHeadings: [], analysisTitle: "", analysisHeadings: [], analysisRows: [], datasets: [], labels: [], match_keys: [],
        measureTitle: "", docType: "", title: "", titleValue: "", titleColour: "", titleIcon: "", detailColourKey: [], summaryView: false, alert: "",
       },
      drillDownStack: { item: null, measure: null, title: null, show: false, },
      keyLegends: [],
      reportMenuVisible: false,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedView(val) {
      if (val) this.initSetView();
    },
    async "statisticEdit.view" (val) {
      if (val) {
        const viewDef = this.views.find(x => x.view_definition_id === val)?.definition;
        if (viewDef) {
          this.statisticEdit.viewType = viewDef.viewType;
          this.statisticEdit.editFilter.availableFilters = await this.getViewFilters(val);
          this.statisticEdit.availableMeasures = this.getStatisticMeasures(val);
        } else {         
          this.statisticEdit.availableMeasures = [];
          this.statisticEdit.editFilter.availableFilters = [];
        }
      }
    },
    $route() {},
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.docs.loading,
      useIndex: (state) => state.docs.useIndex,
      classifierTypes: (state) => state.docs.classifierTypes,
      docStatusSummary: (state) => state.docs.docStatusSummary,
      docTypeSummary: (state) => state.docs.docTypeSummary,
      useTranslation: (state) => state.docs.useTranslation,
      detailColumns: (state) =>
        state.docs.docListColumns.filter((c) => c.showInListView),
      hierarchyNodeLookup: (state) => state.hierarchies.hierarchyNodeLookup,
    }),
    currentViewHierarchy() {
      return (
        this.hierarchyTypes.find(
          (h) => h.ht_id === this.selectedView.definition.ht_id
        ) ||
        this.hierarchyTypes.find(
          (h) => h.ht_name.toLowerCase().indexOf("job") >= 0
        )
      );
    },
    defaultSortItems() {
      // one shared default across vertical text columns and vertical measures
      return [
        ...this.verAxisSelected.map((c) => ({
          text: (c.overrideTitle || c.name) + " (column)",
          value: "c:" + (c.cache_column || c.column),
        })),
        ...this.verticalMeasures
          .filter((m) => m.visible && m.available)
          .map((m) => ({
            text: (m.columnTitle || m.title) + " (measure)",
            value: "m:" + m.id,
          })),
      ];
    },
    defaultSortModel: {
      get() {
        const spec = this.getDefaultSortSpec();
        if (!spec) return null;
        if (spec.measureId) {
          const m =
            this.verticalMeasures.find((x) => x.id === spec.measureId) ||
            this.verticalMeasures.find((x) => x.type === spec.measureId);
          return "m:" + (m ? m.id : spec.measureId);
        }
        return "c:" + spec.column;
      },
      set(v) {
        const def = this.selectedView.definition;
        const prev = this.getDefaultSortSpec();
        if (!v) this.$set(def, "defaultSort", null);
        else if (v.startsWith("m:"))
          this.$set(def, "defaultSort", { measureId: v.slice(2), descending: prev ? !!prev.descending : true });
        else
          this.$set(def, "defaultSort", { column: v.slice(2), descending: prev ? !!prev.descending : false });
        def.verticalSortProperty = null;
        this.changeViewSetting("defaultSort");
      },
    },
    defaultSortDirectionModel: {
      get() {
        const spec = this.getDefaultSortSpec();
        return spec ? (spec.descending ? "desc" : "asc") : null;
      },
      set(v) {
        const def = this.selectedView.definition;
        const spec = this.getDefaultSortSpec();
        if (!spec) return;
        this.$set(def, "defaultSort", { ...spec, descending: v === "desc" });
        def.verticalSortProperty = null;
        this.changeViewSetting("defaultSort");
      },
    },
    getfilterableOptions(){
      let mfs = [];
      this.measureFilterTypes.forEach(mf => {
          mf.filters.filter(f => f && f.visible).forEach(f => {
            mfs.push(f);
          });
      });
      if (this.selectedView.definition.showTextSearch) mfs.push({ showTextSearch: true, name: "Search", searchText: this.selectedView.definition.searchText || "" });
      return [ ...this.hierarchyPickerFilters.filter(x => x.included),
        ...this.verAxisAvailable.filter(x => x.visible && x.listValues && x.listValues.length),
        ...mfs];
    },
    primaryTabsVisible(){
      return this.primaryTabs.some(x => x.visible && !x.other);
    },
    titleWithFilters(){
      return this.selectedView.definition.title 
        && this.selectedView.definition.showDownload === 'hidden' 
        && !this.layout?.canSelectDocs;
    },
    showHighlights(){
      return this.layout?.highlights?.length;
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "docs/update" && mutation.payload.doc_id && state) {
        let newVal = mutation.payload;
        let doReload = false;
        if (["DELETED", "ARCHIVED"].some((x) => x === newVal.doc_status)) {
          let ind = _documents.findIndex((d) => d.doc_id === newVal.doc_id);
          if (ind >= 0) {
            _documents.splice(ind, 1);
            ind = this.compareDocs.findIndex((d) => d.doc_id === newVal.doc_id);
            if (ind >= 0) {
              this.compareDocs.splice(ind, 1);
              if (this.compareDocs.length === 0) {
                this.resetCompare();
              } else if (this.editDialogue.items?.length) {
                ind = this.editDialogue.items.findIndex(
                  (d) => d.doc_id === newVal.doc_id
                );
                if (ind >= 0) this.editDialogue.items.splice(ind, 1);
              }
            }
            doReload = true;
          }
        } else {
          const preppedDoc = this.prepareDocument(newVal, this.templates);
          doReload = this.updateDocCollection(this, preppedDoc);
        }
        if (doReload) this.selectJDs();
      }
    });
  },
  beforeDestroy: function () {
    this.unsubscribe();
    window.removeEventListener("pointermove", this.onColResizeMove);
    window.removeEventListener("pointerup", this.endColResize);
    window.removeEventListener("click", this.suppressResizeClick, true);
    if (this.columnWidths.saveTimer) {
      clearTimeout(this.columnWidths.saveTimer);
      this.columnWidths.saveTimer = null;
    }
  },
  updated() {
    // this.$nextTick(function () {
    //   this.afterInit();
    //   if (!this.isLoadingData && this.doSetView) {
    //     this.doSetView = false;
    //     this.setView();
    //     return;
    //   }
    // });
  },
  mounted() {},
  methods: {
    acceptContentGen(data){
      let docs = data.map(d => {
        return {
          populatedData: d.documentData.populatedData,
          hierarchies:  d.documentData.hierarchies
        }
      })
      let newData = {
        tmpl_id: this.generateContentDialog2.node.tmpl_id,
        node: this.generateContentDialog2.node.node,
        docs: docs
      }
			axios  
				.post("document/generateDocument", newData)
				.then((resp) => {
          this.$emit("reloadDocument", resp.data.Data);
				})
				.catch((error) => {
				});
    },
    decorateReviewNode(n, showSubLevel) {
      let sumFunc = (p, c) => {
        this.measures.forEach((m) => {
          p[m.type] += c[m.type];
        });
        return p;
      };
      let tot = this.appendMeasureColumns(null, 0);
      let tots = _documents
        .filter(
          (x) =>
            x["ht_id_" + n.ht_id + "_" + n.level + "_nodeID"] ===
            n.hierarchy_node_id
        )
        .reduce(sumFunc, tot);
      if (n.reviewStatus) n.reviewStatus.editMode = false;
      this.appendMeasureColumns(n, 0, tots);
      (n.description = n.descriptor ? n.descriptor.description : null),
        (n.showNodes = false);
      if (showSubLevel && n.nodes) {
        n.nodes.forEach((nn) => {
          let tot2 = this.appendMeasureColumns(null, 0);
          let ntots = _documents
            .filter(
              (x) =>
                x["ht_id_" + nn.ht_id + "_" + nn.level + "_nodeID"] ===
                nn.hierarchy_node_id
            )
            .reduce(sumFunc, tot2);
          this.appendMeasureColumns(nn, 0, ntots);
        });
      }
      return n;
    },
    afterInit() {
      if (this.resetIsBuilding) {
        this.isBuilding = false;
        this.resetIsBuilding = false;
      }
      if (
        this.selectedView?.definition.viewType !== "catalogue" ||
        this.isLoadingData
      )
        return;
      // this.setVScrollPageHeight();
      // const isLoadingData = this.isLoadingData;
      // this.isLoadingData = false;
      // if (isLoadingData) {
      //   this.buildCompare();
      // }
    },
    resetHScroll() {
      if (this.$refs.colfoot) {
        this.$refs.colfoot.scrollLeft = 0;
        this.setHScroll();
      }
      if (this.$refs.leftfoot) {
        this.$refs.leftfoot.scrollLeft = 0;
        this.setLeftHScroll();
      }
    },
    setHScroll() {
      if (!this.$refs.colfoot || !this.$refs.detailH) return;
      let hd = this.$refs.detailH.scrollLeft;
      let fs = this.$refs.colfoot.scrollLeft;
      if (fs !== hd && this.layout.headerRow) {
        this.$refs[this.layout.headerRow.ref].scrollLeft = fs;
        this.$refs.detailH.scrollLeft = fs;
      }
    },
    updateHScrollNeeded() {
      // hide the horizontal scroll strip when the real overflow is negligible;
      // that negligible overflow clips the last column's right border, so close
      // the box with a container border instead. scrollWidth is clamped to
      // clientWidth, so compare against the layout's known content width
      const hd = this.$refs.detailH;
      const contentPx = this.layout?.rightPanel
        ? parseFloat(this.layout.rightPanel.scrollWidthStyle.minWidth)
        : 0;
      const overflow = hd && contentPx ? contentPx - hd.clientWidth : 0;
      this.hScrollNeeded = overflow > 4;
      this.hEdgeClipped = overflow > -1.5 && overflow <= 4;
    },
    setLeftHScroll() {
      if (!this.$refs.leftfoot) return;
      const fs = this.$refs.leftfoot.scrollLeft;
      if (this.$refs.leftHead) this.$refs.leftHead.scrollLeft = fs;
      if (this.$refs.leftBody) this.$refs.leftBody.scrollLeft = fs;
    },
    wheelScroll(data) {
      if (data) {
        if (data.shiftKey) {
          this.wheelHScroll(data);
        } else {
          this.wheelVScroll(data);
        }
      }
    },
    wheelHScroll(data) {
      if (data) {
        const isLeft = !!(data.target && data.target.closest && data.target.closest(".left-hscroll-region"));
        const foot = isLeft ? this.$refs.leftfoot : this.$refs.colfoot;
        if (!foot) return;
        let fs = foot.scrollLeft;
        let width = foot.scrollWidth;
        fs = fs + data.deltaY;
        if (fs < 0) fs = 0;
        else if (fs > width) fs = width;
        foot.scrollLeft = fs;
        if (isLeft) this.setLeftHScroll();
        else this.setHScroll();
      }
    },
    wheelVScroll(data) {
      if (data && data.deltaY !== 0) {
        // a scrollable description cell owns the wheel entirely: it scrolls
        // natively, and even at its scroll limits the grid must not page -
        // firing the container scroll at the boundary loses the user's place
        const desc = data.target?.closest?.(".descriptor-edit, .descriptor-read");
        if (desc && desc.scrollHeight > desc.clientHeight) return;
        // endClipped: the last window row is only partially shown, so allow
        // scrolling it fully into view even when dEnd has reached dMax
        if (data.deltaY > 0 && (this.vScroll.dEnd < this.vScroll.dMax || this.vScroll.endClipped)) {
            this.vScroll.dStart++;
            this.vScroll.dEnd++;
            this.getNextPageSize();
        } else if (data.deltaY < 0 && this.vScroll.dStart > 0) {
            this.vScroll.dStart--;
            this.vScroll.dEnd--;
            this.getPreviousPageSize();
        } else {
          return;
        }
        this.setScroll();
      }
    },
    setVScroll_(event) {
      if (event.target.closest(".resizable-component")) return;
      if (this.vScroll.inProgress) {
        this.vScroll.inProgress = false;
        return;
      }
      let sl = this.$refs.scrollContainer.scrollTop;
      let max = this.$refs.scrollContainer.scrollHeight - this.$refs.scrollContainer.clientHeight;
      if (sl === 0) {
        this.vScroll.dStart = 0;
      } else {
        const rowCount = this.vScroll.dMax + 1 + this.settData.filter(x => x.showGroupHeader).length;
        this.vScroll.dStart = parseInt((rowCount * sl) / max);
      }
      this.getNextPageSize();
    },
    setVScrollPageHeight() {
      if (this.vScroll.doSetup && this.$refs.detailRow) {
        const pos = this.$refs.detailRow.getBoundingClientRect();
        let detailRowHeight = window.innerHeight - pos.top - (this.maximised ? 30 : 80);
        if (this.horAxisSelected.length && this.horAxisSelected[0].overrideTitle) detailRowHeight -= 40;
        if (detailRowHeight < 250) detailRowHeight = 250;
        this.$refs.detailRow.style.height = detailRowHeight + "px";
        this.vScroll.pageHeight = detailRowHeight;
        this.vScroll.dStart = 0;
        this.$refs.scrollContainer.scrollTop = 0;
        this.getNextPageSize();
        this.setVScrollMax(this.vScroll.dMax);
        this.updateHScrollNeeded();
      }
    },
    // per-row line heights: a row is at least the base single-line height and
    // grows to fit its own description (descriptorHeight) or its detail rows,
    // whichever needs more; rows at levels without descriptors stay single-line
    rowLineHeights(x, heightZ, singleLineHeight) {
      // with horizontal columns, an expanded drilldown parent renders as a slim
      // header band (details hidden, description suppressed - the children
      // carry the content); with no horizontal axis the parent keeps its normal
      // height so its full description stays visible while expanded
      if (x.hideDetails && this.horAxisSelected.length)
        return { single: heightZ, multi: heightZ };
      const descH =
        x.hasDescriptorCells && x.descriptorAvailable ? x.descriptorHeight || 0 : 0;
      const single =
        x.hasDescriptorCells && !x.descriptorAvailable
          ? heightZ
          : Math.max(singleLineHeight, descH);
      const multi =
        x.detailCount > 1 ? Math.ceil(Math.max(heightZ, descH / x.detailCount)) : heightZ;
      return { single: single, multi: multi };
    },
    setVScrollMax(rowCount) {
      this.vScroll.dMax = rowCount;
      // size the scroll spacer from the rows' actual heights (mirroring the
      // allocation in getNextPageSize) - the old page-average estimate was off
      // by one row and went stale when line heights changed (e.g. the taller
      // descriptor-column rows), leaving the scrollbar hidden on small sets
      const heightZ = this.vScroll.lineHeightZ;
      const heightY = this.vScroll.lineHeightY;
      const singleLineHeight = heightZ > heightY ? heightZ : heightY;
      if (this.settData?.length) {
        let total = 0;
        this.settData.forEach((x) => {
          if (x.showGroupHeader) total += heightZ;
          const rh = this.rowLineHeights(x, heightZ, singleLineHeight);
          total += x.detailCount > 1 ? x.detailCount * rh.multi : rh.single;
        });
        this.vScroll.maxHeight = total + "px";
      } else {
        const pageSize = this.vScroll.dEnd - this.vScroll.dStart + 1;
        const rowHeight = this.vScroll.allocatedHeight / pageSize;
        let groupHeaderCount = this.layout ? this.settData.filter(x => x.showGroupHeader).length : 0;
        this.vScroll.maxHeight =
          (rowCount + 1 + groupHeaderCount) * (rowHeight) + "px";
      }
    },
    // actual grid viewport width for fit calculations: the detail row when it
    // has rendered, else the component root (present from mount, so the FIRST
    // build doesn't fall back to the far-wider window width and over-stretch)
    gridViewportPx() {
      const rect = this.$refs.detailRow?.getBoundingClientRect();
      const el = this.$el?.getBoundingClientRect();
      this._assumedViewportPx = rect?.width
        ? rect.width
        : el?.width
        ? el.width - 40
        : window.innerWidth - 100;
      return this._assumedViewportPx;
    },
    // the first build runs before the grid (and sometimes the page shell) has
    // rendered, so the width the fit calculations assumed can be wrong; once
    // the real detail row exists, re-fit a single time if it was material
    refitViewportIfStale() {
      if (!this.layout || this.isBuilding || this.layout.rightPanel.cols) return;
      const rect = this.$refs.detailRow?.getBoundingClientRect();
      if (!rect?.width || !this._assumedViewportPx) return;
      if (Math.abs(rect.width - this._assumedViewportPx) <= 24) return;
      if (Math.abs(rect.width - (this._viewportRefitPx || 0)) <= 1) return;
      this._viewportRefitPx = rect.width;
      this.rebuildCompare();
    },
    setGridLineClass() {
      let gridLineClass = "";
      if (this.selectedView.definition.gridlines.indexOf("vertical") >= 0)
        gridLineClass = " gridline-vertical";
      if (this.selectedView.definition.gridlines.indexOf("horizontal") >= 0)
        gridLineClass += " gridline-horizontal";
      return gridLineClass;
    },
    setHeaderColumnWidths(layout, rows) {
      let titleRatio = layout.leftPanel.titleSectionRatio;
      let remaining = 100;
      layout.detailRow.rowHeading.columnWidths =
        rows.length ? rows[0].headerColumns.map((hc, hci) => {
            const tw = layout.detailRow.rowHeading.titleWidths[hci];
            const pct = Number(tw.percent.replace("%",""));
            let width = 100 * titleRatio * pct / remaining;
            remaining -= titleRatio * pct;
            return { percent: width + "%", remainder: (100 - width) + "%", key: tw.key, px: tw.px, };
      }) : [];
    },
    // the view's default sort: one shared setting covering vertical text columns
    // ({ column, descending }) and vertical measures ({ measureId, descending });
    // legacy definitions carry verticalSortProperty (a measure type, descending)
    getDefaultSortSpec() {
      const def = this.selectedView.definition;
      if (def.defaultSort && (def.defaultSort.measureId || def.defaultSort.column))
        return def.defaultSort;
      if (def.verticalSortProperty)
        return { measureId: def.verticalSortProperty, descending: true };
      return null;
    },
    getResolvedDefaultSortSpec() {
      const spec = this.getDefaultSortSpec();
      if (!spec || !spec.measureId) return spec;
      // rows key their aggregated values by measure id, so map a legacy
      // measure-type reference onto the matching measure's id
      const m =
        this.verticalMeasures.find((x) => x.visible && x.available && x.id === spec.measureId) ||
        this.verticalMeasures.find((x) => x.visible && x.available && x.type === spec.measureId) ||
        this.measures.find((x) => x.id === spec.measureId || x.type === spec.measureId);
      return { ...spec, measureId: m ? m.id : spec.measureId };
    },
    defaultSortMatchesColumn(spec, col) {
      if (!spec || spec.measureId || !col) return false;
      return (
        spec.column === col.cache_column ||
        spec.column === col.column ||
        (col.drillDownLevels || []).some(
          (dl) => dl.column === spec.column || dl.node_column === spec.column
        )
      );
    },
    measureDefaultSort(m) {
      const spec = this.getDefaultSortSpec();
      if (!spec || !spec.measureId || !m) return null;
      return spec.measureId === m.id || spec.measureId === m.type
        ? spec.descending ? "desc" : "asc"
        : null;
    },
    columnDefaultSort(col) {
      const spec = this.getDefaultSortSpec();
      return this.defaultSortMatchesColumn(spec, col)
        ? spec.descending ? "desc" : "asc"
        : null;
    },
    // the picker's Save always follows this with changeColumnStyle, whose
    // changeAxis path rebuilds and persists — so only update the definition here
    setColumnDefaultSort(payload) {
      const def = this.selectedView.definition;
      const spec = this.getDefaultSortSpec();
      const col = this.verAxisSelected[payload.index];
      const isCurrent = this.defaultSortMatchesColumn(spec, col);
      if (payload.sort) {
        this.$set(def, "defaultSort", {
          column: payload.column,
          descending: payload.sort === "desc",
        });
      } else if (isCurrent) {
        this.$set(def, "defaultSort", null);
      } else {
        return;
      }
      def.verticalSortProperty = null;
      this.selectedView.isDirty = true;
    },
    applyMeasureDefaultSort(measure, sort) {
      const def = this.selectedView.definition;
      const current = this.measureDefaultSort(measure);
      const next = sort || null;
      if (next === current) return;
      if (next) {
        this.$set(def, "defaultSort", {
          measureId: measure.id,
          descending: next === "desc",
        });
      } else if (current) {
        this.$set(def, "defaultSort", null);
      } else {
        return;
      }
      def.verticalSortProperty = null;
    },
    // reflect the default sort in the header sort indicator, so the arrow shows
    // the sequence the rows loaded in; clicking the header still toggles it
    applyDefaultSortIndicator() {
      const def = this.selectedView.definition;
      const spec = this.getDefaultSortSpec();
      let sortColumn = null;
      if (spec && (def.allowColumnSort || def.fullVerticalView)) {
        if (spec.measureId) {
          const m = this.verticalMeasures.find(
            (x) => x.visible && x.available && (x.id === spec.measureId || x.type === spec.measureId)
          );
          if (m) sortColumn = { name: m.column, isNumber: true, descending: !!spec.descending };
        } else {
          const vc = this.verAxisSelected.find((x) => this.defaultSortMatchesColumn(spec, x));
          if (vc) sortColumn = { name: vc.column, isNumber: false, descending: !!spec.descending };
        }
      }
      this.$set(this.selectedView, "sortColumn", sortColumn);
    },
    allowSort(column, index) {
      if (column && column.isDescriptor) return false;
      if (this.selectedView.definition.fullVerticalView)
        return true;
      else if (this.selectedView.definition.allowColumnSort && index === 0)
        return true;
      else return false;
    },
    allowSortMeasure() {
      if (this.selectedView.definition.fullVerticalView)
        return true;
      else if (this.selectedView.definition.allowColumnSort && this.verAxisSelected.filter(x => !x.containerColumn || (!x.containerColumnShowRange && !x.containerColumnGroupMeasure)).length === 1)
        return true;
      else return false;
    },
    cloneObjectArray(source) {
      return source.map(x => { return {...x}; });
    },
    setVisibleHeaderColumns() {
      const start = this.vScroll.dStart;
      const end = this.vScroll.dEnd;
      const fullRows = this.selectedView.definition.fullVerticalView;
      const showTotalsRow = this.selectedView.definition.showTotalsRow;
      const getHeaderValue = (col) => {
        return col.value + "_" + col.nestedColumns.map(nc => nc.value).join("|");
      };
      const getRow = (column, collection, rhIndex) => {
        let item = fullRows ? null : collection.find(x => x.value === getHeaderValue(column) && !column.isGroupHeader);
        if (!item) {
          item = { row: collection.length + 1, subRows: [], item: column, value: getHeaderValue(column), width: 0, indentLevel: 0, isGroupHeader: !!column.isGroupHeader, selected: false, rhIndex: rhIndex, showGroupHeader: "" };
          collection.push(item);
        }
        return item;
      }
      // let pageStructure = [];
      let even = true;    
      let hcWidths = this.layout.detailRow.rowHeading.columnWidths;
      let showVerticalLineHeading = this.layout.leftPanel.cols > 0 && this.layout.rightPanel.cols > 0;
      let showVerticalLineMeasure = showVerticalLineHeading && this.verticalMeasures.some(m => m.visible);
      if (showVerticalLineMeasure) showVerticalLineHeading = false;
      let includeEven = false;  
      let pageRowsSett = JSON.parse(JSON.stringify(this.settData
        .filter((x) => x.dIndexEnd >= start && x.dIndexStart <= end)));
            
      let pageStructureSett = [];
      let multiZ = this.settData.some(x => x.detailCount > 1);
      let usesExpansion = pageRowsSett.length && this.verAxisSelected.length === 1 && (this.verAxisSelected[0].drillDownLevels?.length || 0) > 1;
      const recurseDetailsSett = (items, cssclass, height, lastCol, isExpandedHeader) => {
        items.forEach((x, xi) => {
          const isLast = lastCol !== false && xi === items.length - 1;
          if (x.children.length) {
            recurseDetailsSett(x.children, cssclass, height, isLast, isExpandedHeader);
          }
          if (isExpandedHeader)
            x.cssClassDetail = "row-expanded" + (isLast ? " last-column" : "") + this.layout.gridLineClass.replace("gridline-vertical", "");
          else
            x.cssClassDetail = (includeEven && even ? " row-even " : "")  + cssclass + (isLast ? " last-column" : "") + this.layout.gridLineClass;
          x.height = height;
        });
      };
      pageRowsSett.forEach((rh, rhi) => {
          let current = pageStructureSett;
          let cssEven = "";
          if (fullRows && !usesExpansion) {
            even = !even;
            if (even) { 
              cssEven = " row-even ";
            }
            // next.even = even;
          }  
          let isExpandedHeader = rh.headerColumns[0].node?.drilldown?.expanded;
          rh.headerColumns.forEach((hc, hci) => {
            let next = getRow(hc, current, rh.index);
            if (fullRows) next.selected = rh.selected;
            if (next.isGroupHeader) {
              next.cssClass = "group-header";
              next.width = { percent: "100%" };
            } else {
              next.cssClass = "row-header";
              next.width = hcWidths[hci];
            }
            if (isExpandedHeader) 
              next.cssClass += " row-expanded";
            if (rhi === pageRowsSett.length - 1 && !showTotalsRow) {
              next.cssClass += " last-row";
            }
            if (hci === 0 && !fullRows) {
              next.cssClass += " first-column";
            }
            next.cssClass += this.layout.gridLineClass;
            if (fullRows && !usesExpansion) {
              next.cssClass += cssEven;
            }
            includeEven = !usesExpansion && !multiZ && !isExpandedHeader && !next.isGroupHeader && !this.keyLegends.length;
            if (hci === 0) {
              next.indentLevel = rh.indentLevel;
              next.showGroupHeader = rh.showGroupHeader || "";
              // the group-header band renders from the FIRST chain entry, but
              // detail is normally stamped on the LAST - with derived columns
              // (e.g. descriptors) those differ, and RowDetails needs
              // detail.children to draw the band across the right panel
              if (next.showGroupHeader && !next.detail) next.detail = rh;
            }
            if (hci === rh.headerColumns.length - 1) {
              if (showVerticalLineHeading) next.cssClass += " gridline-vertical";
              if (includeEven && !fullRows) {
                even = !even;
                if (even) { 
                  cssEven = " row-even ";
                }
                next.even = even;
              }
              next.detail = rh;
              next.isDetail = true;
              next.showTotalColumn = showTotalsRow;
              next.hideDetails = rh.hideDetails;
              // an expanded parent's slim band (horizontal-axis views) has no
              // room for its description - suppress it while expanded
              if (next.hideDetails && this.horAxisSelected.length && next.item?.isDescriptor)
                next.item.suppressDescriptor = true;
              next.height = next.isGroupHeader ? null : rh.height + "px";
              next.leaf_node_count = rh.leaf_node_count;
              next.cssClassMeasure = ""; //"row-header-measure";
              next.cssClassMeasure += this.layout.gridLineClass;
              next.cssClassMeasureLast = !this.layout.rightPanel.cols ? " last-column" : showVerticalLineMeasure ? " gridline-separator" : "";

              let cssClassCommon = "";
              if (isExpandedHeader) cssClassCommon += " row-expanded";
              if (rhi === pageRowsSett.length - 1 && !showTotalsRow) cssClassCommon += " last-row";
              next.cssClassMeasure += cssClassCommon;
              if (!this.layout.rightPanel.cols) next.cssClassMeasure += " last-column"
              recurseDetailsSett(next.detail.children, cssClassCommon, next.height, null, isExpandedHeader);
              if (!this.layout.headerRow) {
                let visMeas = this.getVisibleVerticalMeasures();
                if (!visMeas.length) 
                  next.cssClass += " last-column";
                else 
                  visMeas[visMeas.length - 1].cssClass = " last-column";
              }
              next.cssClass += cssEven;
              next.cssClassMeasure += cssEven;
            }
            current = next.subRows;
          });
        });
      this.pageStructureSett = pageStructureSett;
      this.setSelectedItems();
    },
    getNextPageSize() {
      this.vScroll.endClipped = false;
      let i = this.vScroll.dStart;
      let available = this.vScroll.pageHeight - (this.selectedView.definition.showTotalsRow ? 50 : 0);
      const heightZ = this.vScroll.lineHeightZ;
      const heightY = this.vScroll.lineHeightY;
      const singleLineHeight = heightZ > heightY ? heightZ : heightY;
      let usedHeight = 0;
      let allocatedHeight = 0;
      let endI = i;
      this.settData.some((x) => {
        x.height = 0;
        if (x.dIndexEnd >= i) {
          const rh = this.rowLineHeights(x, heightZ, singleLineHeight);
          let detailLines = x.detailIndexes.filter((d) => d.dIndex >= endI);
          let detailLinesVisible = detailLines.map((d, di) => {
            return {
              dIndex: d.dIndex,
              // single-row height only for rows that HAVE one line in total -
              // a multi-detail row scrolled down to its last line keeps its
              // per-line height, or the row balloons mid-scroll
              height: x.detailCount > 1 ? rh.multi : rh.single,
            }
          });
          if (x.showGroupHeader) usedHeight += heightZ;
          detailLinesVisible
            .some((d) => {
              usedHeight += d.height;
              // the window's first line is always allocated, even when taller
              // than the page - otherwise the row renders squashed at 0 height
              if (usedHeight < available || allocatedHeight === 0) {
                endI = d.dIndex;
                x.height += d.height;
                allocatedHeight = usedHeight;
                return usedHeight >= available;
              }
              // boundary line doesn't fit: show a clipped slice of it in the
              // leftover space rather than leaving a gap at the page bottom
              const remaining = available - allocatedHeight;
              if (remaining > 40) {
                endI = d.dIndex;
                x.height += remaining;
                allocatedHeight = available;
                // dEnd now points at a partially shown row - the wheel must
                // still be able to scroll it fully into view
                this.vScroll.endClipped = true;
              }
              return true;
            });
          // this.rowDetails[x.index].height = x.height; // to remove
          // this.rowDetails[x.index].style.height = x.height + "px"; // to remove
          x.style.height = x.height + "px";
          return usedHeight > available;
        }
        return usedHeight >= available;
      });
      this.vScroll.dEnd = endI;


      if (
        endI >= this.vScroll.dMax &&
        this.vScroll.dStart > 0 //&&
        //usedHeight + lineHeight < available // 34 < available
      ) {
        this.vScroll.dEnd = this.vScroll.dMax;
        return this.getPreviousPageSize();
      } else {
        this.vScroll.doSetup = false;
        this.vScroll.allocatedHeight = allocatedHeight;
        this.setVisibleHeaderColumns();
        return this.vScroll.dEnd - this.vScroll.dStart + 1;
      }
    },
    getPreviousPageSize() {
      this.vScroll.endClipped = false;
      let i = this.vScroll.dEnd;
      let available = this.vScroll.pageHeight - (this.selectedView.definition.showTotalsRow ? 50 : 0);
      const heightZ = this.vScroll.lineHeightZ;
      const heightY = this.vScroll.lineHeightY;
      const singleLineHeight = heightZ > heightY ? heightZ : heightY;
      let usedHeight = 0;
      let allocatedHeight = 0;
      let startI = i;
      this.settData
        .slice()
        .reverse()
        .some((x) => {
          x.height = 0;
          if (x.dIndexStart <= i) {
            const rh = this.rowLineHeights(x, heightZ, singleLineHeight);
            let detailLines = x.detailIndexes.filter((d) => d.dIndex <= startI)
                .slice()
                .reverse();
            let detailLinesVisible = detailLines.map((d, di) => {
              return {
                dIndex: d.dIndex,
                height: x.detailCount > 1 ? rh.multi : rh.single,
              }
            });
            if (x.showGroupHeader) usedHeight += heightZ;
            detailLinesVisible
              .some((d) => {
                usedHeight += d.height;
                if (usedHeight < available || allocatedHeight === 0) {
                  startI = d.dIndex;
                  x.height += d.height;
                  allocatedHeight = usedHeight;
                  return usedHeight >= available;
                }
                const remaining = available - allocatedHeight;
                if (remaining > 40) {
                  startI = d.dIndex;
                  x.height += remaining;
                  allocatedHeight = available;
                }
                return true;
              });
            x.style.height = x.height + "px";
            return usedHeight > available;
          }
          return usedHeight >= available;
        });
      this.vScroll.dStart = startI;
      if (
        this.vScroll.dStart <= 0 &&
        this.vScroll.dEnd < this.vScroll.dMax &&
        usedHeight + heightZ < available //34 < available
      ) {
        this.vScroll.dStart = 0;
        return this.getNextPageSize();
      } else {
        this.vScroll.doSetup = false;
        this.vScroll.allocatedHeight = allocatedHeight;
        this.setVisibleHeaderColumns();
        return this.vScroll.dEnd - this.vScroll.dStart + 1;
      }
    },
    setNodeActiveStatus(node, parent, makeInactive) {
      if (node.active === undefined) node.active = 1;
      if (makeInactive) node.active = 0;
      node.canDeactivate = !!node.active;
      node.canReactivate = !node.canDeactivate && (!parent || parent?.active);
      if (node.nodes) {
        node.nodes.forEach((n) => {
          this.setNodeActiveStatus(n, node, makeInactive);
        });
      }
    },
    setScroll() {
      this.vScroll.inProgress = true;
      this.vScroll.doSetup = false;
      let max = this.$refs.scrollContainer.scrollHeight;
      this.$refs.scrollContainer.scrollTop =
        (max * this.vScroll.dStart) / this.vScroll.dMax;
    },
    maximiseView() {
      this.maximised = !this.maximised;
      this.vScroll.doSetup = true;
      this.$nextTick(() => {
        this.setVScrollPageHeight();
      });
    },
    deriveCols(hTextMax, dTextMax) {
      const hco = this.horAxisSelected[0];
      this.display.h_col.colWidth = !hco
        ? 0
        : dTextMax > 80
        ? 5
        : dTextMax > 60
        ? 4
        : dTextMax > 40
        ? 3
        : hTextMax > 12 || dTextMax > 12
        ? 2
        : 1;
    },
    probeMeasureFont() {
      if (!this._measureCtx) {
        const canvas = document.createElement("canvas");
        this._measureCtx = canvas.getContext("2d");
        // row: left panel cells; detail: z cells; chip: chip-styled values; header:
        // column headings (bold/uppercase) — the wrong font mis-sizes columns
        this._measureFonts = {
          row: { font: "400 14px Roboto, sans-serif", ls: 0 },
          detail: null,
          chip: null,
          header: null,
          // matches .descriptor-read/.descriptor-edit CSS; refined by probing
          descriptor: { font: '400 12px "DM Sans", sans-serif', ls: 0.3 },
        };
      }
      // probe the real grid fonts from rendered cells; retry each build until found
      const probeFont = (selector) => {
        const el = this.$el?.querySelector(selector);
        if (!el) return null;
        const cs = window.getComputedStyle(el);
        return cs.fontSize && cs.fontFamily
          ? {
              font: `${cs.fontWeight || 400} ${cs.fontSize} ${cs.fontFamily}`,
              // canvas measureText ignores letter-spacing and text-transform,
              // so track them separately
              ls: parseFloat(cs.letterSpacing) || 0,
              tt: cs.textTransform,
            }
          : null;
      };
      if (!this._measureFontProbed) {
        const f = probeFont(".row-header");
        if (f) {
          this._measureFonts.row = f;
          this._measureFontProbed = true;
        }
      }
      if (!this._measureFontDetailProbed) {
        const f = probeFont(".z-detail");
        if (f) {
          this._measureFonts.detail = f;
          this._measureFontDetailProbed = true;
        }
      }
      if (!this._measureFontChipProbed) {
        const f = probeFont(".detail-cell-chip, .nested-cell-chip");
        if (f) {
          this._measureFonts.chip = f;
          this._measureFontChipProbed = true;
        }
      }
      if (!this._measureFontHeaderProbed) {
        const f = probeFont(".y-columnHeader, .y-columnHeader-number, .rm-header");
        if (f) {
          this._measureFonts.header = f;
          this._measureFontHeaderProbed = true;
        }
      }
      if (!this._measureFontDescriptorProbed) {
        const f = probeFont(".descriptor-read, .descriptor-edit");
        if (f) {
          this._measureFonts.descriptor = f;
          this._measureFontDescriptorProbed = true;
        }
      }
      if (!this._measureFontBarValueProbed) {
        const f = probeFont(".bar-number-value");
        if (f) {
          this._measureFonts.barValue = f;
          this._measureFontBarValueProbed = true;
        }
      }
    },
    // mirror MeasureDisplay.formatValue so measured widths match the rendered text
    formatMeasureValueForWidth(m, val) {
      if (m.numberFormat) return String(this.utils.formatNumber(Number(val), m.numberFormat));
      if (m.format === "pct") return `${(Number(val) || 0).toFixed(2)}%`;
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    measureTextWidth(text, kind) {
      if (!this._measureCtx) this.probeMeasureFont();
      const f =
        (kind === "chip" && (this._measureFonts.chip || this._measureFonts.detail)) ||
        (kind === "detail" && this._measureFonts.detail) ||
        (kind === "barValue" && this._measureFonts.barValue) ||
        (kind === "header" && this._measureFonts.header) ||
        (kind === "descriptor" && this._measureFonts.descriptor) ||
        this._measureFonts.row;
      if (this._measureCtx.font !== f.font) this._measureCtx.font = f.font;
      let t = String(text);
      if (f.tt === "uppercase") t = t.toUpperCase();
      return this._measureCtx.measureText(t).width + f.ls * t.length;
    },
    // ------------------------------------------------------------------
    // column width user overrides: drag-resize + per-user persistence
    // keys: "V:<col>" | "VM:<measure>" | "D:<col>" | "DM:<measure>" | "H"
    // ------------------------------------------------------------------
    applyMeasureWidths() {
      const widths = this.layout?.detailRow?.rowHeading?.measureWidths;
      if (!widths) return;
      this.getVisibleVerticalMeasures().forEach((m, mi) => {
        const w = widths[mi];
        if (!w) return;
        m.cols = w.cols;
        m.widthPct = w.percent;
        m.widthPx = w.px;
        this.$set(m, "barNumberPx", w.barNumberPx);
        this.$set(m, "barAlertPx", w.barAlertPx);
      });
      const dWidths = this.layout?.detailRow?.detail?.measureWidths;
      if (!dWidths) return;
      this.horizontalMeasures.filter((m) => m.visible).forEach((m, mi) => {
        const w = dWidths[mi];
        if (!w) return;
        this.$set(m, "barNumberPx", w.barNumberPx);
        this.$set(m, "barAlertPx", w.barAlertPx);
      });
    },
    // the layout width objects are rebuilt with every layout and are the source of
    // truth for a column's current px; template-held copies (e.g. m.widthPx on the
    // measure objects) can be stale when displayView recreates those objects
    findLayoutColumnPx(key) {
      if (!this.layout) return 0;
      if (key === "LP") return this.layout.leftPanel.viewportPx;
      const dr = this.layout.detailRow;
      const match = [
        ...(dr.rowHeading.titleWidths || []),
        ...(dr.rowHeading.measureWidths || []),
        ...(dr.detail.titleWidths || []),
        ...(dr.detail.measureWidths || []),
      ].find((c) => c.key === key);
      return match?.px || 0;
    },
    // delegated hover: project a full-height guide at the hovered handle's
    // boundary so the drag affordance reads as a column line, not one cell edge
    handleResizeHover(event) {
      const hg = this.columnWidths.hoverGuide;
      const handle = event.target?.closest?.(".col-resize-handle, .panel-resize-handle");
      if (!handle || this.columnWidths.drag.active) {
        if (hg.show) hg.show = false;
        return;
      }
      const rect = handle.getBoundingClientRect();
      const gridRect = this.$refs.detailRow
        ? this.$refs.detailRow.getBoundingClientRect()
        : rect;
      hg.x = rect.right - 2;
      hg.top = Math.min(rect.top, gridRect.top);
      hg.height = gridRect.bottom - hg.top;
      hg.show = true;
    },
    hideResizeHover() {
      if (this.columnWidths.hoverGuide.show) this.columnWidths.hoverGuide.show = false;
    },
    startColResize(event, key, basePx, unitCount) {
      // drags started from body cells pass the h column's colWidth instead of px
      if (key === "H" && !basePx && this.layout) {
        basePx = this.layout.hLeafPx;
        unitCount = unitCount && this.display.h_col.colWidth
          ? unitCount / this.display.h_col.colWidth
          : 1;
      }
      if (key && key !== "H" && !basePx) basePx = this.findLayoutColumnPx(key);
      if (!key || !basePx) return;
      const d = this.columnWidths.drag;
      const cell = event.target.parentElement;
      const rect = cell.getBoundingClientRect();
      const units = unitCount || 1;
      // screen px per model px, so dragging is WYSIWYG even when panels are scaled
      d.scale = rect.width > 0 ? rect.width / (basePx * units) : 1;
      d.unitCount = units;
      d.active = true;
      d.key = key;
      d.startX = event.clientX;
      d.startPx = basePx;
      d.guideX = event.clientX;
      const gridRect = this.$refs.detailRow
        ? this.$refs.detailRow.getBoundingClientRect()
        : rect;
      d.guideTop = Math.min(rect.top, gridRect.top);
      d.guideHeight = gridRect.bottom - d.guideTop;
      window.addEventListener("pointermove", this.onColResizeMove);
      window.addEventListener("pointerup", this.endColResize);
    },
    onColResizeMove(event) {
      const d = this.columnWidths.drag;
      if (!d.active) return;
      const minDx = (_minColumnPx - d.startPx) * d.scale * d.unitCount;
      let dx = event.clientX - d.startX;
      if (dx < minDx) dx = minDx;
      d.guideX = d.startX + dx;
    },
    suppressResizeClick(event) {
      event.stopPropagation();
      event.preventDefault();
      window.removeEventListener("click", this.suppressResizeClick, true);
    },
    endColResize(event) {
      window.removeEventListener("pointermove", this.onColResizeMove);
      window.removeEventListener("pointerup", this.endColResize);
      const d = this.columnWidths.drag;
      if (!d.active) return;
      d.active = false;
      const dx = event.clientX - d.startX;
      // swallow the click that follows a real drag so cell click handlers
      // (sort, designer toggle, document links) don't fire; the handler removes
      // itself when it fires — the timeout is only a fallback if no click follows
      if (Math.abs(dx) > 3) {
        window.addEventListener("click", this.suppressResizeClick, true);
        setTimeout(
          () => window.removeEventListener("click", this.suppressResizeClick, true),
          300
        );
      }
      let px = Math.round(d.startPx + dx / (d.scale * d.unitCount));
      if (px < _minColumnPx) px = _minColumnPx;
      if (px === d.startPx) return;
      this.$set(this.columnWidths.overrides, d.key, px);
      this.applyColumnWidthChange();
    },
    resetColumnWidth(key) {
      if (this.columnWidths.overrides[key] === undefined) return;
      this.$delete(this.columnWidths.overrides, key);
      this.applyColumnWidthChange();
    },
    resetAllColumnWidths() {
      if (!Object.keys(this.columnWidths.overrides).length) return;
      this.columnWidths.overrides = {};
      this.applyColumnWidthChange();
    },
    async applyColumnWidthChange() {
      this.saveColumnWidthOverrides();
      await this.rebuildCompare();
    },
    // saved views persist under their id; the built-in architecture tab views have
    // no view_definition_id, so key those by template + view name instead
    widthSettingViewKey() {
      const v = this.selectedView;
      if (!v) return null;
      if (v.view_definition_id) return String(v.view_definition_id);
      const name = (v.name || "view").replace(/\W+/g, "_");
      return (v.definition.tmpl_id || 0) + "_" + name;
    },
    widthSettingKey() {
      return "catalogueColumnWidths_" + this.widthSettingViewKey();
    },
    computeWidthFingerprint() {
      const cols = (list) => (list || []).map((x) => x.column);
      return {
        tmpl_id: this.selectedView.definition.tmpl_id,
        v: (this.verAxisSelected || []).map(
          (x) => x.column + (x.showDescriptor ? "+d" : "")
        ),
        h: cols(this.horAxisSelected),
        d: cols(this.detAxisSelected),
        vm: this.verticalMeasures.filter((m) => m.visible).map((m) => m.id || m.column),
        dm: this.horizontalMeasures.filter((m) => m.visible).map((m) => m.id || m.column),
      };
    },
    // adopt the user's saved widths when (and only when) the view and its axis /
    // measure fingerprint match what the widths were saved under; overrides go
    // dormant on a mismatch and come back if the shape is reverted
    async syncColumnWidthOverrides() {
      const viewId = this.widthSettingViewKey();
      const fp = JSON.stringify(this.computeWidthFingerprint());
      if (viewId === this.columnWidths.loadedForView && fp === this.columnWidths.fingerprint)
        return;
      this.columnWidths.loadedForView = viewId;
      this.columnWidths.fingerprint = fp;
      this.columnWidths.overrides = {};
      if (!viewId) return;
      const setting = await this.$loginState.getUserViewSetting(this.widthSettingKey());
      if (setting?.widths && JSON.stringify(setting.fingerprint) === fp)
        this.columnWidths.overrides = { ...setting.widths };
    },
    saveColumnWidthOverrides() {
      const viewId = this.widthSettingViewKey();
      if (!viewId || viewId !== this.columnWidths.loadedForView) return;
      const key = this.widthSettingKey();
      const payload = {
        fingerprint: this.computeWidthFingerprint(),
        widths: { ...this.columnWidths.overrides },
        updated: new Date().toISOString(),
      };
      if (this.columnWidths.saveTimer) clearTimeout(this.columnWidths.saveTimer);
      this.columnWidths.saveTimer = setTimeout(() => {
        this.columnWidths.saveTimer = null;
        this.$loginState.saveUserViewSetting(key, payload);
      }, 1000);
    },
    async filterAxes(filter) {
      this.selectedView.definition.searchText = filter.searchText;
      await this.selectJDs();
      this.setVScrollPageHeight();
    },
    textFilters() {
      let text = (this.selectedView.definition.searchText || "").toLowerCase().trim().split(" ").filter(x => x);
      let cols = [];
      if (!text.length) return [];
      this.verAxisAvailable.filter(x => this.selectedView.definition.verAxisSelected.some(a => a.column === x.column))
        .forEach(a => {
          if (a.listValues && a.listValues.length) {
            const vals = a.listValues.filter(v => text.every(t => v.value.toLowerCase().indexOf(t) >= 0));
            if (vals.length) {
              cols.push({ column: a.display_column || a.column, cache_column: a.cache_column, values: vals.map(v => v.value), });
            }
          } else if (!a.listValues) {
            cols.push({ column: a.display_column || a.column, cache_column: a.cache_column, searchValues: text, values: [], });
          }
        });
      this.horAxisAvailable.filter(x => x.listValues && this.selectedView.definition.horAxisSelected.some(a => a.column === x.column))
        .forEach(a => {
          const vals = a.listValues.filter(v => text.every(t => v.value.toLowerCase().indexOf(t) >= 0));
          if (vals.length) {
            cols.push({ column: a.display_column || a.column, cache_column: a.cache_column, values: vals.map(v => v.value), });
          }
        });
      this.detAxisAvailable.filter(x => this.selectedView.definition.detAxisSelected.some(a => a.column === x.column))
        .forEach(a => {
          if (a.listValues && a.listValues.length) {
            const vals = a.listValues.filter(v => text.every(t => v.value.toLowerCase().indexOf(t) >= 0));
            if (vals.length) {
              cols.push({ column: a.display_column || a.column, cache_column: a.cache_column, values: vals.map(v => v.value), });
            }
          } else if (!a.listValues) {
            cols.push({ column: a.display_column || a.column, cache_column: a.cache_column, searchValues: text, values: [], });
          }
        });
      if (text.length && !cols.length) {
        cols.push({ column: "___", values: ["___"]});
      }
      return cols;
    },
    async selectJDs(restoring, filterTrigger, nestedDrilldown) {
      this.isBuilding = true;
      this.filterStateVersion++; // invalidates the pickers' scope-on-open cache
      const tmpl_id = this.selectedView.definition.tmpl_id;
      let filters = this.verAxisAvailable
        .filter((x) => x.filterValues.length)
        .concat(this.horAxisAvailable.filter((x) => x.filterValues.length));
      let textFilters = this.textFilters();
      const hpFilters = this.activeHierarchyPickers();
      let selectedDocs = _documents.filter((d) => {
        if (d.tmpl_id !== tmpl_id) return false;
        d.selected = this.compareDocs.some((x) => x.doc_id === d.doc_id);
        if (
          filters.length === 0 &&
          hpFilters.length === 0 &&
          !this.measureFilter?.type &&
          !this.nestedDrilldownFilter
        ) {
          return true;
        } else {
          if (
            this.measureFilter &&
            this.measureFilter.type &&
            (d[this.measureFilter.type] || 0) === 0
          )
            return false;
          let result = true;
          if (this.nestedDrilldownFilter) {
            let val = d[this.nestedDrilldownFilter.column] || "UNCLASSIFIED";
            if (val !== this.nestedDrilldownFilter.value) result = false;
          }
          return (
            result &&
            this.matchesHierarchyPickers(d, hpFilters) &&
            filters.every((f) => {
              let col = f.ht_id ? f.display_column : f.column;
              return f.filterValues.some((fv) => d[col] === fv);
            })
          );
        }
      });
      if (textFilters.length) {
        selectedDocs = selectedDocs.filter((d) => 
            textFilters.some(c => 
              !c.searchValues 
                ? c.values.some(v => v === d[c.column]) 
                : c.searchValues.every(s => d[c.column].toLowerCase().indexOf(s) >= 0) 
        ));
      }
      if (this.measureFilterTypes?.length) {
        const mFilters = this.identifyMeasureFilters("R");
        if (mFilters.length)
          selectedDocs = selectedDocs.filter((d) =>
            mFilters.every(f => 
                (f.rangeFrom === null || d[f.type] >= f.rangeFrom)
                && (f.rangeTo === null || d[f.type] <= f.rangeTo)
              )
          );
      }
      if (this.selectedView.definition.nameChangeFilters?.length) {
        let nfs = this.selectedView.definition.nameChangeFilters;
        if (this.selectedView.definition.ht_id) {
          selectedDocs = selectedDocs.filter((d) =>
            nfs.some((f) => d[f]?.length)
          );
        }
      }
      if (this.selectedView.definition.transactionTypeFilters?.length) {
        let tfs = this.selectedView.definition.transactionTypeFilters;
        if (this.selectedView.definition.ht_id) {
          let col = `ht_id_${this.selectedView.definition.ht_id}_transactions`;
          selectedDocs = selectedDocs.filter(
            (d) => d[col].length && d[col].some((f) => tfs.some((v) => v === f))
          );
        }
      }
      if (!nestedDrilldown)
        this.selectedDocs = selectedDocs;

      this.filterList = filters.map((f) => {
        return {
          title: `${f.name} = [${f.filterValues.join(", ")}]`,
          name: f.name,
        };
      });
      hpFilters.forEach((h) => {
        this.filterList.push({
          title: `${h.name} = [${h.selectedNodes.map((n) => n.name).join(", ")}]`,
          name: h.name,
          column: h.column,
        });
      });
      if (this.selectedView.definition.nameChangeFilters.length) {
        let defs = this.getNameChangeTypes();
        this.filterList.push({
          title: `Name Changes to: [${this.selectedView.definition.nameChangeFilters
            .map((x) => defs.find((d) => d.value === x).text)
            .join(", ")}]`,
          name: "Name Changes",
          column: "nameChangeFilters",
        });
      }
      if (this.selectedView.definition.viewType === "catalogue") {
        if (!nestedDrilldown) {
          // not awaited: the grid rebuild must not wait on the index round trip
          this.narrowFilterOptions();
          this.compareCriteria.splice(0, this.compareCriteria.length);
          this.compareDocs.splice(0, this.compareDocs.length);
        }
        await this.buildCompare(selectedDocs);
      }
      this.resetIsBuilding = true;
      this.afterInit();
      this.resetHScroll();
      if (!restoring) this.updateViewDefinition();
    },
    async narrowFilterOptions() {
      // PD-1318: narrow each visible filter's available options to the docs
      // matching all OTHER active filters — never its own selection, so an
      // existing selection can still be extended.
      const listFilters = this.verAxisAvailable.filter(
        (x) => x.visible && x.listValues && x.listValues.length
      );
      if (!listFilters.length) return;
      const activeConstraints = (except) =>
        this.verAxisAvailable
          .filter((x) => x.filterValues.length && x.column !== except.column)
          .concat(
            this.horAxisAvailable.filter(
              (x) => x.filterValues.length && x.column !== except.column
            )
          );
      const applyValues = (x, values) => {
        // selected values stay listed even when other filters exclude them,
        // so they remain visible and clearable
        const vals = new Set([...values, ...x.filterValues]);
        x.listValuesFiltered = x.listValues
          .filter((v) => vals.has(v.value))
          .map((v) => v.value);
      };
      const token = ++this.narrowFilterToken;
      const hpFilters = this.activeHierarchyPickers();
      if (!activeConstraints({ column: null }).length && !hpFilters.length) {
        // nothing active anywhere: reset locally, no round trip needed
        listFilters.forEach((x) =>
          (x.listValuesFiltered = x.listValues.map((v) => v.value))
        );
        return;
      }
      if (this.useIndex) {
        const hpIndexFilters = this.hierarchyPickerIndexFilters();
        const params = listFilters.map((x) => ({
          column: x.column,
          tag: x.ht_id ? x.display_column : this.getIndexAttrName(x),
          filters: this.getIndexFilterParams([
            ...activeConstraints(x).map(this.mapIndexFilter),
            ...hpIndexFilters,
          ]),
        }));
        const resp = await this.$store.getters["docs/getCountsByAttr"](params);
        if (token !== this.narrowFilterToken) return; // superseded by a newer filter change
        if (!resp || !resp.length) return; // index unavailable: leave lists as they are
        listFilters.forEach((x, xi) => {
          const values =
            resp
              .find((c) => c.tag === params[xi].tag)
              ?.values.map((v) =>
                Array.isArray(v.value) ? v.value.join("|") : v.value
              ) || [];
          applyValues(x, values);
        });
      } else {
        const tmpl_id = this.selectedView.definition.tmpl_id;
        const tmplDocs = _documents.filter(
          (d) =>
            d.tmpl_id === tmpl_id && this.matchesHierarchyPickers(d, hpFilters)
        );
        listFilters.forEach((x) => {
          const others = activeConstraints(x);
          const docs = others.length
            ? tmplDocs.filter((d) =>
                others.every((f) => {
                  const col = f.ht_id ? f.display_column : f.column;
                  return f.filterValues.some((fv) => d[col] === fv);
                })
              )
            : tmplDocs;
          const col = x.ht_id ? x.display_column : x.column;
          applyValues(
            x,
            docs.filter((d) => d.job_count).map((d) => d[col])
          );
        });
      }
    },
    getAggregateMeasures() {
      let aggregateColumns = this.getMeasureColumns().filter(
        (m) => ["mean","overall_percent","mean ratio","median ratio"].some(x => x === m.aggregation)
      );
      this.getVisibleVerticalMeasures().filter(x => x.displayType?.percentColumn && !aggregateColumns.some(a => a.aggregation_quantity_column === x.column))
        .forEach(x => aggregateColumns.push(x));
      this.getVisibleHorizontalMeasures().filter(x => x.displayType?.percentColumn && !aggregateColumns.some(a => a.aggregation_quantity_column === x.column))
        .forEach(x => aggregateColumns.push(x));
      return aggregateColumns;
    },
    getMeasureColumns() {
      const measureFilters = this.measureFilterTypes.reduce((p,c) => [...p, ...c.filters.filter(x => x && (x.rangeFrom !== null || x.rangeTo !== null))],[]);
      return this.measures.filter(m => 
        m.type === "job_count" ||
        this.verticalMeasures.some(v => v.visible && v.available && v.type === m.type) ||
        this.horizontalMeasures.some(v => v.visible && v.available && v.type === m.type) ||
        measureFilters.some(x => x.type === m.type)
      );
    },
    getVisibleVerticalMeasures() {
      return this.verticalMeasures.filter((vm) => vm.visible && vm.available);      
    },
    getVisibleHorizontalMeasures() {
      return this.horizontalMeasures.filter((vm) => vm.visible && vm.available);      
    },
    getVisibleAggregateMeasuresForIndex(chartMeasures) {
      let aggs = [];
      this.measures.forEach((m) => {
        let visM = this.horizontalMeasures.find((vm) => vm.id === m.id && vm.visible && vm.available);
        if (!visM) visM = this.verticalMeasures.find((vm) => vm.id === m.id && vm.visible && vm.available);
        if (!visM && chartMeasures?.length) visM = chartMeasures.find((vm) => vm.id === m.id);
        if (m.derivation === "count" || visM) {
          const as = m.column + (m.derivation !== "count" ? "_" + m.derivation : "");
          const linkedAs = m.derivation === "mean" ? m.column + "_sum" : "";
          let agg = aggs.find(a => a.as === as);
          if (!agg) {
            agg = { type: m.derivation, column: m.cache_column || "", as: as, ids: [] };
            aggs.push(agg);
            if (linkedAs && ! aggs.some(a => a.as === linkedAs))// if any include mean then also get sum...
              aggs.push({ type: "sum", column: m.cache_column || "", as: linkedAs, ids: [] });
          }
          agg.ids.push(m.id);
          if (visM?.column_basis) {
            agg.column_basis = visM.column_basis;
            agg.catalogue_ratio_primary_value = visM.catalogue_ratio_primary_value;
            agg.catalogue_ratio_secondary_value = visM.catalogue_ratio_secondary_value;
            agg.single_comparator_text = visM.single_comparator_text;
          }
        }
      });
      return aggs;
    },
    appendMeasureColumns(subject, defaultValue, source, measureList) {
      let item = subject || {};
      let cols = measureList || this.measures;
      cols.forEach((m) => {
        item[m.id] =
          source && source[m.id] !== undefined
            ? Number(source[m.id])
            : defaultValue !== undefined
            ? defaultValue
            : null;
      });
      if (!subject) return item;
    },
    appendMeasurePercentColumns(cols, source, destination) {
      cols.forEach(c => {
        const sourceVal = destination[c.source] === undefined ? source[c.source] : destination[c.source];
        destination[c.dest] = source[c.divisor] ? 100 * sourceVal / source[c.divisor] : null;
      })
    },
    getPercentColumnDefs() {
      let cols = [];
      this.verticalMeasures.filter(x => x.visible).forEach(m => {
        if (m.displayType.percentColumn)
          cols.push({ scope: m.displayType.scope, dest: `${m.id}${m.displayType.percentColumn}`, source: m.id, divisor: `${m.id}${m.displayType.divisor}`, calc: m.displayType.calc });
      });
      this.horizontalMeasures.filter(x => x.visible).forEach(m => {
        const dest = `${m.id}${m.displayType.percentColumn}`;
        if (m.displayType.percentColumn && !cols.some(c => c.dest === dest) )
          cols.push({ scope: m.displayType.scope, dest: dest, source: m.id, divisor: `${m.id}${m.displayType.divisor}`, calc: m.displayType.calc, isDetail: true });
      });
      return cols;
    },
    appendMatchColumns(subject, matchColumns, match_key) {
      let item = subject || {};
      item.match_key = match_key || "";
      // item.matchColumns = matchColumns || [];
      item.selected = this.compareCriteria.some(
        (x) => x.match_key === item.match_key
      );
      if (!subject) return item;
    },
    appendAggregateColumns(subject, defaultValue, source, measureList) {
      let item = subject || {};
      let cols = measureList || this.measures;
      cols
        .filter((m) => m.aggregation === "mean")
        .forEach((m) => {
          item[m.id + "_mean"] =
            source && source[m.id + "_mean"] !== undefined
              ? source[m.id + "_mean"]
              : defaultValue !== undefined
              ? defaultValue
              : null;
          item[m.id + "_mean_number"] =
            source && source[m.id + "_mean_number"] !== undefined
              ? Number(source[m.id + "_mean_number"])
              : defaultValue !== undefined
              ? defaultValue
              : null;
          item[m.id + "_mean_value_count"] =
            source && source[m.id + "_mean_value_count"] !== undefined
              ? Number(source[m.id + "_mean_value_count"])
              : defaultValue !== undefined
              ? defaultValue
              : null;
          item[m.id + "_std_dev"] =
            source && source[m.id + "_std_dev"] !== undefined
              ? Number(source[m.id + "_std_dev"])
              : defaultValue !== undefined
              ? defaultValue
              : null;
          item[m.id + "_category"] =
            source && source[m.id + "_category"] !== undefined
              ? source[m.id + "_category"]
              : null;
        });
      if (!subject) return item;
    },
    removeFilter(f) {
      [this.verAxisAvailable, this.horAxisAvailable].forEach((o) => {
        let fl = o.find((x) => x.name === f.name);
        if (fl) {
          fl.filterValues = [];
          if (fl.currentDrillDownLevel !== undefined)
            fl.currentDrillDownLevel = 1;
        }
      });
      const hp = this.hierarchyPickerFilters.find((x) => x.column === f.column);
      if (hp) {
        hp.selected = [];
        hp.selectedNodes = [];
      }
      if (f.column === "nameChangeFilters") {
        this.selectedView.definition.nameChangeFilters.splice(
          0,
          this.selectedView.definition.nameChangeFilters.length
        );
      }
      this.updateViewDefinition();
      this.selectJDs();
    },
    doNestedDrilldown(item, compareOptionName) {
      let drilldown = item.node?.drilldown;
      if (!drilldown) return;
      if (drilldown.expanded) {
        // remove rows
        this.removeNestedDrilldown(item, compareOptionName);
        return;
      }
      const cIndex = this[compareOptionName].findIndex((x) => x.ht_id);
      let compareOption = this[compareOptionName][cIndex];
      if (this[compareOptionName].some(x => x.column !== compareOption.column && !x.containerColumn)) {
        return; // can't expand if has further group columns
      }
      drilldown.expanded = true;
      let viewCompareOption = this.selectedView.definition[
        compareOptionName
      ][cIndex];
      let f = {
        column: compareOption.drillDownLevels.find(l => l.hLevel === drilldown.hLevel).column,
        value: drilldown.value,
        ht_id: compareOption.ht_id,
        level: compareOption.currentDrillDownLevel,
        name: compareOption.name,
        leaf_node_count: item.leaf_node_count,
        // columns: cols,
        compareOptionName: compareOptionName,
        drilldown_match_key: item.match_key,
        indentLevel: item.indentLevel + 1,
        compareOption: compareOption,
        viewCompareOption: viewCompareOption,
        drilldown: drilldown,
      };
      this.appendMatchColumns(
        f,
        null, //[this.getColumnName(compareOption)],
        this.buildMatchKey(
          this.getColumnName(compareOption),
          drilldown.value
        )
      );
      this.appendMeasureColumns(f, 0, item);
      this.appendAggregateColumns(f, 0, item);
      this.nestedDrilldownFilter = f;
      compareOption.currentDrillDownLevel = item.indentLevel + 2;
      viewCompareOption.currentDrillDownLevel =
        compareOption.currentDrillDownLevel;
      this.selectJDs(false, false, true);
    },
    addNestedDrilldown(indentLevel, settData){
      if (!settData.length) {
        if (!indentLevel) return false;
        // the drilldown returned no rows (e.g. all pruned by measure filters):
        // unwind the expand and keep the current view — falling through would
        // rebuild the whole layout from the drilldown-filtered structure
        this.response = {
          Status: "Warning",
          Message: "No rows match the current filters for this expansion",
        };
        if (this.nestedDrilldownFilter) {
          this.nestedDrilldownFilter.compareOption.currentDrillDownLevel = this.nestedDrilldownFilter.level;
          this.nestedDrilldownFilter.viewCompareOption.currentDrillDownLevel = this.nestedDrilldownFilter.level;
          if (this.nestedDrilldownFilter.drilldown)
            this.nestedDrilldownFilter.drilldown.expanded = false;
          this.nestedDrilldownFilter = null;
        }
        return true;
      }
      settData.forEach(x => { 
        x.indentLevel = indentLevel;
        x.headerColumns[0].indentLevel = indentLevel;
      });
      if (!indentLevel) {
        return false;
      }
      const recurseTo = this.horAxisSelected.length;
      const recurseChildren = (requiredColumns, suppliedColumns, level) => {
        return requiredColumns.map((rc) => {
          let newCol = suppliedColumns.find(x => x.key === rc.key);
          if (newCol) {
            if (rc.children?.length && level < recurseTo) {
              let newchildren = rc.children.map((ch) => {    
                let newChild = newCol.children.find(x => x.key === ch.key);
                if (newChild) {
                  newChild.children = recurseChildren(ch.children, newChild.children, level + 1);
                  newChild.colCSS = ch.colCSS;
                  return newChild;
                } else {
                  return ch;
                }
              });
              newCol.children = newchildren;
            }
            if (rc.colCSS) newCol.colCSS = rc.colCSS;
            return newCol;
          } else {
            return rc;
          }
        });
      };
      let hindex = this.settData.findIndex(x => x.match_key === this.nestedDrilldownFilter.drilldown_match_key && !x.isGroupHeader);
      if (hindex < 0) {
        // parent row not found: log why, unwind the drill level and the caret's
        // expanded flag, and leave the current view intact instead of throwing
        // eslint-disable-next-line no-console
        console.warn("addNestedDrilldown: parent row not found", {
          drilldown_match_key: this.nestedDrilldownFilter.drilldown_match_key,
          settDataKeys: this.settData.map((x) => x.match_key),
        });
        this.nestedDrilldownFilter.compareOption.currentDrillDownLevel = this.nestedDrilldownFilter.level;
        this.nestedDrilldownFilter.viewCompareOption.currentDrillDownLevel = this.nestedDrilldownFilter.level;
        if (this.nestedDrilldownFilter.drilldown)
          this.nestedDrilldownFilter.drilldown.expanded = false;
        this.nestedDrilldownFilter = null;
        return true;
      }
      const horChildren = this.settData[hindex].children;
      settData.forEach(d => {
        let tmp = JSON.parse(JSON.stringify(horChildren));
        d.children = recurseChildren(tmp, d.children, 1);
      });
      this.settData[hindex].hideDetails = true;
      this.settData[hindex].headerColumns[0].node.drilldown.expanded = true;

      // order the incoming section by the active sort (the view default or the
      // user's header sort), so expanded rows respect it within their section
      const sc = this.selectedView.sortColumn;
      if (sc && sc.name) {
        const vm = this.getVisibleVerticalMeasures().find((x) => x.column === sc.name || x.id === sc.name);
        if (vm || !sc.isNumber) {
          const getKey = vm ? (r) => r[vm.id] : (r) => r.columnSortKeys?.[0];
          settData.sort((a, b) => this.compareSortValues(getKey(a), getKey(b), sc.descending));
        }
      }

      if (this.selectedView.definition.showSubHeading) {
        settData[0].showGroupHeader = settData[0].headerColumns[0].node.label;
      }
      const newMatchKey = this.settData[hindex].match_key;
      this.settData.splice(hindex + 1, 0, ...settData);
      const affectedComp = this.compareCriteria.filter(x => x.match_key.indexOf(newMatchKey) === 0).map(x => { x.childMatch = x.match_key.replace(newMatchKey, ""); return x; } );
      if (affectedComp.some(x => x.match_key === newMatchKey)) {  
        settData.filter(r => r.job_count).forEach(r => { 
          this.selectJob(r, true);
        });
      } else if (affectedComp.length) {
        const recurseChildren = (children) => {
          children.filter(rc => rc.job_count).forEach(rc => {
            if (affectedComp.some(x => rc.match_key.indexOf(x.childMatch) > 0)) {
              this.selectJob(rc, false, true);
            }
            recurseChildren(rc.children);
          });
        };
        settData.filter(r => r.job_count).forEach(r => recurseChildren(r.children));
      }
      // remove hidden match keys
      const toRemove = this.compareCriteria.filter(x => x.match_key.indexOf(newMatchKey) === 0 && x.match_key.length > newMatchKey.length);
      this.compareCriteria = this.compareCriteria.filter(x => !toRemove.some(r => r.match_key === x.match_key));

      this.setRowIndexes();


      this.getNextPageSize();
      this.nestedDrilldownFilter.compareOption.currentDrillDownLevel = 1;
      this.nestedDrilldownFilter.viewCompareOption.currentDrillDownLevel = 1;
      this.nestedDrilldownFilter = null;

      return true;
    },
    deriveNestedRows(item){
      let parentIndex = -1;
      let finished = false;
      let nLength = this.settData.filter((x, xi) => {
        if (finished) return false;
        if (parentIndex < 0 && x.match_key === item.match_key && !x.isGroupHeader) {
          parentIndex = xi;
          return false;
        } else if (parentIndex >= 0 && (x.indentLevel >= item.indentLevel + 1 || x.isGroupHeader)) {
          return true;
        } else if (parentIndex >= 0 && x.indentLevel === item.indentLevel) {
          finished = true;
          return false;
        } else {
          return false;
        }
      }).length;
      return { parentIndex: parentIndex, rowCount: nLength };
    },
    removeNestedDrilldown(item){
      item.node.drilldown.expanded = false;
      let nested = this.deriveNestedRows(item);

      const row = this.settData.find(x => x.match_key === item.match_key);
      if (!row) {
        // eslint-disable-next-line no-console
        console.warn("removeNestedDrilldown: parent row not found", {
          item_match_key: item.match_key,
          settDataKeys: this.settData.map((x) => x.match_key),
        });
        return;
      }
      row.headerColumns[0].node.drilldown.expanded = false;
      row.hideDetails = false;
      const toRemove = this.settData.splice(nested.parentIndex + 1, nested.rowCount).map(x => x.match_key);
      if (this.compareCriteria.some(x => x.match_key === item.match_key))
        this.compareCriteria = this.compareCriteria.filter(x => !toRemove.some(r => r === x.match_key));

      this.setRowIndexes();
      this.getNextPageSize();
    },
    identifyMeasureFilters (axis) {
      const mFilters = [];
      this.measureFilterTypes.filter(x => x.axis === axis && x.filters.filter(f => f).length).
        forEach(mt => {
          mt.filters.filter(x => x && (x.rangeFrom !== null || x.rangeTo !== null)).forEach(f => mFilters.push(f));
        });
      return mFilters.map(f => {
        if (f.rangeFrom !== null) f.rangeFrom = Number(f.rangeFrom);
        if (f.rangeTo !== null) f.rangeTo = Number(f.rangeTo);
        return f;
      });
    },
    async processDetails(docs, filters, maxHLeafs, axes, measureTotals, measureTotalsSett) {
      let data = {
        rowHeadings: [],
        rowDetails: [],
        usedHLeafs: 0,
        dMeasuresLengths: this.horizontalMeasures.filter(m => m.visible).map((m) => {
          return { column: m.column, key_column: m.id || m.column, alignment: m.alignment, maxLength: 0, maxLengthMean: 0, columnTitle: m.columnTitle, adjustment: !m.hideSelector && m.id === "job_count" ? 5 : 0 };
        }),
        dWidths: null,
        vWidths: null,
        vMWidths: null,
        vSectionWidth: null,
        dMWIdths: null,
        measureTotals: [],
        measureTotalsSett: [],
        totalData: [],
      };

      const aggMeasures = this.getAggregateMeasures();

      let [sumDataV, sumDataH] = await Promise.all([this.groupByKeysNested(
          docs,
          filters,
          axes.axisList,
          this.getMeasureColumns(),
          aggMeasures,
          this.getResolvedDefaultSortSpec()
        ),
        this.groupByKeysNested(
          docs,
          filters,
          axes.axisListH,
          this.getMeasureColumns(),
          aggMeasures, null, true
        )]);
      data.totalData = this.selectedView.definition.showTotalsRow ? (await this.groupByKeysNested(
        docs,
        filters,
        [{ 
          axis: 'V', 
          colChildren: "tmpl_id", 
          columns: [{
            column: "tmpl_id", column_key: "tmpl_id", column_match: "tmpl_id", column_title: "tmpl_id", column_sort: "tmpl_id",
            name: "tmpl_id",
          }],
          headerColumns: [{ column: "tmpl_id", contains: [], index: 0, valueDisplayType: "text", valueIcon: null }],
        }],
        this.getMeasureColumns(),
        aggMeasures, null, true
      )).sett : [];

      const groupColWidths = (compareOptions, padding, keyPrefix, titleFloor, sortIcon) => {
        let cols = compareOptions.map((o, oi) => {
          // measuredTextChars (from the actual rendered titles in this result set)
          // is more accurate than the char-count estimate over all template values;
          // when present, the node-chrome char allowances collapse to a small flat
          // icon allowance and the drill-level minimum floor is not needed
          const measured = o.measuredTextChars !== undefined;
          // chip-styled columns render no row actions, so need less chrome
          const pad = measured && o.valueDisplayType === "chip" ? padding / 2 : padding;
          let c = {
            index: oi,
            key: keyPrefix && (o.key_column || o.column) ? keyPrefix + ":" + (o.key_column || o.column) : null,
            length:
              (measured
                ? o.measuredTextChars
                : o.maxLength -
                  0.4 * (o.maxLength - (o.maxLengthMean || o.maxLength))) +
              pad +
              (o.noderule ? (measured ? 3 : 10) : 0) +
              (!measured && o.noderule?.nextLevel ? 10 : 0) +
              (!measured && o.noderule?.currLevel?.usesDescriptor ? 6 : 0) +
              // prefix/suffix are part of the rendered title, so the measured text
              // already includes them — only add them in estimate mode
              (!measured && o.prefix ? o.prefix.length : 0) +
              (!measured && o.suffix ? o.suffix.length : 0) +
              (o.rangeColumns ? o.rangeColumns.reduce((p, cc) => p + cc.maxLength + 8, 0) : 0) +
              (o.groupColumns ? o.groupColumns.reduce((p, cc) => p + cc.maxLength + 8, 0) : 0) +
              (!measured && o.adjustment ? o.adjustment : 0),
            percent: "",
            cols: 0,
            title: o.overrideTitle || o.name || o.columnTitle || "",
            valueDisplayType: o.valueDisplayType,
            containerColumn: o.containerColumn,
            containerColumnShowRange: o.containerColumn && o.containerColumnShowRange,
            containerColumnGroupMeasure: o.containerColumn && o.containerColumnGroupMeasure,
            valueIcon: o.valueIcon,
            column: o.column,
            alignment: o.alignment,
            displayStyle: _defaultHeaderColours,
            isDescriptor: o.isDescriptor || false,
            sortIndex: o.sortKeyIndex,
            // totals-bar alignment metrics: carried on the layout width objects
            // (the source of truth) because displayView recreates measure objects
            barNumberPx: o.barNumberPx,
            barAlertPx: o.barAlertPx,
          };
          if (!measured && o.noderule?.prevLevel && c.length < 50) c.length = 50;
          // the (bold) header title must fit too — but only when that heading is
          // actually rendered (titleFloor: default true; false or a per-column fn)
          const floorByTitle =
            typeof titleFloor === "function" ? titleFloor(o) : titleFloor !== false;
          if (floorByTitle && c.title) {
            const titleChars =
              this.measureTextWidth(c.title, "header") / _pxPerChar + (sortIcon ? 3 : 0);
            if (titleChars + pad > c.length) c.length = titleChars + pad;
          }
          return c;
        });
        let columns = cols.filter(c => !c.containerColumn).map(o => {
          o.embeddedColumns = cols.filter(x => o.column && x.containerColumn === o.column && !x.containerColumnShowRange && !x.containerColumnGroupMeasure);
          o.length = o.embeddedColumns.reduce((p,c) => c.length > p ? c.length : p, o.length);
          o.rangeColumns = cols.filter(x => x.containerColumn === o.column && x.containerColumnShowRange);
          o.groupColumns = cols.filter(x => x.containerColumn === o.column && x.containerColumnGroupMeasure);
          return o;
        });
        // user overrides (px) replace the derived length and are exempt from the shrink loop
        const overrides = this.columnWidths.overrides || {};
        columns.forEach((c) => {
          if (c.key && overrides[c.key] > 0) {
            c.length = Math.max(overrides[c.key], _minColumnPx) / _pxPerChar;
            c.overridden = true;
          }
        });
        let total = columns.reduce((p, c) => p + c.length, 0);
        const shrinkFactor = 0.9;
        const minWidthPct = 8;
        const largeWidthPct = 15;
        let canShrink = true;
        while (canShrink && columns.some(x => !x.overridden && x.length > 0 && (100 * x.length) / total < minWidthPct)) {
          let toShrink = columns.filter(x => !x.overridden && (100 * x.length) / total > largeWidthPct);
          toShrink.forEach(x => x.length = x.length * shrinkFactor);
          canShrink = !!toShrink.length;
          total = columns.reduce((p, c) => p + c.length, 0);
        }
        columns.forEach((w) => {
          w.percent = (100 * w.length) / total + "%";
          w.cols = Math.round((12 * w.length) / total) || 1;
          w.px = Math.round(w.length * _pxPerChar);
        });

        if (columns.length) {
          while (columns.reduce((p, c) => p + c.cols, 0) > 12) {
            let index = columns.findIndex(
              (v) =>
                v.cols ===
                columns.reduce((p, c) => (c.cols > p ? c.cols : p), 0)
            );
            columns[index].cols -= 1;
          }
          while (columns.reduce((p, c) => p + c.cols, 0) < 12) {
            let index = columns.findIndex(
              (v) =>
                v.cols ===
                columns.reduce(
                  (p, c) => (c.cols > 0 && c.cols < p ? c.cols : p),
                  12
                )
            );
            columns[index].cols += 1;
          }
        }
        return {
          columns: columns,
          totalWidth: total,
          totalPx: Math.round(total * _pxPerChar),
        };
      };

      if (this.measureFilterTypes?.length) {
        const vFilters = this.identifyMeasureFilters("V");
        const hFilters = this.identifyMeasureFilters("H");
        const dFilters = this.identifyMeasureFilters("D");
        const testRows = (rows, filters) => {
          return rows.filter(r => 
            filters.every(f => 
              (f.rangeFrom === null || r[f.id] >= f.rangeFrom)
              && (f.rangeTo === null || r[f.id] <= f.rangeTo)
            )
          );
        };
        const testToLevel = (rows, filters, level) => {
          if (!rows.length) return;
          if (level === 1)
            return testRows(rows, filters);
          rows.forEach(r => r.children = testToLevel(r.children, filters, level - 1));
          return rows.filter(r => r.children.length);
        };
        if (vFilters.length)
          sumDataV.sett = testToLevel(sumDataV.sett, vFilters, 1);
        if (hFilters.length && this.detAxisSelected.length) {
          sumDataH.sett = testToLevel(sumDataH.sett, hFilters, this.horAxisSelected.length);
          sumDataV.sett.forEach(x => {
            x.children = x.children.filter(c => sumDataH.sett.some(h => h.key === c.key));
          });
          sumDataV.sett = sumDataV.sett.filter(x => x.children.length);
        } else if (hFilters.length) {
          sumDataV.sett = testToLevel(sumDataV.sett, hFilters, (this.verAxisSelected.length ? 1 : 0) +
            this.horAxisSelected.length);
        }
        if (dFilters.length) {
          sumDataV.sett = testToLevel(sumDataV.sett, dFilters, (this.verAxisSelected.length ? 1 : 0) +
            this.horAxisSelected.length + 1);
        }

        if (sumDataH.sett.length && (vFilters.length || hFilters.length || dFilters.length)) {
          let usedhKeys = new Set([]);
          const getHLevel = (rows, level) => {
            if (level === 1) 
              usedhKeys = usedhKeys.union(new Set(rows.map(c => c.key)));
            else 
              rows.forEach(r => getHLevel(r.children, level - 1));
          };
          getHLevel(sumDataV.sett, 1 + this.horAxisSelected.length);
          const filterKeys = (rows, level) => {
            if (level === 1)
              return rows.filter(x => usedhKeys.has(x.key));
            rows.forEach(r => r.children = filterKeys(r.children, level - 1));
            return rows.filter(r => r.children.length);
          }
          sumDataH.sett = filterKeys(sumDataH.sett, this.horAxisSelected.length);
        }
      }

      const pctColDefs = this.getPercentColumnDefs();  

      let maxMeasureValue = 0;
      const recurseMaxValue = (instance, measure) => {
        if (instance.collectionName) {
          instance[instance.collectionName].forEach(c => {
            recurseMaxValue(c, measure);
          });
        } else {
          const value = instance[measure.source];
          if (maxMeasureValue < value) maxMeasureValue = value;
        }
      };
      let maxMeasureValueSett = 0;
      const recurseMaxValueSett = (instance, measure) => {
        if (instance.children?.length) {
          instance.children.forEach(c => {
            recurseMaxValueSett(c, measure);
          });
        } else {
          const value = instance[measure.source];
          if (maxMeasureValueSett < value) maxMeasureValueSett = value;
        }
      };

      if (pctColDefs.length) {
        pctColDefs.filter(d => d.scope === "line").forEach(m => {
          sumDataV.sett.forEach(x => {
            const value = x[m.source];
            if (m.calc === "max") {
              maxMeasureValueSett = 0;
              recurseMaxValue(x, m);
              x[m.divisor] = maxMeasureValueSett;
            } else {
              x[m.divisor] = value;
            }
            x.children.forEach(hc => this.appendMeasurePercentColumns(pctColDefs, x, hc));
          });
        });
        pctColDefs.filter(d => d.scope === "overall").forEach(m => {
          let max = 0;
          let tot = 0;
          sumDataV.sett.forEach(x => {
            const value = x[m.source];
            if (m.calc === "max") {
              if (m.isDetail) {
                maxMeasureValueSett = 0;
                recurseMaxValueSett(x, m);
                if (max < maxMeasureValueSett) max = maxMeasureValueSett;
              } else {
                if (max < value) max = value;
              }
            } else {
              tot += value;
            }
          });
          if (measureTotalsSett?.length) {
            const target = measureTotalsSett.find(x => x.divisor === m.divisor);
            if (target && m.calc === "max")
              max = target.value;
            else if (target)
              tot = target.value;
          }
          sumDataV.sett.forEach(x => {
            x[m.divisor] = m.calc === "max" ? max : tot;
            x.headerColumns.forEach(hc => this.appendMeasurePercentColumns(pctColDefs, x, hc));
          });
          m.value = m.calc === "max" ? max : tot;
          data.measureTotalsSett.push(m);
        });
      }
      const setIncludedHorizontalColumns = (parent) => {
        let leafCount = 0;
        if (parent.children?.length) {
          parent.children.filter((c) => {
            if (data.usedHLeafs >= maxHLeafs) return false;
            leafCount += setIncludedHorizontalColumns(c);
            return true;
          });
          parent.include = parent.children.some(x => x.include);
        } else {
          leafCount = 1;
          data.usedHLeafs++;
          parent.include = data.usedHLeafs <= maxHLeafs;
        }
        parent.leafCount = leafCount;
        return leafCount;
      };
      const setSubHeaderWidthsSett = (hCol) => {
        hCol.children.forEach((c) => {
          const width =
            100 * c.leafCount / hCol.leafCount;
          c.colCSS = {
            maxWidth: width + "%",
          };
          c.colWidth = this.display.h_col.colWidth * c.leafCount;
          setSubHeaderWidthsSett(c);
        });
      };
      const copySubHeaderWidths = (source, target) => {
        if (!source.children) return;
        source.children.forEach((c, ci) => {
          if (target.children.length > ci) {
            target.children[ci].colCSS = c.colCSS;
            c.children.forEach((rh, rhi) =>
              copySubHeaderWidths(rh, target.children[ci].children[rhi])
            );
          }
        });
      };

      // descriptor columns: splice a description cell in after each vertical
      // hierarchy column configured to show one, and mirror the insert into
      // the width/heading lists (vComparePlus/vNestedPlus) so row cells,
      // header titles and column widths stay index-aligned throughout
      const descriptorInserts = this.getDescriptorInserts(axes);
      let vComparePlus = axes.vCompare;
      let vNestedPlus = axes.vNested;
      axes.vCompare.forEach((o) => { if (o) delete o.sortKeyIndex; });
      if (descriptorInserts.length) {
        const canEditDescriptors = !!this.permissions.editDescriptor;
        sumDataV.sett.forEach((r) => {
          descriptorInserts.forEach((ins, ii) => {
            const at = ins.pos + ii;
            // editable only when the column setting opts in AND the user has
            // the edit-description permission
            r.headerColumns.splice(at + 1, 0,
              this.makeDescriptorCell(r.headerColumns[at], ins.source,
                canEditDescriptors && !!ins.source.descriptorEditable));
          });
          // rows whose node levels have no descriptors configured drop back to
          // single-line height (see getNextPageSize/setVScrollMax)
          r.hasDescriptorCells = true;
          r.descriptorAvailable = r.headerColumns.some(
            (hc) => hc.isDescriptor && hc.descriptorNode
          );
        });
        vComparePlus = [];
        vNestedPlus = [];
        axes.vNested.forEach((vh) => {
          const src = axes.vCompare[vh.index];
          // columnSortKeys are keyed by the original (grouping) column order, so
          // header sort clicks must map back to it once descriptors shift columns
          src.sortKeyIndex = vh.index;
          const nh = { ...vh, index: vComparePlus.length, contains: [] };
          vComparePlus.push(src);
          (vh.contains || []).forEach((c) => {
            nh.contains.push({ ...c, index: vComparePlus.length });
            vComparePlus.push(axes.vCompare[c.index]);
          });
          vNestedPlus.push(nh);
          if (descriptorInserts.some((ins) => ins.source === src)) {
            const dCol = {
              column: src.column + "_desc",
              key_column: src.column + "_desc",
              name: this.descriptorColumnTitle(src),
              maxLength: 0,
              isDescriptor: true,
              valueDisplayType: "text",
            };
            vNestedPlus.push({ column: dCol.column, index: vComparePlus.length, contains: [], isDescriptor: true, valueDisplayType: "text" });
            vComparePlus.push(dCol);
          }
        });
      }

      // measure the actual rendered title widths of the rows in this result set so
      // the left panel derives an accurate content width: the char-count stats are
      // computed over ALL template values and assume a generous px-per-char
      this.probeMeasureFont();
      const noteMeasured = (map, idx, text, extraPx, fontKind) => {
        if (idx === undefined || !text) return;
        const w = this.measureTextWidth(String(text), fontKind) + (extraPx || 0);
        if (!map[idx] || w > map[idx]) map[idx] = w;
      };
      const measureRowColumns = (map, nested, headerColumns, fontKind, isVertical) => {
        headerColumns.forEach((hc, hci) => {
          const outer = nested[hci];
          if (!outer) return;
          // descriptor cells hold long free text and get a fixed width instead
          if (outer.isDescriptor || hc.isDescriptor) return;
          const text = (hc.title_prefix ? hc.title_prefix + ": " : "") + (hc.title || "");
          const isChip = hc.valueDisplayType === "chip";
          // vertical rows can render an expand caret and a selection checkbox
          // inside the title cell — budget for them per row
          const rowChrome = isVertical
            ? (hc.node?.drilldown ? 32 : 0) +
              (hc.isSelectable || hc.nodeSelectable ? 36 : 0)
            : 0;
          noteMeasured(map, outer.index, text, (isChip ? 20 : 0) + rowChrome, isChip ? "chip" : fontKind);
          (hc.nestedColumns || []).forEach((nc, nci) => {
            const emb = outer.contains?.[nci];
            const ncChip = nc.valueDisplayType === "chip";
            if (emb) noteMeasured(map, emb.index, nc.title, ncChip ? 20 : 0, ncChip ? "chip" : fontKind);
          });
        });
      };
      const applyMeasured = (map, compare) => {
        compare.forEach((o, oi) => {
          if (map[oi] !== undefined) o.measuredTextChars = map[oi] / _pxPerChar;
          else delete o.measuredTextChars;
        });
      };
      const measuredPx = {};
      sumDataV.sett.forEach((r) => measureRowColumns(measuredPx, vNestedPlus, r.headerColumns, undefined, true));
      applyMeasured(measuredPx, vComparePlus);
      // descriptor columns wrap their text, so a fixed width beats measuring
      vComparePlus.forEach((o) => {
        if (o.isDescriptor) o.measuredTextChars = 250 / _pxPerChar;
      });
      // the listview row-selector column takes 40px that the renderer carves
      // out of the first column, so budget it into that column's width
      if (this.selectedView.definition.fullVerticalView &&
          vComparePlus.length &&
          vComparePlus[0].measuredTextChars !== undefined)
        vComparePlus[0].measuredTextChars += 40 / _pxPerChar;
      // detail (z) rows sit at the bottom of the V→H…→Z nesting; measure both the
      // z column titles and the detail measure values (their maxLength stats are
      // never populated, so without this the invisible heading title drives width)
      const measuredPxDM = {};
      const dmBarStats = {};
      const visHM = this.horizontalMeasures.filter((m) => m.visible);
      const measureDMValue = (r, m, mi, selectorPx) => {
        const val = r[m.column] ?? r[m.id];
        if (val === undefined || val === null) return;
        let w = this.measureTextWidth(String(val), "detail");
        if (m.displayType?.type === "bar") w = w * 3;
        else if (m.displayType?.type === "bar_total") {
          // track the widest formatted value and any zero rows so detail bars align too
          const stat = dmBarStats[mi] || (dmBarStats[mi] = { maxPx: 0, zero: false });
          const fPx = Math.ceil(this.measureTextWidth(this.formatMeasureValueForWidth(m, val), "detail"));
          if (fPx > stat.maxPx) stat.maxPx = fPx;
          if (Number(val) === 0) stat.zero = true;
          w = w * 8;
        }
        if (selectorPx && !m.hideSelector && m.id === "job_count") w += selectorPx;
        if (!measuredPxDM[mi] || w > measuredPxDM[mi]) measuredPxDM[mi] = w;
      };
      if (axes.zCompare.length) {
        const measuredPxZ = {};
        const zLevel = axes.axisList.length;
        // measure at the z level AND below it — z rows can be nested one level
        // deeper when grouped (zContainer rows)
        const walkToZ = (rows, level) => {
          (rows || []).forEach((r) => {
            if (level >= zLevel) {
              measureRowColumns(measuredPxZ, axes.zNested, r.headerColumns, "detail");
              visHM.forEach((m, mi) => measureDMValue(r, m, mi, 0));
            }
            walkToZ(r.children, level + 1);
          });
        };
        walkToZ(sumDataV.sett, 1);
        applyMeasured(measuredPxZ, axes.zCompare);
        applyMeasured(measuredPxDM, data.dMeasuresLengths);
      } else if (visHM.length) {
        // no detail axis: the measures render per horizontal leaf cell (with the
        // selector checkbox inline), so measure the values at the leaf level
        const hLeafLevel = axes.axisList.length;
        const walkToHLeaf = (rows, level) => {
          (rows || []).forEach((r) => {
            if (level >= hLeafLevel) visHM.forEach((m, mi) => measureDMValue(r, m, mi, 28));
            walkToHLeaf(r.children, level + 1);
          });
        };
        walkToHLeaf(sumDataV.sett, 1);
        applyMeasured(measuredPxDM, data.dMeasuresLengths);
      }

      // finalise the detail totals-bar slots: alert slot only when the column can
      // show warnings, then a value slot sized to the widest value (nested
      // drilldown builds keep the full view's slots — the section shares them)
      if (!this.nestedDrilldownFilter) visHM.forEach((m, mi) => {
        if (m.displayType?.type !== "bar_total") return;
        const stat = dmBarStats[mi];
        const hasWarnings =
          !!(m.alertLevelGT || m.alertLevelLT) ||
          (!m.aggregation_exclude_zero && !!stat?.zero);
        const barAlertPx = hasWarnings ? 26 : 0;
        // 12px cell padding + 8px slack (see the vertical measure width pass)
        const barNumberPx = stat ? stat.maxPx + barAlertPx + 12 + 8 : undefined;
        this.$set(m, "barAlertPx", barAlertPx);
        this.$set(m, "barNumberPx", barNumberPx);
        data.dMeasuresLengths[mi].barAlertPx = barAlertPx;
        data.dMeasuresLengths[mi].barNumberPx = barNumberPx;
      });

      const detailHeadingsVisible =
        this.detAxisSelected.some((x) => x.detailHeadingVisible) ||
        this.selectedView.definition.horizontalHeadingVisible;
      data.dMWIdths = groupColWidths(data.dMeasuresLengths, 6, "DM", detailHeadingsVisible, false);
      data.dWidths = groupColWidths(axes.zCompare, 6, "D", (o) => !!o.detailHeadingVisible, false);
      data.vWidths = groupColWidths(
        vComparePlus,
        6,
        "V",
        true,
        this.selectedView.definition.fullVerticalView || this.selectedView.definition.allowColumnSort
      );
      data.vMWidths = groupColWidths(
        this.getVisibleVerticalMeasures().map((m) => {
          // measure the actual rendered values (thousand separators included);
          // the heading is handled by the title floor
          let maxValPx = 0;
          sumDataV.sett.forEach((r) => {
            const val = r[m.id] ?? r[m.column] ?? r.job_count;
            if (val === undefined || val === null) return;
            const w = this.measureTextWidth(this.formatMeasureValueForWidth(m, val), "barValue");
            if (w > maxValPx) maxValPx = w;
          });
          const hasAlert = !!(m.alertLevelLT || m.alertLevelGT);
          let px;
          let barNumberPx;
          let barAlertPx;
          if (m.displayType.type === "bar_total") {
            // reserve a leading alert slot only when the column can show warnings,
            // then a value slot sized to the widest value, so the numbers
            // right-align beneath each other and every row's bar starts at the
            // same position with the same width
            const hasWarnings =
              hasAlert ||
              (!m.aggregation_exclude_zero &&
                sumDataV.sett.some((r) => Number(r[m.id] ?? r[m.column] ?? r.job_count) === 0));
            barAlertPx = hasWarnings ? 26 : 0;
            // 12px cell padding + 8px slack: the canvas measurement can run a few
            // px under the rendered text (font probe/letter-spacing rounding), and
            // an exact fit ellipsizes the widest value
            barNumberPx = Math.ceil(maxValPx) + barAlertPx + 12 + 8;
            // alert + value section + bar + "99.9 %"
            px = barNumberPx + 50 + 52;
          }
          else if (m.displayType.type === "bar")
            px = Math.max(maxValPx * 3, 100);
          else
            px =
              maxValPx +
              (hasAlert ? 26 : 0) +
              (m.type === "job_count" && !m.hideSelector ? 36 : 0);
          return {
            measuredTextChars: px / _pxPerChar,
            maxLength: 0,
            column: m.column,
            key_column: m.id || m.column,
            columnTitle: m.columnTitle,
            barNumberPx: barNumberPx,
            barAlertPx: barAlertPx,
          };
        }),
        4,
        "VM",
        true,
        this.allowSortMeasure()
      );
      this.getVisibleVerticalMeasures().forEach((m, mi) => {
        m.cols = data.vMWidths.columns[mi].cols;
        m.widthPct = data.vMWidths.columns[mi].percent;
        m.widthPx = data.vMWidths.columns[mi].px;
        // a nested drilldown build only measures the expanded section's rows, so
        // keep the full view's totals-bar slots — the section shares them
        if (!this.nestedDrilldownFilter) {
          this.$set(m, "barNumberPx", data.vMWidths.columns[mi].barNumberPx);
          this.$set(m, "barAlertPx", data.vMWidths.columns[mi].barAlertPx);
        }
      });
      // full-width views with a description column: the other columns hug their
      // measured content and the description absorbs the remaining viewport
      // width, instead of every column inflating proportionally
      const descWidthCols = data.vWidths.columns.filter((c) => c.isDescriptor);
      if (descWidthCols.length &&
          !axes.hCompare.some((x) => !x.hidden) &&
          !this.selectedView.definition.showTotalsRow &&
          !descWidthCols.some((c) => c.overridden)) {
        const fitPx = Math.floor(this.gridViewportPx() - 30) - data.vMWidths.totalPx;
        if (data.vWidths.totalPx < fitPx) {
          const extraChars = (fitPx - data.vWidths.totalPx) / _pxPerChar / descWidthCols.length;
          descWidthCols.forEach((c) => { c.length += extraChars; });
          const totalChars = data.vWidths.columns.reduce((p, c) => p + c.length, 0);
          data.vWidths.columns.forEach((w) => {
            w.percent = (100 * w.length) / totalChars + "%";
            w.px = Math.round(w.length * _pxPerChar);
          });
          data.vWidths.totalWidth = totalChars;
          data.vWidths.totalPx = Math.round(totalChars * _pxPerChar);
        }
      }
      // row heights for descriptions: store each row's own required height -
      // every view sizes rows individually as max(description height, detail
      // rows, single-line base) in the paging code (rowLineHeights)
      if (data.vWidths.columns.some((c) => c.isDescriptor)) {
        sumDataV.sett.forEach((r) => {
          let rowLines = 0;
          (r.headerColumns || []).forEach((hc) => {
            if (!hc.isDescriptor || !hc.title) return;
            const col = data.vWidths.columns.find((c) => c.isDescriptor && c.column === hc.column);
            const availPx = Math.max((col?.px || 250) - 34, 80);
            let lines = 0;
            String(hc.title).split("\n").forEach((seg) => {
              lines += Math.max(1, Math.ceil((this.measureTextWidth(seg, "descriptor") * 1.05) / availPx));
            });
            if (lines > rowLines) rowLines = lines;
          });
          if (rowLines > 40) rowLines = 40;
          // 24px cell insets + 6px textarea chrome + a line of headroom so wrap
          // rounding never leaves the last line clipped or behind a scrollbar
          r.descriptorHeight = rowLines ? rowLines * 17 + 48 : 0;
        });
      }
      data.vSectionWidth = groupColWidths(
        [
          { maxLength: data.vWidths.totalWidth },
          { maxLength: data.vMWidths.totalWidth },
        ],
        0
      );
      
      let hcForWidth = axes.hCompare.length ? axes.hCompare[axes.hCompare.length - 1] : null;
      let hTextMax = hcForWidth
        ? hcForWidth.maxLengthMean +
          (hcForWidth.maxLength - hcForWidth.maxLengthMean) / 2
        : 0;
      this.deriveCols(hTextMax, data.dWidths.totalWidth + data.dMWIdths.totalWidth);
      // content-derived leaf width: measured detail columns + measures + the 37px
      // selector checkbox, floored by the measured leaf-level horizontal header
      // titles; the legacy 150 x bucket width still applies with no detail axis
      let hHeaderPx = 0;
      const walkHTitles = (rows) =>
        (rows || []).forEach((r) => {
          if (r.children?.length) walkHTitles(r.children);
          else {
            const t = r.headerColumns?.[0]?.title;
            if (t) {
              const w = this.measureTextWidth(String(t));
              if (w > hHeaderPx) hHeaderPx = w;
            }
          }
        });
      walkHTitles(sumDataH.sett);
      // header titles can wrap/ellipsize, so they only widen a leaf up to a point —
      // otherwise one long horizontal header inflates every leaf's detail columns
      if (hHeaderPx) hHeaderPx = Math.min(hHeaderPx + 48, 300);
      const zContentPx = axes.zCompare.length
        ? data.dWidths.totalPx + data.dMWIdths.totalPx + 37
        : Object.keys(measuredPxDM).length
        ? data.dMWIdths.totalPx
        : 0;
      const derivedLeafPx = Math.max(
        zContentPx || _hLeafBasePx * this.display.h_col.colWidth,
        hHeaderPx,
        _hLeafBasePx
      );
      data.hOverridden = this.columnWidths.overrides["H"] > 0;
      data.hLeafPx = data.hOverridden
        ? Math.max(this.columnWidths.overrides["H"], _minColumnPx)
        : derivedLeafPx;
      // diagnostics: run `window.rmDebugWidths = true` in the console, change a
      // filter (or resize) to trigger a rebuild, and read the dump
      if (window.rmDebugWidths)
        // eslint-disable-next-line no-console
        console.log("rmWidths", JSON.parse(JSON.stringify({
          fonts: this._measureFonts,
          v: data.vWidths.columns.map((c) => ({ key: c.key, px: c.px, measured: vComparePlus[c.index]?.measuredTextChars })),
          vm: data.vMWidths.columns.map((c) => ({ key: c.key, px: c.px })),
          d: data.dWidths.columns.map((c) => ({ key: c.key, px: c.px, len: c.length, measured: axes.zCompare[c.index]?.measuredTextChars, maxLength: axes.zCompare[c.index]?.maxLength })),
          dm: data.dMWIdths.columns.map((c) => ({ key: c.key, px: c.px, measured: c.overridden })),
          dTotalPx: data.dWidths.totalPx,
          dmTotalPx: data.dMWIdths.totalPx,
          hHeaderPx: hHeaderPx,
          zContentPx: zContentPx,
          derivedLeafPx: derivedLeafPx,
          hLeafPx: data.hLeafPx,
          hOverride: this.columnWidths.overrides["H"] || null,
          overrides: this.columnWidths.overrides,
        })));

      sumDataH.sett.forEach((h, hi) => {
        setIncludedHorizontalColumns(h);
        h.colWidth = this.display.h_col.colWidth * h.leafCount;
        setSubHeaderWidthsSett(h);
        const width = data.hLeafPx * h.leafCount;
        // exact width: leaf cells must not flex-stretch into spare panel space, or
        // the detail columns (percent splits of the cell) inflate with them
        let colCSS = { minWidth: width + "px", maxWidth: width + "px" };
        if (axes.hCompare.length > 1 && hi > 0)
          colCSS.borderLeft = axes.hCompare.length + "px solid lightgray;";
        h.colCSS = colCSS;
      });
      sumDataH.sett = sumDataH.sett.filter((x) => x.include);

      const populateHCols = (v, templateCols) => {
        let allCols = [];
        templateCols.forEach(c => {
          let targetCol = v.children.find(x => x.key === c.key);
          if (targetCol) {
            targetCol.colCSS = c.colCSS;
            targetCol.colWidth = c.colWidth;
            allCols.push(targetCol);
          } else {
            this.appendMeasureColumns(c, 0);
            this.appendAggregateColumns(c, 0);
            allCols.push(c);
          }
          if (c.children.length && targetCol) {
            populateHCols(targetCol, c.children);
          }
        });
        v.children = allCols;
      };
      
      sumDataV.sett.forEach((v, vi) => {
        populateHCols(v, sumDataH.sett);
        v.height = 0;
        v.style = { height: null };
      });
      
      const recurseHeaderCols = (cols) => {
        cols.forEach(x => {
          x.headerColumns.forEach((c) => {
            c.visible = true;
            c.style = { height: null };
            c.nestedColumns.forEach(n => n.cssClass = n.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell');
          });
         recurseHeaderCols(x.children);
        })
      };
      recurseHeaderCols(sumDataV.sett);

      data.vData = sumDataV.sett;
      data.hData = sumDataH.sett;

      return data;
    },
    prepareNested(axisColumns) {
      let indexed = axisColumns.filter(x => !x.containerColumnShowRange && !x.containerColumnGroupMeasure).map((x, xi) => {
        return {
          column: x.column,
          index: xi,
          valueDisplayType: x.valueDisplayType,
          valueIcon: x.valueIcon,
          containerColumn: x.containerColumn,
        }
      });
      return indexed.filter(x => !x.containerColumn)
        .map((x) => {
          return {
            column: x.column,
            index: x.index,
            valueDisplayType: x.valueDisplayType,
            valueIcon: x.valueIcon,
            contains: indexed.filter(y => y.containerColumn === x.column),
          }
        });
    },
    prepareAxes(vCompare, hCompare, zCompare) {
        hCompare = hCompare ?? this.horAxisSelected;
        vCompare = vCompare ?? this.verAxisSelected;
        zCompare = zCompare ?? this.detAxisSelected;

        if (vCompare.length === 0)
          vCompare = [{ column: "_", name: "Hidden", hidden: true }];
        if (hCompare.length === 0)
          hCompare = [{ column: "_", name: "Hidden", hidden: true }];
        
        let setComparerRule = (comparer) => {
          let ht =
            comparer.ht_id
              ? this.hierarchyTypes.find((ht) => ht.ht_id === comparer.ht_id)
              : null;
          let nextLevel =
            ht &&
            comparer.drillDownLevels &&
            comparer.drillDownLevels.length > comparer.currentDrillDownLevel
              ? comparer.drillDownLevels.find(
                  (dl) => dl.hLevel === comparer.currentDrillDownLevel + 1
                )
              : null;
          let prevLevel =
            ht && comparer.drillDownLevels && comparer.currentDrillDownLevel > 1
              ? comparer.drillDownLevels.find(
                  (dl) => dl.hLevel === comparer.currentDrillDownLevel - 1
                )
              : null;
          let currLevel =
            ht && comparer.drillDownLevels
              ? comparer.drillDownLevels.find(
                  (dl) => dl.hLevel === comparer.currentDrillDownLevel
                )
              : null;
          if (ht) {
            comparer.noderule = {
              ht: ht,
              nextLevel: nextLevel,
              prevLevel: prevLevel,
              currLevel: currLevel,
            };
            if (!comparer.ht_level) comparer.ht_level = comparer.currentDrillDownLevel;
          }
          comparer.column = currLevel?.column || comparer.column;
          comparer.column_key = currLevel?.node_column || (comparer.hidden ? "_" : comparer.column);
          comparer.column_sort = currLevel?.column || comparer.display_column || comparer.column_key;
          comparer.column_match = currLevel?.node_column || comparer.column_key;
          comparer.column_title = currLevel?.column || comparer.display_column || comparer.column_key;
        };
        vCompare.forEach((c) => setComparerRule(c));
        hCompare.forEach((c) => setComparerRule(c));
        zCompare.forEach((c) => setComparerRule(c));

        let axes = {
          hCompare: hCompare,
          vCompare: vCompare,
          zCompare: zCompare,
          inValid: !hCompare.length || !vCompare.length,
          hNested: this.prepareNested(hCompare),
          vNested: this.prepareNested(vCompare),
          zNested: this.prepareNested(zCompare),
          axisList: [],
        };
        const identifyColumnOrder = (headings, options) => {
          let cols = [];
          headings.forEach(vh => {
            vh.index = cols.length;
            cols.push(options.find(x => x.column === vh.column));
            if (vh.contains?.length) {
              vh.contains.forEach(c => {
                c.index = cols.length;
                cols.push(options.find(x => x.column === c.column));
              });
            }
          });
          return cols;
        };
        axes.vCompare = identifyColumnOrder(axes.vNested, vCompare.filter(x => !x.containerColumn || (!x.containerColumnShowRange && !x.containerColumnGroupMeasure)));
        axes.zCompare = identifyColumnOrder(axes.zNested, zCompare.filter(x => !x.containerColumn || (!x.containerColumnShowRange && !x.containerColumnGroupMeasure)));

        let rangeColumns = [];
        let groupColumns = [];
        axes.vCompare.forEach(x => { 
          x.rangeColumns = this.verAxisSelected.filter(o => o.containerColumn === x.column && o.containerColumnShowRange);
          x.groupColumns = this.verAxisSelected.filter(o => o.containerColumn === x.column && o.containerColumnGroupMeasure);
          rangeColumns = [ ...rangeColumns, ...x.rangeColumns ];
          groupColumns = [ ...groupColumns, ...x.groupColumns ];
        });
        const calculateRequiredLineHeight = (columns) => {
          return columns.reduce((p, c) => {
            let max = 50 + (c.contains.filter(x => x.valueDisplayType !== "chip").length * 17) 
                        + (c.contains.some(x => x.valueDisplayType === "chip") ? 22 : 0);
            return max > p ? max : p;
          }, 50);
        };
        this.vScroll.lineHeightZ = calculateRequiredLineHeight(axes.zNested);
        // during a drilldown-expansion build keep the current (possibly
        // description-derived) row height rather than resetting it
        const requiredLineHeightY = calculateRequiredLineHeight(axes.vNested);
        this.vScroll.lineHeightY = this.nestedDrilldownFilter
          ? Math.max(this.vScroll.lineHeightY, requiredLineHeightY)
          : requiredLineHeightY;
        // descriptor row heights are per-row (descriptorHeight via
        // rowLineHeights), so no grid-wide line height raise is needed here

        axes.axisList = [{ 
          axis: "V", 
          columns: axes.vCompare.filter((x) => x.column), 
          headerColumns: axes.vNested,
          rangeColumns: rangeColumns,
          groupColumns: groupColumns,
        }];
        axes.axisListH = [];
        axes.hCompare.filter((x) => x.column).forEach((x, xi) => { 
          const headCol = axes.hNested[xi];
          headCol.index = 0;
          axes.axisListH.push({ axis: "H", columns: [x], headerColumns: [headCol] });
          axes.axisList.push({ axis: "H", columns: [x], headerColumns: [headCol] });
        });
        if (axes.zCompare.length)
          axes.axisList.push({ axis: "Z", columns: axes.zCompare, headerColumns: axes.zNested });

        return axes;
    },
    async buildCompare(docs) {
      if (this.isLoadingData) return;
      if (!this.selectedDocs?.length && !this.useIndex) {
        this.layout = null;
      } else {
        this.isBuilding = true;
        const axes = this.prepareAxes();
        if (axes.inValid) return;
        // this.dragTarget.show = zCompare.length && zCompare[0].isNode;

        const nestedDrilldowLevel = this.nestedDrilldownFilter?.indentLevel || 0;
        if (!nestedDrilldowLevel)
          this.setupViewMeasures(this, this.selectedView.definition);

        if (!this.useIndex && !this.verticalMeasures.some(x => x.available && x.visible && x.isLeafNodeCount)) {
          docs = docs.filter((x) => x.job_count);
        }
     
        const maxHLeafs = 100;
        const filters = this.getIndexFilters();

        if (nestedDrilldowLevel > 0 && this.nestedDrilldownFilter && this.nestedDrilldownFilter.value) {
          filters.push({ column : this.nestedDrilldownFilter.column, filterValues: [ this.nestedDrilldownFilter.value ] });
        }

        // nested drilldown builds splice rows into the existing layout and return
        // early, so keep the current width overrides and avoid the async fetch
        if (!nestedDrilldowLevel) await this.syncColumnWidthOverrides();

        let structure = await this.processDetails(docs, filters, maxHLeafs, axes, nestedDrilldowLevel > 0 ? this.layout.measureTotals : [], nestedDrilldowLevel > 0 ? this.layout.measureTotalsSett : []);
        let dWidths = structure.dWidths;
        let vWidths = structure.vWidths;
        let vMWidths = structure.vMWidths;
        let dMWIdths = structure.dMWIdths;

        if (!structure.vData.length && this.inProgressIndexRequests.length === 0) {
          this.response = {
            Status: "Warning",
            Message: "No results for specified criteria",
          };
          this.layout = null;
          this.isBuilding = false;
          return;
        } else if (structure.usedHLeafs >= maxHLeafs) {
          this.response = {
            Status: "Warning",
            Message:
              "WARNING: The horizontal axis has exceeded the maximum number of columns (" +
              maxHLeafs +
              ") so columns have been truncated. Apply filters to reduce the number of columns",
          };
        } else {
          this.response = null;
        }
                
        if (this.addNestedDrilldown(nestedDrilldowLevel, structure.vData)) { 
          this.hasExpanded = true;
          return;
        }
        this.hasExpanded = false;
        let headerRow = structure.hData.length ? {
            ref: "colhead",
            columnsSett: structure.hData,
            detailHeadings: null,
          } : null;
        const gridLineClass = this.setGridLineClass();
        const detailHeadingVisible = this.detAxisSelected.some(x => x.detailHeadingVisible) || this.selectedView.definition.horizontalHeadingVisible;
        if (headerRow) {          
          const useHorizontalTitle = this.horAxisSelected.length && !!this.horAxisSelected[0].overrideTitle;
          const lastLevel = this.horAxisSelected.length - 1;
          // const noD = !this.detAxisSelected.length;
          const noV = !this.verAxisSelected.length;
          // const visDetH = this.detAxisSelected.some(x => x.detailHeadingVisible);
          const setStyle = (hCols, level, firstColumn, lastColumn) => {
            hCols.forEach((c, ci) => {
              if (level === 0 && ci === hCols.length - 1) lastColumn = true;
              c.class = c.headerColumns[0].node ? null : "title_cell";
              c.cssClass = `x-rowHeader ${dMWIdths.columns.length && (level === lastLevel) ? "header-" + dMWIdths.columns[0].alignment : ""} ${gridLineClass}`;
              if (level === 0 && !useHorizontalTitle) 
                c.cssClass += " first-row";
              if (firstColumn && ci === 0) // && (level < lastLevel || noV || visDetH)) 
                c.cssClass += " first-column";
              if (lastColumn && !this.selectedView.definition.showTotalsRow) 
                c.cssClass += " last-column";

              setStyle(c.children, level + 1, firstColumn, lastColumn);
            });
          };
          setStyle(structure.hData, 0, this.horAxisSelected.length > 1 || noV || detailHeadingVisible, false);
        }

        //  -------------------------------------------------------------------------------------------------------------------------------------
        //  title / filters applied list
        //  -------------------------------------------------------------------------------------------------------------------------------------
        //  headerRow
        //  | leftPanel.cols                                                                    | rightPanel.cols                               |
        //  |-----------------------------------------------------------------------------------|-----------------------------------------------|
        //  || lp.colsTitle                         | lp.colsDescriptor   |   lp.colsTotal     |||  <columnPicker>                             ||
        //  || <columnPicker>                       |    "Descriptor"     |     "TOTAL"        ||                                               |
        //  |-----------------------------------------------------------------------------------|[--------for-hierarchyHeaderRows---------------|
        //  || lp.colsTitle                         | lp.colsDescriptor   |   lp.colsTotal     || [|          for columns                     |]|
        //  ||                                      |                     |--------------------||]                                              |
        //  ||                                      |                     || lc | jc | ec | s  ||-----------------------------------------------|
        //  |                                                                                   |[|         for headerRow.columns             |]|
        //  -------------------------------------------------------------------------------------------------------------------------------------
        //  detailRow
        //  | leftPanel.cols                                                                    | rightPanel.col                                |
        //  |-----------------------------------------------------------------------------------|                                               |
        //  | if lp.colsHierarchy          |                                                    |                                               |
        //  |[--for dr.hierarchyHeadings---|[---for-dr.rowHeadings------------------------------|-----------------------------------------------|
        //  | | -> nested hierarchy       || | lp.colsTitle |lp.colsDescDe| lp.colsTotalDetail |||[---for-dr.rowDetails]-----------------------||
        //  |]                             |]                             |--------------------||| [|         for columns                     |||
        //  |                              |                              || lc | jc | ec | s  |||  |----...if--------------------------------|||
        //  |                              |                              |[----for-zRows-|||  || ...if | ...if | ...if | ...if | ...if ||||
        //  |                              |                              | |  jc  |  ec  |  s |||  |[---for-zRows-----------------------|||
        //  |                              |                              |]                   |||  | | ...if | ...if | ...if | ...if | ..if ||||
        //  |                              |                              |[----for-detCntHdr--|||  |]                                        |||
        //  |                              |                              | |  jc  |  ec  |  s ||| ]                                          |||
        //  |                              |                              |]                   |||]                                           |||
        //  -------------------------------------------------------------------------------------------------------------------------------------
        //  scroll row
        //  | leftPanel.cols                                                                    | rightPanel.cols                               |
        //  |                                                                                   |-----------------------------------------------|
        //  |                                                                                   |[|         for headerRow.columns             |]|
        //  -------------------------------------------------------------------------------------------------------------------------------------
        
        const availableWidth = window.innerWidth - 100;
        const leftWidth = vWidths.totalPx + vMWidths.totalPx;
        const rightWidth = structure.hData.reduce((p, c) => p + structure.hLeafPx * c.leafCount, 0);
        
        const lenVCols = vWidths.totalWidth;
        const lenMCols = vMWidths.totalWidth;
        const lenLeftCols = lenVCols + lenMCols;
        let leftPanelCols = lenLeftCols > 150 && lenLeftCols < 180
          ? 5
          : Math.round(lenLeftCols / 28) || 1;
        if (leftPanelCols === 1 && lenLeftCols > 28) leftPanelCols = 2;
        if (leftPanelCols > 11) leftPanelCols = 11;
        let leftPanelColsT =
          !this.verAxisSelected.length
            ? 0
            : Math.round((12 * lenVCols) / lenLeftCols);
        if (leftPanelColsT === 12 && vMWidths.columns.length) leftPanelColsT = 11;
        if (this.horAxisSelected.length === 0) leftPanelCols = 12;
        else {
          if (this.verAxisSelected.length === 0) leftPanelCols = 0;
        }
        let leftPanelColsTotal =
          vMWidths.columns.length === 0
            ? 0
            : leftPanelCols > 0
            ? 12 - leftPanelColsT
            : 0;
        if (leftPanelColsTotal === 0) leftPanelColsT = 12;
        // exact px split of the left panel between the title and measure sections
        // (colsTitle/colsTotal are retained for the excel export only)
        const titleSectionRatio = !this.verAxisSelected.length
          ? 0
          : vMWidths.columns.length === 0
          ? 1
          : vWidths.totalPx / leftWidth;
        const rightTotalPanelPx = this.selectedView.definition.showTotalsRow
          ? Math.round(leftWidth * (1 - titleSectionRatio))
          : 0;
        const showTotalsSplit = rightTotalPanelPx > 0;
        let leftContentPx = leftWidth - rightTotalPanelPx;
        // full-width views (no horizontal axis): the column widths are content
        // ESTIMATES with per-column padding slack, so a small overshoot of the
        // viewport produces a pointless horizontal scrollbar - shrink-to-fit
        // instead (the columns are %-based so they just narrow slightly);
        // a large overshoot keeps its scrollbar, and explicit user column
        // widths are never squeezed
        if (!rightWidth && !Object.keys(this.columnWidths.overrides || {}).length) {
          const fitPx = Math.floor(this.gridViewportPx() - 30);
          if (leftContentPx > fitPx && leftContentPx < fitPx * 1.25)
            leftContentPx = fitPx;
        }
        const effectiveTitleRatio = showTotalsSplit ? 1 : titleSectionRatio;
        const titleSectionPct = 100 * effectiveTitleRatio;
        // the left panel viewport is content-sized by default so no horizontal
        // scrollbar appears; a user panel-width override ("LP") or the viewport cap
        // (too many columns to display) shrink the viewport and introduce scrolling
        const lpOverride = this.columnWidths.overrides["LP"];
        const capPx = Math.max(300, Math.round(0.6 * availableWidth));
        const leftPanelPx = lpOverride > 0
          ? Math.max(lpOverride, _minColumnPx)
          : rightWidth
          ? Math.min(leftContentPx, capPx)
          : leftContentPx;
        const leftScrollVisible = !rightWidth || leftContentPx > leftPanelPx;

        
        let layout = {
          // title: title,
          canSelectDocs: this.verticalMeasures.some(x => x.visible && x.column === "job_count" && !x.hideSelector) 
            || this.horizontalMeasures.some(x => x.visible && x.column === "job_count" && !x.hideSelector) 
            || this.detAxisSelected.length,
          leftPanel: {      // **USED**
            cols: leftPanelCols,
            colsTitle: showTotalsSplit ? 12 : leftPanelColsT,
            colsTotal: showTotalsSplit ? 0 : leftPanelColsTotal,
            colsDescriptor: 0,
            colWidthStyle: rightWidth
              ? { width: leftPanelPx + "px", minWidth: leftPanelPx + "px", maxWidth: leftPanelPx + "px" }
              : { flex: "1 1 auto", minWidth: "0" },
            contentPx: leftContentPx,
            viewportPx: leftPanelPx,
            lpOverridden: lpOverride > 0,
            scrollVisible: leftScrollVisible,
            scrollWidthStyle: { minWidth: leftContentPx + "px" },
            titleSectionRatio: effectiveTitleRatio,
            titleSectionStyle: { minWidth: titleSectionPct + "%", maxWidth: titleSectionPct + "%" },
            totalSectionStyle: { minWidth: (100 - titleSectionPct) + "%", maxWidth: (100 - titleSectionPct) + "%" },
          },
          rightPanel: {
            cols: 12 - leftPanelCols,
            colWidthStyle: { minWidth: "150px" },
            scrollWidthStyle: { minWidth: rightWidth + "px" },
            text: "",
            horizontalHeadingVisible: detailHeadingVisible,
          },
          rightTotalPanel: {
            cols: showTotalsSplit ? 12 : 0,
            colWidthStyle: { width: rightTotalPanelPx + "px", minWidth: rightTotalPanelPx + "px", maxWidth: rightTotalPanelPx + "px" },
            text: "Total",
            horizontalHeadingVisible: detailHeadingVisible,
          },
          measureTotals: structure.measureTotals,
          measureTotalsSett: structure.measureTotalsSett,
          hLeafPx: structure.hLeafPx,
          hOverridden: structure.hOverridden,
          gridLineClass: gridLineClass,    // **USED**
          headerRow: headerRow, // **USED** ref and columns
          detailRow: {
            rowHeading: {
              titleWidths: vWidths.columns, // **USED**
              measureWidths: vMWidths.columns, // **USED**
              titleSectionWidth: `${(100 * dWidths.totalWidth) /
                  (dWidths.totalWidth + dMWIdths.totalWidth)}%`,
              columnWidths: [],
            },
            detail: { // **USED**
              visible: dWidths.columns.length > 0,
              titleSectionWidth: `calc(${(100 * dWidths.totalWidth) /
                  (dWidths.totalWidth + dMWIdths.totalWidth)}% - 37px)`,
              measureSectionWidth:
                (100 * dMWIdths.totalWidth) /
                  (dWidths.totalWidth + dMWIdths.totalWidth) +
                "%",
              titleWidths: dWidths.columns,
              measureWidths: dMWIdths.columns,
              widthSplitMeasures: dMWIdths.columns.map(x => x.length / (dWidths.totalWidth + dMWIdths.totalWidth)),
              widthSplitTitle: dWidths.totalWidth / (dWidths.totalWidth + dMWIdths.totalWidth),
              measureSectionHeadingStyle: { maxWidth: 
                (100 * dMWIdths.totalWidth) /
                  (dWidths.totalWidth + dMWIdths.totalWidth) +
                "%", 
                color: _defaultHeaderColours.color, 
                backgroundColor: _defaultHeaderColours.backgroundColor }
            },
          },
          footerRow: {
            data: structure.totalData.length ? structure.totalData[0].headerColumns[0] : null,
          },
          highlights: [],
        };
        this.setHeaderColumnWidths(layout, structure.vData);
        this.setDetailHeadings(layout);
        await this.setHighlights(layout, structure);
        this.layout = layout;
        this.settData = structure.vData;
        this.applyDefaultSortIndicator();

        this.setRowIndexes();
        this.highlightRulesKeys();
        // re-derive the visible page rows from the NEW layout immediately: the
        // header reads layout widths reactively, but the rows render from the
        // pageStructureSett snapshot, which otherwise only refreshes on the
        // next scroll/page event - leaving header and rows briefly misaligned
        this.getNextPageSize();
      }

      this.resetIsBuilding = true;
      this.isBuilding = false;
      this.vScroll.doSetup = true;
      this.$nextTick(() => {
        this.updateHScrollNeeded();
        this.refitViewportIfStale();
      });
    },
    async setHighlights(layout, structure) {
      let mainMeasure = this.getMainMeasure();
      let horMeasure = this.horizontalMeasures.some(x => x.visible) ? this.horizontalMeasures.filter(x => x.visible)[0] : null;
      if (horMeasure && horMeasure.highLightMeasureMinimum && horMeasure.highLightMeasureMinimumValue) {
        structure.vData.forEach(v => {
          v.children.forEach(vc => {
            let hc = vc.headerColumns[0];
            let fail = Number(hc[horMeasure.highLightMeasureMinimum]) < Number(horMeasure.highLightMeasureMinimumValue);
            if (fail) {
              hc.failsHighlight = fail;
              vc.failsHighlight = fail;
            }
          });
        });
      }
      if (horMeasure && horMeasure.single_comparator_text) {
        structure.vData.forEach(v => {
          v.children.forEach(vc => {
            let fail = vc[`${horMeasure.id}_single_comparator`];
            if (fail) {
              vc.headerColumns[0].single_comparator = fail;
              vc.single_comparator = fail;
            }
          });
        });
      }
      if (layout.footerRow.data) {
        const data = await this.prepMeasureDrilldown(layout.footerRow.data, mainMeasure);
      
        let mainValue = layout.footerRow.data[mainMeasure.id];
        let rule = this.utils.determineHighlightRule(mainMeasure, mainValue);
        const formatNumber = (value) => {
          if (value.isNaN) {
            return "";
          } else if (mainMeasure.drilldown?.numberFormat) {
            return this.utils.formatNumber(Number(value), mainMeasure.drilldown?.numberFormat);
          } else {
            return Number(value).toFixed(0);
          }
        }
        
        layout.highlights.push({
          title: mainMeasure.columnTitle,
          values: [ {
            valueText: this.utils.formatNumber(mainValue, mainMeasure.numberFormat),
            valueColour: rule ? this.utils.darkenColor(rule.style.backgroundColor, 10) : "black",
            match_key: layout.footerRow.data.match_key,
            showWarning: !!rule,
            showTick: !rule,
          }],
          icon: "mdi-radar",
          iconColour: "#dbb7ff", //"#FFCB00",
          style: { maxWidth: "17%", backgroundColor: "#f6edff" }, //"#FFF5CC"
          addendumText: `Mean<br/>${formatNumber(data.bpDatasets[0].aggregates.mean)} ${data.bpDatasets[0].name} | ${formatNumber(data.bpDatasets[1].aggregates.mean)} ${data.bpDatasets[1].name}`,
        });
        let compressedStats = false;
        layout.highlights[layout.highlights.length - 1].values[0][mainMeasure.id] = mainValue;
        let statusCategories = [];
        let totalCategories = 0;
        const createIssue = (stat, colId, desc, colour) => {
          return { display_colour_id: stat?.display_colour_id ?? colId, description: stat?.description ?? desc, style: stat?.style ?? { backgroundColor: colour }, count: 0, showWarning: !!stat };
        };
        let summary = { maxValue: -999999999, maxSubject: "", maxDocs: 0, minValue: 999999999, minSubject: "", minDocs: 0, maxMatchKey: "", minMatchKey: "", };
        structure.vData.forEach(v => {
          v.children.forEach(c => {
            if (c.job_count && !c.failsHighlight) {
              totalCategories++;
              if (c.single_comparator) {
                let issue = statusCategories.find(x => x.display_colour_id === -1);
                if (!issue) {
                  issue = createIssue(null, -1, `${horMeasure.columnTitle} ${horMeasure.single_comparator_text}`, "#EEEEEE");
                  statusCategories.push(issue);
                }
                issue.count++;
              } else {
                let value = Number(c[horMeasure.id]);
                let subject = `${v.headerColumns[0].title}<br/>${c.headerColumns[0].title}`;
                if (value > summary.maxValue) {
                  summary.maxValue = value;
                  summary.maxSubject = subject;
                  summary.maxDocs = c.job_count;
                  summary.maxMatchKey = c.match_key;
                }
                if (value < summary.minValue) {
                  summary.minValue = value;
                  summary.minSubject = subject;
                  summary.minDocs = c.job_count;
                  summary.minMatchKey = c.match_key;
                }
                let stat = this.utils.determineHighlightRule(horMeasure, value, c.failsHighlight);
                if (stat) {
                  let issue = statusCategories.find(x => x.display_colour_id === stat.display_colour_id);
                  if (!issue) {
                    issue = createIssue(stat);
                    statusCategories.push(issue);
                  }
                  issue.count++;
                } else {
                  let issue = statusCategories.find(x => x.display_colour_id === 0);
                  if (!issue) {
                  issue = createIssue(null, 0, `${horMeasure.columnTitle} OK`, "#000000");
                    statusCategories.push(issue);
                  }
                  issue.count++;
                }
              }
            }
          });
        });        
        if (statusCategories.length) {
          const segmentSummary = {
            title: compressedStats ? `Of ${totalCategories} Segments:` : `Segment Summary`,
            values: [],
            icon: "mdi-view-dashboard",
            iconColour: "#CEDC26",
            style: { maxWidth: "36%", backgroundColor: "#F5F8D4" },
            // addendumText: `${statusCategories[1].count} of ${totalCategories} ${statusCategories[1].description}`,
          };
          statusCategories.forEach(sc => {
            segmentSummary.values.push({
              valueText: compressedStats ? `${sc.count}` : `${sc.count} of ${totalCategories}`,
              valueTextAddendum: `${sc.description}`,
              valueColour: this.utils.darkenColor(sc.style.backgroundColor, 10),
              showWarning: sc.showWarning,
            })
          });
          layout.highlights.push(segmentSummary);  
        }
        if (summary.maxSubject) {
          layout.highlights.push({
            title: "Biggest Gaps",
            values: [ {
              valueText: this.utils.formatNumber(summary.maxValue, mainMeasure.numberFormat),
              valueTextAddendum: `${summary.maxSubject}  (${summary.maxDocs} people)`,
              valueColour: "black",
              match_key: summary.maxMatchKey,
            }, {
              valueText: this.utils.formatNumber(summary.minValue, mainMeasure.numberFormat),
              valueTextAddendum: `${summary.minSubject}  (${summary.minDocs} people)`,
              valueColour: "black",
              match_key: summary.minMatchKey,
            },],
            icon: "mdi-briefcase-variant-outline",
            iconColour: "#50B3CB",
            style: { maxWidth: "30%", backgroundColor: "#EEF7F9" },
          });
          layout.highlights[layout.highlights.length - 1].values[0][mainMeasure.id] = summary.maxValue;
          layout.highlights[layout.highlights.length - 1].values[1][mainMeasure.id] = summary.minValue;
        }
        layout.highlights.push({
          title: "People",
          values: [{
            valueText: data.docs.length,
            valueColour: "black",
          }],
          backgroundColour: "#",
          icon: "mdi-account-multiple",
          iconColour: "#EA3785",
          style: { maxWidth: "17%", backgroundColor: "#FEEBF2" },
          addendumText: `${data.bpDatasets[0].aggregates.count} male | ${data.bpDatasets[1].aggregates.count} female`,
        });
        // set widths
        const hiVals = layout.highlights.reduce((p,c) => p + c.values.length, 0);
        const hlratio = layout.highlights.map(c => c.values.length);
        layout.highlights.forEach((h, hi) => h.style.maxWidth =  (100 * hlratio[hi] / hiVals) + "%");
      }
    },
    setRowIndexes() {
        const vData = this.settData;
        let dIndex = 0;
        let zCompare = this.detAxisSelected.length > 0;
        let hCompare = this.horAxisSelected.length;

        const getMaxZ = (row, depth) => {
          let max = 0;
          if (depth === 1) {
            max = row.children.reduce((p, c) => c.children.length > p ? c.children.length : p, 0);
          } else {
            row.children.forEach(c => {
              let maxC = getMaxZ(c, depth - 1);
              if (maxC > max) max = maxC; 
            });
          }
          return max;
        };
        const setZIndexes = (row, depth, index, detailCount) => {
          if (depth === 1) {
            row.children.filter(x => x.children.length).forEach((x) => {
              x.children.forEach((c, ci) => c.dIndex = index + ci);
            });
          } else {
            row.children.forEach(c => {
              setZIndexes(c, depth - 1, index, detailCount);
            });
          }
        };

        dIndex = 0;
        vData.forEach((x, xi) => {
          x.index = xi;
          x.detailCount = zCompare && !x.hideDetails ? getMaxZ(x, hCompare) : 0;
          x.detailIndexes = Array.from(
            { length: x.detailCount || 1},
            (v, i) => i
          ).map((i) => {
            return { dIndex: dIndex + i };
          });

          x.dIndexStart = dIndex;
          if (x.detailCount) {
            setZIndexes(x, hCompare, dIndex, x.detailCount);
            dIndex += x.detailCount - 1;
          }
          x.dIndexEnd = dIndex < 1 ? 0 : dIndex;
          dIndex++;
        });
        this.setVScrollMax(dIndex - 1);
    },
    showMatches() {
      // no longer wanted
    },
    nodeSelected(item) {
      item.node.selected = !item.node.selected;
      this.selectJobRowHeader(item);
    },
    selectListRow(row) {
      this.selectJob(row.item, true);
    },
    selectJobRowHeader(item) {
      this.selectJob(item, true);
    },
    selectJobRowDetail(item) {
      this.selectJob(item, false, true);
    },
    selectJob(item, isHeader, isDetail) {
      const getNestedRows = () => {        
          if (item.node?.drilldown?.expanded) {
            // set selector on expanded children
            let nested = this.deriveNestedRows(item);
            return this.settData
              .filter((rh,rhi) => rhi > nested.parentIndex && rhi <= nested.parentIndex + nested.rowCount);
          } else return [];
      };
      const nestedRows = getNestedRows();
      const usesDetails = this.detAxisSelected.length > 0;
      const getParentMatchKeysForIndented = (collection, match_key, indentLevel, ignoreChildren) => {
        let ind = this.settData.findIndex(x => x.match_key === match_key);
        let i = ind - 1;
        while (i >= 0) {
          let rh = this.settData[i];
          if (rh.indentLevel < indentLevel) {
            collection.push({ match_key: rh.match_key });
            if (!ignoreChildren) rh.children.forEach(c => collection.push({ match_key: c.match_key }));
          }
          if (rh.indentLevel === 0) {
            i = -1;
          } else {
            i--;
          }
        }
      };

      if (this.compareCriteria.some((x) => x.match_key === item.match_key)) {
        //identify any detail children to remove
        const toRemove = this.compareCriteria.filter(x => x.match_key.indexOf(item.match_key) === 0 && item.match_key.length < x.match_key.length);
        //identify drilldown children to remove
        nestedRows.forEach(x => toRemove.push({ match_key: x.match_key }));
        //identify parents to remove
        const matchList = item.match_key.split("|");
        let key = "";
        for(let i = 0; i < matchList.length - 1; i = i + 2) {
          key += `${matchList[i]}|${matchList[i + 1]}|`;
          toRemove.push({ match_key: key });
        }
        if (item.indentLevel > 0) {
          // find parents
          getParentMatchKeysForIndented(toRemove, item.match_key, item.indentLevel);
        }
        if (isDetail) {
          // find parents
          const pos = matchList[0].indexOf("_nodeID");
          const ind = Number(matchList[0].substring(pos - 1, pos));
          this.compareCriteria = this.compareCriteria.filter(x => !toRemove.some(r => x.match_key === r.match_key));
          toRemove.splice(0, toRemove.length);
          getParentMatchKeysForIndented(toRemove, `${matchList[0]}|${matchList[1]}|`, ind - 1, true);
        }
        this.compareCriteria = this.compareCriteria.filter(x => !toRemove.some(r => x.match_key.indexOf(r.match_key) === 0));
        item.selected = false;
      } else {
        this.compareCriteria.push({
          match_key: item.match_key,
        });
        item.selected = true;
      }

      const addCriteria = (match_key) => {
        if (!this.compareCriteria.some(x => x.match_key === match_key))
          this.compareCriteria.push({
            match_key: match_key,
          });
      };

      const setDetailMatchKeys = (items) => {
        items.filter(s => s.job_count).forEach(s => {
          if (s.zContainer && usesDetails) 
            s.children.forEach(c => {
              addCriteria(c.match_key);
            });
          else if (!usesDetails && s.children.length === 0)
            addCriteria(s.match_key);
          else setDetailMatchKeys(s.children);
        });
      };

      if (item.selected) {
        if (isHeader) {
          if (this.layout.rightPanel.cols && (usesDetails || this.horizontalMeasures.some(x => x.visible && x.type === "job_count" && !x.hideSelector))) {
            // get matchKeys of any details
            let row = this.settData.find(x => x.match_key === item.match_key);
            setDetailMatchKeys(row.children);
          }
          // set selector on expanded children
          nestedRows.forEach(r => {
            addCriteria(r.match_key);
            if (this.layout.rightPanel.cols) setDetailMatchKeys(r.children);
          });
        } else if (isDetail) {
          addCriteria(item.match_key);
        }
      }
      this.setCompareDocsForCriteria();
      this.setSelectedItems();
      return item.selected;
    },
    setSelectedItems() {
      const matchKeys = this.compareCriteria.map(x => x.match_key);
      const recurseStructure = (rows) => {
        rows.forEach(r => {
          const isSelected = matchKeys.some(x => x === (r.match_key || r.item?.match_key));
          r.selected = isSelected;
          if (r.node) r.node.selected = isSelected;
          if (r.item) r.item.selected = isSelected;
          if (r.subRows?.length) {
            recurseStructure(r.subRows);
          } else if (r.detail) {
            r.detail.selected = isSelected;
            if (r.detail.node) r.detail.node.selected = isSelected;
            recurseStructure(r.detail.headerColumns);
            recurseStructure(r.detail.children);
          } else {
            if (r.headerColumns) recurseStructure(r.headerColumns);
            if (r.children) recurseStructure(r.children);
          }
        });
      };
      recurseStructure(this.pageStructureSett);
    },
    extractMatchCols(match_key) {
      return match_key.split("|").filter((x, xi) => xi % 2 === 0 && x);
    },
    async setCompareDocsForCriteria() {
      const criteria = JSON.parse(JSON.stringify(this.compareCriteria));
      this.compareDocs.splice(0, this.compareDocs.length);
      if (!criteria.length)
        return;
      
      if (this.useIndex) {
        const filters = this.getIndexFilters();
        const docCriteria = criteria.map(c => ({ postProcess: false, filters: this.matchKeyToFilterCriteria(c.match_key) }));
        docCriteria.forEach(x => x.postProcess = x.filters.some(f => !f.filterValues[0].length));
        let redisFilters = docCriteria.map(x => 
          x.filters.map(f => ({ column: f.column, filterValues: f.filterValues.filter(v => (v || "").length) }))
            .filter(f => f.filterValues.length)
        ).filter(x => x.some(f => f.filterValues.length));
        if (redisFilters.length)
          filters.push({ ORFilters: true, filters: redisFilters });

        const params = {
          filters: filters,
          pageSize: 500,
          returnFields: ['doc_id', 'system_number'],
        }
        docCriteria
          .filter(x => x.postProcess)
          .forEach(x => x.filters
            .map(f => f.column)
            .forEach(x => !params.returnFields.some(r => r === x) ? params.returnFields.push(x) : null)
          );

        let docs = await this.$store.getters["docs/filter"](params);
        if (docCriteria.some(x => x.postProcess)) {
          const cleanRedisResult = (data, column) => {
            const val = data[column];
            if (!val) return "";
            if (val.endsWith('"]') && val.startsWith('["'))
              return val.replace('"]', '').replace('["', '');
            else 
              return val;
          }
          docs = docs.filter(d => docCriteria.some(dc => {
            return dc.filters.every(f => cleanRedisResult(d, f.column) === f.filterValues[0]);
          }));
        }
        this.compareDocs = docs;
      } else {
        criteria.forEach(c => {
          c.matchColumns = this.extractMatchCols(c.match_key);
        });
        this.compareDocs = this.selectedDocs.filter(
          (x) =>
            x.doc_id > 0 &&
            criteria.some(c => this.buildMatchItem(x, c.matchColumns) === c.match_key)
        );
      }
    },
    selectAllRowsClicked() {
      this.selectAllRows = !this.selectAllRows;
      this.compareCriteria.splice(0, this.compareCriteria.length);
      this.settData.forEach((x) => {
        if (x.selected !== this.selectAllRows) {
          x.selected = this.selectAllRows;
        }
        if (x.selected) {
          let match_key = x.match_key;
          this.compareCriteria.push({
            match_key: match_key,
            item: x,
          });
        }
      });
      if (this.selectAllRows) {
        this.compareDocs = this.selectedDocs.map(x => x);
      } else { 
        this.compareDocs.splice(0, this.compareDocs.length);
      }
      this.setVisibleHeaderColumns();
    },
    resetCompare() {
      this.compareCriteria.splice(0, this.compareCriteria.length);
      this.compareView = true;
      let recurseReset = (item) => {
        if (item.selected) item.selected = false;
        if (item.node?.selected) item.node.selected = false;
        item.children.forEach((c) => recurseReset(c));
      };
      if (this.layout?.headerRow?.columnsSett?.length) {
        this.layout.headerRow.columnsSett.forEach((r) => (r.selected = false));
      }
      const resetStructure = (rows) => {
        rows.forEach(r => {
          r.selected = false;
          if (r.node) r.node.selected = false;
          if (r.subRows?.length) {
            resetStructure(r.subRows);
          } else if (r.detail) {
            r.detail.selected = false;
            if (r.detail.headerColumns?.length) {
              r.detail.headerColumns[0].selected = false;
              if (r.detail.headerColumns[0].node)
                r.detail.headerColumns[0].node.selected = false;
            }
            resetStructure(r.detail.children);
          } else if (r.children) {
            resetStructure(r.children);
          }
        });
      }
      if (this.settData) resetStructure(this.settData);
      resetStructure(this.pageStructureSett);

      this.compareDocs.splice(0, this.compareDocs.length);
      this.compareDocsCount = 0;
    },
    compareDocDetails(items) {
      this.sideBySide.show = true;
      this.sideBySide.items = items || this.compareDocs;
    },
    compareDocDetailsFull(items) {
      this.fullCompareView.show = true;
      this.fullCompareView.items = items || this.compareDocs;
    },
    async compareBucketDocs(bucket) {
      let docs = [];
      for (let a of bucket.additions) {
        let ds = await this.getDocs(a);
        ds.forEach((d) => docs.push(d));
      }
      if (docs.length) this.compareDocDetailsFull(docs);
    },
    showLinkedDocs(ids) {
      if (ids?.length) this.compareDocDetailsFull(ids.split(",").map(x => { return { doc_id: Number(x) }; }));
    },
    getDocumentTags(docs) {
      if (docs.length) {
        this.tagsDialogue.doc_ids = docs.map((x) => x.doc_id);
        this.tagsDialogue.hierarchy_node_id = null;
        this.tagsDialogue.show = true;
        return;
      }
    },
    changeDocType(refreshDefinition) {
      this.setupTemplate(this.selectedView.definition.tmpl_id, false, refreshDefinition);
    },
    loadViews(data) {
      this.setUpHierarchies();
      data.forEach((v) => {
        v.isDirty = false;
        v.definition = {
          ...this.defaultViewProperties(),
          ...v.definition,
        };
        // cleanup after change of property names...
        [{ old: "verCompareOptions", neww: "verAxisSelected" },
          { old: "horCompareOptions", neww: "horAxisSelected" }, 
          { old: "detCompareOptions", neww: "detAxisSelected" }].forEach(p => {
            if (v.definition[p.old]) {
              v.definition[p.neww] = v.definition[p.old];
              delete v.definition[p.old];
            }
          })
      });
      this.compareCriteria = [];
      this.views = data.sort((a,b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      if (!this.container) this.setSimilarityViews();
      let defaultHierarchy = this.hierarchyTypes.find(
        (ht) => ht.ht_name.toLowerCase().indexOf("job") >= 0
      );
      if (!defaultHierarchy) defaultHierarchy = this.hierarchyTypes[0];
      this.defaultHierarchy = {
        ht_id: defaultHierarchy.ht_id,
        ht_name: defaultHierarchy.label,
      };

      let callback = async () => {
        await this.setPrimaryViews();
        let viewToSelect = "";
        let viewIDToSelect = null;
        if (this.$route.name === "jobfamily") {
          viewToSelect = `${this.defaultHierarchy.ht_name} List View`;
        } else {
          const passedParams = this.$passedParams.get();
          viewToSelect = passedParams.view;

          let scViews = this.shortcuts.items.filter(x => this.primaryViews.some(pv => pv.name === x.name));

          if (!viewToSelect && scViews.length && this.selectedTab) {
            viewToSelect = scViews.find((x) => x.parentTab === this.selectedTab.key)?.name;
          }
          if (!viewToSelect && scViews.length) {
            viewToSelect = scViews.find((x) => x.isDefault)?.name;
          }
          if (!viewToSelect && scViews.length && this.primaryViews.some) {
            viewToSelect = scViews.sort((a,b) => a.position > b.position ? 1 : b.position > a.position ? -1 : 0)[0].name;
          }
          if (!viewToSelect && this.primaryViews.length) {
            viewToSelect = this.primaryViews[0].name;
          }
          if (!viewToSelect) {
            viewToSelect = this.views.find((x) => x.isDefault)?.name;
          }
          if (!viewToSelect) {
            viewToSelect = `${this.defaultHierarchy.ht_name} Summary`;
          }
        }
        this.selectedView = this.views.find((x) => x.name === viewToSelect);

        this.viewToSelect = this.selectedView ? null : viewToSelect;

        this.fetchData(false, this.selectedView?.definition.tmpl_id);
      };
      this.getShortcuts(callback);
    },
    async fetchData(isRefresh, tmpl_id, refreshDefinition) {
      if (this.isLoading) return;
      // this.isLoadingData = true;
      let possibleError = false;
      if (this.templates) {
        this.setupTemplate(tmpl_id, isRefresh, refreshDefinition);
        return;
      }
      let self = this;
      let args = { nodeDescriptors: !this.nodeDescriptors };
      if (tmpl_id) args.tmpl_id = tmpl_id;
      await axios
        .post("document/jobcatalogue", args)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Data) {
            // this.template_data.push({ tmpl_id: Number(resp.data.Data.template) , data: resp.data.Data});
            self.setupReferenceData(resp.data.Data, tmpl_id);
          }
          this.isLoadingData = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isLoadingData = false;
        });
    },
    setupDescriptors(data) {
      data.hierarchyTypeNodes.forEach((x) => {
        _descriptors["ht_o_" + x.ht_id] = x.descObject;
        delete x.descObject;
        delete x.descriptors;
        x.transactionTypes = [];
        let trantypes = [];
        x.nodeList
          .filter((n) => n.transactions.length)
          .forEach((n) => {
            n.transactions
              .filter((t) => !trantypes.some((tt) => tt === t))
              ?.forEach((t) => trantypes.push(t));
          });
        trantypes.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
        x.transactionTypes = trantypes;
      });
    },
    getTransactionTypes() {
      if (this.selectedView.ht_id) {
        return _hierarchyTypeNodes.find(
          (h) => h.ht_id === this.selectedView.ht_id
        ).transactionTypes;
      } else {
        let ret = [];
        _hierarchyTypeNodes.forEach(
          (h) => (ret = [...new Set([...ret, ...h.transactionTypes])])
        );
        ret.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
        return ret;
      }
    },
    getNameChangeTypes() {
      let ht_id = this.selectedView.definition.ht_id;
      let mapLevels = (l) => {
        return {
          text: l.name,
          value: `ht_id_${ht_id}_${l.index}_previousNames`,
        };
      };
      if (ht_id) {
        return this.hierarchyTypes
          .find((h) => h.ht_id === ht_id)
          .levels.map(mapLevels);
      } else {
        let ret = [];
        this.hierarchyTypes.forEach((h) => {
          ht_id = h.ht_id;
          ret = [...ret, ...h.levels.map(mapLevels)];
        });
        return ret;
      }
    },
    defaultMeasures() {
      return this.measures
        .filter((x) => x.type === "job_count")
        .map((x) => {
          return { type: x.type, column: x.column, id: x.id, aggregation: x.aggregation, displayTypeId: "value", columnTitle: x.abbreviation, hideSelector: false, alignment: "right", alertLevelGT: null, alertLevelLT: null, alertLevelMessage: "", highlightRules: [], allowDrillDown: false, drillDownTitle: "", drilldownMeasures: [], display_colour_id_primary: null, display_colour_id_secondary: null, highlightRulesKeyVisible: false, highlightRulesKeyTextAddendum: "", numberFormat: null, highLightMeasureMinimum: null, highLightMeasureMinimumValue: 0, drilldown: null, single_comparator_text: null, };
        });
    },
    defaultViewProperties() {
      return {
        viewType: "",
        ht_id: null,
        primary: null,
        isPrimary: false,
        isDefault: false,
        tmpl_id: null,
        verticalMeasures: [],
        horizontalMeasures: [],
        groupedViewShowDescriptor: false,
        verticalSortProperty: null,
        defaultSort: null,
        displayAs: this.layoutTypes.find(x => x.default).type,
        // charts: [],
        viewSections: [],
        showDownload: "icon + title",
        gridlines: "vertical only",
        gridWidth: 12,
        showSubHeading: true,
        showTextSearch: false,
        hideNodeActions: false,
        fullVerticalView: false,
        allowColumnSort: false,
        horAxisSelected: [],
        verAxisSelected: [],
        detAxisSelected: [],
        attributeFilters: [],
        hierarchyPickers: [],
        // columnFilters: [],
        measureFilterTypes: [],
        // drilldownFilters: [],
        transactionTypeFilters: [],
        nameChangeFilters: [],
        measureFilter: null,
        compareDVisible: false,
        measurePickerVisible: true,
        isDirty: false,
        isBase: true,

        hideColumnTitles: true,
        description: "",

        //sim props
        templates: [],
        //   tmpl_id: null,
        statuses: [],
        columnsVisible: [],
        matchLevels: [],
        name_match: null,
        content_match:null,
        linked_doc_view: false,
        horizontalHeadingVisible: false,
        showTotalsRow: false,
      };
    },
    defaultViewDef() {
      let def = this.defaultViewProperties();
      def.tmpl_id = this.tmpl_id_default;
      def.verticalMeasures = this.defaultMeasures();
      def.horizontalMeasures = this.defaultMeasures();
      def.horAxisSelected = this.horAxisAvailable?.length ? [
        this.getViewCompareOption(this.horAxisAvailable[0]),
      ] : [];
      def.verAxisSelected = this.verAxisAvailable?.length > 0 ? [
        this.getViewCompareOption(this.verAxisAvailable[1]),
      ] : [];
      def.measureFilter = this.measureFilters.length ? this.measureFilters[0] : null;
      def.measureFilterTypes = [];
      return def;
    },
    setSimDirty(changeType) {
      this.selectedView.isDirty = true;
      switch (changeType) {
        case "changeDocType":
          jaCommon.changeSimDocType(this.selectedView.definition, this.similarityData);
          this.similarityData.updated++;
          break;
        case "filterMatches":
          this.similarityData.updated++;
          // this.filterMatches();
          break;
        case "setColumns":
          this.similarityData.updated++;
          // this.setColumns();
          break;
      }
    },
    getSimDescription() {
      return jaCommon.getDescription(this.selectedView.definition, this.docTypeSummary, this.similarityData.similarityColumnsName, this.similarityData.similarityColumnsContent);
    },
    compareDocuments(d1, d2) {
      const template = this.templates.find(t => t.tmpl_id === d1.tmpl_id);
      let diff = false;
      template.propAttributes.forEach(a => {
        if (d1[a.column] !== d2[a.column]) diff = true;
      });
      if (diff) return false;
      template.propMeasures.forEach(a => {
        if (d1[a.type] !== d2[a.type]) diff = true;
      });
      if (diff) return false;
      this.hierarchyTypes.forEach(ht => {
        if (d1[ht.col_hr_id] !== d2[ht.col_hr_id]) diff = true;
        ht.levels.forEach(l => {
          if (d1[l.col_title] !== d2[l.col_title]) diff = true;
          if (d1[l.col_node] !== d2[l.col_node]) diff = true;
        });
      });
      return !diff;
    },
    prepareDocument(d, templates) {
      const template = templates.find(t => t.tmpl_id === d.tmpl_id);
      const created_date = dayJS(d.created_date);
      const today = dayJS();
      const doc = { 
        doc_id: d.doc_id,
        doc_name: d.doc_title || d.doc_name,
        doc_status: d.doc_status_text,
        tmpl_id: template.tmpl_id,
        system_number: d.system_number,
        job_count: 1,
        selected: false,
        created_date: created_date.format("YYYY-MM-DD"),
        created_year: created_date.format("YYYY"),
        created_month: created_date.format("YYYY-MM"),
        age_months: today.diff(created_date, 'month'),
      }
      template.propAttributes.forEach(a => {
        doc[a.changeCol] = true;
        doc[a.column] = (d[a.cache_column] || "").trim();
      });
      template.propMeasures.forEach(a => {
        doc[a.type] = Number(d[a.cache_column]) || 0;
				doc[a.column] = doc[a.type];
      });
      template.derivedMeasures.forEach(m => {
        let related = template.derivedMeasureDocuments.find(x => x.doc_id === doc.doc_id);
        doc[m.column] = related ? Number(related[m.column]) : 0;
        doc[m.doc_column] = related ? related[m.doc_column] : null;
        doc[m.doc_name_column] = related ? related[m.doc_name_column] : null;
      });
      d.hierarchies.forEach(h => {
        this.setDocHierarchyProperties(h.ht_id, h.hr_id, doc);
      });
      return doc;        
    },
    setDocHierarchyProperties(ht_id, hr_id, doc) {
      const ht_ = this.hierarchyTypes.find(x => x.ht_id === ht_id);
      if (ht_) {
        doc[ht_.col_hr_id] = hr_id;
        let hr = ht_.values.find(x => x.value === hr_id);
        if (hr) hr[`hasDoc_${doc.tmpl_id}`] = true;
        let label = "";

        ht_.levels.forEach(l => {
          // const title = hr[l.col_hierarchy] || "UNCLASSIFIED";
          const title = (hr ? hr[l.col_level] : null) || "UNCLASSIFIED";
          doc[l.col_title] = title;
          doc[l.col_node] = hr ? hr[l.col_node_id] : null;
          doc[l.col_prev] = [];
          if (l.isLinkLevel) doc[ht_.col_text] = title;
          label = " > " + title + label;
        });
        doc[ht_.col_label] = label.substring(3);
      }
    },
    async setupReferenceData(data, tmplate_id) {
      data.templates.forEach(t => {
        t.measures.forEach((m) => {
          m.alignRight = false;
          m.available = true;
          m.cols = 0;
        });
        // // fix employee_percentage measure so that its realistic...
        // t.measures.filter(x => x.type === "employee_percentage")
        //   .forEach(x => {
        //     x.aggregation = "overall_percent";
        //     x.aggregation_quantity_column = "employee_count";
        //   });
        this.setupViewMeasures(t);
      });
      if (!this.templates) this.templates = data.templates;
      // "refreshDefinition" means that tmpl_id has change for current view
      //  so need to repopulate view properites based on new template
      if (data?.hierarchyTypeNodes) {
        this.setupDescriptors(data);
        // _hierarchyTypeNodes = data.hierarchyTypeNodes;
      }
      if (data?.nodeDescriptors) {
        this.nodeDescriptors = data.nodeDescriptors;
        _nodeDescriptorMap = null;
      }
      if (data.permissions) {
        this.permissions = data.permissions;
      }
      if (data.clientColours) {
        this.clientColours = data.clientColours;
      }

      let tmpl_id = Number(tmplate_id || this.docTypeSummary[0].tmpl_id);
      if (!tmpl_id) {
        alert("You are not permitted to view any documents");
        this.isLoadingData = false;
        this.isSaving = false;
        this.isBuilding = false;
        return;
      }
      data.templates.forEach(t => {
        t.propAttributes = t.attributes.filter(a => a.cache_column).map(a => {
          return {
            changeCol: "change_" + a.column,
            cache_column: a.cache_column,
            column: a.column,
          };
        });
        t.propMeasures = t.measures.filter(x => x.cache_column).map(a => {
          return {
            cache_column: a.cache_column,
            column: a.column,
            type: a.type,
          };
        });
      });
      _documents = this.$store.getters["docs/docsList"]
          .filter(x => x.doc_status !== "DELETED" && x.doc_status !== "ARCHIVED")
          .map(d => { 
            return this.prepareDocument(d, data.templates);
          });
      // add dummy for nodes without doc
      let did = -1;
      this.hierarchyTypes.forEach(ht => {
        data.templates.forEach(template => {
          const t_doc = { 
            doc_id: did--,
            doc_name: `NO ${ht.linklevelName.toUpperCase()}`,
            doc_status: "",
            tmpl_id: template.tmpl_id,
            system_number: "",
            job_count: 0,
            selected: false,
            created_date: "",
            created_year: "",
            created_month: "",
            age_months: 0,
          }
          template.attributes.filter(a => a.tpa_id).forEach(a => {
            t_doc[a.column] = "UNKNOWN";
            t_doc["change_" + a.column] = true;
          });
          template.measures.forEach(m => {
            t_doc[m.id] = 0;
          });
          this.hierarchyTypes.forEach(th => {
            t_doc[th.col_hr_id] = null;
            th.levels.forEach(l => {
              t_doc[l.col_title] = "";
              t_doc[l.col_node] = null;
              t_doc[l.col_prev] = [];
            });
            t_doc[th.col_label] = "";
          });

          ht.values.filter(x => !x[`hasDoc_${template.tmpl_id}`] && x.hr_active && x.level1).forEach(h => {
            const doc = { ...{}, ...t_doc };
            doc[ht.col_hr_id] = h.value;
            let label = "";

            ht.levels.forEach(l => {
              const title = h[l.col_hierarchy_missing] || "UNCLASSIFIED";
              doc[l.col_title] = title;
              doc[l.col_node] = h[l.col_node_id];
              doc[l.col_prev] = [];
              if (l.isLinkLevel) doc[ht.col_text] = title;
              label = " > " + title + label;
            });
            doc[ht.col_label] = label.substring(3);                    
            _documents.push(doc);
          });

        });
      });
      
      this.tmpl_id_default = Number(data.tmpl_id_default);
      await this.setupTemplate(tmpl_id);
      _reviewNodes = data.reviewNodes || [];
      let rdocs =
        data.reviewDocs.map((x) => {
          x.showNextLevel = false;
          x.showComments = false;
          x.nodesMain.forEach((n) => (n.showComments = false));
          return x;
        }) || [];
      this.reviewDocs = [
        {
          type: "Open",
          docs: rdocs.filter((x) => x.status_type === "Open"),
          show: false,
        },
        {
          type: "Completed",
          docs: rdocs.filter((x) => x.status_type === "Completed"),
          show: false,
        },
      ];
    },
    getIndexFilterParams(filters) {
      const resp = [ { column: "doc_status", exclude: true, filterValues: [ 'DELETED', 'ARCHIVED' ] } ];

      const tmplId = this.catalogueDocType?.tmpl_id;
      if (tmplId)
        resp.push({ column: "tmpl_id", filterValues: [ tmplId ] });

      if (filters && filters.length)
        resp.push(...filters);

      return resp;
    },
    getIndexAttrName(c) {
      let indexAttr = c.column;
      let colName = c.name ?? c.title ?? c.column;
      if (indexAttr === 'doc_status') {
        indexAttr = 'doc_status_text';
      } else if (indexAttr.startsWith('c_') && colName) {
        //tmpl part attr field indexed by name
        indexAttr = `tpa_${colName.toLowerCase().replaceAll(' ','_')}`;
      }
      return indexAttr;
    },
    async getCompareOptions(attributes, docs, docType) {
      let indexDistinctVals = {};
      if (this.useIndex) {
        const filters = this.getIndexFilterParams();
        const params = [
          ...attributes.filter(a => a.cache_column).map(a => {
            return {
              column: a.column,
              tag: this.getIndexAttrName(a),
              filters: filters
            }
          }),
          ...this.hierarchyTypes.map(h => (
            [1, 2, 3, 4, 5, 6]
              .filter(l => l <= h['linklevel']) // && h[`use_h${l}`] === 1)
              .map((l, li) => ({
                  column: `ht_id_${h.ht_id}_${l}_`,
                  tag: `ht_id_${h.ht_id}_${l}_`,
                  filters: filters,
                }))
          )).flat(),
          // distinct node ids per level, used to scope the hierarchy tree
          // filters to nodes that have documents (docsList is not fully
          // populated in index mode, so hasDoc flags can't be used there)
          ...this.hierarchyTypes.map(h => (
            [1, 2, 3, 4, 5, 6]
              .filter(l => l <= h['linklevel'])
              .map((l) => ({
                  column: `ht_id_${h.ht_id}_${l}_nodeID`,
                  tag: `ht_id_${h.ht_id}_${l}_nodeID`,
                  filters: filters,
                }))
          )).flat()
        ];
        this.inProgressIndexRequests++;
        await this.$store.getters['docs/getCountsByAttr'](params)
          .then((resp) => {
            this.inProgressIndexRequests--;
            params.forEach(p => {
              indexDistinctVals[p.column] = resp.find(c => c.tag === p.tag)
                  ?.values.map(v => Array.isArray(v.value) ? v.value.join('|') : v.value) || []
              }
            );
            const docNodes = {};
            this.hierarchyTypes.forEach(h => {
              const ids = new Set();
              [1, 2, 3, 4, 5, 6].filter(l => l <= h.linklevel).forEach(l => {
                (indexDistinctVals[`ht_id_${h.ht_id}_${l}_nodeID`] || [])
                  .forEach(v => ids.add(String(v)));
              });
              docNodes[h.ht_id] = ids;
            });
            this.indexHierarchyDocNodes = docNodes;
          });
      }
      const getDistinctValues = (column) => {
        if (this.useIndex) {
          return indexDistinctVals[column]
            ?.sort((a,b) => a > b ? 1 : a < b ? -1 : 0)
            ?.map(v => ({ sort_key: v, value: v })) || [];
        } else {
          return [...new Set(docs.filter(x => x[column]).map(x => x[column]))]
                          .sort((a,b) => a > b ? 1 : a < b ? -1 : 0)
                          .map(x => ({ sort_key: x, value: x }));
        }
      }
      let compareOptions = [];
      attributes.forEach((a) => {
        let vals;
        if (a.values.length === 0) {
          vals = getDistinctValues(a.column);
        }
        compareOptions.push({
          name: a.title,
          column: a.column,
          cache_column: a.cache_column,
          tpa_id: a.tpa_id,
          useSortKey: a.useSortKey,
          listValues: a.values.length ? a.values : vals,
          listValueLength: (a.values.length ? a.values : vals).length,
          listValuesFiltered: (a.values.length ? a.values : vals).filter(x => x.value).map(
            (x) => x.value
          ),
          filterValues: [],
          sortKey: `1_${a.title}`,
          colWidth: 12,
          detail_prefix: "", //a.catalogue_attribute_prefix,
          data_type: a.data_type,
        });
      });
      compareOptions.push({
        name: docType + " Document",
        column: "doc_id",
        cache_column: "doc_id",
        display_column: "doc_name",
        showSimCount: true,
        hideHorizontal: true,
        hideVertical: false,
        isDocument: true,
        filterValues: [],
        sortKey: `1_1_0`,
        colWidth: 12,
        data_type: "text",
      });
      this.hierarchyTypes.forEach((ht) => {
        let levels = [1, 2, 3, 4, 5, 6].filter((l) => l <= ht.linklevel); //.filter((i) => ht["col" + i] > 0);
        compareOptions.push({
          name: ht.label + " (Drilldown)",
          column: `ht_id_${ht.ht_id}_1_`,
          cache_column: `ht_id_${ht.ht_id}_1_`,
          ht_id: ht.ht_id,
          ht_name: ht.ht_name,
          ht_label: ht.label,
          linklevel: ht.linklevel,
          filterValues: [],
          hideDDrilldown: true,
          currentDrillDownLevel: 1,
          drillDownLevels: levels.map((i) => {
            let usesDescriptor = ht["descriptor_h" + i];
            return {
              column: `ht_id_${ht.ht_id}_${i}_`,
              node_column: `ht_id_${ht.ht_id}_${i}_nodeID`,
              ht_label: ht.h_levels[i - 1],
              hLevel: i,
              usesDescriptor: usesDescriptor,
            };
          }),
          sortKey: `2_${ht.position}_1`,
          colWidth: 12,
          data_type: "text",
        });
        levels.forEach((l) => {
          let colname = `ht_id_${ht.ht_id}_${l}_nodeID`;
          let coltext = `ht_id_${ht.ht_id}_${l}_`;
          let vals = getDistinctValues(coltext);
          compareOptions.push({
            name: ht.h_levels[l - 1],
            column: colname,
            cache_column: colname,
            display_column: coltext,
            isLeafNode: l === ht.linklevel,
            ht_id: ht.ht_id,
            ht_name: ht.ht_name,
            ht_label: ht.label,
            ht_level: l,
            linklevel: ht.linklevel,
            filterValues: [],
            listValueLength: vals.length,
            listValues: vals,
            listValuesFiltered: vals.map(
              (x) => x.value
            ),
            usesDescriptor: !!ht["descriptor_h" + l],
            // hideHorizontal: true,
            // hideVertical: true,
            sortKey: `1_${ht.position}_${l}`,
            colWidth: 12,
          });
        });
      });
      compareOptions.sort((a, b) =>
        a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0
      );
      // template data (re)loaded: rescope the hierarchy tree filters
      this.hierarchyPickerScopedTmpl = null;
      this.scopeHierarchyPickerTrees(this.catalogueDocType?.tmpl_id);
      return compareOptions;
    },
    async setupTemplate(tmpl_id, isRefresh, refreshDefinition) {
      const template = this.templates.find(x => x.tmpl_id === tmpl_id);
      if (!template) return;
      this.usesTags = template.usesTags;
      this.catalogueDocType = this.docTypeSummary.find(
        (x) => x.tmpl_id === tmpl_id
      );

      this.attributes = JSON.parse(JSON.stringify(template.attributes));

      this.measures = JSON.parse(JSON.stringify(template.measures));
      this.measureFilters = template.measures
        .filter((x) => x.filterPresence)
        .map((x) => {
          return { title: x.title, type: x.type };
        });
      if (this.measureFilters.length) {
        this.measureFilters.unshift({
          title: "No Similarity Filter",
          type: null,
        });
      }
      
      const docs = _documents.filter(x => x.job_count && x.tmpl_id === tmpl_id);
      this.haveData = !!this.catalogueDocType;
      let compareOptions = await this.getCompareOptions(template.attributes, docs, template.tmpl_name)
      // this.attributes.forEach((a) => {
      //   let vals;
      //   if (a.values.length === 0) {
      //     vals = [...new Set(docs.filter(x => x[a.column]).map(x => x[a.column]))]
      //                       .sort((a,b) => a > b ? 1 : a < b ? -1 : 0)
      //                       .map(x => {
      //         return { sort_key: x, value: x };
      //       });
      //   }
      //   compareOptions.push({
      //     name: a.title,
      //     column: a.column,
      //     tpa_id: a.tpa_id,
      //     useSortKey: a.useSortKey,
      //     listValues: a.values.length ? a.values : vals,
      //     listValueLength: (a.values.length ? a.values : vals).length,
      //     listValuesFiltered: (a.values.length ? a.values : vals).filter(x => x.value).map(
      //       (x) => x.value
      //     ),
      //     filterValues: [],
      //     sortKey: `1_${a.title}`,
      //     colWidth: 12,
      //     detail_prefix: "", //a.catalogue_attribute_prefix,
      //     data_type: a.data_type,
      //   });
      // });
      // compareOptions.push({
      //   name: this.catalogueDocType.docType + " Document",
      //   column: "doc_id",
      //   display_column: "doc_name",
      //   showSimCount: true,
      //   hideHorizontal: true,
      //   hideVertical: false,
      //   isDocument: true,
      //   filterValues: [],
      //   sortKey: `1_1_0`,
      //   colWidth: 12,
      //   data_type: "text",
      // });
      // this.hierarchyTypes.forEach((ht) => {
      //   let levels = [1, 2, 3, 4, 5, 6].filter((l) => l <= ht.linklevel); //.filter((i) => ht["col" + i] > 0);
      //   compareOptions.push({
      //     name: ht.label + " (Drilldown)",
      //     column: `ht_id_${ht.ht_id}_1_`,
      //     ht_id: ht.ht_id,
      //     ht_name: ht.ht_name,
      //     ht_label: ht.label,
      //     linklevel: ht.linklevel,
      //     filterValues: [],
      //     hideDDrilldown: true,
      //     currentDrillDownLevel: 1,
      //     drillDownLevels: levels.map((i) => {
      //       let usesDescriptor = ht["descriptor_h" + i];
      //       return {
      //         column: `ht_id_${ht.ht_id}_${i}_`,
      //         node_column: `ht_id_${ht.ht_id}_${i}_nodeID`,
      //         ht_label: ht.h_levels[i - 1],
      //         hLevel: i,
      //         usesDescriptor: usesDescriptor,
      //       };
      //     }),
      //     sortKey: `2_${ht.position}_1`,
      //     colWidth: 12,
      //     data_type: "text",
      //   });
      //   levels.forEach((l) => {
      //     let colname = `ht_id_${ht.ht_id}_${l}_nodeID`;
      //     let coltext = `ht_id_${ht.ht_id}_${l}_`;
      //     let vals = [...new Set(docs.filter(x => x[coltext]).map(x => x[coltext]))]
      //       .sort((a,b) => a > b ? 1 : a < b ? -1 : 0)
      //       .map(x => {
      //         return { value: x };
      //       });
      //     compareOptions.push({
      //       name: ht.h_levels[l - 1],
      //       column: colname,
      //       display_column: coltext,
      //       isLeafNode: l === ht.linklevel,
      //       ht_id: ht.ht_id,
      //       ht_name: ht.ht_name,
      //       ht_label: ht.label,
      //       ht_level: l,
      //       linklevel: ht.linklevel,
      //       filterValues: [],
      //       listValueLength: vals.length,
      //       listValues: vals,
      //       listValuesFiltered: vals.map(
      //         (x) => x.value
      //       ),
      //       // hideHorizontal: true,
      //       // hideVertical: true,
      //       sortKey: `1_${ht.position}_${l}`,
      //       colWidth: 12,
      //     });
      //   });
      // });
      // compareOptions.sort((a, b) =>
      //   a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0
      // );
      this.verAxisAvailable = JSON.parse(
        JSON.stringify(compareOptions.filter((x) => !x.hideVertical))
      ).map(x => {
        x.visible = false;
        return x;
      });
      this.horAxisAvailable = JSON.parse(
        JSON.stringify(compareOptions.filter((x) => !x.hideHorizontal))
      );
      this.detAxisAvailable = JSON.parse(
        JSON.stringify(compareOptions.filter((x) => !x.hideDDrilldown))
      );

      this.isLoadingData = false;
      this.isSaving = false;
      this.isDataLoaded = true;
      if (isRefresh) {
        this.selectJDs();
      } else {
        let defaultCompare = (type, defaults) => {
          let def;
          if (defaults?.length) {
            let index = 0;
            while (!def && index < defaults.length) {
              let values = defaults[index].toLowerCase().split("|");
              def = this[type].find((x) =>
                values.every((v) => x.name.toLowerCase().indexOf(v) >= 0)
              );
              index++;
            }
          }
          return this.getViewCompareOption(def ? def : this[type][0]);
        };
        let curDef = this.selectedView?.definition;
        if (curDef) {
          if (refreshDefinition) {
            curDef.verticalMeasures = this.defaultMeasures();
            curDef.horizontalMeasures = this.defaultMeasures();
            curDef.horAxisSelected = [
              defaultCompare("horAxisAvailable", ["management", "grade"]),
            ];
            curDef.verAxisSelected = [
              defaultCompare("verAxisAvailable", ["Job|Drilldown"]),
            ];
            curDef.detAxisSelected = [];
            curDef.attributeFilters = [];
            // curDef.columnFilters = [];
            curDef.measureFilterTypes = [];
            // curDef.drilldownFilters = [];
            curDef.transactionTypeFilters = [];
            curDef.nameChangeFilters = [];
            curDef.measureFilter = this.measureFilters.length ? this.measureFilters[0] : null;
          } else {
            // fix change to column name
            const fixColumn = (options) => {
              if (options?.length)
                options.filter(x => x.column === "system_number").forEach(x => x.column = "doc_id");
            }
            fixColumn(curDef.horAxisSelected);
            fixColumn(curDef.verAxisSelected);
            fixColumn(curDef.detAxisSelected);
            // make sure contents valid for changed doc type
            curDef.verticalMeasures = curDef.verticalMeasures ? curDef.verticalMeasures.filter((m) =>
              this.measures.some((x) => x.id=== m.id)
            ) : [];
            curDef.horizontalMeasures = curDef.horizontalMeasures ? curDef.horizontalMeasures.filter((m) =>
              this.measures.some((x) => x.id=== m.id)
            ) : [];
            if (
              curDef.horAxisSelected.length === 1 &&
              !this.horAxisAvailable.some(
                (h) => h.column === curDef.horAxisSelected[0].column
              )
            ) {
              curDef.horAxisSelected = [
                defaultCompare("horAxisAvailable", ["management", "grade"]),
              ];
            }
            if (
              curDef.verAxisSelected.length === 1 &&
              !this.verAxisAvailable.some(
                (h) => h.column === curDef.verAxisSelected[0].column
              )
            ) {
              curDef.verAxisSelected = [
                defaultCompare("verAxisAvailable", ["Job|Drilldown"]),
              ];
            }
            curDef.detAxisSelected = curDef.detAxisSelected.filter(x => this.detAxisAvailable.some((h) => h.column === x.column));
            if (
              !curDef.detAxisSelected ||
              !curDef.detAxisSelected.every((x) =>
                this.detAxisAvailable.some((h) => h.column === x.column)
              )
            ) {
              curDef.detAxisSelected = [];
            }
            if (
              !curDef.horizontalMeasures.length &&
              !curDef.detAxisSelected.length
            )
              curDef.horizontalMeasures = this.defaultMeasures();
          }
        }
        this.addView({
          name: `${this.defaultHierarchy.ht_name} Summary`,
          viewType: "catalogue",
          isDefault: !this.views.some((x) => x.isDefault),
          ht_id: this.defaultHierarchy.ht_id,
          primary: { icon: "mdi-view-comfy", position: 2 },
          horAxisSelected: [
            defaultCompare("horAxisAvailable", ["management", "grade"]),
          ],
          verAxisSelected: [
            defaultCompare("verAxisAvailable", ["Job|Drilldown"]),
          ],
          compareDVisible: true,
          detAxisSelected: [],
        });
        this.hierarchyTypes.forEach((ht) => {
          let isDefault = ht.ht_id === this.defaultHierarchy?.ht_id;
          if (this.usesReviews) {
            this.addView({
              name: `${ht.ht_name} Reviews`,
              viewType: "reviews",
              ht_id: ht.ht_id,
              primary: isDefault
                ? { icon: "mdi-comment-text-multiple", position: 5 }
                : null,
            });
          }
        });
        if (this.measures.some((m) => m.type === "employee_count")) {
          const empMeasures = () => [{ type: "employee_count", id: "employee_count", displayTypeId: "value", columnTitle: "Headcount", alignment: "center" }];
          const empMeasuresBar = () => [{ type: "employee_count", id: "employee_count_max", displayTypeId: "max_value_overall", columnTitle: "Headcount", alignment: "center" }];
          this.addView({
            name: "Employee Distribution Matrix",
            viewType: "catalogue",
            ht_id: this.defaultHierarchy.ht_id,
            primary: { icon: "people", position: 7 },
            verticalMeasures: empMeasures(),
            horizontalMeasures: empMeasures(),
            horAxisSelected: [
              defaultCompare("horAxisAvailable", ["management", "level"]),
            ],
            verAxisSelected: [
              defaultCompare("verAxisAvailable", ["Job|Drilldown"]),
            ],
            compareDVisible: true,
            detAxisSelected: [],
          });
          this.addView({
            name: "Employee Distribution by Level",
            viewType: "catalogue",
            ht_id: this.defaultHierarchy.ht_id,
            longMeasureTitle: true,
            primary: { icon: "transfer_within_a_station", position: 8 },
            verticalMeasures: empMeasuresBar(),
            horizontalMeasures: [],
            horAxisSelected: [],
            verAxisSelected: [
              defaultCompare("verAxisAvailable", ["job level", "level"]),
            ],
            detAxisSelected: [],
          });
          if (this.measures.some((m) => m.type === "employee_percentage")) {
            let empMV = empMeasures();
            empMV.push({ type: "employee_percentage", id: "employee_percentage", displayTypeId: "value", columnTitle: "Headcount %", alignment: "right" });
            empMV.push({ type: "job_count", id: "job_count", displayTypeId: "value", columnTitle: "JDs", alignment: "right" });
            this.addView({
              name: "Employee Distribution by Family",
              viewType: "catalogue",
              ht_id: this.defaultHierarchy.ht_id,
              longMeasureTitle: true,
              primary: { icon: "elevator", position: 9 },
              verticalMeasures: empMV,
              horizontalMeasures: [],
              horAxisSelected: [],
              verAxisSelected: [
                defaultCompare("verAxisAvailable", ["Job|Drilldown"]),
              ],
              detAxisSelected: [],
              verticalSortProperty: "employee_percentage",
            });
          }
        }

        if (this.viewToSelect) {
          this.selectedView = this.views.find(
            (x) => x.name === this.viewToSelect
          );
          this.viewToSelect = null;
        } else this.setView();
      this.prepareMeasureFiltersCurrent();
      }
      //   }
    },
    addView(view) {      
      let existingView = this.views.find((x) => x.name === view.name);
      if (existingView) {
        if (existingView.isStandardView) {
          existingView.definition = {
            ...this.defaultViewDef(),
            ...view,
          };
        } else {
          existingView.definition = {
            ...this.defaultViewDef(),
            ...existingView.definition,
          };
        }
        return;
      }
      let vDef = {
        view_definition_id: null,
        name: view.name,
        isNew: false,
        isStandardView: true,
        restricted: false,
        description: "",
        definition: {
          ...this.defaultViewDef(),
          ...view,
        },
      };
      vDef.description = this.getViewDescription(vDef.definition);
      this.views.push(vDef);
    },
    allowDesigner(location, section, sectionIndex) {
      if (!(this.permissions.changeSettings && this.permissions.designIconVisible))
        return false;
      return this.showViewButton(location, section, sectionIndex);
    },
    showViewButton(location, section, sectionIndex) {
      if (section && sectionIndex > 0) return false;
      if (!section) section = this.selectedView.definition;
      if (section.title && location === "title")
        return true;
      if (section.description && !section.title && location === "description")
        return true;
      if (!section.description && !section.title && location === "")
        return true;
      return false;
    },
    filterScroll(data, filterSettings) {
      if (data) {
        let page = filterSettings.page + (data.deltaY >= 0 ? 1 : -1);
        if (page > filterSettings.pages || page < 1) return;
        filterSettings.page = page;
      }
    },
    setFilterValue(item, column) {
      if (column && column.filterSettings) {
        let value = item[column.value];
        column.filterSettings.values.forEach((x) => {
          x.selected = x.text === value;
        });
        this.filterHeading(column.filterSettings);
      }
    },
    removeFilterValue(item, column) {
      if (column && column.filterSettings) {
        let value = item[column.value];
        column.filterSettings.values
          .filter((x) => x.text === value)
          .forEach((x) => (x.selected = false));
        this.filterHeading(column.filterSettings);
        this.updateViewDefinition();
      }
    },
    filterHeading(filterSettings) {
      filterSettings.values
        .filter((v) => v.selected)
        .forEach((v) => (v.applied = true));
      filterSettings.isActive = filterSettings.values.some((x) => x.selected);
      filterSettings.show = false;
      let activeCount = 0;
      filterSettings.mostRecent = filterSettings.isActive;
      this.activeFilterCount = activeCount;
      this.updateViewDefinition();
      this.selectJDs();
    },
    filterSearchAll(filterSettings) {
      if (filterSettings.searchText) {
        let newVal = !filterSettings.values.every(
          (x) => !x.visible || x.selected
        );
        filterSettings.values.forEach((x) => {
          if (x.visible || !newVal) x.selected = newVal;
        });
      } else {
        let newVal = !filterSettings.values.every((x) => x.selected);
        filterSettings.values.forEach((x) => {
          x.selected = newVal;
        });
      }
    },
    filterSearch(filterSettings) {
      let index = 0;
      let search = (filterSettings.searchText || "")
        .toLowerCase()
        .split(" ")
        .filter((x) => x);
      filterSettings.values.forEach((x) => {
        const visible =
          !search.length ||
          search.every((s) => x.searchValues.some((v) => v.indexOf(s) >= 0)); // x.text.toLowerCase().indexOf(search) >= 0;
        x.visible = visible;
        if (visible) {
          x.page = parseInt(index / 7) + 1;
          index++;
        } else {
          x.page = 0;
        }
      });
      filterSettings.pages = parseInt((index - 1) / 7) + 1;
      filterSettings.page = 1;
    },
    filterClear(filterSettings) {
      filterSettings.searchText = "";
      filterSettings.values.forEach((x, xi) => {
        x.visible = true;
        x.selected = false;
        x.applied = false;
        x.page = parseInt(xi / 7) + 1;
      });
      filterSettings.pages =
        parseInt((filterSettings.values.length - 1) / 7) + 1;
      this.filterHeading(filterSettings);
    },
    openDocumentID(id) {
      let doc = _documents.find((d) => d.system_number === id);
      if (doc) this.openDocument(doc);
    },
    openDocument(item) {
      this.$emit("openDocument", {
        system_number: utils.removeTags(item.system_number),
        doc_name: utils.removeTags(item.doc_name),
        doc_type: item.doc_type,
        viewAction: item.viewAction,
      });
    },
    openDocumentSummary(event, item) {
      this.documentSummary.doc_id = item.doc_id;
      this.documentSummary.trigger = event;
    },
    async viewNodeDoc(event, item) {
      let docs = await this.getDocs(item);
      if (docs.length === 1) {
        this.documentSummary.doc_id = Number(docs[0].doc_id);
        this.documentSummary.trigger = event;
      } else if (docs.length > 1) {
        this.compareDocDetailsFull(docs);
      }
    },
    exportToCSV() {
      //   this.csvHeaders = JSON.parse(JSON.stringify(this.dtHeaders));
      this.csvHeaders.push({
        text: "Created By",
        value: "created_by",
      });
      let data =
        this.csvHeaders.map((h) => '"' + h.text + '"').join(",") + "\n";
      this.items.forEach((d) => {
        data +=
          this.csvHeaders
            .map((h) => utils.csvEscape(utils.removeTags(d[h.value])))
            .join(",") + "\n";
      });
      utils.downloadFile(data, "Documents.csv", "text/csv;encoding:utf-8");
    },

    setUpHierarchies() {
      if (
        !this.$store.state.hierarchies.loading &&
        this.$store.state.hierarchies.hierarchies.length
      ) {
        let hierarchyTypes = JSON.parse(
          JSON.stringify(this.$store.state.hierarchies.hierarchies)
        ).map(ht => {
          let item = {
            ht_id: ht.ht_id,
            label: ht.label,
            h_levels: ht.h_levels,
            descriptor_h1: ht.descriptor_h1,
            descriptor_h2: ht.descriptor_h2,
            descriptor_h3: ht.descriptor_h3,
            descriptor_h4: ht.descriptor_h4,
            descriptor_h5: ht.descriptor_h5,
            descriptor_h6: ht.descriptor_h6,
            ht_name: ht.ht_name,
            linklevel: ht.linklevel,
            linklevelName: ht.h_levels[ht.linklevel - 1],
            position: ht.position,
            col_hr_id: "ht_id_" + ht.ht_id,
            col_text: "ht_id_" + ht.ht_id + "_text",
            col_label: "ht_id_" + ht.ht_id + "_label",
            levels: [],
            values: ht.values,
          };
          let i = 1, level = ht.linklevel;
          while (i <= ht.linklevel) {
            item.levels.push({
              level: level,
              isLinkLevel: level === ht.linklevel,
              hasNextLevel: i < ht.linklevel,
              col_hierarchy: "hierarchy" + i,
              col_title: "ht_id_" + ht.ht_id + "_" + level + "_",
              col_node: "ht_id_" + ht.ht_id + "_" + level + "_nodeID",
              col_prev: "ht_id_" + ht.ht_id + "_" + level + "_previousNames",
              col_node_id: "hierarchy_node_id_level" + level,
              col_level: "level" + level,
              level_name: ht.h_levels[i - 1],
              col_hierarchy_missing: "level" + level,
              col_node_id_missing: "hierarchy_node_id_level" + i,
            });
            i++;
            level--;
          }
          return item;
        });
        this.hierarchyTypes = hierarchyTypes;
        this.setupHierarchyPickerFilters();
      }
    },
    setupHierarchyPickerFilters() {
      const storeHierarchies = this.$store.state.hierarchies.hierarchies;
      this.hierarchyPickerFilters = this.hierarchyTypes.map((ht) => {
        const src = storeHierarchies.find((h) => h.ht_id === ht.ht_id);
        // display tree: treePickerOptionsActive (nested, sorted, picker-ready);
        // node levels and parent links come from itemsActive since getItems
        // drops `level`
        const nodeMap = {};
        const walk = (items, parentId) =>
          items.forEach((x) => {
            nodeMap[x.node_id] = {
              node_id: x.node_id,
              level: x.level,
              name: x.text,
              parent: parentId,
            };
            if (x.items && x.items.length) walk(x.items, x.node_id);
          });
        walk(src?.itemsActive || [], null);
        // read-only after build: freeze so Vue doesn't observe every node
        Object.freeze(nodeMap);
        return {
          treePicker: true,
          ht_id: ht.ht_id,
          name: ht.label,
          column: `htp_${ht.ht_id}`,
          linklevel: ht.linklevel,
          fullItems: src?.treePickerOptionsActive || [],
          items: src?.treePickerOptionsActive || [],
          narrowedItems: null,
          narrowedVersion: -1,
          narrowLoading: false,
          nodeIdsAvailable: true,
          onOpen: (h) => this.narrowHierarchyPickerTree(h),
          nodeMap,
          included: false,
          selected: [],
          selectedNodes: [],
          filterValues: [],
        };
      });
      this.hierarchyPickerScopedTmpl = null;
    },
    scopeHierarchyPickerTrees(tmpl_id) {
      // restrict each picker tree to nodes with at least one document for the
      // view's template. Ancestors of a doc-bearing node are always included
      // because node ids are collected per level. Index mode reads the
      // distinct node ids fetched in getCompareOptions; client mode uses the
      // hasDoc_<tmpl_id> row flags set during prepareDocument.
      if (!tmpl_id || this.hierarchyPickerScopedTmpl === tmpl_id) return;
      // doc data not loaded yet: keep the full trees and don't cache, so a
      // later call can still scope them
      if (this.useIndex && !this.indexHierarchyDocNodes) return;
      if (!this.useIndex && !_documents.length) return;
      this.hierarchyPickerScopedTmpl = tmpl_id;
      this.hierarchyPickerFilters.forEach((hp) => {
        let docNodes;
        if (this.useIndex) {
          docNodes = this.indexHierarchyDocNodes[hp.ht_id] || new Set();
        } else {
          const ht = this.hierarchyTypes.find((h) => h.ht_id === hp.ht_id);
          docNodes = new Set();
          (ht?.values || [])
            .filter((r) => r[`hasDoc_${tmpl_id}`])
            .forEach((r) => {
              for (let l = 1; l <= ht.linklevel; l++) {
                const id = r[`hierarchy_node_id_level${l}`];
                if (id) docNodes.add(String(id));
              }
            });
        }
        const prune = (nodes) =>
          nodes
            .filter((n) => docNodes.has(String(n.node_id)))
            .map((n) =>
              n.children ? { ...n, children: prune(n.children) } : n
            );
        // an empty set means no docs OR node ids missing from a stale index —
        // fall back to the full tree rather than showing nothing
        hp.nodeIdsAvailable = docNodes.size > 0;
        hp.items = docNodes.size ? prune(hp.fullItems) : hp.fullItems;
        hp.narrowedItems = null;
        hp.narrowedVersion = -1;
      });
    },
    async narrowHierarchyPickerTree(hp) {
      // scope-on-open: restrict this picker's tree to nodes with documents
      // matching all OTHER active filters; cached until the next filter change
      if (hp.narrowedVersion === this.filterStateVersion) return;
      const listConstraints = this.verAxisAvailable
        .filter((x) => x.filterValues.length)
        .concat(this.horAxisAvailable.filter((x) => x.filterValues.length));
      const otherPickers = this.hierarchyPickerFilters.filter(
        (h) => h !== hp && h.selectedNodes.length
      );
      if (!listConstraints.length && !otherPickers.length) {
        hp.narrowedItems = null; // nothing else active: doc-scoped tree applies
        hp.narrowedVersion = this.filterStateVersion;
        return;
      }
      const version = this.filterStateVersion;
      const levels = [1, 2, 3, 4, 5, 6].filter((l) => l <= hp.linklevel);
      const docNodes = new Set();
      if (this.useIndex) {
        if (!hp.nodeIdsAvailable) {
          // node ids missing from the index: cannot narrow reliably
          hp.narrowedItems = null;
          hp.narrowedVersion = version;
          return;
        }
        const filters = this.getIndexFilterParams([
          ...listConstraints.map(this.mapIndexFilter),
          ...this.hierarchyPickerIndexFilters(hp),
        ]);
        const params = levels.map((l) => ({
          column: `ht_id_${hp.ht_id}_${l}_nodeID`,
          tag: `ht_id_${hp.ht_id}_${l}_nodeID`,
          filters: filters,
        }));
        hp.narrowLoading = true;
        const resp = await this.$store.getters["docs/getCountsByAttr"](params);
        hp.narrowLoading = false;
        if (version !== this.filterStateVersion) return; // superseded
        if (!resp || !resp.length) return; // index unavailable: leave as is
        params.forEach((p) => {
          (resp.find((c) => c.tag === p.tag)?.values || []).forEach((v) =>
            docNodes.add(String(Array.isArray(v.value) ? v.value[0] : v.value))
          );
        });
      } else {
        const tmpl_id = this.selectedView.definition.tmpl_id;
        _documents
          .filter(
            (d) =>
              d.tmpl_id === tmpl_id &&
              d.job_count &&
              this.matchesHierarchyPickers(d, otherPickers) &&
              listConstraints.every((f) => {
                const col = f.ht_id ? f.display_column : f.column;
                return f.filterValues.some((fv) => d[col] === fv);
              })
          )
          .forEach((d) => {
            levels.forEach((l) => {
              const id = d[`ht_id_${hp.ht_id}_${l}_nodeID`];
              if (id) docNodes.add(String(id));
            });
          });
      }
      // keep current selections (and their ancestor branches) visible
      hp.selectedNodes.forEach((n) => {
        let id = n.node_id;
        while (id) {
          docNodes.add(String(id));
          id = hp.nodeMap[id]?.parent;
        }
      });
      const prune = (nodes) =>
        nodes
          .filter((n) => docNodes.has(String(n.node_id)))
          .map((n) =>
            n.children ? { ...n, children: prune(n.children) } : n
          );
      hp.narrowedItems = prune(hp.fullItems);
      hp.narrowedVersion = version;
    },
    hierarchyPickerIndexFilters(excludeHp) {
      // one OR-group per hierarchy type: nodes selected at different levels
      // live in different index columns (ht_id_<ht>_<level>_nodeID)
      return this.hierarchyPickerFilters
        .filter((h) => h.selectedNodes.length && h !== excludeHp)
        .map((h) => {
          const byLevel = {};
          h.selectedNodes.forEach((n) => {
            (byLevel[n.level] = byLevel[n.level] || []).push(
              String(n.node_id)
            );
          });
          return {
            ORFilters: true,
            filters: Object.keys(byLevel).map((l) => ({
              column: `ht_id_${h.ht_id}_${l}_nodeID`,
              filterValues: byLevel[l],
            })),
          };
        });
    },
    activeHierarchyPickers() {
      // like attribute filters, selections apply even when the picker is not
      // shown in the filter bar (included only controls display)
      return this.hierarchyPickerFilters.filter((h) => h.selectedNodes.length);
    },
    matchesHierarchyPickers(d, hpFilters) {
      return hpFilters.every((h) =>
        h.selectedNodes.some(
          (n) => d[`ht_id_${h.ht_id}_${n.level}_nodeID`] === n.node_id
        )
      );
    },
    toggleHierarchyPicker() {
      this.updateViewDefinition();
    },
    editHierarchyDescriptor(node) {
      if (!node.descriptor) return;
      this.hierarchyDescriptorDialogue.show = true;
      this.hierarchyDescriptorDialogue.node = node.descriptor;
      this.hierarchyDescriptorDialogue.label = node.descriptor.label;
      this.hierarchyDescriptorDialogue.text = node.descriptor.description;
    },
    saveHierarchyDescriptor() {
      let possibleError = false;

      axios
        .post("hierarchy/saveNodeDescription/", {
          hierarchy_node_id:
            this.hierarchyDescriptorDialogue.node.hierarchy_node_id,
          ht_id: this.hierarchyDescriptorDialogue.node.ht_id,
          description: this.hierarchyDescriptorDialogue.text,
        })
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.hierarchyDescriptorDialogue.node.description =
              this.hierarchyDescriptorDialogue.text;
            this.hierarchyDescriptorDialogue.show = false;
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    getHierarchyTypeNode(ht_id, hierarchy_node_id) {
      return _descriptors["ht_o_" + ht_id]["hn" + hierarchy_node_id];
    },
    // ----- vertical axis descriptor columns -----
    // descriptions live in two places depending on the endpoint: the per-type
    // descObject map (_descriptors, empty on the V2 jobcatalogue endpoint) and
    // the flat nodeDescriptors list - resolve from either
    getNodeDescriptor(ht_id, hierarchy_node_id) {
      const fromTypes = (_descriptors["ht_o_" + ht_id] || {})["hn" + hierarchy_node_id];
      if (fromTypes) return fromTypes;
      if (!this.nodeDescriptors?.length) return null;
      if (!_nodeDescriptorMap) {
        _nodeDescriptorMap = {};
        this.nodeDescriptors.forEach((d) => {
          _nodeDescriptorMap[d.ht_id + "_" + d.hierarchy_node_id] = d;
        });
      }
      return _nodeDescriptorMap[ht_id + "_" + hierarchy_node_id] || null;
    },
    columnSupportsDescriptor(col) {
      if (!col || !col.ht_id) return false;
      if (col.drillDownLevels) return col.drillDownLevels.some((l) => l.usesDescriptor);
      return !!col.usesDescriptor;
    },
    descriptorColumnTitle(src) {
      // drilldown columns mix levels as rows expand, so a level-specific
      // title would mislead - use the generic label
      if (src.drillDownLevels) return "Description";
      const base = src.overrideTitle || src.name || "";
      return base + " Description";
    },
    getDescriptorInserts(axes) {
      const inserts = [];
      axes.vNested.forEach((vh, pos) => {
        const src = axes.vCompare[vh.index];
        if (src?.showDescriptor && this.columnSupportsDescriptor(src))
          inserts.push({ pos: pos, source: src });
      });
      return inserts;
    },
    makeDescriptorCell(srcCell, source, canEdit) {
      const node = srcCell?.node;
      // descriptors only exist for nodes at levels the hierarchy config marks as
      // using them, so a missing entry means "not allowed here" - render empty
      const descriptor = node
        ? this.getNodeDescriptor(node.ht_id, node.hierarchy_node_id)
        : null;
      const cell = {
        isDescriptor: true,
        column: source.column + "_desc",
        value: srcCell ? srcCell.value : "",
        title: descriptor?.description || "",
        name: this.descriptorColumnTitle(source),
        descriptorNode: descriptor
          ? { ht_id: node.ht_id, hierarchy_node_id: node.hierarchy_node_id, name: node.name, label: descriptor.label || node.label }
          : null,
        notAvailable: !!(node && !descriptor),
        canEdit: !!(canEdit && descriptor),
        visible: true,
        selected: false,
        nestedColumns: [],
      };
      // the vertical measure columns render from the row's LAST cell, which is
      // this descriptor when it sits at the end of the chain - carry the source
      // cell's measure values (job counts etc.) so they keep their data;
      // presentational fields stay the descriptor's own
      if (srcCell) {
        Object.keys(srcCell).forEach((k) => {
          if (k in cell || k === "node" || k === "valueRanges" || k === "valueGroups") return;
          cell[k] = srcCell[k];
        });
      }
      return cell;
    },
    saveDescriptorInline(item, text) {
      const node = item.descriptorNode;
      if (!node) return;
      const description = (text || "").trim() || null;
      axios
        .post("hierarchy/saveNodeDescription/", {
          hierarchy_node_id: node.hierarchy_node_id,
          ht_id: node.ht_id,
          description: description,
        })
        .then((resp) => {
          if (resp.data.Status === "OK") {
            const descriptor = this.getNodeDescriptor(node.ht_id, node.hierarchy_node_id);
            if (descriptor) descriptor.description = description;
            // the same node can appear on several listview rows - refresh them all
            this.settData.forEach((r) =>
              (r.headerColumns || []).forEach((hc) => {
                if (hc.isDescriptor && hc.descriptorNode?.hierarchy_node_id === node.hierarchy_node_id)
                  hc.title = description || "";
              })
            );
            this.setVisibleHeaderColumns();
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    getHierarchyNodeReviewStatus(hierarchy_node_id) {
      let rev = _reviewNodes.find(
        (x) => x.hierarchy_node_id === hierarchy_node_id
      );
      if (rev) rev.editMode = false;
      return rev;
    },
    addHierarchy(ht) {
      this.hierarchyAddDialogue.ht_id = ht.ht_id;
      this.hierarchyAddDialogue.show = true;
    },
    saveHierarchy() {
      if (!this.hierarchyAddDialogue.text) return;
      this.hierarchyAddDialogue.show = false;
      this.hierarchyAddDialogue.hierarchyType.values.push(
        this.hierarchyAddDialogue.text
      );
    },
    pickHierarchy(hierarchy, property) {
      let node = {
        ht_id: hierarchy.ht_id,
        level: hierarchy.linklevel,
        label: hierarchy.label,
        name: null,
        hierarchy_node_id: null,
        property: property,
      };
      this.setUpEditHierarchy(node, "pick");
    },
    doMenuAction(action, item, compareOption, nodeContainer) {
      switch (action.action) {
        case "edit":
        case "rename":
        case "move":
        case "merge":
        case "add":
        case "delete":
        case "deactivate":
        case "reactivate":
          this.setUpEditHierarchy(action.node, action.action, action);
          break;
        case "editDescriptor":
        case "editHierarchyDescriptor":
          this.setUpEditHierarchy(action.node, "editDescriptor");
          break;
        case "drilldown":
          this.doNestedDrilldown(item, compareOption);
          break;
        case "addHierarchyDocument":
          this.addHierarchyDocument(action.node, item);
          break;
        case "showReview":
          this.showHierarchyNodeReview(action.node);
          break;
        case "addFilter":
          this.setFilterValue(action.listviewItem, action.listviewColumn);
          break;
        case "removeFilter":
          this.removeFilterValue(action.listviewItem, action.listviewColumn);
          break;
        case "history":
          this.getNodeHistory(action.node);
          break;
        case "hr_id":
          this.hr_idDialogue.node = action.node;
          this.hr_idDialogue.show = true;
          break;
        case "prompt_chain":{
          let docType = this.docTypeSummary.find(x => x.tmpl_id === this.selectedView.definition.tmpl_id);
          let data = {
            node: action.node,
            tmpl_id: this.selectedView.definition.tmpl_id,
            tmpl_name: docType.docType
          };
          this.generateContentDialog2.node = data;
          this.generateContentDialog2.prompt_chain = action.actionDef.prompt_chain;
          this.generateContentDialog2.show = true;
          break; }       
        case "addPending":
          this.dragItem = nodeContainer;
          if (!this.dragTarget.buckets.length) {
            this.addBucketPlus(null);
          } else {
            this.addAddition(null, this.dragTarget.buckets[0]);
          }
          break;
      }
    },
    setUpEditHierarchy(h, mode, action, multiNodes, bucket) {
      this.hierarchyEditDialogue.show = true;
      this.hierarchyEditDialogue.node = h;
      this.hierarchyEditDialogue.mode = mode;
      this.hierarchyEditDialogue.action = action;
      this.hierarchyEditDialogue.multiNodes = multiNodes || [];
      this.hierarchyEditDialogue.bucket = bucket || null;
      this.hierarchyEditDialogue.showAddNodeDescriptor =
        mode === "add" &&
        this.hierarchyTypes.some(
          (x) => x.ht_id === h.ht_id && x["descriptor_h" + h.level + 1]
        );
    },
    attributePicked(attribute) {
      attribute.isDirty = true;
      if (this.editDialogue.items.length === 1) {
        this.editDialogue.items[0]["change_" + attribute.value_column] = true;
      }
      this.setCanSave();
    },
    nodePicked(details) {
      let target = this.editDialogue.columns.find(
        (x) => x.ht_id === details.original.ht_id
      );
      if (target.value !== details.updated.hr_id) {
        let labels = [details.updated.node.name];
        if (details.updated.node.parents)
          details.updated.node.parents.forEach((p) => labels.unshift(p.name));
        target.value = details.updated.hr_id;
        target.text = details.updated.node.name;
        target.isDirty = true;
        target.hLabel = labels;
        if (this.editDialogue.items.length === 1) {
          this.editDialogue.items[0]["change_" + target.value_column] = true;
        }
      }
      this.setCanSave();
      this.hierarchyEditDialogue.show = false;
    },
    addHierarchyDocument(node, item) {
      let possibleError = false;
      this.isSaving = true;

      axios
        .post("document/createHierarchyDocument/", {
          hierarchy_node_id: node.hierarchy_node_id,
        })
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            let rh = this.settData.find(
              (x) => x.key === item.key
            );
            if (rh) rh.job_count = 1;
            item.job_count = 1;
            node.job_count = 1;
            node.canAddDocumentType = null;
            this.docAdded([resp.data.Data.document[0]]);
          }
          this.response = resp.data;
          this.isSaving = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    setCanSave() {
      this.editDialogue.canSave = this.editDialogue.columns.some(
        (c) =>
          c.isDirty &&
          this.editDialogue.items.some((d) => d["change_" + c.value_column])
      );
    },
    nodeUpdated(details) {
      let updateColumn = details.original
        ? `ht_id_${details.original.ht_id}_${details.original.level}_`
        : null;
      let matchColumn = `${updateColumn}nodeID`;
      //   let updateObject = null;
      let desc = null;
      switch (details.action) {
        case "rename":
        case "edit":
          _documents
            .filter(
              (d) => d[matchColumn] === details.original.hierarchy_node_id
            )
            .forEach((d) => (d[updateColumn] = details.updated.new_name));
          if (details.updated.affected_docs) {
            details.updated.affected_docs.forEach((d) => {
              let doc = _documents.find((x) => x.doc_id === d.doc_id);
              if (doc) doc.doc_name = d.doc_name;
            });
          }
          break;
        case "editDescriptor":
          desc = this.getHierarchyTypeNode(
            details.original.ht_id,
            details.original.hierarchy_node_id
          );
          if (desc) {
            desc.description = details.updated.description;
          }
          break;
        case "add":
        case "move":
        case "merge":
        case "reactivate":
          this.hierarchyEditDialogue.show = false;
          this.hierarchyAddDialogue.show = false;
          if (details.action === "move" && this.hierarchyEditDialogue.bucket) {
            this.removeAdditionAll(this.hierarchyEditDialogue.bucket);
            this.hierarchyEditDialogue.multiNodes.splice(
              0,
              this.hierarchyEditDialogue.multiNodes.length
            );
            this.hierarchyEditDialogue.bucket = null;
            this.afterNodeMove(details);
          } else {
            this.setupTemplate(this.selectedView.definition.tmpl_id, true);
          }
          return;
        case "delete":
        case "deactivate":
          _documents = _documents.filter(
            (d) => d[matchColumn] !== details.original.hierarchy_node_id
          );
          break;
      }
      this.hierarchyEditDialogue.show = false;
      this.hierarchyAddDialogue.show = false;
      this.selectJDs();
    },
    afterNodeMove: function (details) {
      // necessary because doc update happens asynchronously and may still be in progress
      const ht_id = details.updated.ht_id;
      let hn_id = details.updated.move_to_node.hierarchy_node_id;
      if (details.updated.new_nodes?.length) {
        this.addNewNodes(details.updated.new_nodes);
      }
      let parents = [
        {
          hierarchy_node_id: hn_id,
          name: details.updated.move_to_node.name,
          nodeCol: `ht_id_${ht_id}_${details.updated.move_to_node.level}_nodeID`,
          nameCol: `ht_id_${ht_id}_${details.updated.move_to_node.level}_`,
        },
      ];
      let parent = this.getNode(
        ht_id,
        details.updated.move_to_node.hierarchy_node_id_parent
      );
      while (parent) {
        parents.push({
          hierarchy_node_id: parent.hierarchy_node_id,
          name: parent.name,
          nodeCol: `ht_id_${ht_id}_${parent.level}_nodeID`,
          nameCol: `ht_id_${ht_id}_${parent.level}_`,
        });
        parent = this.getNode(ht_id, parent.hierarchy_node_id_parent);
      }

      details.updated.moved_nodes.forEach((mn) => {
        let node = this.getNode(details.updated.ht_id, mn);
        node.hierarchy_node_id_parent =
          details.updated.move_to_node.hierarchy_node_id;
        const col = `ht_id_${ht_id}_${details.updated.move_to_level}_nodeID`;
        _documents
          .filter((d) => d[col] === mn)
          .forEach((d) =>
            parents.forEach((p) => {
              d[p.nodeCol] = p.hierarchy_node_id;
              d[p.nameCol] = p.name;
            })
          );
      });
      this.selectJDs(true);
    },
    docAdded: function (documents) {
      if (documents.length) _documents.push(...documents);

      if (documents.length === 1 && documents[0]?.doc_id > 0)
        this.editDocs(documents);

      this.haveData = _documents.length !== 0;
    },
    nodeSaved(original, updates) {
      let descriptor = this.getHierarchyTypeNode(
        original.ht_id,
        original.hierarchy_node_id
      );
      descriptor.description = updates.description;
      original.name = updates.name;
      original.description = updates.description;
    },
    closeHierarchyNodeReview() {
      this.nodeReviewDialogue.node = null;
      this.nodeReviewDialogue.show = false;
    },
    showHierarchyNodeReview(node) {
      this.getNodeReviewActivity(node, () => {
        this.nodeReviewDialogue.node = node;
        this.nodeReviewDialogue.show = true;
      });
    },
    getNodeReviewActivity(node, callback) {
      let possibleError = false;
      let setViewActivity = (_node, docs) => {
        if (docs.length) {
          [
            "docs_open",
            "docs_completed",
            "docsAsParent_open",
            "docsAsParent_completed",
          ].forEach((t) => {
            _node.reviewStatus[t].forEach((d) => {
              let activity = docs.filter((r) => r.doc_id === d.doc_id);
              if (activity.length) {
                d.viewAction = activity[0].viewAction;
                d.activity = activity.map((a) => {
                  let detail =
                    Number(a.events) === 1
                      ? ` once by ${a.activity_by_name} on ${a.activity_date_first}`
                      : ` ${a.events} times by ${a.activity_by_name} between ${a.activity_date_first} and ${a.activity_date_last}`;
                  switch (a.activity_type) {
                    case "Create":
                      return `Created ${a.activity_date_first} by ${a.activity_by_name}`;
                    case "View":
                    case "Edit":
                      return `${a.activity_type}ed ${detail}`;
                    default:
                      return `${a.activity_type}: ${detail}`;
                  }
                });
              }
            });
          });
          _node.reviewStatus.docs_open.forEach((x) => x.tab === null);
          if (_node.nodes) {
            _node.nodes
              .filter((n) => n.reviewStatus)
              .forEach((n) => {
                setViewActivity(n, docs);
              });
          }
        }
      };
      axios
        .get("hierarchy/getHierarchyNodeReviews/" + node.hierarchy_node_id, {
          hierarchy_node_id: node.hierarchy_node_id,
        })
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK" && resp.data.Data) {
            setViewActivity(node, resp.data.Data);
            if (callback) callback();
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    getNodeHistory(node) {
      this.historyNode = node;
    },
    findNode(nodes, node_id) {
      let n = nodes.find((x) => x.hierarchy_node_id === node_id);
      if (n) return n;
      let found = null;
      nodes.forEach((n) => {
        if (!found && n.nodes) {
          found = this.findNode(n.nodes, node_id);
        }
        if (found) return;
      });
      return found;
    },
    getNode(ht_id, node_id) {
      const ht = _hierarchyTypeNodes.find((x) => x.ht_id === ht_id);
      return this.findNode(ht.nodes, node_id);
    },
    addNewNodes(nodes) {
      const ht = _hierarchyTypeNodes.find((x) => x.ht_id === nodes[0].ht_id);
      let parentCollection = ht.nodes;
      nodes.sort((a, b) =>
        a.level > b.level ? 1 : a.level < b.level ? -1 : 0
      );
      nodes.forEach((nn) => {
        ht.nodeList.push(nn);
        let currentNode = this.findNode(ht.nodes, nn.hierarchy_node_id);
        if (!currentNode) {
          nn.nodes = [];
          parentCollection.push(nn);
          parentCollection = nn.nodes;
          _descriptors["ht_o_" + nn.ht_id]["hn" + nn.hierarchy_node_id] =
            nn.descriptor;
        } else {
          parentCollection = currentNode.nodes;
        }
      });
    },
    showAuditReport(ht_id) {
      let possibleError = false;
      axios
        .post("hierarchy/getHierarchyNodeAuditReport", { ht_id: ht_id })
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK" && resp.data.Data.length) {
            this.filterAuditReport(resp.data.Data);
            this.nodeHistoryReport.nodes = resp.data.Data;
            this.nodeHistoryReport.label =
              resp.data.Data[0].level_name + " History";
            this.nodeHistoryReport.show = true;
            let userList = [];
            let getUsers = (nodes) => {
              nodes.forEach((n) => {
                if (n.changes) {
                  n.changes.forEach((c) => {
                    if (!userList.some((l) => l === c.updated_by_name))
                      userList.push(c.updated_by_name);
                  });
                }
                if (n.nodes) {
                  getUsers(n.nodes);
                }
              });
            };
            getUsers(resp.data.Data);
            this.nodeHistoryReport.userList = userList;
          }
          this.response = resp.data;
          this.isBuilding = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    selectAuditRow(item, row) {
      row.expand(!row.isExpanded);
    },
    getAuditDescriptionHTML(text) {
      let html = "";
      text = text || "";
      let posS = text.indexOf('"');
      let posE = text.indexOf('"', posS + 1);
      let start = 0;
      while (posS >= 0 && posE > posS) {
        html += `${text.substring(
          start,
          posS - 1
        )} <div class="node-description">${text.substring(
          posS + 1,
          posE
        )}</div>`;
        start = posE + 1;
        posS = text.indexOf('"', start);
        posE = text.indexOf('"', posS + 1);
      }
      html += text.substring(start);
      return html;
    },
    showAuditData(ht_id) {
      this.nodeAuditData.ht_id = ht_id;
      if (this.nodeAuditData.dateRangeFilter.length < 2) {
        this.nodeAuditData.dateRangeFilter = [
          dayJS().subtract(1, "month").format("YYYY-MM-DD"),
          dayJS().format("YYYY-MM-DD"),
        ];
      }
      this.getAuditData();
    },
    filterAuditDataDateRange(range) {
      this.nodeAuditData.dateRangeFilter = range;
      this.getAuditData();
    },
    filterAuditData() {
      if (
        !this.nodeAuditData.userFilter.length &&
        !this.nodeAuditData.typeFilter.length &&
        !this.nodeAuditData.reasonFilter.length
      ) {
        this.nodeAuditData.items = this.nodeAuditData.data;
      } else {
        let users = this.nodeAuditData.userFilter;
        let types = this.nodeAuditData.typeFilter;
        let reasons = this.nodeAuditData.reasonFilter;
        this.nodeAuditData.items = this.nodeAuditData.data.filter(
          (x) =>
            (users.length === 0 || users.some((u) => u === x.user_name)) &&
            (types.length === 0 ||
              types.some((u) => u === x.transaction_sub_type)) &&
            (reasons.length === 0 ||
              reasons.some((u) => u === x.transaction_reason_type))
        );
      }
    },
    getAuditData() {
      let possibleError = false;
      let data = {
        ht_id: this.nodeAuditData.ht_id,
        from: this.nodeAuditData.dateRangeFilter.length
          ? this.nodeAuditData.dateRangeFilter[0]
          : null,
        to:
          this.nodeAuditData.dateRangeFilter.length === 2
            ? dayJS(this.nodeAuditData.dateRangeFilter[1])
                .add(1, "day")
                .format("YYYY-MM-DD")
            : null,
      };
      axios
        .post("hierarchy/getHierarchyNodeAuditData", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK" && resp.data.Data) {
            this.nodeAuditData.data = resp.data.Data;
            this.nodeAuditData.label = "Transactions";
            //   resp.data.Data[0].level_name + " History";
            this.nodeAuditData.show = true;
            let userList = [];
            let typeList = [];
            let reasonList = [];
            resp.data.Data.forEach((d) => {
              if (!userList.some((l) => l === d.user_name))
                userList.push(d.user_name);
              if (
                d.transaction_sub_type &&
                !typeList.some((l) => l === d.transaction_sub_type)
              )
                typeList.push(d.transaction_sub_type);
              if (
                d.transaction_reason_type &&
                !reasonList.some((l) => l === d.transaction_reason_type)
              )
                reasonList.push(d.transaction_reason_type);
            });
            this.nodeAuditData.userList = userList.sort((a, b) =>
              a.toLowerCase() > b.toLowerCase()
                ? 1
                : a.toLowerCase() < b.toLowerCase()
                ? -1
                : 0
            );
            this.nodeAuditData.typeList = typeList.sort((a, b) =>
              a > b ? 1 : a < b ? -1 : 0
            );
            this.nodeAuditData.reasonList = reasonList.sort((a, b) =>
              a > b ? 1 : a < b ? -1 : 0
            );
            if (reasonList.length === 0) {
              this.nodeAuditData.headers = this.nodeAuditData.headers.filter(
                (x) => x.value !== "transaction_reason_type"
              );
            }
            this.filterAuditData();
          }
          this.response = resp.data;
          this.isBuilding = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    showAuditReportChanges(show) {
      let setShow = (nodes) => {
        nodes.forEach((n) => {
          if (n.changes?.length) n.showChanges = show;
          if (n.nodes) {
            setShow(n.nodes);
          }
        });
      };
      setShow(this.nodeHistoryReport.nodes);
    },
    filterAuditReportDateRange(dateRange) {
      this.nodeHistoryReport.dateRangeFilter = dateRange.sort((a, b) =>
        a > b ? 1 : a < b ? -1 : 0
      );
      this.filterAuditReport();
    },
    filterAuditReport(nodes) {
      if (!nodes) nodes = this.nodeHistoryReport.nodes;
      let range = this.nodeHistoryReport.dateRangeFilter;
      let users = this.nodeHistoryReport.userFilter;
      let setVisible = (nodes) => {
        let hasVisible = false;
        nodes.forEach((n) => {
          n.visible = false;
          if (n.changes) {
            n.visible =
              range.length === 0 ||
              n.changes.some(
                (c) =>
                  (dayJS(c.updated_date).isSame(range[0]) ||
                    dayJS(c.updated_date).isAfter(range[0])) &&
                  (dayJS(c.updated_date).isSame(range[1]) ||
                    dayJS(c.updated_date).isBefore(range[1]))
              );
            if (n.visible) {
              n.visible =
                users.length === 0 ||
                n.changes.some((c) =>
                  users.some((u) => u === c.updated_by_name)
                );
            }
          }
          if (n.nodes) {
            if (setVisible(n.nodes)) n.visible = true;
          }
          if (n.visible) hasVisible = true;
        });
        return hasVisible;
      };
      setVisible(nodes);
    },
    buildMatchKey: (col, value) => {
      return col + "|" + value + "|";
    },
    processKeyRange: function (keyDef, data, range) {
      let value = this.processKeyTitle(keyDef, data);
      if (!value || value === "UNKNOWN") return;
      if (!range) {
        range = {
          name: keyDef.name,
          column: keyDef.column,
          minValue: value,
          maxValue: value,
          title: "",
          valueDisplayType: keyDef.valueDisplayType,
          valueIcon: keyDef.valueIcon,
          cssClass: keyDef.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
        };
      } else {
        if (range.minValue > value) range.minValue = value;
        if (range.maxValue < value) range.maxValue = value;
      }
      range.title = range.minValue === range.maxValue ? range.minValue : `${range.minValue} - ${range.maxValue}`;
      if (keyDef.prefix) range.title = `${keyDef.prefix} ${range.title}`;
      if (keyDef.suffix) range.title = `${range.title} ${keyDef.suffix}`;
      this.processKeyLength(keyDef, range.title);
      return range;
    },
    processKeyMeasureGroup: function (keyDef, data, group) {
      let title = this.processKeyTitle(keyDef, data);
      if (!title || title === "UNKNOWN") return;
      if (keyDef.prefix) title = `${keyDef.prefix} ${title}`;
      if (keyDef.suffix) title = `${title} ${keyDef.suffix}`;
      if (!group) {
        group = {
          name: keyDef.name,
          column: keyDef.column,
          values: [ { title: title, value: data[keyDef.containerColumnGroupMeasure] } ],
          valueDisplayType: keyDef.valueDisplayType,
          valueIcon: keyDef.valueIcon,
          cssClass: keyDef.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
        };
      } else {
        let groupInstance = group.values.find(v => v.title === title);
        if (!groupInstance) {
          groupInstance = { title: title, value: 0 };
          group.values.push(groupInstance);
        }
        groupInstance.value += data[keyDef.containerColumnGroupMeasure];
      }
      this.processKeyLength(keyDef, group);
      return group;
    },
    processKeyTitle: function (keyDef, item, defaultValue, formatted) {
      const col = keyDef.column_title || keyDef.display_column;
      let title = (col
        ? item[col]
        : defaultValue ? defaultValue : item[keyDef.column]) || "";
      if (formatted) {
        if (title && keyDef.prefix) title = `${keyDef.prefix} ${title}`;
        if (title && keyDef.suffix) title = `${title} ${keyDef.suffix}`;
        this.processKeyLength(keyDef, title);
      }
      return title;
    },
    processKeyLength: function (keyDef, title) {
      if (keyDef.maxLength === undefined) {        
        keyDef.maxLength = 0;
        keyDef.maxLengthMean = 0;
        keyDef.maxLengthTot = 0;
        keyDef.maxLengthCount = 0;
      }
      if (title?.length > keyDef.maxLength)
        keyDef.maxLength = title.length;
      keyDef.maxLengthTot += title.length;
      keyDef.maxLengthCount++;
      keyDef.maxLengthMean =
        keyDef.maxLengthTot / keyDef.maxLengthCount;
    },
    processKeyGroupLength: function (keyDef, group) {
      if (keyDef.maxLength === undefined) {        
        keyDef.maxLength = 0;
        keyDef.maxLengthMean = 0;
        keyDef.maxLengthTot = 0;
        keyDef.maxLengthCount = 0;
      }
      let glen = group.values.reduce((p, c) => p + c.title.length, 0)
      if (glen > keyDef.maxLength)
        keyDef.maxLength = glen;
      keyDef.maxLengthTot += glen;
      keyDef.maxLengthCount++;
      keyDef.maxLengthMean =
        keyDef.maxLengthTot / keyDef.maxLengthCount;
    },
    getColumnName: (compareOption) => {
      return compareOption.currentDrillDownLevel
        ? compareOption.drillDownLevels[compareOption.currentDrillDownLevel - 1]
            .column
        : compareOption.hidden
        ? "_"
        : compareOption.column;
    },
    appendNodeHierarchyLevels: function (node, source) {
      let ht = this.hierarchyTypes.find((x) => x.ht_id === node.ht_id);
      node.levels = ht?.h_levels;
      node.active = true;
      node.canReview = source?.canReview;
    },
    formatAggregate: function (measure, data) {
      let format = measure.format || "0";
      if (format !== "0") {
        let prefix = ["£", "$"].find((x) => format.indexOf(x) >= 0) || "";
        let suffix = ["k", "m"].find((x) => format.indexOf(x) >= 0) || "";
        if (suffix === "k") data = data / 1000;
        if (suffix === "m") data = data / 1000000;
        format = format.replace(prefix, "").replace(suffix, "");
        return prefix + data.toFixed(parseInt(format) || 0) + suffix;
      } else {
        return data;
      }
    },
    addAggregateColumns: function (row, item, measure) {
      if (!row[measure.type + "_sd_values"])
        row[measure.type + "_sd_values"] = [];
      let val = item[measure.type];
      if (val === null || val === undefined || val === "") return;
      val = Number(item[measure.type]);
      if (val === 0 && measure.aggregation_exclude_zero) return;
      if (measure.aggregation_quantity_column) {
        let avg = val / Number(item[measure.aggregation_quantity_column]);
        for (let e = 1; e <= item[measure.aggregation_quantity_column]; e++) {
          row[measure.type + "_sd_values"].push(avg);
        }
      } else {
        row[measure.type + "_sd_values"].push(item[val]);
      }
    },
    groupByKeysNested: async function (
      rawData,
      filters,
      axes,
      measures,
      aggMeasures,
      overrideSortProperty,
      ignoreLeafCount,
      isChartData
    ) {

      if (!axes.length) return rawData;
      // pre-process axes
      axes.forEach((a) => {
        let colWidth = 12 / a.columns.length;
        if (colWidth < 2) colWidth = 2;
        a.columns.forEach((k) => {
          k.colWidth = colWidth;
          k.maxLength = 0;
          k.maxLengthMean = 0;
          k.maxLengthTot = 0;
          k.maxLengthCount = 0;
        });
        a.colChildren = a.columns.map((k) => k.column_key).join("_") + "s";
      });
      const processAggregate = (measure, rows, sourceColumn, destinationColumn, destinationRow) => {
        let bRows = rows.map(r => Number(r[sourceColumn] || 0));
        if (measure.aggregation_exclude_zero) bRows = bRows.filter(x => x !== 0)
        let bVal = null;
        let medianVals = null;
        let medianMid = null;
        const bLen = bRows.length;
        const derivation = measure.derivation || measure.aggregation || measure.type;
        if (bLen > 0) {
          switch (derivation) {
            case "count":
            case "sum":
              bVal = bRows.reduce((p,c) => p + c || 0, 0);
              if (bVal && measure.format === "pct") bVal = Number(bVal.toFixed(2));
              break;
            case "mean":
              bVal = bRows.reduce((p,c) => p + c || 0, 0) / bLen;
              bVal = bVal.toFixed(1);
              break;
            case "median":
              medianVals = bRows.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
              medianMid = Math.round(bLen / 2);
              if (bLen % 2 === 1) {
                bVal = medianVals[medianMid - 1];
              } else {
                bVal = (medianVals[medianMid - 2] + medianVals[medianMid - 1]) / 2;
                if (!Number.isInteger(bVal)) bVal = bVal.toFixed(1);
              }
              break;
          }
        }
        destinationRow[destinationColumn] = bVal;
      };

      let formatNumber = this.formatAggregate;
      let calculateAggregateValue = (row, overallTotals, preProcessed) => {
        aggMeasures.forEach(function (sm) {
          if (sm.aggregation === "mean") {
            const values = preProcessed.filter(d => d.axes[0].match_key === row.match_key && (!sm.aggregation_exclude_zero || d[sm.type] !== 0)).map(d => Number(d[sm.type]));
            const n = values.length;
            if (!n) return;
            const mean = values.reduce((a, b) => a + b) / n;
            row[sm.type + "_std_dev"] = Math.sqrt(
              values.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n
            );
            row[sm.type + "_mean"] = formatNumber(sm, mean);
            row[sm.type + "_mean_number"] = mean;
            row[sm.type + "_mean_value_count"] = n;
            row[sm.type + "_mean_maxLength"] = row[sm.type + "_mean"].toString().length;
          } else if (sm.aggregation === "overall_percent") {
            row[sm.type] = overallTotals[sm.aggregation_quantity_column] ? Number((100 * row[sm.aggregation_quantity_column] / overallTotals[sm.aggregation_quantity_column]).toFixed(1)) : 0;
          } else if (sm.aggregation === "median") {
            const values = preProcessed.filter(d => d.axes[0].match_key === row.match_key && (!sm.aggregation_exclude_zero || d[sm.type] !== 0)).map(d => Number(d[sm.type]));
            const n = values.length;
            if (!n) return;
            const medianVals = values.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
            let median;
            const mid = Math.round(n / 2);
            if (n % 2 === 1) {
              median = medianVals[mid];
            } else {
              median = (medianVals[mid] + medianVals[mid + 1]) / 2;
            }
            row[sm.type + "_median"] = formatNumber(sm, median);
            row[sm.type + "_median_number"] = median;
          }
        });
      };
      const zAxisIndex = axes.findIndex(x => x.axis === "Z");
      const linkedMeasures = measures.filter(x => x.linked_docs_column);
      let data = {};
      let preProcessed = [];
      let sett = [];
      const visibleMeasures = this.getVisibleAggregateMeasuresForIndex(isChartData ? measures : null);
      const calculateAggregateValuesSett = (keyIndex, sett, overallTotals) => {
        if (keyIndex >= axes[0].columns.length) return;
        sett.forEach((row) => {
          calculateAggregateValue(row, overallTotals, preProcessed);
          calculateAggregateValuesSett(keyIndex + 1, row.children, overallTotals);
        });
      };
      const populateNodeNames = (groupBy, item) => {
        // indexGroupByParams[0].
        if (!groupBy) return;
        groupBy
          .filter(g => g.attr.endsWith('_nodeID') && item[g.attr])
          .forEach(g => item[g.attr.replace('_nodeID', '_')] = this.hierarchyNodeLookup[`hn${item[g.attr]}`]?.name);
      };
      const preProcess = (d, groupBy) => {
        populateNodeNames(groupBy, d);
        let ret = {
          doc_id: d.doc_id, axes: [], rangeColumns: [], groupColumns: [],
        };
        if (this.useIndex)
          visibleMeasures.forEach(m => {
            m.ids.forEach(id => {
              if (m.column_basis) {
                ret[id + "_primary"] = d[m.column_basis] === m.catalogue_ratio_primary_value ? Number(d[m.as]) : null;
                ret[id + "_secondary"] = d[m.column_basis] === m.catalogue_ratio_secondary_value ? Number(d[m.as]) : null;
              } else {
                ret[id] = d[m.as];
              }
            });
            ret[m.as] = d[m.as];
          });
        else
          measures.forEach(m => {
            if (m.column_basis) {
              ret[m.id + "_primary"] = d[m.column_basis] === m.catalogue_ratio_primary_value ? Number(d[m.column]) : null;
              ret[m.id + "_secondary"] = d[m.column_basis] === m.catalogue_ratio_secondary_value ? Number(d[m.column]) : null;
            } else {
              ret[m.column] = d[m.column];
            }
          });
        linkedMeasures.forEach(m => { 
          ret[m.linked_docs_column] = d[m.linked_docs_column] || '';
          ret[m.linked_docnames_column] = d[m.linked_docnames_column] || '';
        });
        axes.forEach(a => {
          const keys = a.columns.map(keyDef => {
            let val = d[keyDef.column_key] || "";
            let matchVal = d[keyDef.column_match] || val;
            let sortKey = d[keyDef.column_sort] || "";
            if (keyDef.useSortKey && keyDef.listValues) {
              sortKey = keyDef.listValues.find(
                (x) => x.value === val
              )?.sort_key;
            }
            return { 
              key: val,
              sortKey: sortKey,
              columnSortKey: sortKey,
              title: this.processKeyTitle(keyDef, d, val, true),
              matchVal: matchVal,
              matchKey: `${keyDef.column_match}|${matchVal}`,
            };
          });
          const key = keys.map(x => x.key).join("|");
          ret.axes.push({ 
            key: key, 
            sortKey: keys.map(x => x.sortKey).join("|"), 
            columnSortKeys: keys.map(x => x.columnSortKey),
            title: keys.map(x => x.title),
            match_key: keys.map(x => x.matchKey).join("|") + "|",
          });
          
          if(a.rangeColumns?.length) {
            ret.rangeColumns = a.rangeColumns.map(keyDef => {
              let val = d[keyDef.column_key] || "";
              let sortKey = d[keyDef.column_sort] || "";
              if (keyDef.useSortKey && keyDef.listValues) {
                sortKey = keyDef.listValues.find(
                  (x) => x.value === val
                )?.sort_key;
              }
              return { 
                key: keyDef.column_key,
                sortKey: sortKey,
                title: this.processKeyTitle(keyDef, d, val, true),
              };
            });
          }
          if(a.groupColumns?.length) {
            ret.groupColumns = a.groupColumns.map(keyDef => {
              let val = d[keyDef.column_key] || "";
              let sortKey = d[keyDef.column_sort] || "";
              if (keyDef.useSortKey && keyDef.listValues) {
                sortKey = keyDef.listValues.find(
                  (x) => x.value === val
                )?.sort_key;
              }
              return { 
                key: keyDef.column_key,
                sortKey: sortKey,
                title: this.processKeyTitle(keyDef, d, val, true),
                value: Number(d[keyDef.containerColumnGroupMeasure]),
              };
            });
          }
        });              
        return ret;
      };
      
      const setChildren = (current, currentRows, axisIndex, parent) => {
        if (axisIndex === 0) {
          sett = [...new Set(currentRows.map(x => x.axes[axisIndex].key))].map(x => { return { key: x, children: [] }; });
          sett.forEach(s => setChildren(s, currentRows.filter(x => x.axes[axisIndex].key === s.key), axisIndex + 1));
        } else {
          let rows = currentRows.filter(x => x.axes[axisIndex - 1].key === current.key);
          current.sortKey = rows[0].axes[axisIndex - 1].sortKey;
          current.columnSortKeys = rows[0].axes[axisIndex - 1].columnSortKeys;
          current.match_key = (parent ? parent.match_key : "") + rows[0].axes[axisIndex - 1].match_key;
          current.titles = rows[0].axes[axisIndex - 1].title;          
          current.zContainer = zAxisIndex > 0 && axisIndex === zAxisIndex;
          if (this.useIndex) {
            visibleMeasures.forEach(function (m) {
              if (!m.column_basis) {
                if (!m.ids.length) {
                  processAggregate(m, rows, m.as, m.as, current);
                }
                m.ids.forEach(id => {
                  processAggregate(m, rows, id, id, current);
                });
              } else {
                m.ids.forEach(id => {
                  const primary = `${id}_primary`;
                  const secondary = `${id}_secondary`;
                  let sumCol;
                  let countCol;
                  if (m.type === "mean") {
                    sumCol = m.as.replace("_mean", "_sum");
                    countCol = "job_count";
                  } else if (m.type === "median") {
                    sumCol = m.as;
                    countCol = "";
                  }
                  if (sumCol) {
                    const stat = rows
                      .reduce((p,c) => { 
                        const target = c[primary] !== null ? p.primary : p.secondary;
                        target.sum += c[sumCol];
                        target.count += countCol ? c[countCol] : 1;
                        return p;
                      }, { primary : { sum: 0, count: 0 }, secondary : { sum: 0, count: 0 }});
                    current[primary] = stat.primary.sum / (stat.primary.count || 1);
                    current[secondary] = stat.secondary.sum / (stat.secondary.count || 1);
                  }
                  let val1 = current[primary];
                  let val2 = current[secondary];
                  let val = null;
                  if (val1) val = (100 * (val1 - val2) / val1).toFixed(1);
                  current[id] = val;
                  
                  if (m.single_comparator_text) {
                    const showSCT = val1 === 0 || val2 === 0
                    current[`${id}_single_comparator`] = showSCT;
                    current[`${id}_single_comparator_text`] = showSCT ? m.single_comparator_text : "";
                  }
                });
              }
            });
          } else {
            measures.forEach(function (m) {
              if (!m.column_basis) {
                processAggregate(m, rows, m.column, m.id, current);
              } else {
                [m.id + "_primary", m.id + "_secondary"].forEach(x => {
                  processAggregate(m, rows, x, x, current);
                });
                let val1 = Number(current[m.id + "_primary"]);
                let val2 = Number(current[m.id + "_secondary"]);
                let val = null;
                if (val1) val = (100 * (val1 - val2) / val1).toFixed(1);
                current[m.id] = val;

                const vm = visibleMeasures.find(x => x.ids.some(i => i === m.id));

                if (vm?.single_comparator_text) {
                  const showSCT = val1 === 0 || val2 === 0
                  current[`${m.id}_single_comparator`] = showSCT;
                  current[`${m.id}_single_comparator_text`] = showSCT ? vm.single_comparator_text : "";
                }
              }
          });
          }
          linkedMeasures.forEach(m => { 
            current[m.linked_docs_column] = rows.reduce((p,c) => p + (p.length ? "," : "") + c[m.linked_docs_column], "");
            current[m.linked_docnames_column] = [ ...new Set(rows.reduce((p,c) => p + (p.length ? "," : "") + c[m.linked_docnames_column], "").split(","))];
          });
          current.selected = false;
          current.axisColumns = current.key.split("|").map((c, ci) => {
            const colDef = axes[axisIndex - 1].columns[ci];
            if (!colDef) return null;
            let item = {
              value: c,
              sortKey: current.columnSortKeys[ci],
              title: current.titles[ci],
              name: colDef.name,
              doc_id: colDef.isDocument ? Number(c) : null,
              node: colDef.noderule ? {
                      level: colDef.ht_level, 
                      hierarchy_node_id: Number(c),
                      name: current.titles[ci],
                      descriptor: null,
                      ht_id: colDef.ht_id,
                      isLeaf: colDef.ht_level === colDef.linklevel,
                      level_name: colDef.noderule.currLevel?.ht_label || colDef.noderule.ht.h_levels[colDef.ht_level - 1],
                      label: colDef.noderule.currLevel?.ht_label || colDef.noderule.ht.h_levels[colDef.ht_level - 1],
                      nextLevel: colDef.noderule.nextLevel
                        ? colDef.noderule.nextLevel.ht_label
                        : null,
                      previousLevel: colDef.noderule.prevLevel
                        ? colDef.noderule.prevLevel.ht_label
                        : null,
                      canAdd: false,
                      canAddDocumentType:
                        !colDef.noderule.nextLevel && current.job_count === 0
                          ? this.catalogueDocType.docType
                          : null,
                      reviewStatus: null, //this.getHierarchyNodeReviewStatus(hierarchy_node_id),
                      drilldown: axes[axisIndex - 1].columns.length === 1 && colDef.noderule.nextLevel
                        ? {
                            column: colDef.column,
                            ht_id: colDef.ht_id,
                            value: current.titles[ci],
                            hLevel: colDef.currentDrillDownLevel,
                            expanded: false,
                          }
                        : null,
                      selected: false,
                    } : null,
              visible: true,
              selected: false,
              nodeSelectable: colDef.noderule ? colDef.nodeSelectable : false,
            };
            this.appendMatchColumns(item, null, current.match_key);
            this.appendMeasureColumns(item, 0, current, measures);
            this.appendAggregateColumns(item, 0, null, aggMeasures);
            item.valueRanges = (colDef.rangeColumns ?? []).map((rc, rci) => {
              const vr = [ ...new Set(rows.map(r => r.rangeColumns[rci].title)) ];
              vr.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
              if (vr.length) {
                const min = vr[0];
                const max = vr.pop();
                let title = min === max ? min : `${min} - ${max}`;
                if (rc.prefix) title = `${rc.prefix} ${title.replaceAll(rc.prefix + " ", "")}`;
                if (rc.suffix) title = `${title.replaceAll(" " + rc.suffix, "")} ${rc.suffix}`;
                return {
                  name: rc.name,
                  column: rc.column,
                  minValue: min,
                  maxValue: max,
                  title: title,
                  valueDisplayType: rc.valueDisplayType,
                  valueIcon: rc.valueIcon,
                  cssClass: rc.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
                };
              } else return null;
            }).filter(x => x);
            item.valueGroups = (colDef.groupColumns ?? []).map((gc, gci) => {
              const gvs = [ ...new Set(rows.map(r => r.groupColumns[gci].title)) ];
              gvs.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
              if (gvs.length) {
                let instances = gvs.map(v => {
                  return {
                    title: v,
                    value: rows.filter(x => x.groupColumns[gci].title === v).reduce((p,c) => p + c.groupColumns[gci].value, 0),
                  }
                })
                return {
                  name: gc.name,
                  column: gc.column,
                  values: instances,
                  valueDisplayType: gc.valueDisplayType,
                  valueIcon: gc.valueIcon,
                  cssClass: gc.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
                };
              } else return null;
            }).filter(x => x);
            return item;
          }).filter(x => x);
          current.headerColumns = axes[axisIndex - 1].headerColumns
            .map((x) => {
              let col = current.axisColumns[x.index];
              col.nestedColumns = x.contains ? x.contains.map(n => {
                let nc = current.axisColumns[n.index];
                nc.valueDisplayType = n.valueDisplayType;
                nc.valueIcon = n.valueIcon;
                return nc;
              }) : [];
              return col;
            });
          // ?? can now remove current.axisColumns and current.sortkey ????
          delete current.axisColumns;
          delete current.titles;
          if (axisIndex < axes.length) {
            current.children = [...new Set(rows.map(x => x.axes[axisIndex].key))].map(x => { return { key: x, children: [] }; });
            current.children.forEach(c => setChildren(c, rows.filter(x => x.axes[axisIndex].key === c.key), axisIndex + 1, current));
          }
        }
      };
      if (this.useIndex) {
        const indexGroupByParams = [{
          groupBy: [ ...axes
            .filter(a => a.columns.length)
            .map(a => a.columns.filter(c => !c.hidden).map(c => {
              if (c.column.startsWith('ht_id_') && !c.column.endsWith('_nodeID'))
                return { attr: `${c.column}nodeID`, as: `${c.column}nodeID` };
              else
                return { attr: this.getIndexAttrName(c), as: c.column };
            })) ].flat().filter((v, i, a) => a.findIndex(t => (t.attr === v.attr)) === i),
          // aggregates: measures.map(m => ({ type: m.aggregation, column: m.cache_column, as: m.column }))
          //   .concat(aggMeasures?.map(m => ({ type: m.aggregation, column: m.cache_column, as: m.column })) ?? [])
          //   .filter((v, i, a) => a.findIndex(t => (t.column === v.column)) === i),
          aggregates: visibleMeasures,
          filters: filters,
        }];
        [...new Set(measures.filter(x => x.column_basis).map(x => x.column_basis))].forEach(cb => {
          const indexColName = this.getIndexColumnName(cb);
          if (!indexGroupByParams[0].groupBy.some(x => x.attr === indexColName)) {
            indexGroupByParams[0].groupBy.push({ attr: indexColName, as: cb });
          }
        });
        if (indexGroupByParams[0].groupBy.length) {
          if (indexGroupByParams[0].groupBy.some(p => p.attr === "doc_id"))
            indexGroupByParams[0].groupBy.push({ attr: "doc_title", as: "doc_name" });
          //indexGroupByParams[0].filters.forEach(f => f.filterValues.filter(v => typeof v === "string").forEach(v => v = v.replace(/&/g, '\\&')))
          this.inProgressIndexRequests++;
          await (this.$store.getters['docs/getDocIndexGroupBy'](indexGroupByParams).then(resp => {
            this.inProgressIndexRequests--;
            if (resp.length) {
              preProcessed = resp[0].values.map(d => preProcess(d, indexGroupByParams[0].groupBy));
            }
          }));
        }
      } else {
        preProcessed = rawData.map(d => preProcess(d));      
      }
      setChildren(null, preProcessed, 0);
      // top-level rows honour the view's default sort (a measure or a vertical
      // text column, either direction); children always sort by their sortKey.
      // A legacy string override (a measure type) still means "descending".
      const sortSpec = typeof overrideSortProperty === "string"
        ? { measureId: overrideSortProperty, descending: true }
        : overrideSortProperty;
      let topGetKey = null;
      let topDescending = false;
      if (sortSpec) {
        if (sortSpec.measureId) {
          topGetKey = (row) => row[sortSpec.measureId];
        } else if (sortSpec.column) {
          const ci = axes[0].columns.findIndex(
            (c) =>
              c.cache_column === sortSpec.column ||
              c.column === sortSpec.column ||
              c.column_key === sortSpec.column
          );
          if (ci >= 0) topGetKey = (row) => row.columnSortKeys?.[ci];
        }
        topDescending = !!sortSpec.descending;
      }
      const hasSortValue = (v) => v !== undefined && v !== null && v !== "";
      // a stale default (e.g. a measure no longer in the view) yields no values
      // at all — fall back to the axis sort keys rather than raw data order
      if (topGetKey && !sett.some((r) => hasSortValue(topGetKey(r))))
        topGetKey = null;
      let sortSett = (dat, getKey, desc) => {
          const sortBy = (a, b) => {
            const av = getKey(a);
            const bv = getKey(b);
            // rows without a value always sink to the bottom
            if (!hasSortValue(av) || !hasSortValue(bv))
              return hasSortValue(av) ? -1 : hasSortValue(bv) ? 1 : 0;
            const an = Number(av);
            const bn = Number(bv);
            const a1 = !Number.isNaN(an) && !Number.isNaN(bn) ? an : av;
            const b1 = !Number.isNaN(an) && !Number.isNaN(bn) ? bn : bv;
            return a1 > b1 ? (desc ? -1 : 1) : a1 < b1 ? (desc ? 1 : -1) : 0;
          };
          dat.sort(sortBy);
          dat.forEach((x,xi) => {
            sortSett(x.children, (r) => r.sortKey, false);
            x.index = xi;
          });
      };
      sortSett(sett, topGetKey || ((r) => r.sortKey), topGetKey ? topDescending : false);
      const leafMatchColumn = this.leafNodeCountColumn(this);
      if (!ignoreLeafCount && leafMatchColumn && measures.some((m) => m.type === "leaf_node_count")) {
        sett.forEach(s => {
          let key = Number(s.headerColumns[leafMatchColumn.index].value);
          s.leaf_node_count = rawData.filter((x) => x[leafMatchColumn.column] === key).length;
          s.headerColumns[leafMatchColumn.index].leaf_node_count = s.leaf_node_count;
          if (s.headerColumns[leafMatchColumn.index].node)
            s.headerColumns[leafMatchColumn.index].node.leaf_node_count = s.leaf_node_count;
        });
        sett = sett.filter((x) => x.leaf_node_count || x.job_count);
      }
      // if (aggMeasures?.some(x => x.aggregation === "overall_percent")) {
        let overallTotals = {};
        aggMeasures?.filter(x => x.aggregation === "overall_percent")
          .forEach(x => {
            overallTotals[x.aggregation_quantity_column] = rawData.reduce((p, c) => p + (c[x.aggregation_quantity_column] || 0), 0);
            calculateAggregateValuesSett(0, sett, overallTotals);
          });        
      // }
      return { data: data, sett: sett };
    },
    // _indexGroupByKeysNested: async function(
    //   filters,
    //   axes,
    //   measures,
    //   aggMeasures,
    //   overrideSortProperty,
    //   ignoreLeafCount,
    //   processAggregate, calculateAggregateValue, setChildren
    // ) {
    //   let data = {};
    //   let preProcessed = [];
    //   let sett = [];
    //   let calculateAggregateValuesSett = (keyIndex, sett, overallTotals) => {
    //     if (keyIndex >= axes[0].columns.length) return;
    //     sett.forEach((row) => {
    //       calculateAggregateValue(row, overallTotals, preProcessed);
    //       calculateAggregateValuesSett(keyIndex + 1, row.children, overallTotals);
    //     });
    //   };
    //   const linkedMeasures = measures.filter(x => x.linked_docs_column);
    //   const leafMatchColumn = this.leafNodeCountColumn(this);
    //   const indexGroupByParams = [{
    //     groupBy: [ ...axes
    //       .filter(a => a.columns.length)
    //       .map(a => a.columns.map(c => {
    //         if (c.column.startsWith('ht_id_') && !c.column.endsWith('_nodeID'))
    //           return { attr: `${c.column}nodeID`, as: `${c.column}nodeID` };
    //         else
    //           return { attr: this.getIndexAttrName(c), as: c.column };
    //       })) ].flat().filter((v, i, a) => a.findIndex(t => (t.attr === v.attr)) === i),
    //     aggregates: measures.map(m => ({ type: m.aggregation, column: m.cache_column, as: m.column }))
    //       .concat(aggMeasures?.map(m => ({ type: m.aggregation, column: m.cache_column, as: m.column })) ?? [])
    //       .filter((v, i, a) => a.findIndex(t => (t.column === v.column)) === i),
    //     filters: filters,
    //   }];
    //   const populateNodeNames = (item) => {
    //     indexGroupByParams[0].groupBy
    //       .filter(g => g.attr.endsWith('_nodeID') && item[g.attr])
    //       .forEach(g => item[g.attr.replace('_nodeID', '_')] = this.hierarchyNodeLookup[`hn${item[g.attr]}`]?.name);
    //   }
    //   [...new Set(measures.filter(x => x.column_basis).map(x => x.column_basis))].forEach(cb => {
    //     const indexColName = this.getIndexColumnName(cb);
    //     if (!indexGroupByParams[0].groupBy.some(x => x.attr === indexColName)) {
    //       indexGroupByParams[0].groupBy.push({ attr: indexColName, as: cb });
    //     }
    //   });
    //   // if (!indexGroupByParams[0].groupBy.length) {
    //   //   indexGroupByParams[0].groupBy.push({ attr: 'doc_id', as: 'doc_id' })
    //   // }
    //   if (indexGroupByParams[0].groupBy.length) {
    //     this.inProgressIndexRequests++;
    //     await this.$store.getters['docs/getDocIndexGroupBy'](indexGroupByParams).then(resp => {
    //       this.inProgressIndexRequests--;
    //       if (resp.length) {
    //         preProcessed = resp[0].values.map(d => {
    //           populateNodeNames(d);
    //           let ret = {
    //             doc_id: d.doc_id, axes: [], rangeColumns: [], groupColumns: [],
    //           };
    //           measures.forEach(m => {
    //             if (m.column_basis) {
    //               ret[m.id + "_primary"] = d[m.column_basis] === m.catalogue_ratio_primary_value ? Number(d[m.column]) : null;
    //               ret[m.id + "_secondary"] = d[m.column_basis] === m.catalogue_ratio_secondary_value ? Number(d[m.column]) : null;
    //             } else {
    //               ret[m.column] = d[m.column];
    //             }
    //           });
    //           linkedMeasures.forEach(m => { 
    //             ret[m.linked_docs_column] = d[m.linked_docs_column] || '';
    //             ret[m.linked_docnames_column] = d[m.linked_docnames_column] || '';
    //           });
    //           axes.forEach(a => {
    //             const keys = a.columns.map(keyDef => {
    //               let val = d[keyDef.column_key] || "";
    //               let matchVal = d[keyDef.column_match] || val;
    //               let sortKey = d[keyDef.column_sort] || "";
    //               if (keyDef.useSortKey && keyDef.listValues) {
    //                 sortKey = keyDef.listValues.find(
    //                   (x) => x.value === val
    //                 )?.sort_key;
    //               }
    //               return { 
    //                 key: val,
    //                 sortKey: sortKey,
    //                 columnSortKey: sortKey,
    //                 title: this.processKeyTitle(keyDef, d, val, true),
    //                 matchVal: matchVal,
    //                 matchKey: `${keyDef.column_match}|${matchVal}`,
    //               };
    //             });
    //             const key = keys.map(x => x.key).join("|");
    //             ret.axes.push({ 
    //               key: key, 
    //               sortKey: keys.map(x => x.sortKey).join("|"), 
    //               columnSortKeys: keys.map(x => x.columnSortKey),
    //               title: keys.map(x => x.title),
    //               match_key: keys.map(x => x.matchKey).join("|") + "|",
    //             });
                
    //             if(a.rangeColumns?.length) {
    //               ret.rangeColumns = a.rangeColumns.map(keyDef => {
    //                 let val = d[keyDef.column_key] || "";
    //                 let sortKey = d[keyDef.column_sort] || "";
    //                 if (keyDef.useSortKey && keyDef.listValues) {
    //                   sortKey = keyDef.listValues.find(
    //                     (x) => x.value === val
    //                   )?.sort_key;
    //                 }
    //                 return { 
    //                   key: keyDef.column_key,
    //                   sortKey: sortKey,
    //                   title: this.processKeyTitle(keyDef, d, val, true),
    //                 };
    //               });
    //             }
    //             if(a.groupColumns?.length) {
    //               ret.groupColumns = a.groupColumns.map(keyDef => {
    //                 let val = d[keyDef.column_key] || "";
    //                 let sortKey = d[keyDef.column_sort] || "";
    //                 if (keyDef.useSortKey && keyDef.listValues) {
    //                   sortKey = keyDef.listValues.find(
    //                     (x) => x.value === val
    //                   )?.sort_key;
    //                 }
    //                 return { 
    //                   key: keyDef.column_key,
    //                   sortKey: sortKey,
    //                   title: this.processKeyTitle(keyDef, d, val, true),
    //                   value: Number(d[keyDef.containerColumnGroupMeasure]),
    //                 };
    //               });
    //             }
    //           });              
    //           return ret;
    //         });
    //       }
    //     });
    //   }
    //   // const setChildren = (current, currentRows, axisIndex, parent) => {
    //   //   if (axisIndex === 0) {
    //   //     sett = [...new Set(currentRows.map(x => x.axes[axisIndex].key))].map(x => { return { key: x, children: [] }; });
    //   //     sett.forEach(s => setChildren(s, currentRows, axisIndex + 1));
    //   //   } else {
    //   //     let rows = currentRows.filter(x => x.axes[axisIndex - 1].key === current.key);
    //   //     current.sortKey = rows[0].axes[axisIndex - 1].sortKey;
    //   //     current.columnSortKeys = rows[0].axes[axisIndex - 1].columnSortKeys;
    //   //     current.match_key = (parent ? parent.match_key : "") + rows[0].axes[axisIndex - 1].match_key;
    //   //     current.titles = rows[0].axes[axisIndex - 1].title;          
    //   //     current.zContainer = zAxisIndex > 0 && axisIndex === zAxisIndex;
    //   //     measures.forEach(function (m) {
    //   //       if (!m.column_basis) {
    //   //         processAggregate(m, rows, m.column, m.id, current);
    //   //       } else {
    //   //         [m.id + "_primary", m.id + "_secondary"].forEach(x => {
    //   //           processAggregate(m, rows, x, x, current);
    //   //         });
    //   //         let val1 = current[m.id + "_primary"];
    //   //         let val2 = current[m.id + "_secondary"];
    //   //         let val = null;
    //   //         if (val1) val = (100 * (val1 - val2) / val1).toFixed(1);
    //   //         current[m.id] = val;
    //   //       }
    //   //     });
    //   //     linkedMeasures.forEach(m => { 
    //   //       current[m.linked_docs_column] = rows.reduce((p,c) => p + (p.length ? "," : "") + c[m.linked_docs_column], "");
    //   //       current[m.linked_docnames_column] = [ ...new Set(rows.reduce((p,c) => p + (p.length ? "," : "") + c[m.linked_docnames_column], "").split(","))];
    //   //     });
    //   //     current.selected = false;
    //   //     current.axisColumns = current.key.split("|").map((c, ci) => {
    //   //       const colDef = axes[axisIndex - 1].columns[ci];
    //   //       let item = {
    //   //         value: c,
    //   //         sortKey: current.columnSortKeys[ci],
    //   //         title: current.titles[ci],
    //   //         doc_id: colDef.isDocument ? Number(c) : null,
    //   //         node: colDef.noderule ? {
    //   //                 level: colDef.ht_level, 
    //   //                 hierarchy_node_id: Number(c),
    //   //                 name: current.titles[ci],
    //   //                 descriptor: null,
    //   //                 ht_id: colDef.ht_id,
    //   //                 isLeaf: colDef.ht_level === colDef.linklevel,
    //   //                 level_name: colDef.noderule.currLevel?.ht_label || colDef.noderule.ht.h_levels[colDef.ht_level - 1],
    //   //                 label: colDef.noderule.currLevel?.ht_label || colDef.noderule.ht.h_levels[colDef.ht_level - 1],
    //   //                 nextLevel: colDef.noderule.nextLevel
    //   //                   ? colDef.noderule.nextLevel.ht_label
    //   //                   : null,
    //   //                 previousLevel: colDef.noderule.prevLevel
    //   //                   ? colDef.noderule.prevLevel.ht_label
    //   //                   : null,
    //   //                 canAdd: false,
    //   //                 canAddDocumentType:
    //   //                   !colDef.noderule.nextLevel && current.job_count === 0
    //   //                     ? this.catalogueDocType.docType
    //   //                     : null,
    //   //                 reviewStatus: null, //this.getHierarchyNodeReviewStatus(hierarchy_node_id),
    //   //                 drilldown: axes[axisIndex - 1].columns.length === 1 && colDef.noderule.nextLevel
    //   //                   ? {
    //   //                       column: colDef.column,
    //   //                       ht_id: colDef.ht_id,
    //   //                       value: current.titles[ci],
    //   //                       hLevel: colDef.currentDrillDownLevel,
    //   //                       expanded: false,
    //   //                     }
    //   //                   : null,
    //   //                 selected: false,
    //   //               } : null,
    //   //         visible: true,
    //   //         selected: false,
    //   //         nodeSelectable: colDef.noderule ? colDef.nodeSelectable : false,
    //   //       };
    //   //       this.appendMatchColumns(item, null, current.match_key);
    //   //       this.appendMeasureColumns(item, 0, current, measures);
    //   //       this.appendAggregateColumns(item, 0, null, aggMeasures);
    //   //       item.valueRanges = (colDef.rangeColumns ?? []).map((rc, rci) => {
    //   //         const vr = [ ...new Set(rows.map(r => r.rangeColumns[rci].title)) ];
    //   //         vr.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
    //   //         if (vr.length) {
    //   //           const min = vr[0];
    //   //           const max = vr.pop();
    //   //           let title = min === max ? min : `${min} - ${max}`;
    //   //           if (rc.prefix) title = `${rc.prefix} ${title.replaceAll(rc.prefix + " ", "")}`;
    //   //           if (rc.suffix) title = `${title.replaceAll(" " + rc.suffix, "")} ${rc.suffix}`;
    //   //           return {
    //   //             name: rc.name,
    //   //             column: rc.column,
    //   //             minValue: min,
    //   //             maxValue: max,
    //   //             title: title,
    //   //             valueDisplayType: rc.valueDisplayType,
    //   //             valueIcon: rc.valueIcon,
    //   //             cssClass: rc.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
    //   //           };
    //   //         } else return null;
    //   //       }).filter(x => x);
    //   //       item.valueGroups = (colDef.groupColumns ?? []).map((gc, gci) => {
    //   //         const gvs = [ ...new Set(rows.map(r => r.groupColumns[gci].title)) ];
    //   //         gvs.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
    //   //         if (gvs.length) {
    //   //           let instances = gvs.map(v => {
    //   //             return {
    //   //               title: v,
    //   //               value: rows.filter(x => x.groupColumns[gci].title === v).reduce((p,c) => p + c.groupColumns[gci].value, 0),
    //   //             }
    //   //           })
    //   //           return {
    //   //             name: gc.name,
    //   //             column: gc.column,
    //   //             values: instances,
    //   //             valueDisplayType: gc.valueDisplayType,
    //   //             valueIcon: gc.valueIcon,
    //   //             cssClass: gc.valueDisplayType === 'chip' ? 'nested-cell-chip' : 'nested-cell',
    //   //           };
    //   //         } else return null;
    //   //       }).filter(x => x);
    //   //       return item;
    //   //     });
    //   //     current.headerColumns = axes[axisIndex - 1].headerColumns
    //   //       .map((x) => {
    //   //         let col = current.axisColumns[x.index];
    //   //         col.nestedColumns = x.contains ? x.contains.map(n => {
    //   //           let nc = current.axisColumns[n.index];
    //   //           nc.valueDisplayType = n.valueDisplayType;
    //   //           nc.valueIcon = n.valueIcon;
    //   //           return nc;
    //   //         }) : [];
    //   //         return col;
    //   //       });
    //   //     // ?? can now remove current.axisColumns and current.sortkey ????
    //   //     delete current.axisColumns;
    //   //     delete current.titles;
    //   //     if (axisIndex < axes.length) {
    //   //       current.children = [...new Set(rows.map(x => x.axes[axisIndex].key))].map(x => { return { key: x, children: [] }; });
    //   //       current.children.forEach(c => setChildren(c, rows, axisIndex + 1, current));
    //   //     }
    //   //   }
    //   // };
    //   setChildren(null, preProcessed, 0);
    //   let sortSett = (dat, property, desc) => {
    //       const sortBy = (a, b) => desc ?
    //         a[property] < b[property] ? 1 : a[property] > b[property] ? -1 : 0 :
    //         a[property] > b[property] ? 1 : a[property] < b[property] ? -1 : 0;
    //       dat.sort(sortBy);
    //       dat.forEach((x,xi) => {
    //         sortSett(x.children, "sortKey");
    //         x.index = xi;
    //       });
    //   };
    //   sortSett(sett, overrideSortProperty || "sortKey", !!overrideSortProperty);
      
    //   // if (!ignoreLeafCount && leafMatchColumn && measures.some((m) => m.type === "leaf_node_count")) {
    //   //   sett.forEach(s => {
    //   //     let key = Number(s.headerColumns[leafMatchColumn.index].value);
    //   //     s.leaf_node_count = rawData.filter((x) => x[leafMatchColumn.column] === key).length;
    //   //     s.headerColumns[leafMatchColumn.index].leaf_node_count = s.leaf_node_count;
    //   //     if (s.headerColumns[leafMatchColumn.index].node)
    //   //       s.headerColumns[leafMatchColumn.index].node.leaf_node_count = s.leaf_node_count;
    //   //   });
    //   //   sett = sett.filter((x) => x.leaf_node_count || x.job_count);
    //   // }
    //   // if (aggMeasures?.length) {
    //   //   let overallTotals = {};
    //   //   aggMeasures.filter(x => x.aggregation === "overall_percent")
    //   //     .forEach(x => {
    //   //       overallTotals[x.aggregation_quantity_column] = rawData.reduce((p, c) => p + (c[x.aggregation_quantity_column] || 0), 0);
    //   //     });
    //   //   calculateAggregateValuesSett(0, sett, overallTotals);        
    //   // }
    //   return { data: data, sett: sett };
    // },
    // _groupByKeysNested: function (
    //   rawData,
    //   axes,
    //   measures,
    //   aggMeasures,
    //   overrideSortProperty,
    //   ignoreLeafCount,
    //   processAggregate, calculateAggregateValue, setChildren
    // ) {
    //   let data = {};
    //   let preProcessed = [];

    //   let calculateAggregateValuesSett = (keyIndex, sett, overallTotals) => {
    //     if (keyIndex >= axes[0].columns.length) return;
    //     sett.forEach((row) => {
    //       calculateAggregateValue(row, overallTotals, preProcessed);
    //       calculateAggregateValuesSett(keyIndex + 1, row.children, overallTotals);
    //     });
    //   };
    //   const linkedMeasures = measures.filter(x => x.linked_docs_column);
    //   preProcessed = rawData.map(d => {
    //     let ret = {
    //       doc_id: d.doc_id, axes: [], rangeColumns: [], groupColumns: [],
    //     };
    //     measures.forEach(m => {
    //       if (m.column_basis) {
    //         ret[m.id + "_primary"] = d[m.column_basis] === m.catalogue_ratio_primary_value ? Number(d[m.column]) : null;
    //         ret[m.id + "_secondary"] = d[m.column_basis] === m.catalogue_ratio_secondary_value ? Number(d[m.column]) : null;
    //       } else {
    //         ret[m.column] = d[m.column];
    //       }
    //     });
    //     linkedMeasures.forEach(m => { 
    //       ret[m.linked_docs_column] = d[m.linked_docs_column] || '';
    //       ret[m.linked_docnames_column] = d[m.linked_docnames_column] || '';
    //     });
    //     axes.forEach(a => {
    //       const keys = a.columns.map(keyDef => {
    //         let val = d[keyDef.column_key] || "";
    //         let matchVal = d[keyDef.column_match] || val;
    //         let sortKey = d[keyDef.column_sort] || "";
    //         if (keyDef.useSortKey && keyDef.listValues) {
    //           sortKey = keyDef.listValues.find(
    //             (x) => x.value === val
    //           )?.sort_key;
    //         }
    //         return { 
    //           key: val,
    //           sortKey: sortKey,
    //           columnSortKey: sortKey,
    //           title: this.processKeyTitle(keyDef, d, val, true),
    //           matchVal: matchVal,
    //           matchKey: `${keyDef.column_match}|${matchVal}`,
    //         };
    //       });
    //       const key = keys.map(x => x.key).join("|");
    //       ret.axes.push({ 
    //         key: key, 
    //         sortKey: keys.map(x => x.sortKey).join("|"), 
    //         columnSortKeys: keys.map(x => x.columnSortKey),
    //         title: keys.map(x => x.title),
    //         match_key: keys.map(x => x.matchKey).join("|") + "|",
    //       });
          
    //       if(a.rangeColumns?.length) {
    //         ret.rangeColumns = a.rangeColumns.map(keyDef => {
    //           let val = d[keyDef.column_key] || "";
    //           let sortKey = d[keyDef.column_sort] || "";
    //           if (keyDef.useSortKey && keyDef.listValues) {
    //             sortKey = keyDef.listValues.find(
    //               (x) => x.value === val
    //             )?.sort_key;
    //           }
    //           return { 
    //             key: keyDef.column_key,
    //             sortKey: sortKey,
    //             title: this.processKeyTitle(keyDef, d, val, true),
    //           };
    //         });
    //       }
    //       if(a.groupColumns?.length) {
    //         ret.groupColumns = a.groupColumns.map(keyDef => {
    //           let val = d[keyDef.column_key] || "";
    //           let sortKey = d[keyDef.column_sort] || "";
    //           if (keyDef.useSortKey && keyDef.listValues) {
    //             sortKey = keyDef.listValues.find(
    //               (x) => x.value === val
    //             )?.sort_key;
    //           }
    //           return { 
    //             key: keyDef.column_key,
    //             sortKey: sortKey,
    //             title: this.processKeyTitle(keyDef, d, val, true),
    //             value: Number(d[keyDef.containerColumnGroupMeasure]),
    //           };
    //         });
    //       }
    //     });
    //     return ret;
    //   });
    //   let sett = [];
    //   setChildren(null, preProcessed, 0);
    //   let sortSett = (dat, property, desc) => {
    //       const sortBy = (a, b) => desc ?
    //         a[property] < b[property] ? 1 : a[property] > b[property] ? -1 : 0 :
    //         a[property] > b[property] ? 1 : a[property] < b[property] ? -1 : 0;
    //       dat.sort(sortBy);
    //       dat.forEach((x,xi) => {
    //         sortSett(x.children, "sortKey");
    //         x.index = xi;
    //       });
    //   };
    //   sortSett(sett, overrideSortProperty || "sortKey", !!overrideSortProperty);
    //   const leafMatchColumn = this.leafNodeCountColumn(this);
    //   if (!ignoreLeafCount && leafMatchColumn && measures.some((m) => m.type === "leaf_node_count")) {
    //     sett.forEach(s => {
    //       let key = Number(s.headerColumns[leafMatchColumn.index].value);
    //       s.leaf_node_count = rawData.filter((x) => x[leafMatchColumn.column] === key).length;
    //       s.headerColumns[leafMatchColumn.index].leaf_node_count = s.leaf_node_count;
    //       if (s.headerColumns[leafMatchColumn.index].node)
    //         s.headerColumns[leafMatchColumn.index].node.leaf_node_count = s.leaf_node_count;
    //     });
    //     sett = sett.filter((x) => x.leaf_node_count || x.job_count);
    //   }
    //   // if (aggMeasures?.some(x => x.aggregation === "overall_percent")) {
    //     let overallTotals = {};
    //     aggMeasures?.filter(x => x.aggregation === "overall_percent")
    //       .forEach(x => {
    //         overallTotals[x.aggregation_quantity_column] = rawData.reduce((p, c) => p + (c[x.aggregation_quantity_column] || 0), 0);
    //         calculateAggregateValuesSett(0, sett, overallTotals);
    //       });        
    //   // }
    //   return { data: data, sett: sett };
    // },
    getCompareOptionDef: function (source, type) {
      return this[type].find((x) => x.column === source.column);
    },
    getViewCompareOption: function (source) {
      let co = {
        column: source.column,
        displayStyle: source.displayStyle,
        prefix: source.prefix,
        suffix: source.suffix,
        overrideTitle: source.overrideTitle,
        detailHeadingVisible: source.detailHeadingVisible,
        valueDisplayType: source.valueDisplayType,
        containerColumn: source.containerColumn,
        containerColumnShowRange: source.containerColumn && source.containerColumnShowRange,
        containerColumnGroupMeasure: source.containerColumn && source.containerColumnGroupMeasure,
        valueIcon: source.valueIcon,
        chartDisplayRange: source.chartDisplayRange,
        chartDisplayRangeQuantity: source.chartDisplayRangeQuantity,
        nodeActionsAlignment: source.nodeActionsAlignment,
        nodeSelectable: source.nodeSelectable,
        showDescriptor: source.showDescriptor,
        descriptorEditable: source.showDescriptor && source.descriptorEditable,
      };
      if (source.currentDrillDownLevel !== undefined) {
        co.currentDrillDownLevel = source.currentDrillDownLevel;
      }
      return co;
    },
    setViewCompareOption: function (compareOptionName) {
      let val = this[compareOptionName];
      this.selectedView.definition[compareOptionName] =
        this.getViewCompareOption(val);
    },
    setMeasureOptionTemp: function (col, prev) {
      let hmeas = this.selectedView.definition.horizontalMeasures.find(x => x.id === prev.id);
      let vmeas = this.selectedView.definition.verticalMeasures.find(x => x.id === prev.id);
      if (hmeas) hmeas.id = col.id;
      if (vmeas) vmeas.id = col.id;
      this.rebuildCompare();
    },
    setAxisCompareOptionTemp: function (type, val, index) {
      this.setAxisCompareOption(type, val, index, true);
    },
    setAxisCompareOption: function (type, val, index, temp) {
      let currentOption = this[type][index];
      let newOption = this.getViewCompareOption(val);
      if (currentOption.column === newOption.column) return;
      if (newOption.currentDrillDownLevel !== undefined)
        newOption.currentDrillDownLevel = 1;
      this.changeAxis(type, index, 1, val, newOption, temp);
    },
    setAxisCompareOptionStyle: function (type, style, index, prefix, suffix, overrideTitle, detailHeadingVisible, valueDisplayType, containerColumn, containerColumnShowRange, containerColumnGroupMeasure, valueIcon, chartDisplayRange, chartDisplayRangeQuantity, nodeActionsAlignment, nodeSelectable, showDescriptor, descriptorEditable) {
      let currentOption = this[type][index];
      currentOption.displayStyle = style || _defaultHeaderColours;
      currentOption.showDescriptor = showDescriptor;
      currentOption.descriptorEditable = showDescriptor && descriptorEditable;
      currentOption.prefix = prefix;
      currentOption.suffix = suffix;
      currentOption.overrideTitle = overrideTitle;
      currentOption.detailHeadingVisible = detailHeadingVisible;
      currentOption.valueDisplayType = valueDisplayType;
      currentOption.containerColumn = containerColumn;
      currentOption.containerColumnShowRange = containerColumn && containerColumnShowRange;
      currentOption.containerColumnGroupMeasure = containerColumn && containerColumnGroupMeasure;
      currentOption.valueIcon = valueIcon;
      currentOption.chartDisplayRange = chartDisplayRange;
      currentOption.chartDisplayRangeQuantity = chartDisplayRangeQuantity;
      currentOption.nodeActionsAlignment = nodeActionsAlignment;
      currentOption.nodeSelectable = nodeSelectable;
      this.changeAxis(
        type,
        index,
        1,
        currentOption,
        this.getViewCompareOption(currentOption)
      );
    },
    addAxisCompareOption: function (type, val, index) {
      if (val.currentDrillDownLevel !== undefined)
        val.currentDrillDownLevel = 1;
      let newOption = this.getViewCompareOption(val);
      this.changeAxis(type, index + 1, 0, val, newOption);
    },
    removeAxisCompareOption: function (type, index) {
      this.changeAxis(type, index, 1);
    },
    async rebuildCompare () {
      if (this.hasExpanded) {
        this.selectJDs();
      } else {
        await this.buildCompare(this.selectedDocs);        
        this.setVScrollPageHeight();
      }
    },
    setSort(column, columnIndex, isMeasure) {
      if (!this.selectedView.sortColumn) this.selectedView.sortColumn = { name: "", isNumber: false, descending: false };
      if (this.selectedView.sortColumn.name !== column.column) {
        this.selectedView.sortColumn.name = column.column;
        this.selectedView.sortColumn.isNumber = isMeasure || column.type === "Number";
        this.selectedView.sortColumn.descending = false;
      } else {
        this.selectedView.sortColumn.descending = !this.selectedView.sortColumn.descending;
      }
      const getKey = isMeasure
        ? (r) => r[column.id]
        // expanded drilldown rows carry their own level's key at the same index
        // (expansion only exists for single-column vertical axes)
        : (r) => r.columnSortKeys?.[columnIndex] ?? r.columnSortKeys?.[0];
      this.sortSettDataSections(getKey, this.selectedView.sortColumn.descending);
      this.setRowIndexes();
      this.getNextPageSize();
    },
    // numeric-aware comparison; rows without a value always sink to the bottom
    compareSortValues(av, bv, descending) {
      const hasA = av !== undefined && av !== null && av !== "";
      const hasB = bv !== undefined && bv !== null && bv !== "";
      if (!hasA || !hasB) return hasA ? -1 : hasB ? 1 : 0;
      const an = Number(av);
      const bn = Number(bv);
      const bothNumeric = !Number.isNaN(an) && !Number.isNaN(bn);
      const a1 = bothNumeric ? an : av;
      const b1 = bothNumeric ? bn : bv;
      return a1 > b1 ? (descending ? -1 : 1) : a1 < b1 ? (descending ? 1 : -1) : 0;
    },
    // sort settData while keeping each expanded drilldown section attached to its
    // parent row, applying the same order to the rows inside every section
    sortSettDataSections(getKey, descending) {
      const sortLevel = (rows, level) => {
        // one block per row at this indent level, carrying its nested rows
        const blocks = [];
        rows.forEach((r) => {
          if ((r.indentLevel || 0) <= level || !blocks.length) blocks.push([r]);
          else blocks[blocks.length - 1].push(r);
        });
        blocks.forEach((b) => {
          if (b.length > 1) {
            const nested = sortLevel(b.slice(1), level + 1);
            // the section's sub-heading caption sits on its first row: keep it there
            const withHeader = nested.find((r) => r.showGroupHeader);
            if (withHeader && withHeader !== nested[0]) {
              nested[0].showGroupHeader = withHeader.showGroupHeader;
              withHeader.showGroupHeader = "";
            }
            b.splice(1, b.length - 1, ...nested);
          }
        });
        blocks.sort((x, y) => this.compareSortValues(getKey(x[0]), getKey(y[0]), descending));
        return blocks.flat();
      };
      const sorted = sortLevel(this.settData, 0);
      this.settData.splice(0, this.settData.length, ...sorted);
    },
    removeAxisCompareOptionAll: function (type) {
      this[type].splice(0, this[type].length);
      this.selectedView.definition[type].splice(
        0,
        this.selectedView.definition[type].length
      );
      this.rebuildCompare();
      this.updateViewDefinition();
    },
    changeAxis: function (type, index, remove, newVal, newOption, temp) {
      if (newVal) {
        this[type].splice(index, remove, newVal);
        if (!temp) this.selectedView.definition[type].splice(index, remove, newOption);
      } else {
        this[type].splice(index, remove);
        if (!temp) this.selectedView.definition[type].splice(index, remove);
      }
      this.rebuildCompare();
      if (!temp) this.updateViewDefinition();
    },
    changeDesign: function () {
      this.rebuildCompare();
      this.updateViewDefinition();
    },
    editDocs: function (items) {
      this.prepEditDialogue(this.editDialogue, items);
    },
    initPaging: function (dialogue) {
      dialogue.items.forEach((x, xi) => {
        x.page = parseInt(xi / dialogue.pageSize);
        dialogue.pages = x.page + 1;
        return x;
      });
      if (dialogue.items.length === 0) return;
      dialogue.show = true;
      dialogue.page = 0;
      this.dialoguePageText(dialogue);
    },
    prepEditDialogue: function (dialogue, items) {
      let itemList = null;
      if (items) {
        itemList = _documents.filter((x) =>
          items.some((i) => i.doc_id === x.doc_id)
        );
      } else {
        itemList = this.compareDocs;
      }
      dialogue.items = itemList.map((x) => {
        this.attributes.forEach((a) => {
          x["change_" + a.value_column] = false;
        });
        this.hierarchyTypes.forEach((h) => {
          x["change_ht_id_" + h.ht_id] = false;
        });
        return x;
      });
      if (dialogue.items.length === 0) return;
      dialogue.canSave = false;
      dialogue.columns.splice(0, dialogue.columns.length);
      this.attributes
        .filter((a) => !a.editUnavailable)
        .forEach((a, ai) => {
          let val = dialogue.items[0][a.value_column];
          let same = dialogue.items.every((x) => x[a.value_column] === val);
          dialogue.columns.push({
            column: a.column,
            value_column: a.value_column,
            data_type: a.data_type,
            value_data_type: a.value_data_type,
            label: a.value_label,
            tpa_id: a.tpa_id || ai + 1,
            same: same,
            value: same ? val : null,
            values: a.values ? a.values.map((v) => v.value) : null,
            isDirty: false,
          });
        });
      this.hierarchyTypes.forEach((h) => {
        let val = dialogue.items[0]["ht_id_" + h.ht_id];
        let text = dialogue.items[0][`ht_id_${h.ht_id}_text`];
        let hLabel = dialogue.items[0][`ht_id_${h.ht_id}_label`].split(" > ");
        let same = dialogue.items.every((x) => x["ht_id_" + h.ht_id] === val);
        dialogue.columns.push({
          column: "ht_id_" + h.ht_id,
          value_column: "ht_id_" + h.ht_id,
          label: h.label,
          ht_id: h.ht_id,
          linklevel: h.linklevel,
          same: same,
          value: same ? val : null,
          text: same ? text : null,
          isDirty: false,
          hLabel: same ? hLabel : [],
        });
      });
      this.initPaging(dialogue);
    },
    afterDocumentUpdate: (context, updatedDocs) => {
      if (updatedDocs) {
        updatedDocs.forEach((x) => {
          let ind = _documents.findIndex((d) => d.doc_id === x.doc_id);
          if (ind >= 0) {
            _documents.splice(ind, 1, x);
          } else {
            _documents.push(x);
          }
        });
      }
      context.selectJDs();
    },
    updateDocCollection: (context, document) => {
      let ind = _documents.findIndex((d) => d.doc_id === document.doc_id);
      let doReload = false;
      if (ind >= 0) {
        if (!context.compareDocuments(_documents[ind], document)) {
          _documents.splice(ind, 1, document);
          doReload = true;
        }
      } else {
        _documents.push(document);
        doReload = true;
      }
      return doReload;
    },
    saveDocs: function () {
      let updated = false;
      let data = { updates: [] };
      let ht = null;
      this.editDialogue.items.forEach((d) => {
        this.editDialogue.columns.forEach((a) => {
          if (
            d[a.value_column] !== a.value &&
            d["change_" + a.value_column]
          ) {
            d[a.value_column] = a.value;
            updated = true;
            data.updates.push({
              doc_id: d.doc_id,
              tpa_id: a.tpa_id,
              ht_id: a.ht_id,
              value: a.value,
            });
            if (a.ht_id) {
              this.setDocHierarchyProperties(a.ht_id, a.value, d);
            }
          }
        });
      });
      let afterUpdate = (updatedDocs) => {
        this.resetCompare();
        data.updates.forEach(u => {
          let doc = this.editDialogue.items.find(x => x.doc_id === u.doc_id);
          if (doc) this.updateDocCollection(this, doc);
        })
        this.editDialogue.show = false;
        this.selectJDs();
      };
      if (updated) {
        let possibleError = false;
        this.isSaving = true;

        axios
          .post("document/saveDocAttributes/", data)
          .then((resp) => {
            possibleError = true;
            if (resp.data.Status === "OK") {
              afterUpdate(resp.data.Data.docs);
            }
            this.response = resp.data;
            this.isSaving = false;
          })
          .catch((err) => {
            if (possibleError) {
              alert("Code Error");
            } else if (err.response && err.response.status === 401) {
              this.$emit("sessionExpired", err);
            } else {
              alert(err.response ? err.response.data.message : err);
            }
            console.log(err);
            this.isSaving = false;
          });
      }
    },
    reviewHierarchy: function () {
      let data = { node: this.nodeDescriptorView.node };
      let possibleError = false;
      this.isSaving = true;

      axios
        .post("document/createHierarchyReviewDocument/", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.openDocument(resp.data.Data);
          }
          this.response = resp.data;
          this.isSaving = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    editDialogueCheckCount(attribute) {
      let col = "change_" + attribute;
      return this.editDialogue.items.filter((x) => x[col]).length;
    },
    editDialogueCheckAll(attribute) {
      let col = "change_" + attribute;
      let onCount = 0;
      let offCount = 0;
      this.editDialogue.items.forEach((x) => {
        x[col] ? onCount++ : offCount++;
      });
      let newVal = onCount >= offCount ? false : true;
      this.editDialogue.items.forEach((x) => (x[col] = newVal));
      this.setCanSave();
    },
    dialogueNextPage(dialogue, plus) {
      dialogue.page += plus ? 1 : -1;
      if (dialogue.page >= dialogue.pages) dialogue.page = dialogue.pages - 1;
      else if (dialogue.page < 0) dialogue.page = 0;
      this.dialoguePageText(dialogue);
    },
    dialoguePageText(dialogue) {
      dialogue.colSize = "";
      if (dialogue.pages === 1) {
        dialogue.pageText = `(1 to ${dialogue.items.length} of ${dialogue.items.length})`;
      } else {
        let endno = (dialogue.page + 1) * dialogue.pageSize;
        if (endno > dialogue.items.length) {
          endno = dialogue.items.length;
          dialogue.colSize = parseInt(12 / dialogue.pageSize);
        }
        dialogue.pageText = `(${
          dialogue.page * dialogue.pageSize + 1
        } to ${endno} of ${dialogue.items.length})`;
      }
    },
    getNewTitle() {
      return _newTitle;
    },
    saveDefinition() {
      this.viewDefinition.view = this.selectedView;
      this.viewDefinition.saveTrigger++;
    },
    saveDefinitionAs(v) {
      let view = JSON.parse(JSON.stringify(v ?? this.selectedView));
      view.definition.primary = null;
      view.definition.isBase = false;
      view.definition.parentTab  = null;
      this.viewDefinition.view = view;
      this.viewDefinition.saveAsTrigger++;
      this.viewDefinition.saveAsIsCurrent = !v;
      // this.selectView(view);
    },
    deleteDefinition(view) {
      this.viewDefinition.view = view;
      this.viewDefinition.inactiveTrigger++;
    },
    editDefinition(view) {
      view.originalName = view.name;
      this.viewDefinition.view = view;
      this.viewDefinition.editTrigger++;
      this.viewMenu.keepOpen = true;
    },
    viewAdded(view) {
      if (!this.viewDefinition.saveAsIsCurrent) {
        this.selectedView.definition = JSON.parse(
          JSON.stringify(this.selectedView.orginalDefinition)
        );
        this.selectedView.isDirty = false;
      }
      view.isDirty = false;
      view.orginalDefinition = JSON.parse(JSON.stringify(view.definition));
      this.views.push(view);
      this.selectView(view);
      // this.selectedView = view;
      // this.setViewMenuTabs();
    },
    viewInactive(view) {
      let ind;
      let indP;
      let indSC;
      if (view.view_definition_id) {
        this.setEditShortcuts();
        ind = this.views.findIndex(
          (x) => x.view_definition_id === view.view_definition_id
        );
        indP = this.primaryViews.findIndex(
          (x) => x.view_definition_id === view.view_definition_id
        );
        indSC = this.shortcuts.editItems.findIndex(
          (x) => x.name === view.name
        );
      }
      if (ind < 0) {
        ind = this.views.findIndex(
          (x) => x.name === view.name && x.restricted === view.restricted
        );
        indP = this.primaryViews.findIndex(
          (x) => x.name === view.name && x.restricted === view.restricted
        );
      }
      this.views.splice(ind, 1);
      if (indP >= 0) this.primaryViews.splice(indP, 1);
      if (indSC >= 0) {
        this.shortcuts.editItems[indSC].delete = true;
        this.saveShortcuts();
      }
      if (view.view_definition_id === this.selectedView.view_definition_id) {
        this.selectedView = null;
        this.selectedView = this.views[0];
      }
      this.setViewMenuTabs();
    },
    viewEditCancelled() {
      this.viewMenu.keepOpen = false;
    },
    viewSaved(view) {
      let ind;
      let oldName = view.originalName || view.name;
      if (view.view_definition_id) {
        ind = this.views.findIndex(
          (x) => x.view_definition_id === view.view_definition_id
        );
      }
      if (ind < 0) {
        ind = this.views.findIndex(
          (x) => x.name === view.name && x.restricted === view.restricted
        );
      }
      if (view.name !== oldName && this.shortcuts.items.some(x => x.name === oldName)) {
        // update shortcuts
        this.setEditShortcuts();
        this.shortcuts.editItems.filter(x => x.name === oldName).forEach(x => x.name = view.name);
        this.saveShortcuts();        
      }
      view.orginalDefinition = JSON.parse(JSON.stringify(view.definition));
      view.isDirty = false;
      if (view.view_definition_id === this.selectedView.view_definition_id) {
        this.selectedView.isDirty = false;
        this.selectedView.view_definition_id = view.view_definition_id;
        this.selectedView.name = view.name;
        this.selectedView = view;
      }
      this.views.splice(ind, 1, view);
      this.setViewMenuTabs();
      this.viewMenu.keepOpen = false;
    },
    resetDefinition() {
      this.selectedView.definition = JSON.parse(
        JSON.stringify(this.selectedView.orginalDefinition)
      );
      this.selectedView.isDirty = false;
      this.setView();
    },
    getDefinitionChanges(view) {
      let changes = [];
      if (!view.orginalDefinition) return changes;
      let orig = view.orginalDefinition;
      let current = view.definition;
      if (orig.tmpl_id !== current.tmpl_id)
        changes.push("Document Type updated");
      if (orig.horAxisSelected?.length !== current.horAxisSelected?.length)
        changes.push("Horizontal Axis columns changed");
      else if (
        !orig.horAxisSelected?.every(
          (x, xi) => x.column === current.horAxisSelected[xi].column
        )
      )
        changes.push("Horizontal Axis subject changed");

      if (orig.verAxisSelected?.length !== current.verAxisSelected?.length)
        changes.push("Vertical Axis columns changed");
      else if (
        !orig.verAxisSelected?.every(
          (x, xi) => x.column === current.verAxisSelected[xi].column
        )
      )
        changes.push("Vertical Axis subject changed");

      if (orig.detAxisSelected?.length !== current.detAxisSelected?.length)
        changes.push("Detail Axis columns changed");
      else if (
        !orig.detAxisSelected?.every(
          (x, xi) => x.column === current.detAxisSelected[xi].column
        )
      )
        changes.push("Drilldown Axis subject changed");
      if (
        JSON.stringify(orig.verticalMeasures) !==
        JSON.stringify(current.verticalMeasures)
      )
        changes.push("Vertical Measures changed");
      if (
        JSON.stringify(orig.horizontalMeasures) !==
        JSON.stringify(current.horizontalMeasures)
      )
        changes.push("Detail Measures changed");
      if (orig.groupedViewShowDescriptor !== current.groupedViewShowDescriptor)
        changes.push("Node Descriptor visibility changed");
      if (orig.verticalSortProperty !== current.verticalSortProperty ||
          JSON.stringify(orig.defaultSort || null) !== JSON.stringify(current.defaultSort || null))
        changes.push("Default Sort changed");
      if (orig.displayAs !== current.displayAs)
        changes.push("Display Type changed");
      // if (orig.charts !== current.charts)
      //   changes.push("Charts changed");
      if (JSON.stringify(orig.viewSections) !== JSON.stringify(current.viewSections))
        changes.push("View Sections changed");
      if (orig.showDownload !== current.showDownload)
        changes.push("Show Download changed");
      if (orig.gridlines !== current.gridlines)
        changes.push("Gridlines changed");
      if (orig.gridWidth !== current.gridWidth)
        changes.push("Grid Width changed");
      if (orig.showSubHeading !== current.showSubHeading)
        changes.push("Show Sub Heading changed");
      if (orig.showTextSearch !== current.showTextSearch)
        changes.push("Show Search Box changed");
      if (orig.hideNodeActions !== current.hideNodeActions)
        changes.push("Hide Node Actions changed");
      if (orig.horizontalHeadingVisible !== current.horizontalHeadingVisible)
        changes.push("Show Horizontal Headings changed");
      if (orig.showTotalsRow !== current.showTotalsRow)
        changes.push("Show Totals Row changed");
      if (orig.fullVerticalView !== current.fullVerticalView)
        changes.push("Show Full Vertical Axis changed");
      if (orig.allowColumnSort !== current.allowColumnSort)
        changes.push("Allow Vertical Axis Sorting changed");
      if (
        JSON.stringify(orig.attributeFilters) !==
        JSON.stringify(current.attributeFilters)
      )
        changes.push("Filters changed");
      if (
        JSON.stringify(orig.hierarchyPickers || []) !==
        JSON.stringify(current.hierarchyPickers || [])
      )
        changes.push("Hierarchy Tree Filters changed");
      // if (
      //   JSON.stringify(orig.columnFilters) !==
      //   JSON.stringify(current.columnFilters)
      // )
      //   changes.push("Column Filters changed");
      if (
        JSON.stringify(orig.measureFilterTypes) !==
        JSON.stringify(current.measureFilterTypes)
      )
        changes.push("Measure Filters changed");
      // if (
      //   JSON.stringify(orig.drilldownFilters) !==
      //   JSON.stringify(current.drilldownFilters)
      // )
      //   changes.push("Drilldown Filters changed");
      if (
        JSON.stringify(orig.transactionTypeFilters) !==
        JSON.stringify(current.transactionTypeFilters)
      )
        changes.push("Transaction Type Filters changed");
      if (
        JSON.stringify(orig.nameChangeFilters) !==
        JSON.stringify(current.nameChangeFilters)
      )
        changes.push("Name Change Filters changed");
      if (orig.measureFilter !== current.measureFilter)
        changes.push("Measure Filter changed");
      return changes;
    },
    setDefinitionDescription() {
      this.selectedView.description = this.getViewDescription(
        this.selectedView.definition
      );
    },
    visibleMeasures() {
      return this.measures.filter(m => this.verticalMeasures?.some(x => x.id === m.id && x.visible) || this.horizontalMeasures?.some(x => x.id === m.id && x.visible));
    },
    getViewDescription(view) {
      let text = `<div class="container" style="min-width: 600px;">`;
      let docType = this.docTypeSummary.find((x) => x.tmpl_id === view.tmpl_id);
      let hryTpe = this.hierarchyTypes.find((x) => x.ht_id === view.ht_id);
      let hCompare = this.horAxisAvailable
        .filter((x) =>
          view.horAxisSelected?.some((o) => o.column === x.column)
        )
        .map((x) => x.name)
        .join(", ");
      let vComp = this.verAxisAvailable
        .filter((x) =>
          view.verAxisSelected?.some((o) => o.column === x.column)
        )
        .map((x) => x.name)
        .join(", ");
      let dComp = this.detAxisAvailable
        .filter((x) =>
          view.detAxisSelected?.some((o) => o.column === x.column)
        )
        .map((x) => x.name)
        .join(", ");
      let visibleMeasures = this.measures.filter(m => view.verticalMeasures?.some(x => x.id === m.id && x.visible) || view.horizontalMeasures?.some(x => x.id === m.id && x.visible))
        .map((x) => `<li>${x.title}</li>`)
        .join("");
      let textVisibleMeasures = "";
      if (visibleMeasures) {
        textVisibleMeasures += `<div class="row"><div class="col">Showing${
          view.groupedViewShowDescriptor ? " Descriptors and" : ""
        }:<ul>`;
        textVisibleMeasures += visibleMeasures;
        textVisibleMeasures += `</ul></div></div>`;
      }
      switch (view.viewType) {
        case "catalogue":
          text += `<div class="row"><div class="col">`;
          text += `<h3>${docType.docType} View</h3>`;
          text += `</div></div>`;
          text += `<div class="row"><div class="col">`;
          text += "<h4>";
          text += vComp ? vComp : "";
          text += hCompare ? " by " + hCompare : "";
          text += dComp ? " by " + dComp : "";
          text += "</h4>";
          text += `</div></div>`;
          text += textVisibleMeasures;
          break;
        case "list":
          text += `<div class="row"><div class="col">`;
          text += `<h3>${hryTpe.label} Listview based on ${docType.docType}s</h3>`;
          text += `</div></div><div class="row">`;
          text += `<div class="col col-6">Grouped by:<ul>`;
          text += "</ul></div>";
          text += `<div class="col col-6">Showing:<ul>`;
          text += "</ul></div></div>";
          break;
        case "grouped":
          text += `<div class="row"><div class="col">`;
          text += `<h3>${hryTpe.label} Grouped view based on ${docType.docType}s</h3>`;
          text += `</div></div>`;
          text += textVisibleMeasures;
          break;
      }
      // if (this.filterList.length) {
      //   text += `<div class="row"><div class="col">Filtered by:`;
      //   text += `<ul>`;
      //   text += this.filterList.map((f) => `<li>${f.name}</li>`).join("");
      //   text += "</ul></div></div>";
      // }
      text += "</div>";
      return text;
    },
    showFilters() {
      if (this.viewDefinition.tab === 0) {
        this.viewDefinition.showDesigner = !this.viewDefinition.showDesigner;
      } else {
        this.viewDefinition.showDesigner = true;
        this.viewDefinition.tab = 0;
      }
    },
    toggleDesigner() {
      if (this.permissions.changeSettings) {
        this.viewDefinition.showDesigner = !this.viewDefinition.showDesigner;
        if (this.viewDefinition.showDesigner) this.viewDefinition.tab = 1;
      } else {
        this.viewDefinition.showDesigner = false;
      }
    },
    updateViewDefinition() {
      this.selectedView.isDirty = true;
      this.selectedView.definition.attributeFilters = this.verAxisAvailable
        .filter((x) => x.filterValues.length)
        .map((f) => {
          return {
            column: f.column,
            filterValues: f.filterValues,
          };
        });
      this.selectedView.definition.measureFilterTypes = this.measureFilterTypes
        .filter((x) => x.filters.some(x => x && (x.visible || x.rangeFrom !== null || x.rangeTo !== null)))
        .map((f) => {
          return {
            axis: f.axis,
            filters: f.filters.filter(x => x && (x.visible || x.rangeFrom !== null || x.rangeTo !== null)),
          };
        });
      // this.selectedView.definition.drilldownFilters = this.drilldownFilters.map(
      //   (df) => {
      //     return {
      //       column: df.column,
      //       value: df.value,
      //       ht_id: df.ht_id,
      //       compareOptionName: df.compareOptionName,
      //       hLevel: df.level,
      //     };
      //   }
      // );
      this.selectedView.definition.visibleFilters = this.verAxisAvailable
        .filter((x) => x.visible)
        .map((f) => {
          return {
            column: f.column,
          };
        });
      this.selectedView.definition.hierarchyPickers = this.hierarchyPickerFilters
        .filter((h) => h.included || h.selectedNodes.length)
        .map((h) => {
          return {
            ht_id: h.ht_id,
            included: h.included,
            selected: h.selectedNodes,
          };
        });

      this.setDefinitionDescription();
    },
    changeViewSetting(name, collection, item) {
      this.selectedView.isDirty = true;
      switch (name) {
        case "changeViewMeasure":
          this.changeViewMeasure(collection, item);
          this.rebuildCompare();
          this.updateViewDefinition();
          break;
        case "measuresVisible":
          if (this.selectedView.definition.viewType === "catalogue")
            this.rebuildCompare();
          this.updateViewDefinition();
          break;
        case "verticalSortProperty":
        case "defaultSort":
          this.rebuildCompare();
          this.updateViewDefinition();
          break;
        case "displayAs":
        case "horizontalHeadingVisible":
        case "showTotalsRow":
          this.displayView();
          this.updateViewDefinition();
          break;
        case "showDownload":
        case "gridWidth":
        case "showTextSearch":
        case "hideNodeActions":
          this.updateViewDefinition();
          break;
        case "gridlines":
          this.layout.gridLineClass = this.setGridLineClass();
          this.setVisibleHeaderColumns();
          this.updateViewDefinition();
          break;
        case "showSubHeading":
        case "fullVerticalView":
        case "allowColumnSort":
          this.updateViewDefinition();
          this.setVisibleHeaderColumns();
          this.applyDefaultSortIndicator();
          break;
        case "detailCompareOption":
          this.setViewCompareOption("detailCompareOption");
          this.rebuildCompare();
          this.updateViewDefinition();
          break;
        case "tmpl_id":
          this.changeDocType(true);
          break;
        case "transactionTypeFilters":
          this.selectJDs();
          break;
        case "nameChangeFilters":
          this.selectJDs();
          break;
      }
    },
    setViewMenuTabs() {
      let tabs = [];
      let views = [];
      this.primaryTabs.filter(x => x.visible && !x.other).forEach(t => {
        this.primaryViews.filter(x => x.definition.parentTab === t.key).forEach(pv => {
          views.push(this.views.find(v => v.view_definition_id === pv.view_definition_id));
          views[views.length - 1].lastInSection = false;
        });
        if (views.length) views[views.length - 1].lastInSection = true;
      });
      if (!views.length) {
        this.primaryViews.forEach(pv => {
          views.push(this.views.find(v => v.view_definition_id === pv.view_definition_id));
          views[views.length - 1].lastInSection = false;
        });
        if (views.length) views[views.length - 1].lastInSection = true;
      }
      tabs.push({ 
        title: "Main Views", 
        views: views,
        rename: this.permissions.saveViewMain,
        tip: "Views that appear within the main tabs"
      });
      tabs.push({ 
        title: "Other Views", 
        views: this.views.filter((x) => !x.restricted && !this.primaryViews.some(p => p.view_definition_id === x.view_definition_id)),
        rename: this.permissions.saveViewOwn,
        tip: "Views not contained within the main tabs"
      });
      if (this.permissions.saveViewOwn && this.views.some((x) => x.restricted))
        tabs.push({ 
          title: "My Views", 
          views: this.views.filter((x) => x.restricted),
          rename: true,
          tip: "Views only visible to me"
        });
      if (this.permissions.saveShortcuts) 
        tabs.push({ 
          title: "Manage Tabs", 
          views: null,
          admin: true,
        });        
      this.viewMenu.tabs = tabs;
      if (this.selectedView.restricted) {
        this.viewMenu.tab = 2;
      } else if (!this.selectedTab || this.selectedTab.other) {
        this.viewMenu.tab = 1;
      } else {
        this.viewMenu.tab = 0;
      }
    },
    openViewMenu(e) {
      // this.viewDefinition.showDesigner = false;
      this.viewMenu.show = false;
      // this.viewMenu.isDirty = false;
      this.viewMenu.posX = e.clientX;
      this.viewMenu.posY = e.clientY;
      this.setViewMenuTabs();
      // if (this.measures.length) {
        this.$nextTick(() => {
          this.viewMenu.show = true;
        });
      // }
    },
    getShortcuts(callback) {
      this.$store
        .dispatch("settings/getViewDefinitions", this.page + "-shortcuts")
        .then((resp) => {
          this.shortcuts.items = resp.data.Data.length
            ? resp.data.Data[0].definition.items.map(x => {
              x.tabTitle = x.tabTitle || x.name;
              return x;
            })
            : [];
          this.shortcuts.view_definition_id = resp.data.Data.length
            ? resp.data.Data[0].view_definition_id
            : null;
          if (callback) callback();
        }),
        (error) => {
          console.error(error);
        };
    },
    setEditShortcuts() {
      let editItems = JSON.parse(JSON.stringify(this.shortcuts.items));
      editItems.forEach((i) => {
        i.delete = false;
        i.isNew = false;
        i.restricted = this.views.find(x => x.name === i.name)?.restricted;
        i.tabTitle = i.tabTitle || i.name;
        i.sort_key = (((this.primaryTabs.find(x => x.key === i.parentTab)?.index ?? 98) + 1) * 1000)
                        + (Number(i.position) || 0);
      });
      this.shortcuts.editItems = editItems.sort((a,b) => a.sort_key > b.sort_key ? 1 : a.sort_key < b.sort_key ? -1 : 0);
    },
    toggleRemoveShortcut(s) {
      if (s.isNew) {
        this.shortcuts.editItems.splice(0, 1);
      } else {
        s.delete = !s.delete;
        this.shortcuts.isDirty = true;
      }
    },
    cancelShortcuts() {
      this.setEditShortcuts();
      this.shortcuts.isDirty = false;
    },
    addShortcut() {
      this.shortcuts.isDirty = true;
      this.shortcuts.editItems.unshift({
        name: "",
        tabTitle: "",
        isNew: true,
        icon: null,
        position: this.shortcuts.editItems.length + 1,
        isDefault: false,
      });
    },
    saveShortcuts() {
      let possibleError = false;
      let data = {
        definition: {
          items: JSON.parse(
            JSON.stringify(this.shortcuts.editItems.filter((x) => !x.delete))
          ),
          default: this.shortcuts.default,
        },
        view_type: this.page + "-shortcuts",
        active: true,
        restricted: false, //true,
        view_definition_id: this.shortcuts.view_definition_id,
        name: "Job catalogue Tabs",
        description: "Job catalogue Tabs",
      };
      data.definition.items.forEach((x) => {
        delete x.delete;
        delete x.isNew;
        delete x.sort_key;
      });
      axios
        .post("user/saveViewDefinition/", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (resp.data.Data) {
              if (!data.view_definition_id) {
                this.shortcuts.view_definition_id =
                  resp.data.Data.view.view_definition_id;
              }
              this.shortcuts.items = data.definition.items;
              this.shortcuts.editItems = [];
              this.setPrimaryViews(true);
              this.setViewMenuTabs();
            }
            this.shortcuts.isDirty = false;
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    async setPrimaryViews(postSave) {
      let scItems = this.shortcuts.items;
      let primaryViews = [];
      if (scItems.length) {
        primaryViews = this.views.filter((v) => {
          let sc = scItems.find((s) => s.name === v.name);
          if (sc) {
            v.definition.primary = { icon: sc.icon, position: sc.position };
            v.definition.isDefault = sc.isDefault;
            v.definition.parentTab = sc.parentTab || null;
            v.tabTitle = sc.tabTitle || sc.name;
            return true;
          } else {
            return false;
          }
        });
      } else {
        //initial setup still in use
        primaryViews = this.views.filter((v) => v.definition.primary);
        scItems = primaryViews.map((v) => {
          return {
            name: v.name,
            icon: v.definition.primary.icon,
            position: v.definition.primary.position,
            isDefault: v.definition.isDefault,
          };
        });
      }
      this.shortcuts.default = scItems.find((x) => x.isDefault)?.name;
      primaryViews.sort((a, b) =>
        a.definition.primary.position > b.definition.primary.position
          ? 1
          : a.definition.primary.position < b.definition.primary.position
          ? -1
          : 0
      );
      scItems.sort((a, b) =>
        a.position > b.position ? 1 : a.position < b.position ? -1 : 0
      );
      scItems.forEach((i) => (i.delete = false));
      if (!this.shortcuts.items.length) {
        this.shortcuts.items = scItems;
      }
      
      let iconOnly = 0;
      let full = 0;
      this.primaryTabs.forEach(t => {
        t.visible = primaryViews.some(x => x.definition.parentTab === t.key);
        if (t.other) t.visible = true;
        if (t.visible) t.title ? full++ : iconOnly++
      });
      this.primaryTabs.forEach(t => {
        t.width = "max-width: " + (!t.title ? "120px" : `calc(${100 / full}% - ${120 * iconOnly / full}px)`) + ";"
      });
      this.primaryViews = primaryViews;
      if (!postSave) {
        const visibleTabs = this.primaryTabs.filter(x => x.visible && !x.other);
        this.selectedTab = visibleTabs.find(x => x.default);
        if (!this.selectedTab && visibleTabs.length) this.selectedTab = visibleTabs[0];
        if (primaryViews.some(v => ["linked", "similarity"].some(x => x === v.definition.viewType))) {
          await this.setSimilarityData();
        }
      }
    },
    setSimilarityViews() {
        let simViews = jaCommon.setUpSimViews([], this.detailColumns, this.docTypeSummary, [], _page );

        simViews.forEach(v => 
          this.addView({ ...{ name: v.name, viewType: v.definition.linked_doc_view ? "linked" : "similarity", },
                    ...v.definition
          })
        );
    },
    async setSimilarityData() {
        if (!this.similarityData.initialised) {
          const showLinkSimilarity = (this.$loginState.user.settings.find(x => x.setting === "job_catalogue_linked_doc_similarity_show")?.value || "") === "true";
          let simStats = null;
          if (!this.useIndex) {
            const allDocs = this.$store.getters["docs/docsList"];
            const relatedDocs = [ ...new Set(allDocs.filter(x => x.relationships?.length).reduce((p,c) => p = [ ...p, ...c.relationships.map(x => x.doc_id) ], []))];
            const mainDocs = allDocs.filter(x => x.matches?.length || x.relationships?.length || relatedDocs.indexOf(x.doc_id) >= 0);
            simStats = jaCommon.prepareSimDocs(mainDocs, this.hierarchyTypes, false, showLinkSimilarity);
          } else {         
            const params = {
              filters: [ 
                { 
                  column: "doc_status",
                  exclude: true, 
                  filterValues: [ 'DELETED', 'ARCHIVED' ] 
                },
                {
                  ORFilters: true,
                  filters: [ { column: "matches_count", filterValues: [1, 999] }, { column: "relationships_count", filterValues: [1, 999] }],
                }
              ],
              pageSize: 900000,
            };
            const mainDocs_ = await this.$store.getters["docs/filter"](params);
            simStats = jaCommon.prepareSimDocs(mainDocs_, this.hierarchyTypes, false, showLinkSimilarity);
          }

          this.similarityData.matchLevels = simStats.matchLevels;
          this.similarityData.docStatuss = simStats.docStatuss;
          this.similarityData.relatedDocs = simStats.relatedDocs;
          this.similarityData.matchDocs = simStats.matchDocs;
          this.similarityData.documents = simStats.documents;
          this.similarityData.similarityColumnsName = simStats.similarityColumnsName;
          this.similarityData.similarityColumnsContent = simStats.similarityColumnsContent;
          this.similarityData.initialised = true;
          this.similarityData.showLinkSimilarity = showLinkSimilarity;
        }
    },
    async openDocListMenu(e, item, measure) {
      if (e.preventDefault) e.preventDefault();
      this.docListMenu.show = false;
      this.docListMenu.posX = e.clientX;
      this.docListMenu.posY = e.clientY;
      let JF = this.hierarchyTypes
        .filter((x) => x.ht_name.toLowerCase().indexOf("job") >= 0)
        .map((x) => {
          return {
            ht_id: x.ht_id,
            ht_name: x.ht_name,
            h_levels: x.h_levels,
            linklevel: x.linklevel,
          };
        });
      if (JF.length) JF = JF[0];

      let docs = item ? await this.getDocs(item) : this.compareDocs;
      this.docListMenu.hierarchySuggestions.hierarchyType = JF;
      this.docListMenu.hierarchySuggestions.show = true;
      this.docListMenu.matchColumn =
        measure && measure.isMatchCount ? measure.column : null;
      this.docListMenu.documentType = this.catalogueDocType.docType;
      if (this.docListMenu.matchColumn) {
        docs = docs.filter((d) => d[this.docListMenu.matchColumn].length > 0);
      }
      this.docListMenu.documents = docs.sort((a,b) => a.doc_name.toLowerCase() > b.doc_name.toLowerCase() ? 1 : a.doc_name.toLowerCase() < b.doc_name.toLowerCase() ? -1 : 0);
      this.docListMenu.title =
        measure?.description || this.catalogueDocType.docType;
      if (this.docListMenu.documents.length) {
        this.$nextTick(() => {
          this.docListMenu.show = true;
        });
      }
    },
    buildMatchItem(item, matchColumns) {
      let match = "";
      if (item)
        matchColumns?.forEach((c) => {
          match += this.buildMatchKey(c, item[c]);
        });
      return match;
    },
    matchKeyToFilterCriteria(matchKey) {
      const axes = [ ...this.verAxisAvailable, ...this.horAxisAvailable ];
      return matchKey
        .split("|")
        .filter((x, xi) => xi % 2 === 0 && x)
        .map((c, ci) => {
          return {
            column: this.getIndexAttrName(axes.find(a => a.column === c) ?? { column: c }),
            filterValues: [ matchKey.split("|")[2 * ci + 1] ]
          }
        });
    },
    async getDocs(item) {
      if (item.job_count === 0) return [];
      const match_key = item.nestedColumns?.length ?
                          item.nestedColumns[item.nestedColumns.length - 1].match_key : item.match_key;

      if (this.useIndex) {
        const params = {
          filters: this.getIndexFilterParams([ [ this.matchKeyToFilterCriteria(match_key) ] ]),
          pageSize: 500,
        }

        return this.$store.getters["docs/filter"](params);
      } else {
        const matchColumns = this.extractMatchCols(match_key);
        return this.selectedDocs.filter(
          (x) =>
            x.doc_id > 0 &&
            this.buildMatchItem(x, matchColumns) === match_key
        );
      }
    },
    openContextMenu(e, item, column) {
      this.contextMenu.item = item;
      this.contextMenu.column = column;
      e.preventDefault();
      this.contextMenu.show = false;
      this.contextMenu.posX = e.clientX;
      this.contextMenu.posY = e.clientY;
      let itemText = item[column.value];
      this.contextMenu.title = itemText;
      let actions = [];
      if (column) {
        if (
          column.filterSettings.values.some(
            (x) => x.selected && x.text === itemText
          )
        ) {
          actions.push({
            title: `Remove from Filter`,
            icon: "mdi-filter-minus-outline",
            type: "removeFilter",
            column: null,
          });
        } else {
          actions.push({
            title: `Add to filter`,
            icon: "mdi-filter-plus-outline",
            type: "addFilter",
            column: null,
          });
        }
      }
      this.contextMenu.actions = actions;
      this.$nextTick(() => {
        this.contextMenu.show = true;
      });
    },
    doContextMenuAction(action) {
      switch (action.type) {
        case "addFilter":
          this.setFilterValue(this.contextMenu.item, this.contextMenu.column);
          break;
        case "removeFilter":
          this.removeFilterValue(
            this.contextMenu.item,
            this.contextMenu.column
          );
          break;
      }
      this.contextMenu.show = false;
    },
    openDocActionsMenuContext(event, document) {
      event.preventDefault();
      let doc = { doc_id: document.doc_id };
      if (document?.isDocument) {
        doc.doc_id = _documents.find(
          (x) => x.doc_id === document.value
        )?.doc_id;
      }
      this.docActionsMenuContext.document = doc;
      this.docActionsMenuContext.posX = event.clientX;
      this.docActionsMenuContext.posY = event.clientY;
      this.docActionsMenuContext.show = false;
      this.$nextTick(() => {
        this.docActionsMenuContext.show = true;
      });
    },
    setDescriptorHeight: function (rowHeading) {
      let lines =
        rowHeading.detailIndexes.filter(
          (x) =>
            x.dIndex >= this.vScroll.dStart && this.vScroll.dEnd >= x.dIndex
        ).length;
      if (this.detAxisSelected.length === 0) {
        return "descriptor descriptor1line";
      } else if (lines < 8) {
        return "descriptor descriptor" + lines + "line";
      } else {
        return "descriptor descriptor8line";
      }
    },
    async selectView (v, statistic) {
      if (v.definition?.link) {
        let params;
        try {
          params = {
            sourcePath: "hierarchyview",
            sourceView: this.selectedView.name,
            sourceTitle: `Job Architecture - ${this.selectedView.name}`,
          };
          this.$passedParams.set(params);
        } catch (e) {
          console.log(e);
        }
        this.$router.push({ path: v.definition.link });
      } else {
        this.selectedStatistic = statistic || null;
        if (statistic) {
          this.selectedStatistic.parent_view = this.selectedView.view_definition_id;
        } else {
          const pView = this.primaryViews.find(x => x.view_definition_id === v.view_definition_id);
          if (pView?.definition.parentTab) {
            this.selectedTab = this.primaryTabs.find(x => x.key === pView.definition.parentTab);
          } else {
            this.selectedTab = null; //this.primaryTabs.find(x => x.other);
          }
        }
        if (['linked','similarity'].some(x => x === v.definition.viewType)) await this.setSimilarityData();
        this.selectedView = v;
      }
    },
    resetSelectedStatistic: function () {
      let view = this.primaryViews.find(x => x.view_definition_id === this.selectedStatistic.parent_view);
      this.selectView(view);
    },
    selectTab: function (t, reset) {
      if (!reset && t === this.selectedTab) return;
      this.selectedTab = t;
      let view = this.primaryViews.find(x => x.definition.parentTab === t.key && x.definition.default);
      if (!view) view = this.primaryViews.find(x => x.definition.parentTab === t.key);
      this.selectView(view);
    },
    setupViewMeasures: function (target, view) {
      this.setupLeafNodeMeasure(target);
      this.setupAxisMeasures(target, "verticalMeasures", view);
      this.setupAxisMeasures(target, "horizontalMeasures", view, true);
    },
    setupAxisMeasures: function (target, destination, view, excludeLeafCount) {
      target[destination] = target.measures.filter(m => m.available && (!excludeLeafCount || !m.isLeafNodeCount)).map(m => {
        let item = JSON.parse(JSON.stringify(m));
        let def = view ? view[destination]?.find(x => x.id ? m.id === x.id : m.type === x.type) : null;
        item.visible = !!def || !view;
        item.columnTitle = def?.columnTitle || item.columnTitle || item.abbreviation;
        item.alignment = def?.alignment || item.alignment || "right";
        item.displayType = this.measureDisplayTypes.find(x => x.id === (def?.displayTypeId || "value")) ; 
        item.hideSelector = def?.hideSelector || false;
        item.allowDrillDown = def?.allowDrillDown || false;
        item.drillDownTitle = def?.drillDownTitle || item.columnTitle;
        item.alertLevelGT = def?.alertLevelGT || null;
        item.alertLevelLT = def?.alertLevelLT || null;
        item.alertLevelMessage = def?.alertLevelMessage || null;
        item.highlightRules = this.decorateHighlightRules(def);
        item.drilldownMeasures = def?.drilldownMeasures || [];
        item.display_colour_id_primary = def?.display_colour_id_primary || null;
        item.display_colour_id_secondary = def?.display_colour_id_secondary || null;
        item.highlightRulesKeyVisible = def?.highlightRulesKeyVisible || false;
        item.highlightRulesKeyTextAddendum = def?.highlightRulesKeyTextAddendum || null;
        item.numberFormat = def?.numberFormat || null;
        item.drilldown = def?.drilldown || null;
        item.highLightMeasureMinimum = def?.highLightMeasureMinimum || null;
        item.highLightMeasureMinimumValue = def?.highLightMeasureMinimumValue || 0;
        item.single_comparator_text = def?.single_comparator_text || null;
        item.cssClass = "";
        return item;
      });
    },
    setupLeafNodeMeasure(target) {
      let lnMeasure = target.measures.find(x => x.isLeafNodeCount);
      const lnCol = this.leafNodeCountColumn(target);
      if (lnMeasure && lnCol) {
        lnMeasure.title = `Number of ${lnCol.name}s in Hierarchy`;
        lnMeasure.abbreviation = lnCol.name
                                  .split(" ")
                                  .filter((x) => x)
                                  .map((x) => x.substr(0, 1))
                                  .join("") + "s";
        lnMeasure.available = true;
      } else {
        lnMeasure.available = false;
        lnMeasure.visible = false;
      }
    },
    changeViewMeasure: function (collection, item) {
      let measureDefs = this.selectedView.definition[collection];
      let defIndex = measureDefs.findIndex(x => x.id ? x.id === item.id : x.type === item.type);
      let def = defIndex < 0 ? null : measureDefs[defIndex];
      if (!def && item.visible) {
        def = {
          type: item.type, 
          id: item.id, 
          displayTypeId: item.displayType.id, 
          columnTitle: item.abbreviation, 
          hideSelector: false, 
          allowDrillDown: false, 
          drillDownTitle: "", 
          alignment: "right",
          alertLevelGT: null,
          alertLevelLT: null,
          alertLevelMessage: "",
          highlightRules: [],
          drilldownMeasures: [],
          display_colour_id_primary: null,
          display_colour_id_secondary: null,
          highlightRulesKeyVisible: false, 
          highlightRulesKeyTextAddendum: "", 
          numberFormat: null,
          drilldown: null,
          highLightMeasureMinimum: null,
          highLightMeasureMinimumValue: 0,
          single_comparator_text: null,
        };
        measureDefs.push(def);
      } else if (def && !item.visible) {
        measureDefs.splice(defIndex, 1);
      } else if (def) {
        def.displayTypeId = item.displayType.id;
        def.columnTitle = item.columnTitle;
        def.hideSelector = item.hideSelector || false;
        def.allowDrillDown = item.allowDrillDown || false;
        def.drillDownTitle = item.drillDownTitle || item.columnTitle;
        def.alignment = item.alignment;
        def.alertLevelGT = item.alertLevelGT;
        def.alertLevelLT = item.alertLevelLT;
        def.alertLevelMessage = item.alertLevelMessage;
        def.highlightRules = item.highlightRules?.filter(x => !x.noHighlight) || [];
        def.drilldownMeasures = item.drilldownMeasures || [];
        def.display_colour_id_primary = item.display_colour_id_primary;
        def.display_colour_id_secondary = item.display_colour_id_secondary;
        def.highlightRulesKeyVisible = item.highlightRulesKeyVisible;
        def.highlightRulesKeyTextAddendum = item.highlightRulesKeyTextAddendum;
        def.highLightMeasureMinimum = item.highLightMeasureMinimum;
        def.highLightMeasureMinimumValue = item.highLightMeasureMinimumValue;
        def.single_comparator_text = item.single_comparator_text;
        def.numberFormat = item.numberFormat;
        def.drilldown = item.drilldown;
      }
    },
    initSetView: function () {
      this.isBuilding = true;
      this.resetIsBuilding = false;
      this.doSetView = true;
      if (this.catalogueDocType) this.setView();
    },
    async setView () {
      this.doSetView = false;
      this.resetCompare();
      this.selectedViewIndex = this.primaryViews.filter(x => !this.selectedTab || x.definition.parentTab === this.selectedTab.key).findIndex(x => x.view_definition_id === this.selectedView.view_definition_id  
        && x.name === this.selectedView.name
      );
      if (!this.selectedView.orginalDefinition)
        this.selectedView.orginalDefinition = JSON.parse(
          JSON.stringify(this.selectedView.definition)
        );
      if (['linked','similarity'].some(x => x === this.selectedView.definition.viewType)) {
        this.similarityData.updated++;
        this.isBuilding = false;
        return;
      } else if (this.selectedView.definition.viewType === "audit") {
        this.showAuditReport(this.selectedView.definition.ht_id);
        return;
      } else if (this.selectedView.definition.viewType === "audit_data") {
        this.showAuditData(this.selectedView.definition.ht_id);
        return;
      }
      if ( this.selectedView.definition.viewType === "catalogue" &&
        this.selectedView.definition.tmpl_id !== this.catalogueDocType?.tmpl_id
      ) {
        this.changeDocType();
        return;
      }
      this.selectedView.definition = { ...this.defaultViewDef(), ...this.selectedView.definition };
      let setOption_ = (possibleProps, collection) => {
        const destinationProperty = possibleProps[0]; // just to handle change of variable name
        const legacyProperty = possibleProps[1];
        const sourceProperty = this.selectedView.definition[legacyProperty] ? legacyProperty : destinationProperty;
        if (this.selectedView.definition[sourceProperty]) {
          this[destinationProperty] = [];
          this.selectedView.definition[sourceProperty].forEach((o) => {
            let usedDrilldown = o.currentDrillDownLevel;
            const def = this[collection].find((x) => x.column === o.column);
            if (def) {
              let optDef = JSON.parse(JSON.stringify(def));
              optDef.displayStyle = o.displayStyle || (collection === "horAxisAvailable" || collection === "horCompareOptions" ? _defaultHeaderColours : null);
              optDef.prefix = o.prefix || "";
              optDef.suffix = o.suffix || "";
              optDef.overrideTitle = o.overrideTitle || "";
              optDef.detailHeadingVisible = o.detailHeadingVisible || false;
              optDef.valueDisplayType = o.valueDisplayType || "text";
              optDef.containerColumn = o.containerColumn || null;
              optDef.containerColumnShowRange = (o.containerColumn && o.containerColumnShowRange) || false;
              optDef.containerColumnGroupMeasure = (o.containerColumn && o.containerColumnGroupMeasure) || null;
              optDef.valueIcon = o.valueIcon || null;
              optDef.chartDisplayRange = o.chartDisplayRange || false;
              optDef.chartDisplayRangeQuantity = o.chartDisplayRangeQuantity || 0;
              optDef.nodeActionsAlignment = o.nodeActionsAlignment || "right";
              optDef.nodeSelectable = o.nodeSelectable || false;
              optDef.showDescriptor = o.showDescriptor || false;
              optDef.descriptorEditable = (o.showDescriptor && o.descriptorEditable) || false;
              if (usedDrilldown !== undefined) {
                o.currentDrillDownLevel = 1;
                optDef.currentDrillDownLevel = 1;
                optDef.displayStyle = null;
              } else delete o.currentDrillDownLevel;
              this[destinationProperty].push(optDef);
              // if (usedDrilldown !== undefined) o.currentDrillDownLevel = 1;
            }
          });
        }
        if (sourceProperty === legacyProperty) { // clean up old name
          this.selectedView.definition[destinationProperty] = this.selectedView.definition[legacyProperty];
          delete this.selectedView.definition[legacyProperty]; 
        }
      };
      setOption_(["horAxisSelected","horCompareOptions"], "horAxisAvailable");
      setOption_(["verAxisSelected","verCompareOptions"], "verAxisAvailable");
      setOption_(["detAxisSelected","detCompareOptions"], "detAxisAvailable");
      const isStatisticView = !!this.selectedStatistic;
      let statFilters = this.selectedStatistic?.filters?.length ? this.selectedStatistic.filters : [];
      let attrFilters = !isStatisticView && this.selectedView.definition.attributeFilters.length ? this.selectedView.definition.attributeFilters : [];
      this.verAxisAvailable.forEach((c) => {
        let statFilter = statFilters.find((x) => x.column === c.column);
        let preset = attrFilters.find((x) => x.column === c.column);
        c.filterValues = statFilter ? statFilter.filterValues : preset ? preset.filterValues : [];
        c.visible = !!statFilter  || (this.selectedView.definition.visibleFilters ? this.selectedView.definition.visibleFilters.some(v => v.column === c.column) : false);
      });
      this.scopeHierarchyPickerTrees(this.selectedView.definition.tmpl_id);
      const hpDefs = (!isStatisticView && this.selectedView.definition.hierarchyPickers) || [];
      this.hierarchyPickerFilters.forEach((h) => {
        const def = hpDefs.find((x) => x.ht_id === h.ht_id);
        h.included = !!def?.included;
        // resolve saved nodes through nodeMap so renamed nodes get fresh
        // names and deleted nodes are dropped
        h.selectedNodes = (def?.selected || [])
          .map((n) => h.nodeMap[n.node_id])
          .filter((n) => n);
        h.selected = h.selectedNodes.map((n) => n.node_id);
      });
      this.prepareMeasureFiltersCurrent();
      let statMeas = null;
      if (this.selectedStatistic?.criteriaMeasure) {
        const statMeasures = this.getStatisticMeasures(this.selectedView.view_definition_id);
        statMeas = statMeasures.find(x => x.name === this.selectedStatistic.criteriaMeasure);
      }
      this.measureFilterTypes.forEach((c) => {
        c.filters.filter(f => f).forEach(f => { f.rangeFrom = null; f.rangeTo = null; });
        let preset = !isStatisticView ? this.selectedView.definition.measureFilterTypes?.find(
          (x) => x.axis === c.axis
        ) : null;
        if (preset) {
          preset.filters.filter(f => f).forEach(p => {
            const e = c.filters.find(x => x && x.type === p.type);
            if (e) {
              e.aggregation = p.aggregation;
              e.rangeFrom = p.rangeFrom;
              e.rangeTo = p.rangeTo;
            }
          });
        }
        if (statMeas?.axis === c.axis) {
          const e = c.filters.find(x => x && x.id === statMeas.id);
          if (e) {
            let from = Number(this.selectedStatistic.criteriaValue);
            let to = Number(this.selectedStatistic.criteriaValue);
            if (this.selectedStatistic.criteriaComparator === ">=") 
              to = null;
            if (this.selectedStatistic.criteriaComparator === "<=") 
              from = null;
            // e.aggregation = statMeas.aggregation;
            e.rangeFrom = from;
            e.rangeTo = to;
          }
        }
        // c.visible = this.selectedView.definition.visibleFilters ? this.selectedView.definition.visibleFilters.some(v => v.column === c.column) : false;        
      });
      // this.drilldownFilters = [];
      if (this.selectedView.definition.displayAs.indexOf('grid') >= 0)
        await this.selectJDs(true);
      else {      
        this.resetIsBuilding = true;
        this.isBuilding = false;
      }
      this.displayView();
    },
    assignHierarchy: function (data) {
      let possibleError = false;
      this.isSaving = true;
      let self = this;
      axios
        .post("document/saveSuggestedDocHierarchy/", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (resp.data.Data) {
              if (resp.data.Data.docs?.length) {
                self.afterDocumentUpdate(self, resp.data.Data.docs);
              }
              if (data.callback) data.callback(data.doc_id);
            }
          }
          this.response = resp.data;
          this.isSaving = false;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.isSaving = false;
        });
    },
    removeFromDocList: function (doc) {
      let index = this.compareDocs.findIndex((x) => x.doc_id === doc.doc_id);
      if (index >= 0) {
        this.compareDocs.splice(index, 1);
      }
    },
    editAttributes: function (item) {
      let attr = this.attributes.find((x) => x.column === item.column);
      if (!attr) return;
      this.attributeAdmin.attribute = attr;
      this.attributeAdmin.rawValues = attr.lookup_key ? [] : item.listValues;
      this.attributeAdmin.show++;
    },
    lookupUpdated: function (values) {
      let column = this.attributeAdmin.attribute.column;
      let co = this.verAxisAvailable.find((x) => x.column === column);
      if (!co) return;
      co.listValues = values;
      this.attributeAdmin.attribute.values = values;
      if (
        this.verAxisSelected.some((o) => o.column === column) ||
        this.horAxisSelected.some((o) => o.column === column)
      ) {
        this.verAxisSelected
          .filter((o) => o.column === column)
          .forEach((o) => o.listValues);
        this.horAxisSelected
          .filter((o) => o.column === column)
          .forEach((o) => o.listValues);
        this.selectJDs();
      }
    },
    lookupCreated: function (values) {
      this.attributeAdmin.attribute.lookup_type = "List Value";
      this.attributeAdmin.attribute.lookup_key =
        this.attributeAdmin.attribute.title;
      this.lookupUpdated(values);
    },
    dragStart: function (event, item) {
      this.dragItem = item;
    },
    allowDrop: function (event, bucket) {
      if (
        !bucket ||
        !bucket.subject ||
        bucket.subject === this.dragItem.node.label
      )
        event.preventDefault();
    },
    addAddition: function (event, bucket) {
      if (event) event.preventDefault();
      if (this.dragItem) {
        if (!bucket.subject) bucket.subject = this.dragItem.node.label;
        bucket.additions.push(this.dragItem);
        // this.dragItem.node.actionPending = true;
        this.setPendingNodes([this.dragItem.node.hierarchy_node_id], true);
      }
    },
    removeAddition: function (bucket, node) {
      //   node.actionPending = false;
      bucket.additions = bucket.additions.filter(
        (x) => x.node.hierarchy_node_id !== node.hierarchy_node_id
      );
      this.setPendingNodes([node.hierarchy_node_id], false);
    },
    removeAdditionAll: function (bucket) {
      this.setPendingNodes(
        bucket.additions.map((a) => a.node.hierarchy_node_id),
        false
      );
      //   bucket.additions.forEach((a) => (a.node.actionPending = false));
      bucket.additions.splice(0, bucket.additions.length);
    },
    removeAdditionNode: function (node) {
      let bucket = this.dragTarget.buckets.find((b) =>
        b.additions.some(
          (a) => a.node.hierarchy_node_id === node.hierarchy_node_id
        )
      );
      if (bucket) this.removeAddition(bucket, node);
    },
    addBucketPlus: function (event) {
      let bucket =
        this.dragTarget.buckets.length === 1 &&
        this.dragItem.node.label === this.dragTarget.buckets[0].subject
          ? this.dragTarget.buckets[0]
          : this.addBucket();
      this.addAddition(event, bucket);
    },
    addBucket: function () {
      let bucket = {
        title: "Workspace " + (this.dragTarget.buckets.length + 1),
        edit: false,
        show: true,
        subject: this.dragItem ? this.dragItem.node.label : null,
        additions: [],
      };
      this.dragTarget.buckets.push(bucket);
      return bucket;
    },
    removeBucket: function (bucket) {
      this.removeAdditionAll(bucket);
      this.dragTarget.buckets = this.dragTarget.buckets.filter(
        (x) => x.title !== bucket.title
      );
    },
    setPendingNodes: function (hierarchy_node_ids, actionPending) {
      if (this.detAxisSelected.some((o) => o.noderule)) {
        this.rowDetails.forEach((r) =>
          r.columns.forEach((c) =>
            c.subColumns.forEach((s) =>
              s.zRows.forEach((t) =>
                t.rowHeadings
                  .filter(
                    (h) =>
                      h.node &&
                      hierarchy_node_ids.some(
                        (id) => id === h.node.hierarchy_node_id
                      )
                  )
                  .forEach((h) => {
                    h.node.actionPending = actionPending;
                  })
              )
            )
          )
        );
      }
    },
    moveBucket: function (bucket) {
      let node = bucket.additions[0].node;
      let action = {
        action: "move",
        actionDef: {
          title: "Move " + bucket.subject + "s",
          type: "move",
          newLevel: node.level,
          newLevelName: node.level_name,
          currentLevel: node.level,
          currentLevelName: node.level_name,
          column: null,
        },
        node: null,
        listviewColumn: null,
        listviewItem: null,
      };
      this.setUpEditHierarchy(
        null,
        "move",
        action,
        bucket.additions.map((a) => a.node),
        bucket
      );
    },
    getOptionsAvailable: function (axis) {
      let opts = [
        {
          name: "vertical",
          available: this.verAxisAvailable,
          used: this.verAxisSelected,
          valueLimit: 0,
        },
        {
          name: "horizontal",
          available: this.horAxisAvailable,
          used: this.horAxisSelected,
          valueLimit: 0, //100,
        },
        {
          name: "detail",
          available: this.detAxisAvailable,
          used: this.detAxisSelected,
          valueLimit: 0,
        },
      ];
      let dim = opts.find((x) => x.name === axis);
      return dim.available.filter(
        (x) =>
          (!dim.valueLimit ||
            !x.listValueLength ||
            x.listValueLength <= dim.valueLimit) &&
          opts.every((nd) => !nd.used.some((u) => u.column === x.column))
      );
    },
    getOptionsUsed: function (axis) {
      let opts = [
        {
          name: "vertical",
          available: this.verAxisAvailable,
          used: this.verAxisSelected,
          valueLimit: 0,
        },
        {
          name: "horizontal",
          available: this.horAxisAvailable,
          used: this.horAxisSelected,
          valueLimit: 0, //100,
        },
        {
          name: "detail",
          available: this.detAxisAvailable,
          used: this.detAxisSelected,
          valueLimit: 0,
        },
      ];
      let dim = opts.find((x) => x.name === axis);
      return dim.used.filter(
        (x) => !x.containerColumn
      );
    },
    exportToExcel() {
      let layout = this.layout;
      const axes = this.prepareAxes();
      let data = {
        rows: [],
        name: this.selectedView.name,
        freeze: { xSplit: 0, ySplit: 0 },
        colWidths: [],
      };
      let leftPanelColsNewRow = [];
      let vheaderCols = [];

      let addRow = (cols) => {
        data.rows.push({ cols: cols ? cols : [] });
        return data.rows[data.rows.length - 1];
      };

      let copyRow = () => {
        let cols = JSON.parse(
          JSON.stringify(data.rows[data.rows.length - 1].cols)
        );
        cols.forEach((c) => (c.mergeRows = 1));
        return addRow(cols);
      };

      let currentRow = (add) => {
        if (add)
          return addRow(
            leftPanelColsNewRow.map((x) => JSON.parse(JSON.stringify(x)))
          );
        else return data.rows[data.rows.length - 1];
      };

      const addCol = (
        target,
        type,
        text,
        mergeCols,
        style,
        indent,
        mergeRows,
        border
      ) => {
        target.push({
          type: type || "",
          text: text || "",
          mergeCols: mergeCols || 0,
          style: style || null,
          indent: indent || 0,
          mergeRows: mergeRows || 0,
          border: border || null,
        });
      };
      // if (layout && layout.headerRow) {
        if (layout.leftPanel.cols) {
          const vAxisHeadingWidth = layout.rightPanel.cols ? (300 * layout.leftPanel.cols) / 12 : 200;
          const titleRatio =
            (vAxisHeadingWidth * layout.leftPanel.colsTitle) / 12;
          const measureRatio =
            (vAxisHeadingWidth * layout.leftPanel.colsTotal) / 12;
          // iterate the layout's title columns (not verAxisSelected) so derived
          // columns like listview descriptors keep headers and cells aligned
          (layout.detailRow.rowHeading.titleWidths || []).forEach((tw) => {
            addCol(vheaderCols, "axis-heading-rows", tw.title, null, null);
            if (layout.rightPanel.cols) data.freeze.xSplit++;
            data.colWidths.push((titleRatio * tw.cols) / 12);
          });
          
          if (layout.leftPanel.colsTotal && this.verticalMeasures.length) {
            this.verticalMeasures.filter(m => m.visible).forEach((m, mi) => {
              addCol(vheaderCols, "axis-heading-rows", m.title);
              if (layout.rightPanel.cols) data.freeze.xSplit++;
              data.colWidths.push(
                (measureRatio *
                  layout.detailRow.rowHeading.measureWidths[
                    mi
                  ].cols) /
                  12
              );
            });
          }
          data.rows.push({
            cols: vheaderCols,
          });
          vheaderCols.forEach((hc) => {
            addCol(leftPanelColsNewRow, "", "", null, hc.style, 0, 1);
          });
        }
        
        let detailColumnCount = 0;
        if (layout.rightPanel.cols) {
					// detailColumnCount = layout.detailRow.detail.widthSplitMeasures.length + this.horizontalMeasures.filter(m => m.visible).length;
          detailColumnCount = axes.zNested.length + this.horizontalMeasures.filter(m => m.visible).length;
          if (!data.rows.length) addRow();
          addCol(
            data.rows[0].cols,
            "axis-heading-columns",
            this.horAxisSelected
              .map((hc) => this.getCompareOptionDef(hc, "horAxisAvailable").name)
              .join(" > "),
            -1,
            null,
            1
          );
        }
        let getNestedWidth = (item) => {
          let tot = 0;
          if (item.children.length) {
            item.children.forEach((c) =>
              (tot += getNestedWidth(c))
            );
          } else {
            tot = 1;
          }
          return tot;
        };

        let maxMergeCols = 0;
        let detailsStartRow = 0;
        let detailsEndRow = 0;
        let currenSourceIndex = -1;
        let processNestedColumns = (
          columns,
          targetRow,
          horHeaderRowIndex,
          colType,
          showMeasures,
          showDetails,
          detailsCount,
          sourceIndex
        ) => {
          columns.forEach((hc, hci) => {
            if (colType === "detail" && (hc.zContainer || !hc.children.length)) {
              if (currenSourceIndex < sourceIndex) {
                detailsStartRow = data.rows.length - 1;
                detailsEndRow = detailsStartRow;
                for (let i = 1; i < detailsCount; i++) {
                  copyRow();
                  detailsEndRow++;
                }
                currenSourceIndex = sourceIndex;
              }
              let index = 0;
              for (let i = detailsStartRow; i <= detailsEndRow; i++) {
                let row = data.rows[i];
                let det = hc.children.length > index ? hc.children[index] : null;
                let border = { right: true };
                if (i === detailsEndRow) border.bottom = true;
                let div = axes.zNested.length || 1;
                axes.zNested.forEach((z, zi) => {
                  let cell = "";
                  if (det) {
                    let dc = det.headerColumns[zi];
                    cell = dc.title;
                    dc.nestedColumns.forEach(nc => cell += "\r\n" + nc.title);
                  }
                  let bdr = { ...{}, ...border };
                  if (zi < axes.zNested.length - 1) delete bdr.right;
                  addCol(
                    row.cols,
                    colType,
                    cell,
                    null,
                    null,
                    null,
                    null,
                    bdr
                  );
                  data.colWidths.push(this.display.h_col.colWidth * 17 * layout.detailRow.detail.widthSplitTitle / div);
                });
                index++;
                this.horizontalMeasures.filter(m => m.visible).forEach((m, mi) => {
                  // let prop = m.type + (m.aggregation === "mean" ? "_mean" : "");
                  addCol(
                    row.cols,
                    colType + "-measure",
                    det ? det[m.id] : hc[m.id] || "",
                    null,
                    null,
                    null,
                    null,
                    border
                  );
                  data.colWidths.push(this.display.h_col.colWidth * 17 * layout.detailRow.detail.widthSplitMeasures[mi]);
                });
              }
              return;
            } else if (hc.children?.length) {
              let row = targetRow;
              let nextHRIndex = horHeaderRowIndex
                ? horHeaderRowIndex + 1
                : horHeaderRowIndex;
              if (nextHRIndex) {
                row =
                  data.rows.length > nextHRIndex
                    ? data.rows[nextHRIndex]
                    : currentRow(true);
              }
              processNestedColumns(
                hc.children,
                row,
                nextHRIndex,
                colType,
                showMeasures,
                showDetails,
                hci === 0 ? detailsCount : 0,
                sourceIndex
              );
            } else {
              if (showMeasures) {
                const visVertMeasures = this.verticalMeasures.filter(m => m.visible);
                visVertMeasures.forEach((m, mi) => {
                  let border = mi === visVertMeasures.length - 1 ?  { right: true } : null;
									// let prop = m.type + (m.aggregation === "mean" ? "_mean" : "");
                  addCol(
                    targetRow.cols,
                    colType + "-measure",
                    hc[m.id],
                    null,
                    null,
                    null,
                    null,
                    border
                  );
                data.colWidths.push(this.display.h_col.colWidth * 17 * layout.detailRow.detail.widthSplitMeasures[mi]);
                });
              }
            }
            if (!showDetails && !showMeasures) {

							let mergeCols = (hc.children?.length
								? getNestedWidth(hc)
								: 0) * detailColumnCount; 
							if (mergeCols === 0 && detailColumnCount > 1 && horHeaderRowIndex) mergeCols = detailColumnCount;
              let text = hc.visible === false ? "" : hc.title || "";
              if (colType === "column-heading") {
                text = hc.headerColumns[0].title;
              }
              if (hc.nestedColumns) {
                hc.nestedColumns.forEach(nc => text += "\r\n" + nc.title);
              }
              addCol(
                targetRow.cols,
                colType,
                text,
                mergeCols,
                hc.style,
                null,
                hc.visible === false ? 1 : 0
              );
              maxMergeCols += mergeCols;
            }
          });
        };
        if (layout.rightPanel.cols && layout.headerRow) {
          let hHeadRow = currentRow(true);
          processNestedColumns(
            layout.headerRow.columnsSett,
            hHeadRow,
            data.rows.length - 1,
            "column-heading"
          );
        }
        if (layout.detailRow) {
          this.settData.forEach((r, ri) => {
            let row = addRow();
            if (layout.leftPanel.cols > 0) {
              processNestedColumns(
                r.headerColumns,
                currentRow(),
                false,
                "row-heading"
              );
              this.verticalMeasures.filter(m => m.visible).forEach((m) => {
									// let prop = m.type + (m.aggregation === "mean" ? "_mean" : "");
                addCol(row.cols, "row-heading-measure", r[m.id]);
              });
            }
            if (layout.rightPanel.cols > 0) {
              // let rowDetail = this.rowDetails[ri];
              processNestedColumns(
                r.children,
                currentRow(),
                false,
                "detail",
                true,
                this.detAxisSelected.length > 0,
                r.detailCount,
                ri
              );
            }
          });
        }
        // if (layout.rightPanel.cols) {
        // }
        let colsToMerge = data.rows[0].cols.map((c) => {
          if (c) return { col: null };
        });

        data.rows.forEach((r) => {
          r.cols
            .filter((c, ci) => ci < colsToMerge.length)
            .forEach((c, ci) => {
              if (!c.mergeRows) {
                colsToMerge[ci].col = c;
              } else {
                colsToMerge[ci].col.mergeRows += c.mergeRows;
                c.mergeRows = 0;
              }
            });
        });

        data.rows.forEach((r) =>
          r.cols
            .filter((c) => c.mergeCols === -1)
            .forEach((c) => (c.mergeCols = maxMergeCols))
        );

        data.freeze.ySplit += data.rows.filter((r) =>
          r.cols.some((c) =>
            [
              "column-heading",
              "axis-heading-columns",
              "axis-heading-rows",
            ].some((x) => x === c.type)
          )
        ).length;
      // }
      data.colWidths.splice(
        data.rows[data.rows.length - 1].cols.length,
        data.colWidths.length
      );
      axios
        .post(`document/generateExcel`, data, {
          responseType: "arraybuffer",
        })
        .then((resp) => {
          const fileName = `${this.$loginState.user.client.replace(
            /[^a-z0-9]/gi,
            ""
          )}_${this.selectedView.name.replace(/[^a-z0-9]/gi, "")}.xlsx`;
          utils.downloadFile(resp.data, fileName, resp.headers["content-type"]);
        })
        .catch((error) => {
          console.log(error);
          this.response = {
            Status: "Error",
            Message: `Error generating permission summary`,
          };
        });
    },
    setDetailHeadings(layout) {
      if (this.detAxisSelected.some(x => x.detailHeadingVisible) || this.selectedView.definition.horizontalHeadingVisible) {
        let visibleZCols = this.detAxisSelected.filter(x => !x.containerColumn);
        layout.headerRow.detailHeadings = {
          titles: visibleZCols.map((o, oi) => {
            return {
              name: o.overrideTitle || o.name,
              visible: o.detailHeadingVisible,
              cols: layout.detailRow.detail.titleWidths[oi].cols,
              percent: layout.detailRow.detail.titleWidths[oi].percent,
              px: layout.detailRow.detail.titleWidths[oi].px,
              key: layout.detailRow.detail.titleWidths[oi].key,
              overridden: layout.detailRow.detail.titleWidths[oi].overridden,
            }
          }),
          titleSectionWidth: layout.detailRow.rowHeading.titleSectionWidth,
          measures: layout.detailRow.detail.measureWidths,
          measureSectionHeadingStyle: layout.detailRow.detail.measureSectionHeadingStyle,
          cssClass: "x-rowHeader" + layout.gridLineClass,
        };
        layout.rightPanel.horizontalHeadingVisible = true;

      // } else if (this.selectedView.definition.horizontalHeadingVisible) {
      //   layout.headerRow.detailHeadings = {
      //     titles: [],
      //     titleSectionWidth: layout.detailRow.rowHeading.titleSectionWidth,
      //     measures: layout.detailRow.detail.measureWidths,
      //     measureSectionHeadingStyle: layout.detailRow.detail.measureSectionHeadingStyle,
      //     cssClass: "x-rowHeader" + layout.gridLineClass,
      //   };
      } else if (layout.headerRow) {
        layout.headerRow.detailHeadings = null;
      }
    },
    // editMeasure(item, axis) {
    //   this.measureEditDialogue.show = true;
    //   this.measureEditDialogue.measure = item;
    //   this.measureEditDialogue.displayType = item.displayType;
    //   this.measureEditDialogue.columnTitle = item.columnTitle;
    //   this.measureEditDialogue.hideSelector = item.hideSelector || false;
    //   this.measureEditDialogue.alignment = item.alignment;
    //   this.measureEditDialogue.alertLevelGT = item.alertLevelGT;
    //   this.measureEditDialogue.alertLevelLT = item.alertLevelLT;
    //   this.measureEditDialogue.alertLevelMessage = item.alertLevelMessage;
    //   this.measureEditDialogue.axis = axis;
    // },
    // editMeasureSave() {
    //   this.saveMeasure(this.measureEditDialogue.measure, this.measureEditDialogue, this.measureEditDialogue.axis);
    //   this.measureEditDialogue.columnTitle = null;
    //   this.measureEditDialogue.axis = null;
    //   this.measureEditDialogue.alignment = "right";
    //   this.measureEditDialogue.show = false;
    // },
    highlightRulesKeys() {
      let keyLegends = [];
      const lowSampleTitle = "Low sample";
      ["verticalMeasures", "horizontalMeasures"].forEach(mt => {
        this[mt].filter(x => x.visible && x.highlightRulesKeyVisible && x.highlightRules.length).forEach(m => {
          let keyLeg = keyLegends.find(x => x.name === m.title);
          const title = `Key - ${m.title}` + (m.highlightRulesKeyTextAddendum ? ` : ${m.highlightRulesKeyTextAddendum}` : "");
          if (!keyLeg) {
            keyLeg = {
              name: m.title,
              title: title,
              addendum: m.highlightRulesKeyTextAddendum,
              values: m.highlightRules.reduce((p,c) => {
                if (!p.some(x => x.description === c.description)) {
                  p.push(c);
                }
                return p;
              }, []),
            };
            keyLegends.push(keyLeg);
          } else {
            m.highlightRules
              .filter(h => !keyLeg.values.some(k => k.description === h.description))
              .forEach(h => keyLeg.values.push(h));
            if (!keyLeg.addendum && m.highlightRulesKeyTextAddendum) {
              keyLeg.title = title;
              keyLeg.addendum = m.highlightRulesKeyTextAddendum;
            }
          }
        });
      });
      if (keyLegends.length === 1) {
        keyLegends[0].title = `Key` + (keyLegends[0].addendum ? ` : ${keyLegends[0].addendum}` : "");
      }
      this.keyLegends = keyLegends;
    },
    saveMeasure(measure, updates, axis) {
      measure.displayType = updates.displayType;
      measure.columnTitle = updates.columnTitle;
      measure.hideSelector = updates.hideSelector;
      measure.allowDrillDown = updates.allowDrillDown;
      measure.drillDownTitle = updates.drillDownTitle;
      measure.alignment = updates.alignment;
      measure.alertLevelGT = updates.alertLevelGT;
      measure.alertLevelLT = updates.alertLevelLT;
      measure.alertLevelMessage = updates.alertLevelMessage;
      measure.highlightRules = this.decorateHighlightRules(updates);
      measure.drilldownMeasures = updates.drilldownMeasures || [];
      measure.display_colour_id_primary = updates.display_colour_id_primary;
      measure.display_colour_id_secondary = updates.display_colour_id_secondary;
      measure.highlightRulesKeyVisible = updates.highlightRulesKeyVisible;
      measure.highlightRulesKeyTextAddendum = updates.highlightRulesKeyTextAddendum;
      measure.highLightMeasureMinimum = updates.highLightMeasureMinimum;
      measure.highLightMeasureMinimumValue = updates.highLightMeasureMinimumValue;
      measure.single_comparator_text = updates.single_comparator_text;
      measure.numberFormat = updates.numberFormat;
      measure.drilldown = updates.drilldown;
      if (axis === "vertical") this.applyMeasureDefaultSort(measure, updates.defaultSort);
      this.changeViewSetting('changeViewMeasure', axis + "Measures", measure);
    },
    decorateHighlightRules(measure) {
      let rules = measure?.highlightRules || [];
      rules.forEach(r => {
        const col = this.clientColours.find(c => c.display_colour_id === r.display_colour_id);
        if (col) 
          r.style = { 
            backgroundColor: col.background_colour,
            color: col.text_colour,
          };
      });
      if (rules.length && measure.highLightMeasureMinimum && measure.highLightMeasureMinimumValue) {
        const lowSampleTitle = "Low sample";
        const title = `${lowSampleTitle} (headcount < ${measure.highLightMeasureMinimumValue})`;
        if (!rules.some(x => x.description === title)) {
          rules.push({
            description: title, 
            noHighlight: true,
            style: { backgroundColor: "#EEEEEE", color: "gray !important" },
          });
        }
      }
      return rules;
    },
    defaultViewSection(item) {
      return {        
          type: item?.type || "bar_chart",
          xAxis: item?.xAxis,
          yAxis: item?.yAxis,
          measure: item?.measure,
          useRange: item?.useRange || false,
          rangeQuantity: item?.rangeQuantity || 0,
          xAxisPrefix: item?.xAxisPrefix || "",
          yAxisPrefix: item?.yAxisPrefix || "",
          filtersVisible: item?.filtersVisible || [],
          title: item?.title || "",
          displayTitle: "",
          description: item?.description || "",
          colPosition: item?.colPosition || 1,
          rowPosition: item?.rowPosition || 1,
          colWidth: item?.colWidth || null,
          rowHeight: item?.rowHeight || 1,
          index: item?.index || this.selectedView.definition.viewSections.length,
          icon: item?.icon || null,
          backgroundColour: item?.backgroundColour || '#EEEEEE',
          iconColour: item?.iconColour || '#010101',
          iconDisplay: { icon: item?.icon || null, colour: item?.iconColour || '#010101'},
          useStatusIcon: item?.useStatusIcon || false,
          link: item?.link || null, 
          linkTitle: item.linkTitle || "",
          view: item?.view || null,
          criteriaMeasure: item?.criteriaMeasure || null,
          criteriaComparator: item?.criteriaComparator || null,
          criteriaValue: item?.criteriaValue || null,
          displayBasis: item?.displayBasis || null,
          filters: item?.filters || [],
          includeWarningTrigger: item?.includeWarningTrigger || null,
          includeErrorTrigger: item?.includeErrorTrigger || null,
          includeGoodTrigger: item?.includeGoodTrigger || null,
          includeWarningTriggerComparator: item?.includeWarningTriggerComparator || null,
          includeErrorTriggerComparator: item?.includeErrorTriggerComparator || null,
          includeGoodTriggerComparator: item?.includeGoodTriggerComparator || null,
          hideZeroStatistic: item?.hideZeroStatistic || false,
          isEdited: false,
      }
    },
    async displayView(statChanged) {
      this.viewSectionsLayout.splice(0, this.viewSectionsLayout.length);
      this.viewSectionsDesign.splice(0, this.viewSectionsDesign.length);
      this.setupViewMeasures(this, this.selectedView.definition);
      // setupViewMeasures recreates the measure objects, losing the widths stamped
      // on them by processDetails; re-stamp from the layout before Vue re-renders
      this.applyMeasureWidths();
      const chartTypes = ["bar_chart", "pie_chart"];
      let viewSections = await Promise.all(this.selectedView.definition.viewSections.map(async (vs, vi) => {
        let v = JSON.parse(JSON.stringify(vs));
        v.index = vi;
        v.rowPosition = Number(v.rowPosition);
        v.colPosition = Number(v.colPosition);
        v.colWidth = v.colWidth ? Number(v.colWidth) : null;
        if (chartTypes.some(x => x === v.type)) {
          let chartDef = this.populateChartDef(this.defaultViewSection(v));
          chartDef.index = vi;
          return chartDef
        } else if (v.type === "statistic") {
          this.setStatisticProperties(v, v);
          v = await this.populateStatistic(v, statChanged);
        }
        return v;
      }));
      // viewSections = viewSections.filter(x => !x.hideSection);
      
      const prepSetion = (vSections) => {
        let sections = [];
        vSections.sort((a,b) => 
          (a.rowPosition > b.rowPosition ? 10 : a.rowPosition < b.rowPosition ? -10 : 0) +
            (a.colPosition > b.colPosition ? 1 : a.colPosition < b.colPosition ? -1 : 0)
        ).forEach(v => {
            let row = sections.find(x => x.row === v.rowPosition);
            if (!row) {
              row = { row: v.rowPosition, height: v.rowHeight || 1, cols: [] };
              sections.push(row);
            }
            let col = row.cols.find(x => x.col === v.colPosition);
            if (!col) {
              col = { col: v.colPosition, colWidth: v.colWidth, sections: [] };
              row.cols.push(col);
            }
            col.sections.push(v);
        });
        return sections;
      }
      this.viewSectionsDesign = prepSetion(viewSections);
      this.viewSectionsLayout = prepSetion(viewSections.filter(x => !x.hideSection));
      this.clearViewSectionEdit();
      this.setVScrollPageHeight();
    },
    async filterChanged(event) {  
      await this.selectJDs(false, event);
      this.setVScrollPageHeight();
    },
    clearViewSectionEdit() {
      this.chartEdit.show = false;
      this.taskEdit.show = false; 
      this.statisticEdit.show = false; 
      this.selectedView.definition.viewSections.forEach(s => s.isEdited = false);
    },
    async getAggregateFromIndex(measureDef, filters, criteriaComparator, criteriaValue, attributes) {
      let result = null;
      const getCacheCol = (colName) => (attributes ? attributes.find(x => x.column === colName)?.cache_column : null) || colName;
      let postChecks = [];
        const indexGroupByParams = [{
          groupBy: [ 
            { attr: "tmpl_id", as: "tmpl_id" },
          ],
          aggregates: [{ type: "COUNT", as: "count" }],
          filters: [
            ...filters.filter(x => x.column !== 'age_months' && (!x.filterComparator || x.filterComparator === "=")),
            ...filters.filter(x => x.column === 'age_months' && [">=", "<="].some(c => c === x.filterComparator))
              .map(x => {
                if (x.filterComparator === ">=")
                  return { column: "job_created_at", filterValues: [dayJS(1970, 1, 1), dayJS().subtract(Number(x.filterValue), 'month') ] }
                else
                  return { column: "job_created_at", filterValues: [dayJS().subtract(Number(x.filterValue), 'month'), dayJS() ] }
              }),
          ],
        }];
        filters.filter(x => x.filterComparator && x.filterComparator !== "=" && x.column !== 'age_months')
          .forEach(f => {
            indexGroupByParams[0].groupBy.push({ attr: getCacheCol(f.column), as: f.column});
            postChecks.push({ column: f.column, def: f, });
          });
        if (measureDef?.column) {
          if (criteriaComparator === "=")
            indexGroupByParams[0].filters.push({ column: measureDef.column, filterValues: [criteriaValue, criteriaValue], });      
          else if (criteriaComparator === ">=") 
            indexGroupByParams[0].filters.push({ column: measureDef.column, filterValues: [criteriaValue, 99999999999], });        
          else if (criteriaComparator === "<=") 
            indexGroupByParams[0].filters.push({ column: measureDef.column, filterValues: [0, criteriaValue], });
        }
        indexGroupByParams[0].filters.forEach(x => x.column = getCacheCol(x.column));
        if (indexGroupByParams[0].groupBy.length) {
          this.inProgressIndexRequests++;
          await this.$store.getters['docs/getDocIndexGroupBy'](indexGroupByParams)
            .then(resp => {
              this.inProgressIndexRequests--;
              if (resp.length) {
                let data = resp[0].values;
                postChecks.forEach(f => {
                  data = data.filter(x => {
                    let val = x[f.column];
                    if (val) val = Number(val);
                    if (f.def.filterComparator === ">=") return val >= Number(f.def.filterValue);
                    if (f.def.filterComparator === "<=") return val <= Number(f.def.filterValue);
                  });
                });
                result = data.length ? data.reduce((p,c) => c.count + p, 0) : 0;
              }
            });
        }
        return result || 0;
    },
    async populateStatistic(stat, defChanged) {
      if (!this.processedStatistics || defChanged) this.processedStatistics = [];
      const existing = this.processedStatistics.find(x => x.index === stat.index);
      if (existing) {
        stat = {...stat, ...existing};
        return stat;
      }
      let def = this.views.find(x => x.view_definition_id === stat.view)?.definition;
      let val = 0;
      let contentOnly = false;
      if (def?.viewType === "similarity") {
        let total = 0;
        if (stat.displayBasis === "percent") {
          total = _documents.filter(d => d.tmpl_id === def.tmpl_id && d.job_count && def.statuses.some(s => s === d.doc_status)).length;
          if (this.useIndex) total = await this.getAggregateFromIndex(null, [ {column: "tmpl_id", filterValues: [def.tmpl_id] }, { column: "doc_status", filterValues: def.statuses.map(s => s.doc_status) }], null, null, null);                
        }
        val = jaCommon.filterSimilarity(def, this.similarityData.documents, this.similarityData.matchLevels).length;
        let title = val !== 1 && stat.displayBasis !== "percent" ? utils.pluralise(stat.title) : stat.title;
        if (stat.displayBasis === "percent" && total) val = Math.round(100 * val / total);
        stat.displayTitle = title.replace("{{0}}", val);
      } else if (def) {
        let filters = [];
        if (stat.filters?.length) {
          filters = stat.filters.filter(a => a.filterValues?.length).map(a => {
            return {
              column: a.column.endsWith("_nodeID") ? a.column.replace("_nodeID", "_") : a.column,
              filterValues: a.filterValues, 
            }
          });
          stat.filters.filter(a => !a.filterValues?.length && a.filterValue && a.filterComparator).forEach(a => {
            filters.push({
              column: a.column,
              filterValues: null,
              filterValue: a.filterValue, 
              filterComparator: a.filterComparator, 
            });
          });
        } else {
          filters = def.attributeFilters.map(a => {
            return {
              column: a.column.endsWith("_nodeID") ? a.column.replace("_nodeID", "_") : a.column,
              filterValues: a.filterValues, 
            }
          });
        }
        filters.push({ column: "tmpl_id", filterValues: [def.tmpl_id]});
        let measureDef = this.getStatisticMeasures(stat.view).find(m => m.name === stat.criteriaMeasure) ?? { id: "job_count", axis: "R" };
        let docs = [];
        const criteriaValue = Number(stat.criteriaValue);
        const evaluate =  (d, f) => {
          if (f.filterValues?.length) {
            return f.filterValues.some(v => v === d[f.column]);
          } else if (f.filterComparator === "=") {
            return Number(d[f.column]) === Number(f.filterValue);
          } else if (f.filterComparator === ">=") {
            return Number(d[f.column]) >= Number(f.filterValue);
          } else if (f.filterComparator === "<=") {
            return Number(d[f.column]) <= Number(f.filterValue);
          }
          return false;
        }
        if (measureDef) { // maybe missing if target view definition has been changed!!!
          if (measureDef.id !== "leaf_node_count" && !(measureDef.id === "job_count" && criteriaValue === 0))
            docs = _documents.filter(d => d.job_count && filters.every(f => evaluate(d, f)));
          else 
            docs = _documents.filter(d => filters.every(f => evaluate(d, f)));
          if (measureDef.id === "job_count" && criteriaValue === 0 && def.verAxisSelected.length) {
            const colKey = def.verAxisSelected[0].column_key ?? def.verAxisSelected[0].column;
            docs = docs.filter(x => x[colKey]);
          }
          val = 0;
          let testColumn = this.useIndex ? measureDef.id : measureDef.column;
          let comparer = (d) => d[testColumn] === criteriaValue;
          if (stat.criteriaComparator === ">=")
            comparer = (d) => d[testColumn] >= criteriaValue;
          else if (stat.criteriaComparator === "<=")
            comparer = (d) => d[testColumn] <= criteriaValue;
          if (measureDef.axis === "R") {
            if (this.useIndex) {
              const template = this.templates.find(x => x.tmpl_id === def.tmpl_id);
              const cols = [ ...template.attributes, ...template.measures ].map(x => ({ column: x.column, cache_column: x.cache_column }));
              val = await this.getAggregateFromIndex(measureDef, filters, stat.criteriaComparator, criteriaValue, cols);
              if (stat.displayBasis === "percent") {
                let totalDocs = await this.getAggregateFromIndex(measureDef, filters, null, null, cols);
                val = Math.round(100 * val / totalDocs);
              }
            } else {
              val = docs.filter(comparer).length;
              if (stat.displayBasis === "percent" && docs.length) val = Math.round(100 * val / docs.length);
            }
          } else {
            let axisList = this.prepareAxes(def.verAxisSelected, def.horAxisSelected, def.detAxisSelected).axisList;
            axisList = axisList.filter(x => x.axis === measureDef.axis);
            let total = 0;
            let data = await this.groupByKeysNested(docs, filters, axisList, [measureDef]);
            const recurseTo = (items, level) => {
              if (level === 1) {
                total += items.length;
                return items.filter(comparer).length;
              } else {
                let count = 0;
                items.forEach(x => count += recurseTo(x.children, level - 1));
                return count;
              }
            };
            val = recurseTo(data.sett, axisList.length);
            if (stat.displayBasis === "percent" && total > 0) val = Math.round(100 * val / total);
          }
          let title = val !== 1 && stat.displayBasis !== "percent" ? utils.pluralise(stat.title) : stat.title;
          stat.displayTitle = title.replace("{{0}}",val);
        }
      } else {
        stat.displayTitle = stat.title;
        contentOnly = true;
      }
      const checkIssue = (criteria, comparator, value) => {
        if (criteria === null || isNaN(criteria)) return false;
        const criteriaVal = Number(criteria);
        switch (comparator){
          case ">=":
            return value >= criteriaVal;
          case "<=":
            return value <= criteriaVal;
          default:
            return value === criteriaVal;
        }
      }
      if (!contentOnly) {
        stat.iconDisplay = { icon: stat.icon, colour: stat.iconColour };
        stat.goodIdentified = checkIssue(stat.includeGoodTrigger, stat.includeGoodTriggerComparator, val);
        stat.errorIdentified = checkIssue(stat.includeErrorTrigger, stat.includeErrorTriggerComparator, val);
        stat.warningIdentified = !stat.errorIdentified && checkIssue(stat.includeWarningTrigger, stat.includeWarningTriggerComparator, val);
        if (stat.useStatusIcon && (stat.goodIdentified || stat.errorIdentified || stat.warningIdentified)) {
          stat.iconDisplay.icon = stat.goodIdentified ? "mdi-check-circle" : "mdi-alert";
          stat.iconDisplay.colour = stat.goodIdentified ? "green" : stat.warningIdentified ? "orange" : "red";
          stat.goodIdentified = false;
          stat.errorIdentified = false;
          stat.warningIdentified = false;
        }
      }
      stat.hideSection = !!stat.hideZeroStatistic && val === 0;
      this.processedStatistics.push(stat);
      return stat;
    },
    changeChartYAxis(chart) {
      chart.yAxis = chart.yAxisName ? JSON.parse(JSON.stringify(this.horAxisAvailable.find(x => x.name === chart.yAxisName))) : null;
      this.setChartRawData(chart); 
    },
    populateChartDef(def) {
      const x = this.horAxisAvailable.find(x => x.name === def.xAxis);
      const y = this.horAxisAvailable.find(x => x.name === def.yAxis);
      let chart = {
        xAxis: x ? JSON.parse(JSON.stringify(x)) : null,
        yAxis: y ? JSON.parse(JSON.stringify(y)) : null,
        yAxisName: y ? def.yAxis : null,
        measure: this.measures.find(x => x.column === def.measure),
        useRange: def.useRange,
        rangeQuantity: def.rangeQuantity,
        title: def.title || "",
        description: def.description || "",
        data: null,
        type: def.type || "bar_chart",
        style: def.type === "bar_chart" ? {
            height: this.verAxisSelected.length || this.horAxisSelected.length || this.viewSectionsLayout.length > 1 ? "250px" : "400px",
            width: "100%",
            position: "relative",
          } : {
            height: '140px',
            width: '140px',
          },
        legendStyle: {},
        option: null,
        selectedSortOption: "Alphabetically",
        chartData: null,
        colPosition: def.colPosition || 1,
        rowPosition: def.rowPosition || 1,
        colWidth: def.colWidth || 12,
        rowHeight: def.rowHeight || 1,
        filtersVisible: def.filtersVisible || [],
        filtersData: [],
        link: def.link || "",
        linkTitle: def.linkTitle || "",
      };
      chart.legendStyle = { height: chart.style.height };
      chart.filtersData = jaCommon.populateFilterData(this.verAxisAvailable
        .filter(x => chart.filtersVisible.some(v => v === x.name)),
        _documents);
      if (chart.useRange) chart.useRange = this.chartDateOptions.find(x => x.type === chart.xAxis.data_type)
      if (!chart.title) {
        chart.title = `${chart.measure.title} for ${chart.xAxis.overrideTitle || chart.xAxis.name}`;
        if (def.yAxis) chart.title += ` by ${chart.yAxis.name}`;
        def.title = chart.title;
      }
      if (def.xAxisPrefix) chart.xAxis.prefix = def.xAxisPrefix;
      if (def.yAxis && def.yAxisPrefix) chart.yAxis.prefix = def.yAxisPrefix;

      this.setChartRawData(chart);
      chart.option = {
              responsive: true,
              maintainAspectRatio: false,
              interaction: { intersect: true, mode: 'index', },
              plugins: {
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: function(context) {
                      if (context.parsed.y === null || Number(context.parsed.y) === 0)
                        return "";
                      else 
                        return `${context.dataset.label}: ${context.parsed.y}` ;
                    }
                  }
                },
              },
              scales: {
                x: { stacked: !!chart.yAxis, },
                y: { ticks: { precision: 0 }, stacked: !!chart.yAxis }
              }
            };
      if (chart.type === "pie_chart") {
        chart.option = { 
          responsive: false, maintainAspectRatio: true,
          plugins: { legend: { display: false } }
        }
      }

      return chart;
    },
    async setChartRawData(chartDef) {
      let usedFilters = chartDef.filtersData
        ? chartDef.filtersData
            .filter((f) => f.filterValues.length)
            .map((f) => {
              return {
                column: f.value,
                name: f.text,
                values: f.filterValues,
              };
            })
        : [];
      const tmpl_id = this.selectedView.definition.tmpl_id;
      let selectedDocs = usedFilters.length ? _documents.filter((x) => {
          if (x.tmpl_id !== tmpl_id) return false;
          return usedFilters.every((f) =>
            f.values.some((v) => x[f.column] === v)
          );
        }) : _documents.filter(x => x.tmpl_id === tmpl_id);

      const chartAxes = { 
        axis: "C", 
        columns: [chartDef.xAxis, chartDef.yAxis]
                  .filter(x => x)
                  .map((x, xi) => {
                    x.column_key = x.display_column || x.column;
                    x.column_sort = x.display_column || x.column;
                    x.column_match = x.display_column || x.column;
                    x.column_title = x.display_column || x.column;
                    x.index = xi;
                    return x;
                  }), 
        headerColumns: [] 
      };
      chartAxes.headerColumns = chartAxes.columns;
      const filters = this.getIndexFilterParams(usedFilters);

      let data = await this.groupByKeysNested(
        selectedDocs,
        filters,
        [chartAxes],
        [chartDef.measure], null, null, null, true
      );
      // if (!data.data[data.collectionName].length) return;
      if (!data.sett.length) return;
      const colourGenrator = () => {
        return "#" + [1,2,3,4,5,6].map(x => '0123456789ABCDEF'[[Math.floor(Math.random() * 16)]]).join("");
      };
      let xAxis = [];
      let yAxis = [];
      if (chartDef.useRange) {
        const dateOption = this.chartDateOptions.find(x => x.type === chartDef.xAxis.data_type);
        const quantity = Number(chartDef.rangeQuantity);
        if (dateOption && quantity) {
          let dat = dayJS();
          for (let i = 0; i < quantity; i++) {
            const nextDate = dayJS(dat).subtract(i, dateOption.unit);
            const label = nextDate.format(dateOption.format);
            // let val = xAxis.find(y => y.label === label);
            xAxis.push(
              {
                label: label,
                total: 0,
                valueIndex: xAxis.length,
              });
          }
        }
      }
      data.sett
        .filter(x => x.headerColumns.some(c => c[chartDef.measure.id]))
        .forEach(d => {
          const labelX = d.headerColumns[0].title;
          const labelY = chartAxes.columns.length > 1 ? d.headerColumns[1].title : "";
          let xd = xAxis.find(x => x.label === labelX);
          if (xd || !chartDef.useRange) {
            if (!xd) {
              xd = {
                label: labelX,
                total: 0,
                valueIndex: xAxis.length,
              };
              xAxis.push(xd);
              yAxis.forEach(y => y.data.push(0));
            }
            xd.total += d.headerColumns[0][chartDef.measure.id];
            if (chartAxes.columns.length === 2) {
              let yd = yAxis.find(y => y.label === labelY);
              if (!yd) {
                yd = {
                  label: labelY,
                  colour: yAxis.length < this.chartColours.length ? this.chartColours[yAxis.length] : colourGenrator(),
                  data: xAxis.map(x => 0),
                };
                yAxis.push(yd)
              }
              yd.data[xd.valueIndex] = d.headerColumns[1][chartDef.measure.id];
            }
          }
        });
      
      chartDef.data = { 
        xAxis: xAxis,
        stacks: yAxis,
        stacksSelected: JSON.parse(JSON.stringify(yAxis)),
      };
      this.setChartData(chartDef);
    },
    chartFilterChanged(chartDef) {
      this.setChartRawData(chartDef);
    },
    setChartData(chartDef) {
      switch (chartDef.selectedSortOption) {
        case 'Alphabetically':
          chartDef.data.xAxis.sort((a, b) => a.label.localeCompare(b.label));
          break;
        case 'Reverse Alphabetically':
          chartDef.data.xAxis.sort((a, b) => b.label.localeCompare(a.label));
          break;
        case 'High to Low':
          chartDef.data.xAxis.sort((a, b) => b.total - a.total);
          break;
        case 'Low to High':
          chartDef.data.xAxis.sort((a, b) => a.total - b.total);
          break;
      }

      let datasets = chartDef.data.stacks.length ?
        chartDef.data.stacksSelected.map((c) => {
          return {
            label: c.label,
            data: chartDef.data.xAxis.map(x => x.valueIndex >= 0 ? c.data[x.valueIndex] : 0),
            backgroundColor: c.colour,
          };
        }) :
        [
          {
            label: chartDef.xAxis.name,
            data: chartDef.data.xAxis.map((g) => {
              return g.total || 0;
            }),
            backgroundColor: chartDef.type === "bar_chart" ?
              this.chartColours[0] :
              chartDef.data.xAxis.map((g, gi) => this.chartColours[gi]),
          }
        ]
      let measureTotal = chartDef.data.xAxis.reduce((p, c) => p += c.total, 0);
      chartDef.chartData = {
        labels: chartDef.data.xAxis.map(g => g.label),
        datasets: datasets,
        measureTotal: measureTotal,
        detaillabels: chartDef.data.xAxis.map(g => `${(100 * g.total / measureTotal).toFixed(0)}% (${g.total}) ${g.label}`),
      };   
    },
    addChart(type) {
      this.chartEdit.show = true;
      this.chartEdit.type = type;
      this.chartEdit.xAxis = null;
      this.chartEdit.yAxis = null;
      this.chartEdit.measure = this.measures.length === 1 ? this.measures[0].column : null;
      this.chartEdit.useRange = false;
      this.chartEdit.rangeQuantity = 0;
      this.chartEdit.xAxisPrefix = "";
      this.chartEdit.yAxisPrefix = "";
      this.chartEdit.link = "";
      this.chartEdit.linkTitle = "";
      this.chartEdit.filtersVisible = [];
      this.chartEdit.title = "";
      this.chartEdit.description = "";
      this.chartEdit.existingIndex = -1;
      this.chartEdit.colPosition = 1;
      this.chartEdit.rowPosition = 1;
      this.chartEdit.colWidth = 12;
      this.chartEdit.rowHeight = 1;
      this.chartEdit.existingIndex = -1;
    },
    editChart(chart) {
      let item = this.defaultViewSection(chart);
      this.chartEdit.show = true;
      this.chartEdit.type = item.type;
      this.chartEdit.xAxis = item.xAxis.name;
      this.chartEdit.yAxis = item.yAxis?.name;
      this.chartEdit.measure = item.measure.column;
      this.chartEdit.useRange = item.useRange;
      this.chartEdit.rangeQuantity = item.rangeQuantity;
      this.chartEdit.xAxisPrefix = item.xAxisPrefix;
      this.chartEdit.yAxisPrefix = item.yAxisPrefix;
      this.chartEdit.link = item.link;
      this.chartEdit.linkTitle = item.linkTitle;
      this.chartEdit.filtersVisible = item.filtersVisible;
      this.chartEdit.title = item.title;
      this.chartEdit.description = item.description;
      this.chartEdit.colPosition = item.colPosition;
      this.chartEdit.rowPosition = item.rowPosition;
      this.chartEdit.colWidth = item.colWidth;
      this.chartEdit.rowHeight = item.rowHeight;
      this.chartEdit.existingIndex = chart.index;
    },
    removeChart() {
      this.selectedView.definition.viewSections.splice(this.chartEdit.existingIndex, 1);
      this.displayView();
      this.chartEdit.show = false;
      this.selectedView.isDirty = true;
    },
    saveChart() {
      if (this.chartEdit.existingIndex < 0) {
        this.chartEdit.index = this.selectedView.definition.viewSections.length;
        this.selectedView.definition.viewSections.push(this.defaultViewSection(this.chartEdit));
      } else {
        const existing = this.selectedView.definition.viewSections[this.chartEdit.existingIndex];
        existing.xAxis = this.chartEdit.xAxis;
        existing.yAxis = this.chartEdit.yAxis;
        existing.measure = this.chartEdit.measure;
        existing.useRange = this.chartEdit.useRange;
        existing.rangeQuantity = this.chartEdit.rangeQuantity;
        existing.xAxisPrefix = this.chartEdit.xAxisPrefix;
        existing.yAxisPrefix = this.chartEdit.yAxisPrefix;
        existing.link = this.chartEdit.link;
        existing.linkTitle = this.chartEdit.linkTitle;
        existing.filtersVisible = this.chartEdit.filtersVisible;
        existing.title = this.chartEdit.title;
        existing.description = this.chartEdit.description || "";
        existing.colPosition = this.chartEdit.colPosition;
        existing.rowPosition = this.chartEdit.rowPosition;
        existing.colWidth = this.chartEdit.colWidth;
        existing.rowHeight = this.chartEdit.rowHeight;
      }
      this.displayView();
      this.chartEdit.show = false;
      this.selectedView.isDirty = true;
    },
    doLink(item) {      
      this.$router.push({ path: item.link });
    },
    addTaskList() {
      this.taskEdit.show = true;
      this.taskEdit.columnsVisible = [];
      this.taskEdit.filtersVisible = [];
      const count = this.selectedView.definition.viewSections.filter(x => x.type === "task_list");
      this.taskEdit.defaultView = "1";
      this.taskEdit.title = "Task List" + (count > 0 ? ` (${count})` : "");
      this.taskEdit.description = "";
      this.taskEdit.colPosition = 1;
      this.taskEdit.rowPosition = 1;
      this.taskEdit.colWidth = 12;
      this.taskEdit.rowHeight = 1;
      this.taskEdit.existingIndex = -1;
    },
    editTaskList(item) {
      this.taskEdit.show = true;
      this.taskEdit.columnsVisible = item.columnsVisible;
      this.taskEdit.filtersVisible = item.filtersVisible;
      this.taskEdit.defaultView = item.defaultView;
      this.taskEdit.title = item.title;
      this.taskEdit.description = item.description;
      this.taskEdit.colPosition = item.colPosition;
      this.taskEdit.rowPosition = item.rowPosition;
      this.taskEdit.colWidth = item.colWidth;
      this.taskEdit.rowHeight = item.rowHeight;
      this.taskEdit.existingIndex = item.index;
    },
    removeTaskList() {
      this.selectedView.definition.viewSections.splice(this.taskEdit.existingIndex, 1);
      this.displayView();
      this.taskEdit.show = false;
      this.selectedView.isDirty = true;
    },
    saveTaskList() {
      if (this.taskEdit.existingIndex < 0) {
        const def = {
          columnsVisible: this.taskEdit.columnsVisible,
          filtersVisible: this.taskEdit.filtersVisible,
          columnFilters: [],
          statuses: [],
          defaultView: this.taskEdit.defaultView,
          title: this.taskEdit.title,
          description: this.taskEdit.description,
          colPosition: this.taskEdit.colPosition,
          rowPosition: this.taskEdit.rowPosition,
          colWidth: this.taskEdit.colWidth,
          rowHeight: this.taskEdit.rowHeight,
          index: this.selectedView.definition.viewSections.length,
          type: "task_list",
          updated: 1,
        };
        this.selectedView.definition.viewSections.push(def);
      } else {
        const existing = this.selectedView.definition.viewSections[this.taskEdit.existingIndex];
        existing.columnsVisible = this.taskEdit.columnsVisible;
        existing.filtersVisible = this.taskEdit.filtersVisible;
        existing.defaultView = this.taskEdit.defaultView;
        existing.title = this.taskEdit.title;
        existing.description = this.taskEdit.description;
        existing.colPosition = this.taskEdit.colPosition;
        existing.rowPosition = this.taskEdit.rowPosition;
        existing.colWidth = this.taskEdit.colWidth;
        existing.rowHeight = this.taskEdit.rowHeight;
        existing.updated++;
      }
      this.displayView();
      this.taskEdit.show = false;
      this.selectedView.isDirty = true;
    },
    editViewItem(item) {
      this.clearViewSectionEdit();
      item.isEdited = true;
      if (item.type === "task_list")
        this.editTaskList(item);
      else if (item.type === "statistic")
        this.editStatistic(item);
      else
        this.editChart(item);
    },
    addStatistic() {
      this.setStatisticProperties(this.statisticEdit);
      this.statisticEdit.show = true;
      this.statisticEdit.index = this.selectedView.definition.viewSections.length;
      this.statisticEdit.existingIndex = -1;
    },
    editStatistic(stat) {
      let item = this.defaultViewSection(stat);
      this.setStatisticProperties(this.statisticEdit, item);
      this.statisticEdit.show = true;
      this.statisticEdit.existingIndex = stat.index;
    },
    canSaveStatisticFilter() {
      if (this.statisticEdit.editFilter.column) {
        if (this.statisticEdit.editFilter.data_type === "number") {
          return this.statisticEdit.editFilter.filterValue && this.statisticEdit.editFilter.filterComparator;
        } else {
          return this.statisticEdit.editFilter.filterValues.length;
        }
      }
      return false;
    },
    removeStatistic() {
      this.selectedView.definition.viewSections.splice(this.statisticEdit.existingIndex, 1);
      this.displayView();
      this.statisticEdit.show = false;
      this.selectedView.isDirty = true;
    },
    addStatisticFilter() {
      this.statisticEdit.editFilter.filter = null;
      this.statisticEdit.editFilter.column = null;
      this.statisticEdit.editFilter.filterValues = [];
      this.statisticEdit.editFilter.filterValue = null;
      this.statisticEdit.editFilter.filterComparator = null;
      this.statisticEdit.editFilter.show = true;
    },
    editStatisticFilter(item) {
      this.statisticEdit.editFilter.filter = item;
      this.statisticEdit.editFilter.column = item.column;
      this.statisticEdit.editFilter.filterValues = item.filterValues || [];
      this.statisticEdit.editFilter.filterValue = item.filterValue || null;
      this.statisticEdit.editFilter.filterComparator = item.filterComparator || null;
      this.setStatisticEditFilterType();
      this.statisticEdit.editFilter.show = true;
    },
    saveStatisticFilter(deleted) {
      if (deleted) {
        const existing = this.statisticEdit.filters.findIndex(x => x.column === this.statisticEdit.editFilter.filter.column);
        if (existing >= 0)
          this.statisticEdit.filters.splice(existing, 1);
      } else if (this.statisticEdit.editFilter.filter) {
        this.statisticEdit.editFilter.filter.column = this.statisticEdit.editFilter.column;
        this.statisticEdit.editFilter.filter.filterValues = this.statisticEdit.editFilter.filterValues;
        this.statisticEdit.editFilter.filter.filterValue = this.statisticEdit.editFilter.filterValue;
        this.statisticEdit.editFilter.filter.filterComparator = this.statisticEdit.editFilter.filterComparator;
      } else {
        this.statisticEdit.filters.push(
          { 
            column: this.statisticEdit.editFilter.column,
            filterValues: this.statisticEdit.editFilter.filterValues,
            filterValue: this.statisticEdit.editFilter.filterValue,
            filterComparator: this.statisticEdit.editFilter.filterComparator,
          });
      }
      this.statisticEdit.editFilter.show = false;  
      if (this.statisticEdit.existingIndex < 0) {
        return;
      } else {
        this.statisticEdit.statistic.filters = this.statisticEdit.filters;      
        this.displayView(true);
        this.selectedView.isDirty = true;
        this.statisticEdit.show = true;
      }
    },
    setStatisticProperties(target, source) {
      const props = [
        { name: "type", default: "statistic" },
        { name: "icon", default: "mdi-tools" },
        { name: "backgroundColour", default: "#EEEEEE" },
        { name: "iconColour", default: "green" },
        { name: "title", default: "" },
        { name: "description", default: "" },
        { name: "source", default: null },
        { name: "colPosition", default: 1 },
        { name: "rowPosition", default: 1 },
        { name: "colWidth", default: null },
        { name: "view", default: null },
        { name: "criteriaMeasure", default: null },
        { name: "criteriaComparator", default: null },
        { name: "criteriaValue", default: null },
        { name: "displayBasis", default: "sum" },
        { name: "filters", default: [] },
        { name: "includeWarningTrigger", default: null },
        { name: "includeErrorTrigger", default: null },
        { name: "includeGoodTrigger", default: null },
        { name: "includeWarningTriggerComparator", default: null },
        { name: "includeErrorTriggerComparator", default: null },
        { name: "includeGoodTriggerComparator", default: null },
        { name: "hideZeroStatistic", default: false },
        { name: "warningIdentified", default: false },
        { name: "errorIdentified", default: false },
        { name: "goodIdentified", default: false },
        { name: "useStatusIcon", default: false },
      ];
      props.forEach(x => {
        target[x.name] = (source ? source[x.name] : x.default) ?? x.default;
      });
    },
    saveStatistic() {
      if (this.statisticEdit.existingIndex < 0) {
        this.selectedView.definition.viewSections.push(this.defaultViewSection(this.statisticEdit));
      } else {
        const existing = this.selectedView.definition.viewSections[this.statisticEdit.existingIndex];
        this.setStatisticProperties(existing, this.statisticEdit);
      }
      this.displayView(true);
      this.statisticEdit.show = false;
      this.selectedView.isDirty = true;
    },
    viewStatDetail(stat) {
      if (stat.view) {
        let view = this.views.find(x => x.view_definition_id === stat.view);
        if (view) {
          stat.viewName = view.name;
          this.selectView(view, stat);
        }
      }
    },
    prepareMeasureFiltersCurrent(tmpl_id) {      
      const def = this.prepareMeasureFilters(this.selectedView?.view_definition_id, tmpl_id);
      this.measureFilterTypes = def.measureFilterTypes;
      this.measureFilterTypeTitles = def.allMeasures;
    },
    prepareMeasureFilters(view_definition_id, tmpl_id) {
      const measureFilterTypes = [];
      const view = this.views.find(x => x.view_definition_id === view_definition_id)?.definition;
      let template = this.templates.find(x => x.tmpl_id === view?.tmpl_id || tmpl_id);
      // let docMeasures = template.measures.filter(m => !["job_count", "leaf_node_count"].some(x => x === m.type));
      let docMeasures = template.measures.filter(m => !["leaf_node_count"].some(x => x === m.type));
      const getDescription = (axes) => {
        return axes.map(x => {
          const attr = template.attributes.find(a => a.column === x.column);
          if (attr) return attr.title;
          let parts = x.column.split("_");
          if (parts.length > 3 && parts[0] === "ht" && parts[1] === "id") {
            let ht_id = Number(parts[2]);
            let level = Number(parts[3]);
            return this.hierarchyTypes.find(x => x.ht_id === ht_id)?.h_levels[level - 1];
          }
        }).filter(x => x).join("/");
      };
      const setFilters = (axis, axisMeasures, axisName) => {
        return allMeasures.map(a => {
          let m = axisMeasures.find(x => x.id === a.id);
          if (m) {
            let title = m.title;
            let adjTitle = view?.verticalMeasures.find(x => x.type === a.type)?.columnTitle;
            if (adjTitle && adjTitle !== m.columnTitle) 
              title = adjTitle;
            else {
              adjTitle = view?.horizontalMeasures.find(x => x.type === a.type)?.columnTitle;
              if (adjTitle && adjTitle !== m.columnTitle) 
                title = adjTitle;
            }
            let existing = view?.measureFilterTypes.find(x => x.axis === axis)?.filters?.find(f => f && f.type === m.type);
            return {
              title: m.title,
              type: m.type,
              column: m.column,
              aggregation: m.aggregation,
              rangeFrom: existing?.rangeFrom || null,
              rangeTo: existing?.rangeTo || null,
              visible: existing?.visible || false,
              name: axisName + " " + title,
              id: m.id,
            };
          } else {
            return null;
          }
        });
      };
      let allMeasures = template.measures.filter(m => 
        docMeasures.some(x => x.type === m.type) 
        || template.verticalMeasures.filter(x => x.available).some(x => x.type === m.type)
        || template.horizontalMeasures.filter(x => x.available).some(x => x.type === m.type))
        .map(m => { return { title: m.title, id: m.id, type: m.type, column: m.column }; });
      if (docMeasures.length)
        measureFilterTypes.push({
          name: `${template.tmpl_name || "Document"} Measure Attributes`,
          description: template.tmpl_name,
          axis: "R",
          // filters: setFilters("R", docMeasures.filter(x => x.aggregation === "sum" && !x.column_basis), template.tmpl_name),
          filters: setFilters("R", docMeasures.filter(x => !x.column_basis), template.tmpl_name),
        });
      if (view?.verAxisSelected.length) {
        const axisDescription = getDescription(view.verAxisSelected);
        measureFilterTypes.push({
          name: "Vertical Axis Measures",
          axis: "V",
          description: axisDescription,
          filters: setFilters("V", template.verticalMeasures.filter(x => x.available), axisDescription),
        });
      }
      if (view?.horAxisSelected.length) {
        const axisDescription = getDescription(view.horAxisSelected);
        measureFilterTypes.push({
          name: "Horizontal Axis Measures",
          axis: "H",
          description: axisDescription,
          filters: setFilters("H", template.horizontalMeasures.filter(x => x.available), axisDescription),
        });
      }
      if (view?.detAxisSelected.length) {
        const axisDescription = getDescription(view.detAxisSelected);
        measureFilterTypes.push({
          name: "Detail Measures",
          axis: "D",
          description: axisDescription,
          filters: setFilters("D", template.horizontalMeasures.filter(x => x.available), axisDescription),
        });
      }
      return { measureFilterTypes: measureFilterTypes, allMeasures: allMeasures };
    },
    getStatisticMeasures(view_definition_id) {
      let measures = [];
      if (view_definition_id)
        this.prepareMeasureFilters(view_definition_id).measureFilterTypes.forEach(mt => {
          mt.filters.filter(f => f).forEach(f => {
            measures.push({ 
              // name: mt.name.replace(" Measures", "") + " " + f.title, 
              name: mt.description + " " + f.title, 
              axis: mt.axis, 
              id: f.id, 
              column: f.column, 
              aggregation: f.aggregation
            });
          });
        });
      return measures;
    },
    async getViewFilters(view_definition_id) {
      const view = this.views.find(x => x.view_definition_id === view_definition_id)?.definition;
      const template = this.templates.find(x => x.tmpl_id === view.tmpl_id);
      let vf = await this.getCompareOptions(template.attributes, _documents.filter(x => x.job_count && x.tmpl_id === view.tmpl_id), template.tmpl_name);
      return vf.filter((x) => x.listValues && x.listValues.length || x.column === 'age_months');
    },
    getFilterListValues() {
      const f = this.statisticEdit.editFilter?.availableFilters.find(x => x.column === this.statisticEdit.editFilter.column);
      return f ? f.listValues.map(x => x.value) : [];
    },
    setStatisticEditFilterType() {
      const f = this.statisticEdit.editFilter.availableFilters.find(x => x.column === this.statisticEdit.editFilter.column);
      this.statisticEdit.editFilter.data_type = f ? f.data_type : "text";
      this.statisticEdit.editFilter.filterValues.splice(0, this.statisticEdit.editFilter.filterValues.length);
    },
    resetViewMeasureFilterRange(m) {
      m.rangeFrom = null;
      m.rangeTo = null;
    },
    applyViewMeasureFilters() {
      const getValue = (val) => {
        if (val === null || val === undefined)
          return null;
        else 
          return Number(val);
      };
      this.measureFilterTypes.forEach(mt => {
        mt.filters.filter(f => f).forEach(f => {
          f.rangeFrom = getValue(f.rangeFrom);
          f.rangeTo = getValue(f.rangeTo);
        });
      });
      if (this.measureFilterTypes.some(t => t.axis === "R" && t.filters.some(x => x && (x.rangeFrom !== null || x.rangeTo !== null)))){
        this.selectJDs();
      } else {
        this.buildCompare(this.selectedDocs);
      }
      this.updateViewDefinition();
    },
    leafNodeCountColumn(target) {
      if (target.verAxisSelected?.length && target.verAxisSelected.every(x => x.ht_id)) {
        const linkLevel = target.verAxisSelected[target.verAxisSelected.length - 1]
        return { 
          column: linkLevel.column_key,
          index: target.verAxisSelected.length - 1,
          item: linkLevel,
          name: this.hierarchyTypes.find(x => x.ht_id === linkLevel.ht_id).linklevelName,
        };
      } else {
        return null;
      }
    },
    calulateAggregregates(items, types, ignoreZero, measure) {
      let allTypes = ["sum","mean","min","max","median","std_dev","count"];
      let quartiles = null;
      let values = ignoreZero ? items.filter(x => x !== 0) : items;
      const bLen = values.length;
      const getQuartiles = (vals, q) => {
        let dat = {}
        if (!q) {
          let sorted = vals.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
          dat.median = getQuartiles(sorted, 2);
          dat.q1 = getQuartiles(sorted.filter(x => x >= dat.median.raw), true);
          dat.q3 = getQuartiles(sorted.filter(x => x < dat.median.raw), true);
          return dat;
        }
        const len = vals.length;
        const mid = Math.round(len / 2);
        if (len % 2 === 1) {
          dat.raw = vals[mid - 1];
          dat.formatted = dat.raw;
        } else {
          dat.raw = (vals[mid - 1] + vals[mid]) / 2;
          dat.formatted = dat.raw.toFixed(0);
        }
        return dat;
      }
      let data = { raw: {}, formatted: {} };
      let calcs = types?.length ? allTypes.filter(t => types.some(x => x === t)) : allTypes;
      calcs.forEach(a => {
        if (bLen > 0) {
          switch (a) {
            case "count":
              data.raw.count = items.length;
              data.formatted.count = data.raw.count;
              break;
            case "sum":
              data.raw.sum = values.reduce((p,c) => p + c || 0, 0);
              // data.formatted.sum = data.raw.sum;
              data.formatted.sum = this.utils.formatNumber(data.raw.sum, measure?.drilldown?.numberFormat);
              // if (bVal && measure.format === "pct") bVal = Number(bVal.toFixed(2));
              break;
            case "mean":
              data.raw.mean = values.reduce((p,c) => p + c || 0, 0) / bLen;
              data.raw.std_dev = Math.sqrt(
                values.map((x) => Math.pow(x - data.mean, 2)).reduce((a, b) => a + b) / bLen
              );
              // data.formatted.mean = data.raw.mean.toFixed(0);
              data.formatted.mean = this.utils.formatNumber(data.raw.mean, measure?.drilldown?.numberFormat);
              data.formatted.std_dev = data.raw.std_dev.toFixed(1);
              break;
            case "median":
              quartiles = getQuartiles(values);
              data.raw.median = quartiles.median.raw;
              // data.formatted.median = quartiles.median.formatted;
              data.formatted.median = this.utils.formatNumber(data.raw.median, measure?.drilldown?.numberFormat);
              break;
            case "min":
              data.raw.min = values.reduce((p,c) => c < p ? c : p, 9999999999999);
              data.formatted.min = this.utils.formatNumber(data.raw.min, measure?.drilldown?.numberFormat);
              break;
            case "max":
              data.raw.max = values.reduce((p,c) => c > p ? c : p, -9999999999999);
              data.formatted.max = this.utils.formatNumber(data.raw.max, measure?.drilldown?.numberFormat);
              break;
          }
        } else {
          data[a] = null;
        }
      });
      return data;
    },
    getIndexColumnName(colName) {
      if (this.useIndex) {
        const col = this.verAxisAvailable.find(x => x.column === colName);
        if (col) return col.cache_column;
      }
      return colName;
    },
    getValueColumnName(column) {
      if (column.display_column) return column.display_column;
      if (this.useIndex) return column.cache_column;
      return column.column;
    },
    getMainMeasure() {
      return this.verticalMeasures.find(x => x.visible) || this.horizontalMeasures.find(x => x.visible);
    },
    doCategoryDrilldown(target) {
      if (target?.match_key) {
        this.drillDownStack.show = true;
        this.doMeasureDrilldown(target);
      }
    },
    revertCategoryDrilldown() {
      if (this.drillDownStack.show) {
        this.drillDownStack.show = false;
        this.doMeasureDrilldown(this.drillDownStack.item, this.drillDownStack.measure);
      }
    },
    async doMeasureDrilldown(item, measure) {
      measure = measure || this.getMainMeasure();
      if (!measure) {
        return;
      }
      const data = await this.prepMeasureDrilldown(item, measure);
      
      let title = "";
      this.drillDownDialogue.subjects = data.categoryColumns.map(c => {
        const sub = { title: c.overrideTitle || c.name , text: data.docs[0][this.getValueColumnName(c)] };
        if (title.length) title += " - ";
        if (!isNaN(sub.text)) 
          title += sub.title + " " + sub.text;
        else 
          title += sub.text + " " + sub.title;
        return sub;
      });

      if (!this.drillDownStack.show) {
        this.drillDownStack.item = item;
        this.drillDownStack.measure = measure;
        this.drillDownStack.title = this.drillDownDialogue.subjects.map(s => `${s.title}: ${s.text}`).join(" > ");
      }
      const docLength = data.docs.length;
      const quartiles = [
          { id: 1, start: 0, end: parseInt(docLength / 4) - 1, title: "Highest 25%   " }, 
          { id: 2, start: parseInt(docLength / 4), end: parseInt(docLength / 2) - 1, title: "Middle 50%   " },
          { id: 2, start: parseInt(docLength / 2), end: parseInt(3 * docLength / 4) - 1, title: "Middle 50%   " },
          { id: 3, start: parseInt(3 * docLength / 4), end: docLength - 1, title: "Lowest 25%   "}];
      const qtots = [ { id: 1, types: []}, { id: 2, types: []}, { id: 3, types: []}];

      const ddocs = data.docs.map((d,di) => {
        const qtl = quartiles.find(q => di >= q.start && di <= q.end);
        const qtot = qtots.find(x => x.id === qtl.id);
        let qtype = qtot.types.find(x => x.name === d.type);
        if (!qtype) {
          qtype = { name: d.type, count: 0 };
          qtot.types.push(qtype);
        }
        qtype.count++;
        const dc = {
          doc_id: d.doc_id,
          doc_name: d.doc_name,
          style: d.style,
          // quartile: "Quartile " + (quartiles.findIndex(q => di >= q.start && di <= q.end) + 1),
          quartile: qtl.id,
        };
        data.docHeadings.forEach(h => {
          if (h.isNumber && measure?.drilldown)
            dc[h.column] = this.utils.formatNumber(Number(d[h.column]), measure?.drilldown?.numberFormat);
          else
            dc[h.column] = h.isNumber ? Number(d[h.column]).toFixed(0) : d[h.column];
          if (h.column_match && h.column !== h.column_match) dc[h.column_match] = d[h.column_match];
        });
        return dc;
      });
      ddocs.forEach(d => {
        const qtype = qtots.find(x => x.id === d.quartile);
        const qname = quartiles.find(x => x.id === d.quartile);
        if (qtype && qname) {
          d.quartile = qname.title + "  (" + qtype.types.map(x => x.count + " " + x.name).join(", ") + ")";
        }
      })
      
      this.drillDownDialogue.summaryView = !!data.secondaryColumns.length;
      this.drillDownDialogue.documents = ddocs;
      this.drillDownDialogue.alert = item.failsHighlight ? "Insufficient Data to Categorise" : "";
      this.drillDownDialogue.docHeadings = data.docHeadings.filter(x => !x.hide);
      this.drillDownDialogue.analysisTitle = data.analysisTitle;
      this.drillDownDialogue.analysisHeadings = data.analysisHeadings;
      this.drillDownDialogue.analysisRows = data.analysisRows;
      const boxplotdata = this.getDistributionData(data.bpDatasets, measure, data.secondaryColumns, item);      
      this.drillDownDialogue.datasets = boxplotdata.datasets;
      this.drillDownDialogue.labels = boxplotdata.labels;
      this.drillDownDialogue.match_keys = boxplotdata.match_keys;
      this.drillDownDialogue.measureTitle = measure.drillDownTitle;
      this.drillDownDialogue.docType = data.docType;
      this.drillDownDialogue.title = title;
      this.drillDownDialogue.titleValue = data.titleValue;
      this.drillDownDialogue.titleColour = data.titleColour;
      this.drillDownDialogue.titleIcon = data.titleIcon;
      this.drillDownDialogue.detailColourKey = data.detailColourKey;
      this.drillDownDialogue.show = true;      
    },
    async prepMeasureDrilldown(item, measure) {
      let filters = [];
      let currentFilter = null;
      let categoryColumns = [];
      let verColIncluded = false;
      let horColIncluded = false;
      const reportMeasureColumn = measure.column + "_sum";

      item.match_key.split("|").forEach((x, xi) => {
        if (xi % 2 === 0) {
          currentFilter = { column: this.getIndexColumnName(x), filterValues: null, dd: true };
          filters.push(currentFilter);
        } else {
          currentFilter.filterValues = [x];
        }
        let verCol = this.verAxisSelected.find(a => x === a.column_key);
        let horCol = this.horAxisSelected.find(a => x === a.column_key);
        if (verCol) { 
          categoryColumns.push(verCol);
          verColIncluded = true;
        }
        if (horCol) {
          categoryColumns.push(horCol);
          horColIncluded = true;
        }
      });
      filters = filters.filter(x => x.column);
      let secondaryColumns = verColIncluded && !horColIncluded && this.horAxisSelected.length ? 
                                [this.horAxisSelected[0]] : !verColIncluded && horColIncluded && this.verAxisSelected.length ? [this.verAxisSelected[0]] : [];
      let docs = [];
      if (this.useIndex) {
        const params = {
          // filters: this.getIndexFilterParams(filters.map(x => ({ column: x.col, filterValues: [x.val]}))),
          filters: this.getIndexFilterParams(
            this.verAxisAvailable.filter((x) => x.filterValues.length)
            .concat(this.horAxisAvailable.filter((x) => x.filterValues.length))
            .concat(filters.filter((x) => x.filterValues.length))
            .map(f => ({
              column: !f.dd && f.column.endsWith("_nodeID") ? f.column.replace("_nodeID", "_") : !f.dd ? f.cache_column : f.column,
              filterValues: f.filterValues
            }))),
          pageSize: 500,
        }
        docs = await this.$store.getters["docs/filter"](params);
      } else {
        docs = this.selectedDocs.filter(d => filters.every(f => d[f.column] == f.filterValues[0]));
      }
      if (!docs.length) return;

      const docType = this.catalogueDocType.docType; //this.templates.find(x => x.tmpl_id === docs[0].tmpl_id).tmpl_name;
      let docHeadings = [
        { text: docType, column: "doc_name", cols: "4"},
      ];
      let jobtitlecolumn = this.verAxisAvailable.find(x => x.isLeafNode && x.name.toLowerCase().indexOf("job") >= 0);
      if (jobtitlecolumn) {
        docHeadings.push({ text: jobtitlecolumn.name, column: jobtitlecolumn.display_column });
      }
      const basisColumnTitle = measure.column_basis ? this.verAxisAvailable.find(x => x.column === measure.column_basis).name : "";
      const analysisTitle = (measure.column_basis ? this.measures.find(v => v.id === reportMeasureColumn).title : measure.title);
      if (measure.column_basis) docHeadings.push({ text: basisColumnTitle, column: this.getIndexColumnName(measure.column_basis), hide: true });
      this.measures.filter(v => v.derivation === "sum").forEach(m => docHeadings.push({ text: m.title, column: this.getValueColumnName(m), isNumber: true }))
      secondaryColumns.forEach(c => docHeadings.push({ text: c.name, column: this.getValueColumnName(c), column_match: c.column_match }));
      // if (measure.column_basis) docHeadings.push({ text: basisColumnTitle, column: measure.column_basis, });
      // this.measures.filter(v => v.derivation === "sum").forEach(m => docHeadings.push({ text: m.title, column: m.column, isNumber: true }))
      // secondaryColumns.forEach(c => docHeadings.push({ text: c.name, column: c.display_column || c.column, }));
      const analysisHeadings = [
        { column:"count", text: "Count" },
        { column: `mean`, text: "Mean" }, 
        { column: `median`, text: "Median" },
        { column: `min`, text: "Lowest" }, 
        { column: `max`, text: "Highest" }, ];
      let analysisRows = [];
      let bpDatasets = null;
      let detailColourKey = [];
      const typeColumn = this.getIndexColumnName(measure.column_basis);
      if (measure.column_basis) {
        analysisHeadings.unshift({ text: basisColumnTitle, column: "type" });
        bpDatasets = [measure.catalogue_ratio_primary_value, measure.catalogue_ratio_secondary_value].map((bv,bvi) => {          
          let bvDocs = docs.filter(d => d[typeColumn] === bv)
                        .map(d => {
                          let doc = {}
                          doc[measure.column_basis] = bv;
                          doc[measure.column] = Number(d[this.getValueColumnName(measure)]);
                          secondaryColumns.forEach(s => {
                            doc[s.column_title] = d[this.getValueColumnName(s)];
                            if (s.column_title !== s.column_match)
                              doc[s.column_match] = d[s.column_match];
                          })
                          return doc;
                        });
          let bvAggs = this.calulateAggregregates(bvDocs.map(x => x[measure.column]), null, true, measure);
          let aRow = {};
          analysisHeadings.forEach((x,xi) => aRow[x.column] = xi === 0 ? bv : bvAggs.formatted[x.column]);
          analysisRows.push(aRow);
          let colour = this.clientColours.find(c => c.display_colour_id === (bvi === 0 ? measure.display_colour_id_primary : measure.display_colour_id_secondary));
          if (colour) {
            aRow.style = { backgroundColor: colour.background_colour + " !important", color: colour.text_colour + " !important" };
            detailColourKey.push({ label: bv, style: { backgroundColor: colour.background_colour, borderColor: this.utils.darkenColor(colour.background_colour, 10) } });
          }
          return { name: bv, docs: bvDocs, aggregates: bvAggs.raw, colour: colour?.background_colour || "#EEEEEE" }
        });
      } else {
        let aRow = {};
        analysisHeadings.forEach((x) => aRow[x.column] = item[x.column]);
        analysisRows.push(aRow);          
        // analysisRows.push(analysisHeadings.map(x => item[x.col]));
        bpDatasets = [{ name: measure.columnTitle || measure.title, docs: docs }];
      }
      let titleValue = item[measure.id] + "%";
      let titleColour = "";
      let titleIcon = "";
      if (measure.column_basis) {
        let diffNum = bpDatasets[0].aggregates[measure.derivation] - bpDatasets[1].aggregates[measure.derivation];
        let diffPct = bpDatasets[0].aggregates[measure.derivation] !== 0 ? 100 * diffNum / bpDatasets[0].aggregates[measure.derivation] : 100;
        diffPct = Number(diffPct.toFixed(1));
        if (!isNaN(diffNum)) {
          if (measure.drilldown?.numberFormat)
            titleValue = (diffNum > 0 ? "+" : "") + this.utils.formatNumber(diffNum, measure.drilldown?.numberFormat);
          else
            titleValue = `${diffNum > 0 ? "+" : ""}${diffNum.toFixed(0)}`;
          titleValue = `${titleValue} (${diffNum > 0 ? "+" : ""}${diffPct} %)`;
          const hl = this.utils.determineHighlightRule(measure, diffPct);
          // titleColour = hl ? this.utils.darkenColor(hl.style.backgroundColor, 10) : "";
          titleColour = hl ? this.utils.darkenColor(hl.style.backgroundColor, 5) : "";
          // titleColour = hl ? hl.style.backgroundColor : "";
          titleIcon = titleColour ? "mdi-alert" : "";
        } else {
          titleValue = measure.single_comparator_tooltip || "Insufficient data to evaluate";
        }
      }
      docs.forEach(d => {
        let cat = analysisRows.find(x => x.type === d[typeColumn]);
        if (cat) {
          d.style = cat.style;
          d.type = cat.type;
        }
      });
      docs.sort((a,b) => Number(a[measure.cache_column]) < Number(b[measure.cache_column]) ? 1 : Number(a[measure.cache_column]) > Number(b[measure.cache_column]) ? -1 : 0)
      return {
        docHeadings: docHeadings,
        analysisTitle: analysisTitle,
        analysisHeadings: analysisHeadings,
        analysisRows: analysisRows,
        bpDatasets: bpDatasets,
        secondaryColumns: secondaryColumns,
        docType: docType,
        docs: docs,
        categoryColumns: categoryColumns,
        titleValue: titleValue,
        titleColour: titleColour,
        titleIcon: titleIcon,
        detailColourKey: detailColourKey,
      }    
    },
    getDistributionData(datasets, measure, secondaryCols, item) {
      let data = { 
        datasets: datasets.map(ds => { 
          return {
            label: ds.name,
            backgroundColor: ds.colour, //"rgba(242, 244, 255, 1)",
            borderColor: "gray", //"rgba(108, 123, 192, 1)",
            borderWidth: 2,
            outlierStyle: "circle",
            outlierBackgroundColor: "#FFE2E2",
            outlierBorderColor: "#6E1C1C",
            medianColor: 'blue',
            meanBackgroundColor: 'black',
            meanRadius: 4,
            // yellow version
            // outlierBackgroundColor: "#FFEF98",
            // outlierBorderColor: "#6E3B00",
            outlierRadius: 10,
            outlierBorderWidth: 2,
            padding: 0,
            itemRadius: 2,
            itemHitRadius: 6,
            itemStyle: 'circle',
            itemBackgroundColor: "gray",
            data: [ ds.docs.map(x => Number(x[measure.column])) ],
          };
        }),
        labels: ["Overall"],
        match_keys: [""],
      };
      if (secondaryCols?.length) {
        datasets.forEach((ds, dsi) => {
          secondaryCols.forEach(s => {
            // let secVals = new Set(ds.docs.map(d => d[s.column]));
            let secIds = new Set(ds.docs.sort((a,b) => a[s.column_title] > b[s.column_title] ? 1 : a[s.column_title] < b[s.column_title] ? -1 : 0).map(d => d[s.column_match]));
            secIds.forEach(sid => {
              const secDocs = ds.docs.filter(x => x[s.column_match] === sid);
              data.datasets[dsi].data.push(secDocs.map(x => Number(x[measure.column])));
              if (dsi === 0) {
                const value = secDocs[0][s.column_title];
                data.labels.push((value.length < 4 ? s.name + " " : "") + value);
                data.match_keys.push(`${item.match_key}${s.column_match}|${secDocs[0][s.column_match]}`);
              }
            });
          });
        });
      }
      return data;
    },
    showPrimaryViewTabs() {
      if (this.selectedStatistic) return false;
      const showPrimaryTabs = this.primaryTabs.some(x => x.visible && !x.other);
      if (!showPrimaryTabs && this.primaryViews.length > 1)
        return true;
      else if (this.selectedTab && this.primaryViews.filter(x => x.definition.parentTab === this.selectedTab.key).length > 1)
        return true;
      else
        return false;
    },
    mapIndexFilter(f) {
      if (!f.cache_column)
        return {
          column: "doc_id", filterValues: ["-1"]
        };
      else
        return {
          column: f.column.endsWith("_nodeID") ? f.column.replace("_nodeID", "_") : f.cache_column.endsWith("_nodeID") ? f.cache_column.replace("_nodeID", "_") : f.cache_column,
          filterValues: f.filterValues
        };
    },
    getIndexFilters() {
      if (!this.useIndex) return [];

      let textFilters = this.textFilters().filter((x) => x.values.length).map(x => { return { column: x.column, cache_column: x.cache_column, filterValues: x.values }; });

      const mapFilter = this.mapIndexFilter;
      const filters = this.getIndexFilterParams(this.verAxisAvailable
          .filter((x) => x.filterValues.length)
          .concat(this.horAxisAvailable.filter((x) => x.filterValues.length))
          .concat(this.useIndex ? [] : textFilters)
          .map(mapFilter));

      filters.push(...this.hierarchyPickerIndexFilters());
      if (textFilters.length) {
        filters.push({ ORFilters: true, filters: textFilters.map(mapFilter)});
      }
      const mFilters = this.identifyMeasureFilters("R");
      if (mFilters.length) {
        mFilters.forEach(mf => {
          const meas = this.measures.find(x => x.id === mf.id);
          if (meas) {
            filters.push({ 
              column: meas.cache_column, 
              filterValues: [
                isNaN(mf.rangeFrom) ? null : mf.rangeFrom,
                isNaN(mf.rangeTo) ? null : mf.rangeTo,
              ] 
            });
          }
        });
      }
      return filters;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/vars";

.selectViewMenu {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}

.node circle,
.node rect {
  fill: #fff;
  stroke: steelblue;
  stroke-width: 3px;
}

.node text {
  font: 12px sans-serif;
}

.node--internal text {
  text-shadow: 0 1px 0 #fff, 0 -1px 0 #fff, 1px 0 0 #fff, -1px 0 0 #fff;
}

.link {
  fill: none;
  stroke: #ccc;
  stroke-width: 2px;
}

.compcell {
  text-align: center;
  border-right: solid lightgrey 1px;
}

.overflowHidden {
  overflow: hidden;
}
.overflowAuto {
  overflow: auto;
  height: 400px;
}
div.v-input__slot {
  margin-bottom: 0;
}
.v-input--selection-controls .v-input__slot > .v-label,
.col_header {
  white-space: nowrap;
  /* width: 30px;  */
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  font-size: 14px;
  width: 100%;
}
.scrollCol {
  height: 2px;
  /* margin-top: -1px; */
}
.col-resizable {
  position: relative;
}
.col-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  z-index: 5;
}
.col-resize-handle:hover {
  background-color: rgba(80, 179, 203, 0.4);
}
.col-resize-guide {
  position: fixed;
  width: 2px;
  background-color: #50b3cb;
  z-index: 300;
  pointer-events: none;
}
.col-resize-guide-hover {
  position: fixed;
  width: 3px;
  background-color: rgba(80, 179, 203, 0.45);
  z-index: 299;
  pointer-events: none;
}
/* draggable divider on the right edge of the vertical-axis panel; the visible
   gridline is drawn by .panel-divider on the content-height wrappers, while this
   full-height strip is only the (invisible) drag target */
.panel-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  z-index: 6;
}
.panel-resize-handle:hover {
  background-color: rgba(80, 179, 203, 0.4);
}
.panel-divider {
  border-right: 1px solid #d9d9d9;
}
/* closes the grid box when a few-px overflow clips the last column's border */
.clipped-right-border {
  border-right: 1px solid #d9d9d9;
}
.dialogueRow {
  min-height: 50px;
  max-height: 50px;
}
.dialogueRowTags {
  min-height: 30px;
  max-height: 30px;
}
.dialogueRowHierarchy {
  min-height: 100px;
  max-height: 100px;
}
.dialogueColumn,
.dialogueColumnTop,
.dialogueColumnBottom {
  border-left: 1px solid gray;
  border-right: 1px solid gray;
  margin-right: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.dialogueColumnSame {
  background-color: rgb(238 246 227);
}
.dialogueColumnCheckBoxRow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.dialogueColumnTop {
  border-top: 1px solid gray;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.dialogueColumnBottom {
  border-bottom: 1px solid gray;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.rowHeader,
.menuSubject {
  border: solid 1px #b7d1cd;
  border-radius: 5px;
  display: block;
  height: 24px;
  font-family: "Martel Sans", sans-serif;
  font-size: 12px;
  padding-left: 6px;
  padding-right: 6px;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background-color: white; /* alternate style */
}
/* .axis-background {
  background-color: #f9fafe;
} */
.menuSubject {
  width: fit-content;
  padding-top: 3px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: #f4f1f1;
}
.menuLabel {
  width: fit-content;
  padding-top: 5px;
}
.subjectPicker {
  cursor: pointer;
  display: block;
  border: solid 1px #004d40;
  border-radius: 5px;
  /* height: 32px; */
  height: 95px;
  font-size: 16px;
  padding: 6px;
  padding-left: 12px;
  width: 100%;
}
.subjectText {
  font-size: 14px;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  float: left;
  width: 90%;
}
.subjectIcon {
  margin-top: -3px;
  padding-right: 6px;
  float: right;
}
.changed,
.changedSelect > div > div > fieldset {
  border: solid 2px red !important;
}
.tableHeader {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
  font-size: 12px;
  border-top: 1px lightgray solid;
  border-bottom: 1px lightgray solid;
}
.descriptor {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.descriptor1line {
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
}
.descriptor2Line {
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
}
.descriptor3Line {
  -webkit-line-clamp: 3; /* number of lines to show */
  line-clamp: 3;
}
.descriptor4Line {
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
}
.descriptor5Line {
  -webkit-line-clamp: 5; /* number of lines to show */
  line-clamp: 5;
}
.descriptor6Line {
  -webkit-line-clamp: 6; /* number of lines to show */
  line-clamp: 6;
}
.descriptor7Line {
  -webkit-line-clamp: 7; /* number of lines to show */
  line-clamp: 7;
}
.descriptor8Line {
  -webkit-line-clamp: 8; /* number of lines to show */
  line-clamp: 8;
}

.review-user {
  padding-left: 10px;
  background-color: white;
  border-radius: 5px;
  margin-left: 10px;
  margin-bottom: 3px;
}
.feedback-row {
  background-color: #eceff1;
  border-radius: 8px;
  margin-left: 0;
  margin-bottom: 0;
}
.node-description {
  display: inline;
  border: solid 1px;
  padding: 0 5px;
  font-size: 12px;
  border-radius: 5px;
}
.leaf_node_count_new {
  text-align: right;
  border-radius: 16px;
  color: black;
  max-width: 65px;
  min-width: 20px;
  /* padding: 0 8px; */
  display: inline-block;
  /* border: solid gray 2px; */
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 20.83px;
  letter-spacing: 0.5px;
}
.draggable {
  cursor: move;
  border: solid white 2px;
  border-radius: 5px;
  margin: -2px;
}
.draggable:hover {
  border: solid lightblue 2px;
  border-radius: 5px;
}
.drag-target {
  /*   width: 100px;
   height: 40px;
  border: 1px solid gray;
  border-radius: 6px;
  padding: 3px;
  margin: 2px; */
  min-height: 32px;
}
.column-heading {
  border-top: 2px solid lightgray;
  border-bottom: 2px solid lightgray;
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* display: inline-block; */
  width: 100%;
}
.leftpanel-column-container {
  /* padding-left: 4px;
  padding-right: 4px; */
    border-left: 1px #D9D9D9 solid;
    border-right: 1px #D9D9D9 solid;
}
.leftpanel-column-container-last {
    border-bottom: 1px solid #D9D9D9;
    border-bottom-left-radius: 16px;
}
.document_cell,
.label_cell {
  text-align: left;
  margin-right: 5px;
  margin-left: 5px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.5px;
  height: 50px;
}
.document_cell {
  /*   border: solid 1px #D9D9D9;*/
  background-color: transparent;
  border-radius: 5px;
  padding: 12px;
  cursor: pointer;
  line-height: 20.83px;
}
.label_cell {
  line-height: 50px;
  padding-left: 12px !important;
  padding-right: 12px !important;
}
/* new style adjustments */
</style>

<style>

/* column resize drag handles: global so the row/detail child components share them */
.col-resizable {
  position: relative;
}
.col-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  z-index: 5;
}
.col-resize-handle:hover {
  background-color: rgba(80, 179, 203, 0.4);
}
.rm-header, .rm-footer,
.y-columnHeader, .y-columnHeader-number, .y-columnFooter,
.x-rowHeader, .x-rowHeader > div, .x-rowHeader-number, .x-rowHeader-number > div, .x-rowHeader-border-top {
  font-family: "DM Sans" !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: left;
  background-color: #eeeeee !important;  
  font-size: 14px !important;
  color: #000000 !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 50px;
}
.rm-footer {
  background-color: #ffffff !important;  
}
.rm-footer, .y-columnFooter {  
  border-top: 2px solid #888888;
}
.x-rowHeader, .x-rowHeader-number, .x-rowHeader-border-top {
    padding: 12px !important;
}
.detail-cell-chip, .nested-cell-chip {
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  background-color: #EEEEEE;
  color: #000000;
  height: 21px;
  padding: 2px 4px;
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 10px;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-align: center;
}
.nested-cell-chip {
  margin-right: 12px;
}
.nested-cell {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 10px;
  line-height: 15px;
  letter-spacing: 0.5px;  
  padding-top: 2px;
}

.x-rowHeader-border-top {
  border-top: #D9D9D9 1px solid;
}
.x-rowHeader-border-right {
  border-right: #D9D9D9 1px solid;
}
.x-rowHeader-number, .x-rowHeader-number div {
  text-align: right;
}
.first-column {
  border-left: #d9d9d9 1px solid;
}
.first-row {
  border-top: #D9D9D9 1px solid;
}
.last-column {
  border-right: #D9D9D9 1px solid;
}
.last-row {
  border-bottom: #D9D9D9 1px solid;
}
.first-row.first-column {
  border-top-left-radius: 16px;
}
.first-row.last-column {
  border-top-right-radius: 16px;
}
.last-row.last-column {
  border-bottom-right-radius: 16px;
}
.last-row.first-column {
  border-bottom-left-radius: 16px;
}
.y-columnHeader-empty {
    line-height: 18.23px;
    border-top: 1px solid transparent;
    height: 50px;
}
.y-columnHeader, .y-columnHeader-number, .y-columnFooter {
    padding: 12px !important;
}
.y-columnHeader-number {
  text-align: right;
}
.y-columnDetail {
  border-right: #D9D9D9 1px solid;
  min-height: 50px;
}
.header-left, .header-left div {
  text-align: left;
}
.header-right, .header-right div {
  text-align: right;
}
.header-center, .header-center div {
  text-align: center;
}

.z-detail {
  /* line-height: 50px; */
  padding: 12px !important;
  /* padding-right: 12px !important; */
  text-align: left;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* width: 100%; */
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  /* height: 50px; */
}

.rm-tab {
  text-transform: none;
  font-family: "DM Sans" !important;
  color: #AAAAAA !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  border-bottom: 6px solid transparent;
}
.rm-tab.v-tab--active {
  color: #000000 !important;
  font-weight: 700;
  border-bottom: 6px solid #48A401;
}
.rm-tab-slider {
  background-color: #48A401;
}
.row-header {
  color: black;
  background-color: transparent;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  padding: 12px !important;
}
.row-header-measure {
  text-align: right;
  color: black;
  background-color: transparent;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  padding-top: 16px !important;
  padding-right: 16px !important;
}
.row-header-selector {
  padding-top: 8px !important;
  padding-left: 12px !important;
  padding-bottom: 0 !important;
  padding-right: 0 !important;
}
.gridline-horizontal {
  border-bottom: #d9d9d9 1px solid;
}
.gridline-vertical {
  border-right: #d9d9d9 1px solid;
}
/* .gridline-separator {
  border-right: #888888 2px solid;
} */
.row-even {
  background-color: #F7F9FB;
}
.sub-row {
  background-color: #F7F9FB !important;
  min-height: 50px;
}
.row-expanded {
  background-color: #E6F1FB;
}
.row-cell {
  font-family: "DM Sans" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #000000 !important;
}
.group-header {
  padding-top: 8px !important;
}
.group-header div {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 12px;
  color: black !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 6px !important;
}
.rm-primary-tab-icon {
  font-size: 50px !important;
}
.rm-primary-tab {
  height: 90px;
  padding: 20px 24px;
  font-family: "DM Serif Display" !important;
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  color: #000000;
}
.rm-primary-tab.tab-selected {
  padding: 16px 20px;
}
.rm-box {
  background-color: #FFFFFF;
  border-radius: 24px !important;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, .08) !important;
}
.rm-button, .rm-button-icon {
  background-color: #eeeeee !important;
  border-radius: 8px !important;
  font-weight: 700;
  min-width: 44px;
}
.rm-button-icon {
  min-width: 44px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.rm-tab-container {
  box-shadow: 0px 4px 10px -3px rgba(0, 0, 0, .04) !important;
}
.rm-select {
  border-radius: 8px !important;
  font-size: 14px;
  color: #000000;
}
.rm-view-title {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 18px;
  color: black;
  line-height: 100%;
  letter-spacing: 0;
}
.rm-label {
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  color: black;
  line-height: 100%;
  letter-spacing: 0;
}
.rm-title {
  font-family: "DM Serif Display" !important;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0;
  margin-bottom: 16px;;
}
.rm-page-title {
  font-family: "DM Serif Display" !important;
  font-weight: 400;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
}
.rm-chart-label {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0;
}
.rm-maximised {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
}
.rm-maximised-title {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 16px;
  color: black;
  line-height: 100%;
  letter-spacing: 0;
}
.rm-view-container {
  background-color: white; 
  padding: 40px;
}
.rm-view-container-maximised {
  background-color: white; 
}
.instance-count {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0;  
  padding: 4px;
  border-radius: 4px;
  background-color: #EEEEEE;
  color: #000000;
}
.v-badge__badge { /* for 'Compare Selected'  */
  padding-top: 5px;
  font-weight: 700;
}
.checkbox-small .v-icon {
  font-size: 20px;
}

.chartHolder {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.pie-container {
  padding: 0;
  margin: 0 10px;
  width: 140px;
  position: relative;
}
.pie-container .pie-title {
  text-align: center;
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
}
.pie-title-number {
  font-family: "DM Sans" !important;
  font-size: 14px;
  font-weight: 700;
  margin: 0 !important;
}
.pie-title-text {
  font-family: "DM Sans" !important;
  font-size: 10px;
  font-weight: 400;
  line-height: 11px;
  text-wrap: auto;
  width: 50%;
  margin-left: 25% !important;
}
.pie-legend {
  max-height: 180px;
  height: 180px;
  overflow: auto;
  padding-left: 10px;
  width: calc(100% - 150px);
}
.pie-legend-item {
  font-family: "DM Sans" !important;
  font-size: 14px;
  font-weight: 400;
  margin: 1px;
  padding: 1px;
}
.bar-legend {
  max-height: 200px; 
  overflow: auto;
}

.statistic-icon {
  font-size: 40px !important;
}
.statistic-container-current {
  /* height: 104px; */
  border-radius: 24px !important;
  padding: 24px 16px 20px 16px;
  margin-right: 20px;
  /* margin-bottom: 20px; */
  margin-left: 20px;
  /* margin-top: 20px; */
}
.statistic-container {
  height: 104px;
  border-radius: 24px !important;
  padding: 24px 16px 20px 16px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.statistic-text-container {
  float: right;
  width: calc(100% - 65px);
}
.statistic-title {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0;
  color: #000000;
  padding-bottom: 10px;
}
.statistic-description {
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: #000000;
}
.chart-link {
  font-family: "DM Sans" !important;
  font-weight: 700;
  font-size: 14px;
  color: #48A401;
  cursor: pointer;
  text-decoration: underline;
  padding-top: 10px;
}
.v-text-field__prefix {
    border-right: solid 1px #EEEEEE;
    min-height: calc(100% - 2px);
    padding-top: 8px;
    padding-right: 6px;
    padding-left: 6px;
    background-color: #e7f0f3;
    margin-left: -10px;
    margin-right: 6px;
    margin-bottom: 2px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.measure-column {
  min-height: 50px;
  /* line-height: 50px; */
  text-align: right;
  padding-top: 16px !important;
  padding-right: 12px !important;
  padding-left: 12px !important;
  color: black !important;
}
.highlight-legend-container {
  margin-right: 15px;
  display: inline-flex;
}
.highlight-legend-box {
  height: 20px;
  width: 20px;
  border-radius: 4px;
  border: 1px solid transparent;
  margin-right: 10px;
  display: inline-flex;
}
.highlight-legend-text {
  /* height: 20px;
  margin-right: 10px; */
  display: inline-flex;
  vertical-align: top;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  color: black;
}
.horizontal-border-bottom {
  /* border-bottom: 3px solid blue; */
  border-bottom: 2px solid #888888;
}
.vertical-border-left {
  /* border-right: 3px solid blue; */
  border-left: 2px solid #888888;
}
.vertical-border-right {
  /* border-right: 3px solid blue; */
  border-right: 2px solid #888888;
}
.highlight-container {
  /* border: 1px solid #EEEEEE; */
  border-radius: 24px;
  height: 130px;
  font-family: 'DM Sans' !important;
  padding: 16px 20px 16px 28px !important;
  margin-right: 20px;
}
.highlight-container-link:hover {
  opacity: 0.6;
}
.highlight-container:last-of-type {
  margin-right: 0;
}
.highlight-title {
  /* text-transform: uppercase; */
  font-size: 14px;
  font-weight: 700;
  color: #000000;  
  font-family: 'DM Sans' !important;
}
.highlight-value {
  font-size: 24px;
  font-weight: 400;
  font-family: 'DM Serif Display' !important;
  color: #000000;
  letter-spacing: 0;
  margin-top: 12px;
  margin-bottom: 8px;
}
.highlight-addendum {
  font-size: 11px;
  font-weight: 400;
  color: #000000;  
  font-family: 'DM Sans' !important;
  padding-left: 8px;
  vertical-align: middle;  
  letter-spacing: 0;
  line-height: 1.1;
}
.drilldown-sub-title {
  border: solid 1px lightgray;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 400;
  color: #000000;  
  letter-spacing: 0;
  line-height: 1.1;
  font-family: 'DM Sans' !important;
  margin-top: 8px;
  display: inline-flex;
}
.drilldown-sub-title-stat {
  display: inline-block;
  margin-left: 4px;
  font-weight: 700;
  color: #000000;
  letter-spacing: 0;
}
.drilldown-chart-container {
  border: solid 1px lightgray;
  border-radius: 8px;
  padding: 12px;
}
.drilldown-section {
  display: inline-flex;
  padding: 12px 0;
}
.drilldown-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #000000;  
  letter-spacing: 0;
  font-family: 'DM Sans' !important;
  padding-right: 16px;
}
.drilldown-section-label {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 400;
  font-family: 'DM Sans' !important;
}
.drilldown-quartile-title {
  padding: 8px;
  font-size: 14px;
  font-weight: 700;
  background-color: #d1d1d1;
  cursor: pointer;
}
.drilldown-alert-container{
  padding: 8px;
  font-size: 16px;
  font-weight: 700;
  background-color: red;
  border-radius: 8px;
  text-align: center;
  color: white;
}
</style>